export const Locale = {
  RU: {
    Out: "из",
    PortfolioTitle: "Ваши портфели",
    UntilTheEnd: "До окончания инвестиции",
    TabsActive: "Активные",
    TabsClose: "Закрытые",
    TabsDraft: "Черновик",
    LoansInvesting: "Займов проинвестировано",
    LoansActive: "Активные займы",
    LoansClose: "Займов закрыто",
    LoansDebt: "Взыскание",
    LoansBought: "Выкуплен",
    Hello: "Привет,",
    MonthOne: "месяц",
    MonthSeveral: "месяца",
    MonthMany: "месяцев",
    Delete: "Удалить",
    //
    ResultPaymentErrorTitle: "Тразнакция отклонена банком.",
    ResultPaymentErrorInfo:
      "Вы можете пополнить счет с помощью банковского перевода или воспользоваться сервисами:",
    LimitContentTitle: "За этот месяц вы уже пополнили счет на /1/.",
    LimitContentDescription1:
      "По стандартам Европейского законодательства, мы можем принять от вас до /1/ в месяц.",
    LimitContentList1: "До /1/ вы можете пополнить баланс еще на /2/.",
    LimitContentList2: "С /1/ на любую сумму до /2/.",
    LimitContentDescription2:
      "Если вы планируете инвестировать больше, пожалуйста свяжитесь с нами любым удобным для вас способом, и мы поможем вам это сделать.",
    //
    DepositTabsTitle1: "Карта ",
    DepositTabsTitle2: "Банковский перевод",
    DepositTabsTitle3: `Для изменения ваших персональных данных, пожалуйста напишите в поддержку.`,
    DepositTabsTitle3_EN: `To change your personal information, please contact support. <br /> 
    Currently, only Mastercard is supported. Withdrawal on Visa is in the process.`,
    DepositTabsTitle4: `Вывод может осуществляться только на счет привязаный к аккаунту.`,
    DepositDescriptionCardDesk:
      "Пожалуйста, имейте ввиду, что ваш банк может устанавливать ограничения на пополнения с карты. Если у Вас не получится пополнить баланс с карты, Вы можете обратиться в Ваш банк для решения проблемы или использовать пополнение банковским переводом.",
    DepositDescriptionCardMobile:
      "Если у Вас не получится пополнить баланс с карты, Вы можете обратиться в Ваш банк для решения проблемы или использовать пополнение банковским переводом.",
    DepositDescriptionBankDesk:
      "Переведите средства на указанные реквизиты. Обязательно скопируйте цель платежа.\n" +
      "Пополнение доступно только резидентам SEPA.",
    DepositDescriptionBankMobile:
      "Пополнение доступно <b>только резидентам SEPA.</b>",
    //
    OtherLabel: "Другая",
    RangeInvestmentAmount: "Сумма инвестиции от /min/ до /max/",
    RangeInvestmentTerm: "Срок инвестиции (Месяцы) от /min/ до /max/",
    ValidationAmountMin: "Минимальная сумма /min/",
    ValidationAmountMax: "Максимальная сумма /max/",
    ValidationTermMinMax: "От /min/ - /max/ Месяцев",
    AvailableForInvesting: "Доступно для инвестиций",
    WeeklyInterestPay: "Еженедельные выплаты процентов",
    FirstPayment: "Первая выплата",
    ClassicDescription:
      "Доходность по данной стратегии фиксирована, обеспечена гарантией обратного выкупа и составляет 9.7% годовых. Стратегия обеспечивает отсутствие рисков и гарантированную доходность. Теперь реинвестирование начальной суммы включено по-умолчанию.",
    BalancedDescription:
      "Доходность не фиксирована и, согласно статистике предыдущих периодов, может достигать 13% годовых. Наиболее сбалансированная стратегия в соотношении «риск — доходность». Реинвестирование начальной суммы включено по-умолчанию.",
    SpecialDescription:
      "Доходность не фиксирована и может достигать 17–19% годовых. Инвестиционные риски выше, но при этом доходность позволяет компенсировать потери в рамках общей суммы инвестиционного портфеля. Теперь реинвестирование начальной суммы включено по-умолчанию.",
    NextMoreText: "Подробнее",
    BackButton: "Назад",
    CalculatorInfoTitle: "Спасибо, что присоединились к Nibble!",
    CalculatorInfoDescription:
      "Выбирайте инвестиционную стратегию согласно вашим предпочтениям о доходности и риске.",
    CalculatorListTitle: "Создавайте инвестиционный портфель в три шага:",
    CalculatorListItem1: "Пройдите идентификацию личности Veriff",
    CalculatorListItem2: "Пополните ваш баланс",
    CalculatorListItem3: "Создайте ваш первый портфель.",
    StrategyNameClassic: "Classic",
    StrategyNameBalanced: "Balanced",
    StrategyNameSpecial: "Special",
    IdentifyYourself: "Пройти идентификацию",
    CurrentAnnualRate: "Текущая годовая процентная ставка",
    //
    IdentificationDescription:
      "По стандартам Европейского законодательства мы должны провести идентификацию вашей личности.",
    //

    bannerAchive: "Summer Rally",
    bannerInfo:
      "Не упусти возможность заработать больше - ставка 11,7% по Классической стратегии на портфели, созданные&nbsp;с&nbsp;01.07&nbsp;по&nbsp;31.08",
    //
    PaymentsOpertions_334: "Пополнение банковской картой",
    PaymentsOpertions_150: "Пополнение банковским переводом",
    PaymentsOpertions_355: "Начисление бонуса",
    //
    NoLinkDocsAlert:
      'Заполните поля раздела "Личная информация", чтобы получить возможность скачивать документы',
    NoticeDepositingCard:
      "Пожалуйста, имейте ввиду, что ваш банк может устанавливать ограничения на пополнения с карты. Если у Вас не получится пополнить баланс с карты, Вы можете обратиться в Ваш банк для решения проблемы или использовать пополнение банковским переводом.",
    //
    AboutTheBorrower: "О заемщике",
    AboutVeriff:
      "Veriff — компания, которой доверяют процесс идентификации правительства стран Европы, ведущие банки, а также компании и сервисы финтех отрасли и интернет-магазины.",
    AccountNumber: "Номер счета",
    AccountSumAvailable: "доступно на вашем счету",
    AccuredIncome: "начисленный доход",
    ActiveLoans: "активные займы",
    ActivePortfolio: "действующий портфель",
    AdditionalAgreement: "доп. соглашение",
    Address: "Адрес проживания",
    AddressLine1: "Адрес 1",
    AddressLine2: "Адрес 2",
    Agreement: "соглашение",
    All: "Все",
    AlreadyHaveAccount: "Уже есть аккаунт? Войдите",
    AnnualInterestRate: "текущая годовая <br> процентная ставка",
    AnnualInterestRateClassic: "фиксированная годовая <br> процентная ставка",
    ApplicationReceivedMessage:
      "Ваша заявка принята, наш менеджер свяжется с вами в ближайшее время. Спасибо!",
    ApplyPromoCode: "Применить промо-код",
    AreYouSure: "Вы уверены?",
    Articles: "Статьи",
    AverageInterest: "средневзвешенная процентная ставка",
    Balance: "Баланс",
    BalanceReplenishment: "Пополнение баланса",
    Bank: "Банк",
    BankAccountNumber: "Номер банковского аккаунта",
    BankName: "Наименование банка",
    BankTransferReplenishment: "Пополнение банковским переводом",
    BankTransferWithdrawal: "Вывод банковским переводом",
    CardTransferWithdrawal: "Withdrawal by card",
    Basic: "Основные",
    BirthDate: "Дата рождения",
    Borrower: "Заемщик",
    BorrowingCompany: "компания-заемщик",
    BringFriend: "Приведи друга",
    BuybackGuarantee: "Гарантия BuyBack",
    c11: "Россия",
    c12: "Австрия",
    c197: "Без реинвестирования",
    c198: "Полное реинвестирование",
    c199: "Основная сумма реинвестирования",
    c206: "Испания",
    c208: "Бельгия",
    c242: "Болгария",
    c243: "Великобритания",
    c244: "Венгрия",
    c245: "Германия",
    c246: "Греция",
    c247: "Дания",
    c248: "Ирландия",
    c249: "Италия",
    c250: "Кипр",
    c251: "Латвия",
    c252: "Литва",
    c253: "Люксембург",
    c254: "Мальта",
    c255: "Нидерланды",
    c256: "Польша",
    c257: "Португалия",
    c258: "Румыния",
    c259: "Словакия",
    c260: "Словения",
    c261: "Финляндия",
    c262: "Франция",
    c263: "Хорватия",
    c264: "Чехия",
    c265: "Швеция",
    c266: "Швейцария",
    c267: "Эстония",
    c270: "Joymoney Россия (скоро будет доступно)",
    c271: "Joymoney Испания",
    c272: "Joymoney Мексика (скоро будет доступно)",
    c274: "Фотографии отсутствуют",
    c275: "Изображение лица не распознано",
    c276: "Документ отображается не полностью",
    c277: "Низкое качество изображения",
    c278: "Документ поврежден",
    c279: "Данный тип документа не поддерживается",
    c280: "Документ истек",
    c281: "Утверждено",
    c282: "Другие причины",
    c283: "Просрочено",
    CalculatorNote:
      "Теперь реинвестирование начальной суммы включено по-умолчанию, а весь, полученный от инвестиций доход, будет еженедельно выплачиваться на баланс вашего счета Nibble",
    CapitalReinvestment: "реинвестирование основной суммы",
    CardInfo:
      "Мы работаем над расширением способов пополнения вашего счета Nibble. Скоро у вас появится возможность пополнять счет со своей дебетовой или кредитной карты",
    CashbackForFriends: "Кэшбэк за инвестиции друга",
    CashbackForInvestments: "Кэшбэк за свои инвестиции",
    CashDeposit: "Внесение средств",
    ChangePassword: "Изменить пароль",
    ChoiceOf70: "Выбор 70% инвесторов",
    ChoosePortfolioType: "Выбрать тип портфеля",
    City: "Город",
    ClosedLoans: "Закрытые займы",
    ClosingDate: "Дата закрытия",
    CompanyHeadName: "ФИО руководителя",
    CompanyName: "Название компании",
    CompleteRegistration:
      "Завершите регистрацию идентификацией личности, чтобы пополнить баланс и начать инвестировать",
    Confirm: "Подтвердить",
    ConfirmationLinkSent: "Ссылка для подтверждения отправлена на ваш email",
    Continue: "Продолжить",
    ContractsAndDocs: "Договоры и документы",
    Country: "Страна",
    CountryOfIssue: "Страна выдачи",
    CountryOfResidence: "Страна проживания",
    Code: "Код",
    CreateAccount: "Создать аккаунт",
    CreatePortfolio: "Создать портфель",
    CreatePortfolioInfo:
      "Если выбрано, то весь полученный доход будет заново проинвестирован, чтобы вы могли получать больше. По-умолчанию, весь доход от инвестиций выводится на ваш счет Nibble и доступен для вывода по мере закрытия займов",
    CreateTestPortfolio: "Создать пробный портфель",
    CurrentBalance: "Текущий баланс",
    CurrentIncome: "Текущий доход",
    CurrentlyOnYourAccount: "сейчас на вашем счету",
    CurrentPassError: "Текущий пароль не верен",
    CurrentPassword: "Текущий пароль",
    DailyReport: "Ежедневный отчет",
    DateFormat: "Формат даты",
    DaysLabel: "дней",
    DepositAccount: "Пополнить счет",
    DepositAccountMobile: "Пополнить",
    DepositFunds: "Пополнить",
    DepositHistory: "История внесения средств",
    DepositPortfolio: "Пополнить портфель",
    DepositViaBankAccount: "Пополнение через банковский счет",
    DocBackScan: "Скан документа обратная сторона",
    DocFrontScan: "Скан документа лицевая сторона",
    DocPhoto: "Фото документа",
    DocType: "Тип документа",
    Document: "Документ",
    DownloadAgreement: "Скачать договор",
    DownloadWarning: "Чтобы скачать договор укажите необходимую",
    DownloadWarningNext: "личную информацию",
    Email: "Электронная почта",
    EmailAlreadyReg: "Этот email-адрес уже используется в системе",
    EmailChangeInfo:
      "Чтобы изменить адрес электронной почты обратитесь в службу поддержки",
    EnabledByDefault: "включено по-умолчанию",
    ERROR_001:
      "На вашем балансе не хватает средств для создания портфеля с выбранными параметрами",
    ERROR_002: "Не выбраны страны",
    ERROR_003: "Неизвестная ошибка",
    ERROR_004: "Неверная сумма",
    ERROR_005: "Можно создать только один пробный портфель",
    ERROR_006: "Выбранная сумма инвестиций не соответствует балансу",
    ErrorEmailLength: "E-mail не может быть пустым",
    ErrorEmailLogin: "Неправильный формат Email",
    ErrorEmailPassLogin: "Неправильный email или пароль",
    ErrorEmptyFields: "Не все обязательные поля заполнены",
    ErrorFirstNameLength: "Вы не указали свое имя",
    ErrorLastNameLength: "Вы не указали свою фамилию",
    ErrorLoadDocument:
      "Для загрузки договора, на странице настроек, необходимо заполнить дату рождения и адрес!",
    ErrorPhoneFormat: "Телефон указан не верно",
    ErrorPromoCode: "Указан недействительный промо-код",
    Exit: "Выход",
    ExpectedAnnualReturn: "ожидаемая годовая доходность",
    ExpectedClosingDate: "Планируемая дата закрытия",
    ExpectedIncome: "ожидаемый доход",
    FacePhoto: "Фото лица",
    Finish: "Завершить",
    FirstName: "Ваше имя",
    FirstStep: "Первый шаг регистрации",
    ForBusiness: "для бизнеса",
    ForgotPassword: "Забыли пароль?",
    FormatDate1: "гггг-мм-дд",
    FormatDate2: "гггг/мм/дд",
    FormatDate3: "мм/дд/гггг",
    FormatDate4: "мм-дд-гггг",
    From3To60Months: "от 3 до 60 месяцев",
    Full: "Полное",
    FundsWithdrawal: "Вывод средств",
    Gender: "Пол",
    GetSMSCode: "Получить проверочный код",
    GoIdent: "Пройти идентификацию <br> личности",
    GoToAccount: "Перейти в Личный кабинет",
    Help: "Помощь",
    History: "История операций",
    HowItWorks: "Как это работает",
    HugeAmountWarning:
      "Для инвестирования свыше 10000 EUR необходимо пройти дополнительную проверку",

    HelperRisksTitle:
      "Классификация займов по риску выхода на просрочку NPL 30, 60, 90, 120+",
    HelperRisksText:
      'Компании холдинга IT Smart Finance применяют&nbsp;скоринговые модели для определения качества заёмщиков. Всем одобренным кредитам присваивается соответствующая классификация.</p><table border="0" cellpadding="0" cellspacing="0"><tbody><tr><td><strong>AA</strong></td><td><strong>A</strong></td></tr><tr><td>закрытые в срок</td><td>закрытые досрочно</td></tr><tr><td colspan="2">Займы с низким уровнем риска. Клиенты этой категории, как правило, возвращают деньги в срок или досрочно, поэтому доходность по ним невысокая, но и риски невысоки.</td></tr><tr><td><strong>ВВ</strong></td><td><strong>В</strong></td></tr><tr><td>с просрочкой NPL 0-30</td><td>с просрочкой NPL 30-60</td></tr><tr><td colspan="2">Займы со средним уровнем риска. Клиенты этой категории могут допустить просрочку NPL30 и NPL60, но почти всегда в итоге возвращают займы. Риск дефолта для данной категории выше, но выше и средний доход.</td></tr><tr><td><strong>СС</strong></td><td><strong>С</strong></td></tr><tr><td>с просрочкой NPL 60-90</td><td>с просрочкой 90-120</td></tr><tr><td colspan="2">Займы с повышенным уровнем риска. Среди займов этой категории есть NPL 60, NPL90, &nbsp;NPL120 и&nbsp;займы, по которым ведется судебная работа, что&nbsp;обеспечивает максимальную доходность среди всех категорий.</td></tr></tbody></table><p>На Комитете по рискам&nbsp;раз в месяц происходит анализ и корректировка процесса присвоения классификации кредитам. Далее выданные кредиты сортируются по стратегиям.',
    HelperAnnualRateTitle: "Годовая процентная ставка",
    HelperAnnualRateText:
      "Ставка доходности формируется и одобряется каждый месяц на внутреннем Комитете рисков и зависит от результатов рассматриваемого периода.",
    HelperStrategyClassicTitle:
      "Стратегия &laquo;Классическая&raquo; c BuyBack Guarantee",
    HelperStrategyClassicText:
      "Вы инвестируете в необеспеченные потребительские кредиты с&nbsp;классификацией&nbsp;АА, А, ВВ, по которым риск выхода заемщика на просрочку крайне низкий. С гарантией&nbsp;обратного выкупа&nbsp;вы защищены от рисков и получаете гарантированный доход по фиксированной процентной ставке.</p><p><strong>Сопутствующие риски</strong></p><p><strong>Риск невозврата кредита / нарушения графика возврата / невозврата всей положенной к погашению суммы кредита&nbsp;</strong></p><p>Указанные риски инвестора обеспечиваются гарантией обратного выкупа полученных активов и процентов. Рассмотрим подробно как это работает: инвестор платформы Nibble, выбирая данную стратегию, инвестирует в кредиты,&nbsp;выданные&nbsp;компаниями группы IT Smart Finance, доступные на день инвестиции.&nbsp;Компания холдинга размещает выданный займ на платформе Nibble для поиска инвестора.&nbsp;Oтношения между компаниями группы IT Smart Finance и конечным заемщиком регулируются договором краткосрочного потребительского займа с вытекающими из него правами требования к заемщику. На основании договора цессии, заключенным с Инвестором, Nibble принимает на себя обязательства по получению платежей конечного заемщика, производимых в адрес компаний группы IT Smart Finance в соответствии с договорами краткосрочного потребительского займа и далее выплачивает их Инвестору в порядке и размере, установленном Договором Цессии. В случае, если заемщик не возвращает своевременно займ или продлевает срок его возврата, компании группы IT Smart Finance выкупают право требования инвестора Nibble в размере суммы инвестиции и гарантированного процентного дохода по продукту.",
    HelperStrategyBalancedTitle: "Стратегия &laquo;Сбалансированная&raquo;",
    HelperStrategyBalancedText:
      "Инвестирование в потребительские кредиты с классификацией ВВ, В и СС. Степень риска невозврата кредита с данной классификацией, как правило, крайне мала &mdash; по таким кредитам возможна&nbsp;просрочка NPL30 и NPL60, но почти всегда в итоге они закрываются. Риск дефолта для данной стратегии невелик, но доход значительно выше, чем в стратегии с фиксированной доходностью.</p><p><strong>Сопутствующие риски</strong></p><p><strong>Нет обеспечения</strong></p><p>Инвестиции по этой стратегии не защищены гарантией обратного выкупа и не застрахованы в каком-либо государственном фонде, то есть, в случае невозврата кредита заемщиком, инвестор несет риск потери инвестированного капитала или его части</p><p><strong>Риск получения прибыли по ставке ниже ожидаемой, либо вообще отсутствия прибыли</strong></p><p>Получение прибыли по этой стратегии не гарантируется NIbble. Инвестор покупает права требования к конечным заемщикам и получение процентного дохода напрямую зависит от исполнения заемщиками обязательств по возврату займа. В случае, если заемщик не возвращает займ полностью или частично, инвестор может не получить процентную составляющую дохода или сроки возврата инвестированной суммы и начисленного дохода увеличатся.</p><p>Фактическая норма доходности по данной стратегии&nbsp;превосходит максимальную заявленную доходность в 13%. Доходы, получаемые сверх этого, не являются собственностью платформы Nibble и реинвестируются для снижения риска и достижения заявленной ставки доходности.",
    HelperStrategySpecialTitle: "Стратегия &laquo;Специальная&raquo;&nbsp;",
    HelperStrategySpecialText:
      "Инвестирование в необеспеченные потребительские кредиты с классификацией В, СС и С. В этой стратегии&nbsp;степень риска невозврата кредита выше, чем в стратегии &laquo;Сбалансированная&raquo;, но при этом доходность &mdash; до 19% годовых и компенсирует возможные потери в пределах суммы инвестиционного портфеля.&nbsp;Минимальный срок инвестирования 12 месяцев объясняется тем, что в данном портфеле присутствуют кредиты, по которым может возникнуть просрочка платежа и ее взыскание может занять более длительный период.</p><p><strong>Сопутствующие риски</strong></p><p><strong>Нет обеспечения</strong></p><p>Инвестиции по этой стратегии не защищены гарантией обратного выкупа и не застрахованы в каком-либо государственном фонде, то есть, в случае невозврата кредита заемщиком, инвестор несет риск потери инвестированного капитала или его части</p><p><strong>Риск получения прибыли по ставке ниже ожидаемой, либо вообще отсутствия прибыли</strong></p><p>Получение прибыли по этой стратегии не гарантируется NIbble. Инвестор покупает права требования к конечным заемщикам и получение процентного дохода напрямую зависит от исполнения заемщиками обязательств по возврату займа. В случае, если заемщик не возвращает займ полностью или частично, инвестор может не получить процентную составляющую дохода или сроки возврата инвестированной суммы и начисленного дохода увеличатся.</p><p>Фактическая норма доходности по данной стратегии&nbsp;превосходит максимальную заявленную доходность в 19%. Доходы, получаемые сверх этого, не являются собственностью платформы Nibble и реинвестируются для снижения риска и достижения заявленной ставки доходности.",

    IdentFailed: "Идентификация не пройдена.",
    Identification: "Идентификация",
    IdentificationGoal1: "соблюдать законы Европейского союза",
    IdentificationGoal2:
      "обеспечить и гарантировать безопасность ваших средств и транзакций",
    IdentificationGoal3:
      "упростить бизнес-процессы, сделать их прозрачными и эффективными",
    IdentificationGoalsTitle:
      "Наши общие цели персональной идентификации личности:",
    IdentificationH1:
      "почему мы просим вас предоставить фотографии документов?",
    IdentificationLead:
      "Nibble неукоснительно следует строгим стандартам Европейского законодательства в части противодействия легализации доходов (AML), верификации пользователей, хранения и использования персональных данных.",
    IdentificationProfitsList:
      '<li class="veriffFeature-list__item">Инвестирование доступно только подтвержденным пользователям</li> <li class="veriffFeature-list__item">Мы не сообщаем третьим лицам ваши персональные данные</li> <li class="veriffFeature-list__item">Ваши данные передаются по защищенному каналу и хранятся в зашифрованном виде</li> <li class="veriffFeature-list__item">Мы несем полную ответственность за сохранность ваших персональных данных</li>',
    IdentityDocHint:
      "Для идентификации вы можете использовать как удостоверение личности, так и водительские права. Если вы предоставляете в качестве удостоверения личности водительское удостоверение, убедитесь, что сфотографировали и загрузили обе стороны удостоверения.",
    ID: "ID",
    IDHint:
      "Пожалуйста, убедитесь, что указали номер и серию выбранного документа",
    IDNumber: "Серия и номер документа",
    Income: "Поступление",
    IncomeCalculation: "Начисление дохода",
    IncomeReceived: "получено дохода",
    Individual: "Физическое лицо",
    InitialDeposit: "первоначальный взнос",
    InterestRate: "Процентная ставка",
    Invest: "Инвестировать",
    InvestedInPortfolio: "Проинвестировано в портфель",
    InvestedLoans: "Проинвестированные займы",
    Investing: "Инвестирование",
    InvestingIn: "Инвестирование в [ID X]",
    Investment_amount: "Сумма инвестиции",
    Investment_date: "Дата инвестиции",
    Investment_type: "Тип инвестирования",
    InvestmentAmount: "сумма инвестирования",
    InvestmentPeriod: "Срок инвестирования, мес.",
    InvestmentPeriodDays: "Срок инвестирования, дней",
    InvestmentPortfolios: "Инвестиционные портфели",
    InvestmentsCountTotal: "проинвестировано всего, штук",
    InvestmentsSumTotal: "всего инвестиций",
    IHavePromoCode: "У меня есть промокод",

    InformationTitleSection1: "Инвестиции с&nbsp;Nibble",
    InformationContentSection1: `
        <p>
        Мы предлагаем вам три стратегии инвестирования: &laquo;Классическую&raquo;, &laquo;Сбалансированную&raquo; и
        &laquo;Взыскание&raquo;.
        Они отличаются друг от друга не только уровнем годовой доходности, но и уровнем
        рисков и тем, как эти риски распределяются между платформой и пользователем. Сравните наши стратегии и выберите
        для себя наиболее комфортную.
    </p>
    <ul>
        <li>Даже если у вас нет опыта в инвестировании &mdash; попробуйте инвестиции с защищенной доходностью. Риски мы
            возьмем на себя.</li>
        <li>Если вы уже опытный инвестор &mdash; выбирайте комфортную по соотношению &laquo;риск &mdash;
            доходность&raquo; стратегию. Мы разделим риски с вами.</li>
    </ul>
    <h3>Условия стратегий инвестирования</h3>
    <div class="article-table">
        <table border="0" cellpadding="0" cellspacing="0">
            <tbody>
                <tr>
                    <th><strong>Стратегии</strong></th>
                    <th><strong>Классическая</strong></th>
                    <th><strong>Сбалансированная</strong></th>
                    <th><strong>Взыскание</strong></th>
                </tr>
                <tr>
                    <th><strong>Годовая процентная ставка</strong></th>
                    <td>8%</td>
                    <td>12.5%</td>
                    <td>14.5%</td>
                </tr>
                <tr>
                    <th><strong>Аннотация</strong></th>
                    <td>Защищенная доходность</td>
                    <td>Сбалансированные риски</td>
                    <td>Высокий доход для терпеливых инвесторов</td>
                </tr>
                <tr>
                    <th><strong>Описание</strong></th>
                    <td>
                        Доходность по данной стратегии фиксирована, обеспечена гарантией обратного выкупа&nbsp;и
                        составляет 8% годовых. Стратегия обеспечивает отсутствие рисков и гарантированную доходность.
                    </td>
                    <td>
                        Доходность не фиксирована и, согласно статистике предыдущих периодов, может достигать
                        12&ndash;15% годовых.&nbsp;Наиболее сбалансированная стратегия в соотношении &laquo;риск &mdash;
                        доходность&raquo;.
                    </td>
                    <td>
                        <p>Эта стратегия инвестирования в портфели, состоящие из потребительских кредитов с
                            классификацией В, СС и С, которые находятся в процессе досудебного и судебного взыскания. За
                            счет того, что по этим кредитам есть просроченная задолженность и штрафы, доходность этой
                            стратегии достигает до 19% годовых.</p>
                        <p>Минимальный срок инвестирования 6 месяцев объясняется тем, что судебный процесс и процесс
                            взыскания занимают длительный период времени.</p>
                    </td>
                </tr>
                <tr>
                    <th><strong>Срок инвестирования</strong></th>
                    <td>1&ndash;6 месяцев</td>
                    <td>7&ndash;60 месяцев</td>
                    <td>6&ndash;60 месяцев</td>
                </tr>
                <tr>
                    <th><strong>Обратный выкуп</strong></th>
                    <td><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOCAyTDcgMTNMMiA4IiBzdHJva2U9IiNCN0Q3NUQiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="
                            alt="check">
                    </td>
                    <td>&mdash;</td>
                    <td>
                        <ul>
                            <li>Гарантия возврата депозита.</li>
                            <li>Гарантированная минимальная доходность 8% годовых</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <th><strong>Реинвестирование</strong></th>
                    <td colspan="2">автоматическое реинвестирование тела инвестиций в новые займы</td>
                    <td>
                        <img src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNERTM1MEIiIGN4PSI4IiBjeT0iOCIgcj0iOCIvPjxwYXRoIGQ9Ik05LjQ4NSA4LjA3MWwyLjEyMiAyLjEyMWExIDEgMCAxIDEtMS40MTUgMS40MTVsLTIuMTItMi4xMjItMi4xMjIgMi4xMjJhMSAxIDAgMSAxLTEuNDE0LTEuNDE1bDIuMTItMi4xMi0yLjEyLTIuMTIyQTEgMSAwIDEgMSA1Ljk1IDQuNTM2bDIuMTIxIDIuMTIgMi4xMjEtMi4xMmExIDEgMCAxIDEgMS40MTUgMS40MTRMOS40ODUgOC4wN3oiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+'/>
                    </td>
                </tr>
                <tr>
                    <th><strong>Начисление&nbsp;и вывод %</strong></th>
                    <td colspan="2">
                        начисление &mdash; ежедневно, вывод &mdash; еженедельно на счет инвестора в Nibble
                    </td>
                    <td>
                        Начисление ежедневное по 8% годовых, выплаты раз в квартал по фактически полученной доходности
                        до 14,5% годовых.
                    </td>
                </tr>
                <tr>
                    <th><strong>Классификация займов по риску NPL</strong></th>
                    <td>АА&ndash;А&ndash;ВВ</td>
                    <td>ВВ&ndash;В&ndash;СС</td>
                    <td>В&ndash;СС&ndash;С</td>
                </tr>
                <tr>
                    <th><strong>Прогнозируемый уровень дефолта</strong></th>
                    <td>&mdash;</td>
                    <td>до NPL 30</td>
                    <td>NPL 30&ndash;90</td>
                </tr>
                <tr>
                    <th><strong>Сумма инвестирования **</strong></th>
                    <td>10&ndash;10 000 &euro;</td>
                    <td>100&ndash;10 000 &euro;</td>
                    <td>10&ndash;10 000 &euro;</td>
                </tr>
                <tr>
                    <th><strong>Мин. сумма вывода</strong></th>
                    <td colspan="3">от 50 &euro;</td>
                </tr>
            </tbody>
        </table>
    </div>
    <p> <small>*&nbsp;Ставка доходности формируется и одобряется каждый месяц на внутреннем Комитете рисков и зависит от
            результатов рассматриваемого периода</small> <small>**&nbsp;Для инвестирования сумм свыше 15000 &euro;,
            нужно будет предоставить дополнительный пакет документов</small> </p>
    <h3>Стратегия &laquo;Классическая&raquo; c BuyBack Guarantee</h3>
    <p>Вы инвестируете в необеспеченные потребительские кредиты с&nbsp;классификацией&nbsp;АА, А, ВВ, по которым риск
        выхода заемщика на просрочку крайне низкий. С гарантией&nbsp;обратного выкупа&nbsp;вы защищены от рисков и
        получаете гарантированный доход по фиксированной процентной ставке.</p>
    <p><strong>Сопутствующие риски</strong></p>
    <p><strong>Риск невозврата кредита / нарушения графика возврата / невозврата всей положенной к погашению суммы
            кредита&nbsp;</strong></p>
    <p>Указанные риски инвестора обеспечиваются гарантией обратного выкупа полученных активов и процентов. Рассмотрим
        подробно как это работает: инвестор платформы Nibble, выбирая данную стратегию, инвестирует в
        кредиты,&nbsp;выданные&nbsp;компаниями группы IT Smart Finance, доступные на день инвестиции.&nbsp;Компания
        холдинга размещает выданный займ на платформе Nibble для поиска инвестора.&nbsp;Oтношения между компаниями
        группы IT Smart Finance и конечным заемщиком регулируются договором краткосрочного потребительского займа с
        вытекающими из него правами требования к заемщику. На основании договора цессии, заключенным с Инвестором,
        Nibble принимает на себя обязательства по получению платежей конечного заемщика, производимых в адрес компаний
        группы IT Smart Finance в соответствии с договорами краткосрочного потребительского займа и далее выплачивает их
        Инвестору в порядке и размере, установленном Договором Цессии. В случае, если заемщик не возвращает своевременно
        займ или продлевает срок его возврата, компании группы IT Smart Finance выкупают право требования инвестора
        Nibble в размере суммы инвестиции и гарантированного процентного дохода по продукту.</p>
    <h3>Стратегия &laquo;Сбалансированная&raquo;</h3>
    <p>Инвестирование в потребительские кредиты с классификацией ВВ, В и СС. Степень риска невозврата кредита с данной
        классификацией, как правило, крайне мала &mdash; по таким кредитам возможна&nbsp;просрочка NPL30 и NPL60, но
        почти всегда в итоге они закрываются. Риск дефолта для данной стратегии невелик, но доход значительно выше, чем
        в стратегии с фиксированной доходностью.</p>
    <p><strong>Сопутствующие риски</strong></p>
    <p><strong>Нет обеспечения</strong></p>
    <p>Инвестиции по этой стратегии не защищены гарантией обратного выкупа и не застрахованы в каком-либо
        государственном фонде, то есть, в случае невозврата кредита заемщиком, инвестор несет риск потери
        инвестированного капитала или его части</p>
    <p><strong>Риск получения прибыли по ставке ниже ожидаемой, либо вообще отсутствия прибыли</strong></p>
    <p>Получение прибыли по этой стратегии не гарантируется NIbble. Инвестор покупает права требования к конечным
        заемщикам и получение процентного дохода напрямую зависит от исполнения заемщиками обязательств по возврату
        займа. В случае, если заемщик не возвращает займ полностью или частично, инвестор может не получить процентную
        составляющую дохода или сроки возврата инвестированной суммы и начисленного дохода увеличатся.</p>
    <p>Фактическая норма доходности по данной стратегии&nbsp;превосходит максимальную заявленную доходность в 15%.
        Доходы, получаемые сверх этого, не являются собственностью платформы Nibble и реинвестируются для снижения риска
        и достижения заявленной ставки доходности.</p>

    <h3>Стратегия &laquo;Вызскание&raquo;</h3>
    <p>Эта стратегия инвестирования в портфели, состоящие из потребительских кредитов с классификацией В, СС и С,
        которые находятся в процессе досудебного и судебного взыскания. За счет того, что по этим кредитам есть
        просроченная задолженность и штрафы, доходность этой стратегии достигает до 19% годовых.</p>
    <p>Минимальный срок инвестирования 6 месяцев объясняется тем, что судебный процесс и процесс взыскания занимают
        длительный период времени. Весь судебный процесс и взыскание средств, обеспечивается компанией Boostr.</p>
    <p><strong>Сопутсвующие риски:</strong></p>
    <p><strong>Риск невозврата кредита / невозврата всей положенной к погашению суммы кредита</strong></p>
    <p>
    <ul>
        <li>Стратегия обеспечена гарантией Deposit back - это обязательство коллекторского агенства вернуть тело
            инвестиции в полном объеме в конце срока инвестиции и обеспечить минимальную доходность 8% годовых.</li>
        <li>За счет инвестиции в портфель состоящий из большого кол-ва займов, снижен риск неполучения дохода от
            нескольких договоров, их перекрывают другие займы.</li>
        <li>Начисление ежедневное по 8% годовых, выплаты раз в квартал по фактически полученной доходности до 14,5%
            годовых.</li>
        <li>Пока собираются деньги на покупку портфеля, мы начисляем доход по 8% годовых - это ваша бонусная доходность
            к основной до 14,5%. Максимальный срок сбора денег на покупку портфеля - 30 дней.</li>
    </ul>
    </p>
        `,
    InformationTitleSection2:
      "Классификация займов по риску выхода на просрочку NPL 30, 60, 90, 120+",
    InformationContentSection2:
      '<p>Компании холдинга IT Smart Finance применяют&nbsp;скоринговые модели для определения качества заёмщиков. Всем одобренным кредитам присваивается соответствующая классификация.</p> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>AA</strong></td> <td><strong>A</strong></td> <td><strong>ВВ</strong></td> <td><strong>В</strong></td> <td><strong>СС</strong></td> <td><strong>С</strong></td> </tr> <tr> <td>закрытые в срок</td> <td>закрытые досрочно</td> <td>с просрочкой NPL 0-30</td> <td>с просрочкой NPL 30-60</td> <td>с просрочкой NPL 60-90</td> <td>с просрочкой 90-120</td> </tr> <tr> <td colspan="2">Займы с низким уровнем риска. Клиенты этой категории, как правило, возвращают деньги в срок или досрочно, поэтому доходность по ним невысокая, но и риски невысоки.</td> <td colspan="2">Займы со средним уровнем риска. Клиенты этой категории могут допустить просрочку NPL30 и NPL60, но почти всегда в итоге возвращают займы. Риск дефолта для данной категории выше, но выше и средний доход.</td> <td colspan="2">Займы с повышенным уровнем риска. Среди займов этой категории есть NPL 60, NPL90, &nbsp;NPL120 и&nbsp;займы, по которым ведется судебная работа, что&nbsp;обеспечивает максимальную доходность среди всех категорий.</td> </tr> </tbody> </table> </div> <p>На Комитете по рискам&nbsp;раз в месяц происходит анализ и корректировка процесса присвоения классификации кредитам. Далее выданные кредиты сортируются по стратегиям.</p> <h3>Продукт &laquo;Гибкое инвестирование&raquo; предусматривает три стратегии инвестирования</h3> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>АА</strong></td> <td><strong>A</strong></td> <td colspan="1"><strong>ВВ</strong></td> <td colspan="1"><strong>В</strong></td> <td colspan="1"><strong>СС</strong></td> <td colspan="1"><strong>С</strong></td> </tr> <tr> <td colspan="3"><strong>Классическая</strong></td> <td colspan="3" rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">65%</td> <td colspan="1">25%</td> <td colspan="1">10%</td> </tr> <tr> <td colspan="2" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Сбалансированная</strong></td> <td rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">63%</td> <td colspan="1">32%</td> <td colspan="1">5%</td> </tr> <tr> <td colspan="3" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Взыскание</strong></td> </tr> <tr> <td colspan="1">54%</td> <td colspan="1">28%</td> <td colspan="1">18%</td> </tr> </tbody> </table> </div> <p>В каждой стратегии автоматически подбираются займы соответствующей классификации. Каждая стратегия может включать до 3-х видов NPL, что позволяет получить заявленный доход и обеспечить соотвествующие требования по риску.</p>',
    InformationTitleSection3: "Вывод средств со счета",
    InformationContentSection3: `<p>Вывод свободных средств и средств, полученных после истечения срока действия инвестиционного портфеля, осуществляется на банковский счет инвестора через личный кабинет Nibble.</p> 
      <ul> 
      <li>Минимальная сумма вывода составляет 50 евро.</li> 
      <li>Nibble переводит деньги только на тот счет, который принадлежит инвестору. Это необходимая мера, которая защищает наших инвесторов и противодействует нелегальному отмыванию денежных средств.</li>
      <li>Изменить номер счета можно через&nbsp;обращение в нашу службу поддержки. В этом случае наш AML-инспектор попросит предоставить дополнительные документы.</li>
      </ul>
      <h3>Досрочное расторжение инвестиционного договора и вывод средств</h3> 
      <p>Вы можете досрочно расторгнуть договор инвестирования и вывести средства с платформы Nibble. Для этого Вам нужно подать заявку на досрочное расторжение договора через ЛК Nibble. После получения запроса мы начнем искать инвестора на ваш портфель. Портфель может быть перепродан только целиком. Если мы не найдем инвестора в течение 60 календарных дней после получения запроса на расторжение договора, то на 61 день выплатим вам из резервного фонда компании сумму инвестированных активов и соответствующие проценты, удержав комиссию в размере 3% от всей суммы, подлежащей выплате.</p>`,
    InformationTitleSection4: "Политика обратного выкупа",
    InformationContentSection4: `
        <p>Для обеспечения возврата средств по стратегии «Классическая» кредитор предоставляет гарантию обратного выкупа —
        это обязанность кредитора выкупить займ у инвестора, если займ не был погашен в течение 60 дней с момента
        инвестирования.</p>
    <p>При этом, вместе с первоначальной стоимостью кредита, кредитор выплатит и причитающиеся инвестору проценты.
        Cредства для обеспечения указанных обязательств формируются в&nbsp;<a
            href="https://nibble.local/ru/safety-and-security/reserve-fund.html">резервном фонде компании</a>.</p>
    <h3>Как работает Политика обратного выкупа:</h3>
    <ul>
        <li>Наши инвесторы, выбирая классическую стратегию инвестируют в кредиты, выданные компаниями группы IT Smart
            Finance.&nbsp;</li>
        <li>Компании холдинга размещают выданные ими кредиты на платформе Nibble для поиска инвесторов.</li>
        <li>Oтношения между компаниями группы IT Smart Finance и заемщиком регулируются договором краткосрочного
            потребительского займа с вытекающими из него правами требования к заемщику.&nbsp;</li>
        <li>На основании Договора Цессии, заключенного с Инвестором, Nibble принимает на себя следующие обязательства:
            <ol>
                <li>принимать платежи от конечного заемщика в адрес компаний группы IT Smart Finance, в соответствии с
                    договором краткосрочного потребительского займа</li>
                <li>выплачивать их Инвестору в порядке и размере, установленном Договором Цессии.&nbsp;</li>
            </ol>
        </li>
        <li>Если заемщик не возвращает своевременно или продлевает срок возврата займа, компании группы IT Smart Finance
            выкупают право требования инвестора Nibble в размере суммы инвестиции и гарантированного процентного дохода
            по займу.</li>
    </ul>
    <p>
        <h3>
            Стратегия Взыскание
        </h3>
    </p>
    <p>
        Стратегия обеспечена гарантией Deposit back - это обязательство коллекторского агенства вернуть тело инвестиции
        в полном объеме в конце срока инвестиции и обеспечить минимальную доходность 8% годовых.
    </p>
    <p>
        <strong>
            Как это работает?
        </strong>
    </p>
    <p>Вам ежедневно начисляются проценты по ставке 8% годовых. Каждые 90 дней мы автоматически рассчитываем фактическую
        доходность судебных портфелей и доначисляем вам разницу между гарантированной ставкой 8% и фактической ставкой.
        Таким образом каждые 90 дней вы получаете доход от 8% до 14,5%, на ваш счет Nibble.</p>
    <p>Пример: Инвестировав 1000 евро на 12 месяцев, в конце срока вы получаете обратно весь свой капитал 1000 евро и
        доход от 90 до 145 евро, которые мы выплачиваем вам квартально.</p>
        `,
    InformationTitleSection5: "Общая политика о рисках",
    InformationContentSection5:
      "<p>Риски распределяются между инвестором и микрофинансовыми организациями следующим образом:</p> <ul> <li>На продуктах с гарантией обратного выкупа, риски дефолта берёт на себя микрофинансовая организация за счёт&nbsp;резервного фонда</li> <li>На продуктах без гарантии обратного выкупа, риски дефолта разделяются между инвестором и микрофинансовой организацией в форме изменяющейся процентной ставки</li> <li>Риски изменения курса валют в текущих продуктах берёт на себя микрофинансовая организация</li> </ul>",
    InformationTitleSection6: "Комитет по рискам",
    InformationContentSection6:
      "<p>Для определения текущих процентных ставок по стратегиям &laquo;Сбалансированная&raquo; и &laquo;Специальная&raquo; в компании в конце каждого месяца собирается Комитет по рискам.</p> <h3>В состав комитета по рискам входят руководители следующих подразделений группы компаний IT Smart Finance:</h3> <ul> <li>Директор по рискам</li> <li>Операционный директор</li> <li>Руководитель департамента по взысканию задолженности</li> <li>Руководитель департамента андеррайтинга.</li> <li>Риск-аналитик</li> </ul> <h3>Основные задачи Комитета:&nbsp;</h3> <ul> <li>Рассмотрение и анализ результатов работы по выданным кредитам с NPL 30-60-90-120 за отчетный месяц.</li> <li>Сверка в периоде фактических показателей с запланированными.</li> <li>Анализ скоринговой модели.</li> <li>Построение прогноза на последующий период и калибровка скоринговой модели.</li> <li>Формирование и одобрение текущей годовой ставки доходности по стратегиям &laquo;Сбалансированная&raquo; и &laquo;Специальная&raquo;</li> </ul> <p>Результаты проведения Комитета по Рискам публикуются в виде&nbsp;отчета на сайте.</p>",
    InformationTitleSection7: "Формирование резервного фонда",
    InformationContentSection7:
      "<p>Резервный фонд это дополнительная &laquo;подушка безопасности&raquo; для инвестора, которая покрывает риски невозврата кредита конечным заемщиком. Благодаря наличию резервного фонда, мы предлагаем инвесторам инвестиционную стратегию с Гарантией обратного выкупа.</p>",
    InformationTitleSection8: "Обеспечение безопасности и конфиденциальности",
    InformationContentSection8:
      '<p>Мы ставим в приоритет защиту ваших персональных данных и безопасность ваших транзакций. Вот некоторые из гарантий важности этих приоритетов:</p> <h3>Гарантии безопасности</h3> <ul> <li>Данные хранятся в соответствии со стандартом безопасности ISO 27001:2013</li> <li>Все пароли хранятся в системе в защищённом виде</li> <li>Банковский счёт привязывается к аккаунту при совершении первого пополнения баланса и может быть изменён только при ручной идентификации инвестора</li> <li>В соответствии с законодательством Европейского Союза мы обязаны проводить идентификацию клиентов. Nibble используем подрядчика &mdash; компанию Veriff. С её политикой конфиденциальности вы можете ознакомиться&nbsp;<a href="https://www.veriff.com/privacy-policy">здесь</a></li> </ul> <h3>Гарантии приватности</h3> <ul> <li>Платформа Nibble является оператором обработки персональных данных в соответствии с законодательством Европейского Союза</li> <li>Мы не передаём данные инвесторов третьим лицам</li> </ul> <h3>Гарантии по финансовым рискам</h3> <ul> <li>Все инвестиции привлекаются группой компаний холдинга&nbsp;<a href="https://itsmartfinance.com/">IT Smart Finance</a></li> <li>По стратегии &laquo;Классическая&raquo; предоставляется гарантия обратного выкупа из резервного фонда</li> <li>Инвестиционная платформа Nibble является частью холдинга IT Smart Finance, который объединяет кредиторов из Евразии, Европы, и Латинской Америки</li> </ul>',

    JoinUs: "Присоединяйтесь к нам",
    JoymoneyInfo:
      "Компания Joymoney ES выдаёт займы на срок до 30 дней на территории Испании. Все займы защищены гарантией обратного выкупа - если займ не был закрыт в течение 60 дней со дня инвестиций, Joymoney ES выкупает долю инвестора вместе с начисленными процентами.",
    Later: "позже",
    Legal: "Юридическое лицо",
    literal_bread_reg: "Регистрация",
    LittleBitLeft: "Осталось совсем чуть-чуть",
    LoanType: "тип кредита",
    LoginBtn: "Войти",
    LoginHead: "Вход в личный кабинет",
    LongTerm: "Долгосрочный",
    LongTermInvestmensInfo:
      "Долгосрочные инвестиции позволяют получить максимальную доходность за счёт того, что в течение срока реинвестирования сумма закрытых займов реинвестируется заново (полностью или только основная сумма долга, в зависимости от настроек).",
    LongTermPortfolio: "Долгосрочный портфель",
    LowBalanceAlert:
      "На вашем балансе не хватает средств для создания портфеля с выбранными параметрами",
    MessageWithdrawalSuccess:
      "Запрос получен. Средства выводятся в течение 5-7 бизнес-дней",
    // ResultPaymentSuccessTitle: "The balance has been successfully replenished!",
    MonthlyDeposit: "Ежемесячный вклад",
    MonthlyDepositInfo:
      "Вы можете пополнять портфель не позднее чем за 3 месяца до окончания срока действия портфеля",
    MonthlyReport: "Ежемесячный отчет",
    Months: "месяцев",
    MrLabel: "Г-н",
    MsLabel: "Г-жа",
    MyAccount: "Мой аккаунт",
    MyInvestments: "Мои инвестиции",
    NameChangeWarning:
      "Вы можете изменить имя и фамилию до тех пор, пока не прошли идентификацию личности Veriff",
    NeedToVerifyBySMS: "Указанный телефон будет необходимо подтвердить по SMS",
    NewPassDlina: "Длина нового пароля меньше 5 символов",
    NewPassword: "Новый пароль",
    NewPasswordInfo:
      "Придумайте сложный пароль. Рекомендуем добавить в него служебные символы, цифры и заглавные буквы",
    NewPasswordSent: "Новый пароль был выслан на Ваш e-mail",
    NewRepeatPasChange: "Пароли не совпадают",
    News: "Новости",
    NewsletterCheckboxLabel: "Получать ежедневные рассылки",
    Next: "Далее",
    NibbleAgreement: "Соглашение с Nibble",
    No: "Нет",
    Notifications: "Уведомления",
    NotLimited: "не ограничена",
    OnlyActive: "Только активные",
    Opened: "Открыто",
    Operation: "Операция",
    OperationDate: "Дата операции",
    OrEmail: "или по электронной почте",
    OutputFail: "Невозможно вывести данную сумму",
    Page: "Страница",
    PageNotExist: "Извините, запрашиваемая Вами страница не существует.",
    PageNotFound: "Страница не найдена",
    Partial: "Частичное",
    PartnerCode: "Поделиться промокодом",
    PartnerCodeSet: "Промокод для приглашения",
    PartnerFaq:
      '<h2 class="title faq__title">Остались какие-либо вопросы?</h2> <div class="box faq-wrapper"> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text"> Какой срок действия промокода или реферальной ссылки?</span> <p class="faq-answer__text">Промокод/ссылка действует с момента генерации и не имеет срока действия.</p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Когда один из моих друзей инвестирует более 1000 евро, я не буду получать выплаты?</span> <p class="faq-answer__text">В этом случае, вы и ваш друг получите 2% от суммы 1000 евро.</p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Получу ли я доход, если один из моих друзей инвестирует менее 1000 евро?</span> <p class="faq-answer__text"> Если ваш друг совершит инвестиции на сумму менее 1000 евро, вы вместе получите вознаграждение в размере 2% от суммы инвестиций. </p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Сколько друзей я могу привести по промокоду или реферальной ссылке?</span> <p class="faq-answer__text">Вы можете привести по промокоду или реферальной ссылке неограниченное количество друзей.</p> </div> </div>',
    PartnerInfo:
      '<h1 class="title partner__title">Расскажите друзьям о нашем сервисе, и получите вознаграждение</h1> <span   class="partner__subtitle">Для вас, и ваших друзей</span> <ul class="partner-list">   <li class="partner-item">     <h2 class="partner-item__title">Расскажите друзьям о Nibble</h2>     <p class="partner-item__description">Вы можете поделиться с друзьями своей реферальной ссылкой или промокодом</p>   </li>   <li class="partner-item">     <h2 class="partner-item__title">Регистрация</h2>     <p class="partner-item__description">Ваши друзья регистрируются по ссылке или вводят промокод в процессе регистрации в Nibble </p>   </li>   <li class="partner-item">     <h2 class="partner-item__title">Получите вознаграждение</h2>     <p class="partner-item__description">Вы и ваш друг получите по 2% с каждой инвестиций совершенным вашим другом на сумму до 1000       евро. </p>   </li> </ul>',
    PartnerLinkSet: "Ссылка с приглашением",
    PartnerLinkSocial: "Поделиться ссылкой в соцсетях",
    PartnerTextStep1:
      "Вы можете поделиться с друзьями своей реферальной ссылкой или промокодом",
    PartnerTextStep2:
      "Ваши друзья регистрируются по ссылке или вводят промокод в процессе регистрации в Nibble",
    PartnerTextStep3:
      "Вы и ваш друг получите по 2% с каждой инвестиций совершенным вашим другом на сумму до 1000 евро",
    PartnerTitle:
      "Расскажите друзьям о нашем сервисе, и получите вознаграждение",
    PartnerTitleStep1: "Расскажите друзьям о Nibble",
    PartnerTitleStep2: "Регистрация",
    PartnerTitleStep3: "Получите вознаграждение",
    PartnerTransaction: "транзакции",
    PartnerTransactionIncome: "Зачислено",
    Password: "Пароль",
    PasswordChange: "Смена пароля",
    PasswordChanged: "Пароль изменен",
    PasswordSentMessage: "Пароль был выслан на телефон",
    PasswordsMakeSure: "Убедитесь, что пароли совпадают",
    PaymentOnformation: "Платежная информация",
    PaymentPurposeInfo:
      "Переведите средства на указанные реквизиты. Обязательно скопируйте цель платежа.",
    PeriodInvest: "Срок инвестирования",
    PeriodInvest1: "Срок инвестирования",
    PersonalData: "Личные данные",
    PersonalDataChangeInfo:
      "Чтобы изменить личные данные обратитесь в службу поддержки",
    PersonalID: "Персональный ID",
    PersonalInfo: "Личная информация",
    PersonLastName: "Фамилия",
    PersonName: "Имя",
    Persons: "чел.",
    Phone: "Контактный телефон",
    Phone1: "Ваш телефон",
    PhoneAlreadyReg: "Телефон уже зарегистрирован",
    PhoneChangeInfo:
      "Чтобы изменить контактный телефон обратитесь в службу поддержки",
    PhoneConfirm: "Телефон подтверждён",
    PhoneNotConfirm: "Телефон не подтверждён",
    PhoneNotValid: "Неправильный формат номера телефона",
    PhoneVerification: "Подтверждение номера телефона",
    PlacehoderBirthDate: "дд.мм.гггг",
    PolicyAgreement:
      'Согласие на <a href="/policy_privacy.aspx">Обработку персональных данных</a>',
    PolicyAgreement1:
      'Согласие на <a href="/policy_privacy.aspx">Обработку персональных данных</a>',
    PortfolioConfirmText:
      "Мы сейчас создадим портфель с указанными параметрами",
    PortfolioCreated: "Создан портфель",
    PortfolioCreation: "Создание портфеля",
    PortfolioID: "Портфель",
    PortfolioIncome: "Доход по портфелю",
    PortfolioParams: "Параметры портфеля",
    PortfolioReplenishment: "Пополнение портфеля [ID X]",
    PortfolioReplenishmentOperation: "Пополнение портфеля",
    PotentialProfit: "ваша возможная прибыль",
    Precalculation: "Предварительный расчет доходности",
    Precalculation1: "Предварительный расчет доходности",
    PrefferedLanguage: "Предпочитаемый язык",
    ProductDescription: "Описание продукта",
    ProfitCalc: "Расчет доходности",
    ProgressCompleteInfoDesc:
      "Осталось указать пару деталей в настройках вашего личного профиля.",
    ProgressCompleteInfoStep: "Дополнить информацию",
    ProgressCompleteInfoTitle: "Ваш аккаунт активирован...",
    ProgressConfirmEmailDesc:
      "Подтвердите адрес электронной почты и активируйте аккаунт. Для этого перейдите по ссылке в письме, которое мы вам отправили.",
    ProgressConfirmEmailDescRestore: "Отправить новую ссылку для активации",
    ProgressConfirmEmailStep: "Подтвердить e-mail",
    ProgressIdentifyDesc:
      "Пройдите идентификацию личности Veriff, чтобы пополнить баланс и начать инвестировать",
    ProgressIdentifyStep: "Пройти идентификацию",
    ProgressIdentifyTitle: "Последний и самый важный шаг...",
    PromoCode: "Промо-код",
    PropsContractsDocs: "Реквизиты",
    ProvideSMSCode: "Введите проверочный код из SMS",
    PurposeOfPayment: "Назначение платежа",
    Rate: "Ставка",
    ReceivingIncomeBy: "Получение дохода по [ID X]",
    Referals: "Рефералы",
    ReferralTitle: "Вознаграждение по реферальной программе",
    RefillFromCard: "Пополнение картой VISA/MC",
    RefillHistory: "История пополнения",
    RefillTheAccount:
      '<a href="/depositing.aspx">Пополните счет</a> удобным для вас способом, чтобы начать инвестировать с Nibble',
    RefillWithCard: "Пополнение с помощью карты",
    Registrations: "Регистрации",
    RegreshPage: "обновить страницу",
    ReinvestIncome: "реинвестировать доходы",
    Reinvestment: "реинвестирование",
    RepeatPassword: "Повторите пароль",
    Replenishment: "Пополнение портфеля, ежемесячно",
    Replenishments: "Пополнения",
    ResetPassword: "Сброс пароля",
    RestorePassword: "Новый пароль был выслан на телефон",
    RestorePasswordEmail:
      "Если адрес зарегистрирован, на него было отправлено сообщение",
    ReturnDate: "Дата возврата",
    ReturnMainPage: "Вернуться на главную страницу",
    RevenueFromRegistrationsAndRenewals: "Доход с регистраций и пополнений",
    Risks: "Риски",
    Save: "Сохранить",
    ScanHint:
      "Загрузите скан или фотографии паспорта или водительского удостоверения. Пожалуйста, загружайте читаемые и детальные изображения документов. Не закрывайте или иным образом не искажайте информацию в документе.",
    Selfie: "Автопортрет",
    SelfieHint:
      "Старайтесь, чтобы фотография вашего лица выглядела примерно так же как в паспорте — без засветов и искажений",
    SendMessageBtn: "Отправить сообщение",
    SendRequest: "Отправить запрос",
    SEPAInfo: "Пополнение доступно только резидентам SEPA.",
    ServiceUnavailable: "Сервис временно не доступен",
    Settings: "Настройки",
    ShareLink: "Поделиться ссылкой",
    ShowAllLoans: "Показывать все займы",
    SkipIdentification: "Назад",
    SmsCode: "Код из СМС",
    SmsCodeIsSent:
      "На указанный вами номер телефона было отправлено смс с кодом подтверждения. Введите полученный код",
    Sortby: "Сортировать по:",
    SortbyIncome: "[по] ожидаемому доходу",
    SortbyOpened: "[по] дате открытия",
    SortbyOperationDate: "[по] дате операции",
    SortbyReturnDate: "[по] дате возврата",
    SortbySum: "[по] сумме",
    StartDeposit: "Начальная сумма",
    Stats: "Статистика",
    Status: "Статус",
    STATUS_001: "Закрыт",
    STATUS_002: "Активен",
    STATUS_003: "Просрочен",
    STATUS_004: "Выполнена",
    STATUS_005: "Запланирована",
    STATUS_006: "Отклонена",
    StatusCanceled: "Отменена",
    StatusCompleted: "Завершена",
    StatusInprocess: "В процессе",
    Step1: "Первый шаг",
    Step2: "Второй шаг",
    StrategyBalancedDescription:
      "Доходность не фиксирована и, согласно статистике предыдущих периодов, может достигать 12–15% годовых. Наиболее сбалансированная стратегия в соотношении «риск — доходность»",
    StrategyBalancedTitle: "Сбалансированная",
    StrategyClassicDescription:
      "Доходность по данной стратегии фиксирована, обеспечена гарантией обратного выкупа и составляет 8% годовых. Стратегия обеспечивает отсутствие рисков и гарантированную доходность.",
    StrategyClassicTitle: "Классическая",
    StrategyDescription: `Выбирайте инвестиционную стратегию согласно вашим предпочтениям о доходности и риске. <br> Создавайте инвестиционный портфель в три шага.`,
    StrategySpecialDescription:
      "Доходность не фиксирована и может достигать 17–19% годовых. Инвестиционные риски выше, но при этом доходность позволяет компенсировать потери в рамках общей суммы инвестиционного портфеля",
    StrategySpecialTitle: "Специальная",
    StrategyStep1: "Шаг 1: выбор стратегии",
    StrategyStep2: "Шаг 2: расчет доходности",
    StrategyStep3: "Шаг 3: создание портфеля",
    StrategyTitle: "Гибкое инвестирование",
    InviteFriends: "Приглашайте друзей",
    OtherStrategy: `Классическая / Сбалансированная`,
    LegalStrategy: `Взыскание`,
    String: "Здесь хранится история движения всех ваших денежных средств",
    SuccessfullySaved: "Ваши настройки успешно сохранены",
    Sum: "Сумма",
    SumAmount: "Сумма пополнения",
    Support: "Техподдержка",
    SupportMessageSentMessage:
      "Ваше сообщение доставлено операторам. Первый освободившийся оператор ответит вам в европейское рабочее время",
    SupportTextareaPlaceholder: "Текст обращения или вопроса",
    SupportTitle: "Мы ответим на все ваши вопросы",
    SystemSettings: "Системные настройки",
    Term: "Срок",
    TermDays: "Срок, дней",
    TermMonths: "Срок, мес.",
    Test: "Тестовый",
    TestInvestmentsInfo:
      "Пробные инвестиции позволяют испытать сервис за короткий срок. Один пользователь может создать только один тестовый портфель на сумму не более 300 EUR.",
    ThankyouErrorText:
      "Проверка не удалась. Возможно мы не распознали фотографию вашего документа или произошел сбой связи. Не стоит волноваться, <a target=\"_top\" href='/profile'>попробуйте пройти верификацию еще раз</a>. Попробуйте использовать другой документ.",
    ThankyouErrorTitle: "Кажется что-то пошло не так...",

    ThankyouSuccessText:
      'Идентификация на 100% пройдена — создавайте первые инвестиции на Nibble. Мы уже настроили Личный кабинет и вам остается только <a target="_top" href="/depositing">пополнить баланс</a> и <Link target="_top" href="/profile">создать свой первый инвестиционный портфель</a>.',
    ThankyouSuccessTitle: "Все прошло отлично!",
    ThroughSocialNetworks: "Через социальные сети",
    ThroughSocialNetworks1: "Через социальные сети",
    TimeFormat: "Формат времени",
    Try: "Попробуйте",
    TutorialMessage0:
      "Мы можем рассказать вам об основных моментах работы в личном кабинете Nibble. Продолжить?",
    TutorialMessage1:
      "Вы можете рассчитать доходность вашего портфеля на калькуляторе",
    TutorialMessage2:
      "Чтобы начать инвестировать вам нужно пополнить баланс счета",
    TutorialMessage3: 'Управляйте своими портфелями в разделе "Мои инвестиции"',
    TutorialMessage4: "Получайте еще больший доход вместе со своими друзьями",
    TutorialMessage5:
      "Расскажем как создать инвестиционный портфель или о том, как работает система вцелом",
    Unavailable: "отсутствует",
    UserAgreement: {
      text_1: "Нажимая на кнопку “Продолжить” Вы принимаете ",
      text_1_legal: "Нажимая на кнопку “Отправить запрос” Вы принимаете ",
      text_link_1: "Пользовательское соглашение",
      text_2: ", а также ",
      text_link_2: "Политику конфидециальности компании NIBBLE",
      text_3: " ",
    },
    UserAgreement1:
      'Нажимая на кнопку “Продолжить” Вы принимаете <a href="/user_agreement.aspx">Пользовательское соглашение</a>, а также <a href="/policy_privacy.aspx"> Политику конфидециальности компании NIBBLE</a>',
    VERIFF_274: "Фотографии отсутствуют",
    VERIFF_275: "Изображение лица не распознано",
    VERIFF_276: "Документ отображается не полностью",
    VERIFF_277: "Низкое качество изображения",
    VERIFF_278: "Документ поврежден",
    VERIFF_279: "Данный тип документа не поддерживается",
    VERIFF_280: "Документ истек",
    VERIFF_282: "Другие причины",
    VeriffGuarantees: "Сервис Veriff гарантирует безопасность ваших данных.",
    VeriffGuaranteesHtml:
      '<span>Сервис <u id="veriffLink">Veriff</u> гарантирует безопасность ваших данных.</span>',
    VeriffInfo:
      "В соответствии с законодательными нормами ЕС, каждый инвестор платформы Nibble должен пройти верификацию личности перед началом работы. Процедура проходит в два этапа: вы загружаете фотографии вашего документа, удостоверяющего личность; а затем они проходят проверку нашей партнерской компании Veriff. Вся процедура верификации занимает не более 10 минут. Пожалуйста, приготовьте свой паспорт или удостоверение личности и убедитесь, что на фотографии четко видны все детали.",
    VeriffInProcess:
      "Документы проходят проверку сервисом Veriff — обычно это занимает несколько минут. </br> Пополнить счет не получится пока проверка не будет завершена",

    VeriffInfoTitle: "Пройти идентификацию личности",
    VeriffInfoDesc:
      "Nibble неукоснительно следует строгим стандартам Европейского законодательства в части противодействия легализации доходов (AML), верификации пользователей, хранения и использования персональных данных.",
    VeriffInfoQuest: "Насколько просто пройти цифровую идентификацию?",
    VeriffInfoAsk1:
      "Мы попросим вас сделать с помощью смартфона или компьютера фотографию одного из ваших документов — обычно это паспорт или водительские права.",
    VeriffInfoAsk2:
      "Далее, тем же способом вам нужно будет сделать селфи. Мы поможем выбрать правильный ракурс, чтобы фотография получилась у вас с первого раза.",
    VeriffInfoAsk3:
      "Проверка займет буквально несколько секунд и вы получите решение.",
    VeriffStartButton: "Начать верификацию",
    Cancel: "Позже",

    WeAreDoingAll: "Мы делаем все, чтобы это исправить.",
    WeeklyReport: "Еженедельный отчет",
    WeEnsureSecurity:
      'Мы обеспечиваем вашу безопасную идентификацию совместно с нашим партнером — сервисом <a href="https://www.veriff.com" target="_blank">Veriff</a>',
    WeWorkHonest:
      "Мы работаем честно и открыто. <br> И ценим, когда наши пользователи отвечают взаимностью",
    WidgetBringFriendLead:
      "Порекомендуйте нас друзьям и получите вознаграждение за каждую рекомендацию",
    WidgetHistoryLead:
      "Все пополнения счета, начисления доходов и выводы средств вы найдете здесь",
    WidgetInvestLead: "Центральный пункт управления вашими инвестициями",
    WidgetSupportLead:
      "С любыми вопросами и сомнениями вам помогут наши специалисты",
    WillAddXMonth:
      'мои вложения<br>за <span class="js-calcMonth">6</span> мес.',
    WillAddXMonth1: "мои вложения&nbsp;<br>за",
    WillAddXMonth2: "мес.",
    Withdrawal: "Списание",
    WithdrawalAmount: "Сумма вывода",
    WithdrawalHistory: "История вывода средств",
    WithdrawalInfo1: "Вывод будет осуществлён на привязанный номер счёта.",
    WithdrawalInfo2: "Минимальная сумма вывода 50 EUR",
    WithdrawalInfo3:
      "Вывод осуществляется на счёт, с которого было произведено первое пополнение",
    WithdrawalOfBalances: "Вывод остатков из портфеля",
    WithdrawalViaBankAccount: "Вывод через банковский счет",
    WithdrawFunds: "Вывести деньги",
    WithdrawFundsMobile: "Вывести",
    XActiveLoans: "займов активны",
    XClosedLoans: "займов закрыто",
    XInvestedLoans: "займов проинвестировано",
    XOverdueLoans: "займов просрочено",
    Yes: "Да",
    YourInvestmentsXMonth:
      'мои вложения за <span class="js-calcMonth"></span> мес.',
    ZIP: "Индекс",
    LowBalanceAlert:
      "На вашем балансе не хватает средств для создания портфеля с выбранными параметрами",
    LowBalanceAlertCommon: "На вашем балансе не хватает средств",
    NoBankAlert:
      "Вы не указали реквизиты банковского счета. Обратитесь в службу поддержки",

    // validation
    required: "Обязательное поле",
    regexDate: "Введите корректную дату",
    regexEmail: "Введите корректный e-mail",
    checkbox: "Поставьте отметку на обработку данных",
    regexNot: "Недопустимый формат",
    minlength: "",
    simple: "Простой",
    normal: "Нормальный",
    hard: "Сложный",

    //Tutorial
    step0:
      "Спасибо, что присоединились к Nibble! Пройдите идентификацию личности Veriff, чтобы пополнить баланс и начать инвестировать",
    step1: "Чтобы начать инвестировать вам нужно пополнить баланс счета",
    step2: "Вы можете рассчитать доходность вашего портфеля на калькуляторе",
    step3: 'Управляйте своими портфелями в разделе "Мои инвестиции"',
    step4: "Здесь хранится история движения всех ваших денежных средств",
    step5: "Получайте еще больший доход вместе со своими друзьями",
    step6:
      "Расскажем как создать инвестиционный портфель или о том, как работает система вцелом",
    step7:
      "Вы можете создать пробный портфель с максимальной суммой инвестирования 300 EUR сроком на 21 день",
    TutorialCancel: "Позже",
    TutorialConfirm: "Подтвердить сейчас",
    TutorialPrev: "Назад",
    TutorialNext: "Далее",
    TutorialFinal: "Завершить",

    NoticeMaxSum: "Максимальная сумма",
    NoticeMinSum: "Минимальная сумма",

    // StopWarNanner
    StopWarBannerTitle: "О текущей ситуации",
    StopWarBannerMore: "Подробнее об этом",
    StrategyTitleInvestClassic: "Классическая",
    StrategyTitleInvestBalanced: "Сбалансированная",

    // ------ Судебная ------

    JudicialTitle: `Доступные портфели`,
    JudicialPanelTitle: `Инвестируйте`,
    JudicialBabberTitle: `Nibble вводит новую стратегию инвестирования - Взыскание`,
    JudicialSlideBtn: `Инвестировать`,
    StrategyJudicialTitle: `Взыскание`,
    StrategyJudicialPanelTitle: `Взыскание`,
    TaglineStrategyJudicialPanel: `Высокий доход`,
    TaglineStrategyOtherPanel: `Взвешеные риски`,
    JudicialSubTitle: `стратегия`,
    JudicialCollectionEnd: `До окончания сбора:`,
    JudicialBtnText: `Инвестировать`,
    JudicialLabel: `Сумма инвестирования`,
    JudicialCollectionEnd2: `До окончания сбора`,
    JudicialCollectionCompleted: `Сбор завершен.`,
    JudicialCollectionCompletedSub: `Вы можете инвестировать в новый портфель.`,
    JudicialCollection: `Осталось собрать ХХХ1 из ХХХ2`,
    JudicialMoreStrategy: `Подробнее о стратегии`,
    JudicialGuarantee: `Все портфели, защишены гарантией`,
    JudicialGuaranteeDb: `Deposit back`,
    JudicialStateTitle: `Прогресс портфеля`, // Узнать перевод на других языках
    JudicialState1: `Собираем инвестиции для покупки портфеля`,
    JudicialState2: `Покупаем портфель`,
    JudicialState3: `Досудебное взыскание`,
    JudicialStateSub3: `Договариваемся с заемщиками`,
    JudicialState4: `Подача документов в суд`,
    JudicialState5: `Получаем решение суда`,
    JudicialState6: `Взыскиваем долг по решению суда через Банки и приставов`,
    JudicialState7: `Долги взысканы`,
    JudicialAgreement: `Соглашение`,
    JudicialGarantText: `Гарантия возврата депозита`,
    JudicialInfo: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>Эта стратегия инвестирования в портфели, состоящие из потребительских кредитов с классификацией В, СС и С, которые находятся в процессе досудебного и судебного взыскания. За счет того, что по этим кредитам есть просроченная задолженность и штрафы, доходность этой стратегии достигает до 19% годовых.</p>
        <p>Минимальный срок инвестирования 6 месяцев объясняется тем, что судебный процесс и процесс взыскания занимают длительный период времени. Весь судебный процесс и взыскание средств, обеспечивается компанией Boostr.</p>
        <p>Сопутсвующие риски: Риск невозврата кредита / невозврата всей положенной к погашению суммы кредита</p>

        <ul>
            <li>Стратегия обеспечена гарантией Deposit back - это обязательство коллекторского агенства вернуть тело инвестиции в полном объеме в конце срока инвестиции и обеспечить минимальную доходность 8% годовых.</li>
            <li>За счет инвестиции в портфель состоящий из большого кол-ва займов, снижен риск неполучения дохода от нескольких договоров, их перекрывают другие займы.</li>
            <li>Начисление ежедневное по 8% годовых, выплаты раз в квартал по фактически полученной доходности до 14,5% годовых.</li>
            <li>Пока собираются деньги на покупку портфеля, мы начисляем доход по 8% годовых - это ваша бонусная доходность к основной до 14,5%. Максимальный срок сбора денег на покупку портфеля - 30 дней.</li>
        </ul>
        <p>Как это работает?</p>
        <p>Вам ежедневно начисляются проценты по ставке 8% годовых. Каждые 90 дней мы автоматически рассчитываем фактическую доходность судебных портфелей и доначисляем вам разницу между гарантированной ставкой 8% и фактической ставкой. Таким образом каждые 90 дней вы получаете доход от 8% до 14,5%, на ваш счет Nibble.</p>
        <p>Пример: Инвестировав 1000 евро на 12 месяцев, в конце срока вы получаете обратно весь свой капитал 1000 евро и доход от 90 до 145 евро, которые мы выплачиваем вам ежеквартально.</p>
        </div></div></div>`,

    JudiciaDb: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>Стратегия Взыскание</p>
        <p>Стратегия обеспечена гарантией Deposit back - это обязательство коллекторского агенства вернуть тело инвестиции в полном объеме в конце срока инвестиции и обеспечить минимальную доходность 8% годовых.</p>
        <p>Как это работает?</p>
        <p>Вам ежедневно начисляются проценты по ставке 8% годовых. Каждые 90 дней мы автоматически рассчитываем фактическую доходность судебных портфелей и доначисляем вам разницу между гарантированной ставкой 8% и фактической ставкой. Таким образом каждые 90 дней вы получаете доход от 8% до 14,5%, на ваш счет Nibble.</p>
        <p>Пример: Инвестировав 1000 евро на 12 месяцев, в конце срока вы получаете обратно весь свой капитал 1000 евро и доход от 90 до 145 евро, которые мы выплачиваем вам квартально.</p>
        </div></div></div>`,

    JudicialSlide: `
        <div class="judicial-slide__title">
        <div class="judicial-slide__title-head">
            Nibble вводит новую стратегию инвестирования - Взыскание
        </div>
        <div class="judicial-slide__title-sub">
            <p>С сегодняшнего дня нашим инвесторам доступна новая стратегия инвестирования, которая отличается высокой и прогнозируемой доходностью до 14,5% годовых. И гарантией Deposit back.</p>
            <p>Также для того, что бы соблюдать баланс доходности в текущей ситуации на рынке и требования регулятора, мы обновляем процентные ставки на новые портфели стратегий Классическая и Сбалансированая. Ставки по уже существующим портфелями не меняются.</p>
        </div>
        
        
        <div class="judicial-slide__title-mini">
            Классическая - 8% годовых
        </div>
        <div class="judicial-slide__title-mini">
            Сбалансированая - 12,5% годовых
        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                О продукте
            </div>

            <div class="judicial-slide__sub-text">
                <p>У любой финансовой компании, занимающейся кредитованием неизбежно появляются займы, которые не возвращаются в сроки оговоренные контрактом. Многие компании продают такие займы большими портфелями на аукционах со скидкой до 85%, что бы быстрее вернуть часть денег в бизнес.</p>
                <p>Такие портфели покупаются на аукционах компанией Boostr.</p>
                <p>Под этим брендом работают компании, занимающиеся возвратом задолжености по просроченым займам Joymoney, а также покупкой просроченых займов других компаний для дальнейшего взыскания. Благодаря накопленному опыту и технологиями разработанным внутри компании Boostr, удается достигать высокого процента возврата капитала. В Евразии компания имеет опыт работы более 5 лет и штат сотрудником более 80 человек.</p>
                <p>На территории Европы Boostr работает в партнерстве с коллекторскими агентствами, которые ведут работу по взысканию задолженности Европейских займов.</p>
                <p>С 2019 года на испанском рынке начали активно появляться платформы-аукционы по продаже портфелей, такие как Debex и NLPBroker, что в свою очередь говорит о росте рынка в целом. Так же на рынке есть множество коллекторских организации, которые занимаются досудебной и судебной работой. По данным, предоставленным нашими партнерами, занимающимися управлением сбора долгов более 25 лет, доходность инвестора может достигать до 19% годовых.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Историческая доходность
            </div>

            <div class="judicial-slide__stend">
                <div class="judicial-slide__block">
                    <div class="judicial-slide__block-title">
                        Был куплен портфель.
                    </div>
                    <div class="judicial-slide__purchase-list">

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Купили за
                            </div>
                            <div class="judicial-slide__purchase-money">
                                € 117 801
                            </div>
                        </div>

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Долгов в нем на 
                            </div>
                            <div class="judicial-slide__purchase-money">
                                € 1 328 123
                            </div>
                        </div>
                    </div>

                    <div class="judicial-slide__explanation">
                            <div class="judicial-slide__explanation-icon">
                                <div class="judicial-slide__explanation-smiley" ></div>
                            </div>
                            <div class="judicial-slide__explanation-text">
                                То есть мы купили портфель <br /> с потенциалом € 1 328 123 за € 117 801
                            </div>
                        </div>

                        <div class="judicial-slide__block-info">
                            <div class="judicial-slide__block-collected">
                                <div class="judicial-slide__collected-title">
                                    За первый год мы взыскали:
                                </div>
                                <div class="judicial-slide__collected-money">
                                    €&nbsp;143&nbsp;107
                                </div>
                                <div class="judicial-slide__collected-description">
                                    что на € 25 306 больше чем наша инвестиция. А это больше 20% годовых
                                </div>
                            </div>

                            <div class="judicial-slide__block-description">
                                <div class="judicial-slide__description-icon">
                                    <div class="judicial-slide__description-info-icon"></div>
                                </div>
                                <div class="judicial-slide__block-description-text">
                                    После первого года взыскания, мы можем продать оставшиеся в портфеле займы на аукционе за €&nbsp;70&nbsp;343, даст нам в итоге €&nbsp;95&nbsp;649 дохода
                                </div>
                            </div>
                        </div>

                        
                        <div class="judicial-slide__strategy">
                            <div class="judicial-slide__strategy-title">
                                Статистика портфеля
                            </div>
                            <div class="judicial-slide__strategy-diagram">
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        € 117 801
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom1">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Стоимость портфеля
                                    </div>
                                </div>
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        € 143 107
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom2">
                                        Доход €&nbsp;25&nbsp;306
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Взыскали за первый год
                                    </div>
                                </div>          
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        € 270 784
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom4">
                                        Доход €&nbsp;152&nbsp;983
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Взыскали за второй год
                                    </div>
                                </div>          
                            </div>

                            <div class="judicial-slide__strategy-earned">
                                <div class="judicial-slide__strategy-label">
                                    Заработано за 2 года:
                                </div>
                                <div class="judicial-slide__strategy-sum">
                                    €&nbsp;152&nbsp;983
                                </div>
                            </div>
                        </div>
                </div>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                На основе этого бизнеса, мы разработали стратегию Взыскание.
            </div>

            <div class="judicial-slide__sub-text">
                Эта стратегия инвестирования в портфели, состоящие из потребительских кредитов с классификацией В, СС и С, которые находятся в процессе досудебного и судебного взыскания. За счет того, что по этим кредитам есть просроченная задолженность и штрафы, доходность этой стратегии достигает до 19% годовых. Минимальный срок инвестирования 6 месяцев объясняется тем, что судебный процесс и процесс взыскания занимают длительный период времени.
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Сопутствующие риски:
            </div>

            <div class="judicial-slide__title-small">
                Риск невозврата кредита / невозврата всей положенной к погашению суммы кредита
            </div>

            <div class="judicial-slide__sub-text">
                <ul class="judicial-slide__roll">
                    <li class="judicial-slide__element">Стратегия обеспечена гарантией Deposit back - это обязательство коллекторского агентства вернуть тело инвестиции в полном объеме в конце срока инвестиции и обеспечить минимальную доходность 8% годовых.</li>
                    <li class="judicial-slide__element">За счет инвестиции в портфель состоящий из большого кол-ва займов, снижен риск неполучения дохода от нескольких договоров, их перекрывают другие займы.</li>
                    <li class="judicial-slide__element">Начисление ежедневное по 8% годовых, выплаты раз в квартал по фактически полученной доходности до 14,5% годовых.</li>
                    <li class="judicial-slide__element">Пока собираются деньги на покупку портфеля, мы начисляем доход по 8% годовых - это ваша бонусная доходность к основной до 14,5%. Максимальный срок сбора денег на покупку портфеля - 30 дней.</li>
                </ul>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Как это работает?
            </div>

            <div class="judicial-slide__sub-text">
                Вы выбираете портфель по вашим предпочтениям на витрине и инвестируете в него. Пока портфель находится в процессе сбора денежных средств вам начисляется 8% годовых ежедневно. После окончания сбора вам так же ежедневно начисляются проценты по ставке 8% годовых, а каждые 90 дней мы автоматически рассчитываем фактическую доходность судебных портфелей и доначисляем вам разницу между гарантированной ставкой 8% и фактической ставкой до 14,5% годовых. Таким образом каждые 90 дней вы получаете доход от 8% до 14,5%, на ваш счет Nibble.
            </div>

            <div class="judicial-slide__sub-text-mini">
                Пример: Инвестировав 1000 евро на 12 месяцев, в конце срока вы получаете обратно весь свой капитал 1000 евро и доход от 80 до 145 евро, которые мы выплатим на ваш счет в Nibble
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Как мы зарабатываем деньги для инвесторов:
            </div>

            <div class="judicial-slide__sub-text">
                <ol class="judicial-slide__roll">
                    <li class="judicial-slide__element">Boostr собирает судебные портфели из просроченных займов Joymoney и выкупают подобные портфели у других банков и МФО на аукционах, с дисконтом 85%.</li>
                    <li class="judicial-slide__element">Начинается процесс досудебного взыскания, где агентство связывается с заемщиком и пытается договориться о возврате долга.</li>
                    <li class="judicial-slide__element">Если договориться не удалось, то начинается процесс судебного делопроизводства, для получения судебного решения о взыскании долга с должника. Который ведет Boostr или его пертнер.</li>
                    <li class="judicial-slide__element">После получения судебного решения, через службы судебных приставов и банки происходит взыскание долга, процентов и штрафов.</li>
                </ol>
            </div>

        </div>
    </div>
        `,
    legalTitle: `Взыскание`,
    legalInfoTitle1: `О продукте`,
    legalInfoTitle2: `Историческая доходность`,
    legalInfoTitle3: `На основе этого бизнеса, мы разработали стратегию Взыскание.	`,
    legalInfoTitle4: `Сопутствующие риски`,
    legalInfoTitle5: `Как это работает?`,
    legalInfoTitle6: `Как мы зарабатываем деньги для инвесторов`,
    legalInfoText1: `
        <p>У любой финансовой компании, занимающейся кредитованием неизбежно появляются займы, которые не возвращаются в сроки оговоренные контрактом. Многие компании продают такие займы большими портфелями на аукционах со скидкой до 85%, что бы быстрее вернуть часть денег в бизнес.</p>
        <p>Такие портфели покупаются на аукционах компанией Boostr.</p>
        <p>Благодаря накопленному опыту и технологиями разработанным внутри компании Boostr, удается достигать высокого процента возврата капитала. В Евразии компания имеет опыт работы более 5 лет и штат сотрудником более 80 человек.</p>
        <p>На территории Европы Boostr работает в партнерстве с коллекторскими агентствами, которые ведут работу по взысканию задолженности Европейских займов.</p>
        <p>С 2019 года на испанском рынке начали активно появляться платформы-аукционы по продаже портфелей, такие как Debex и NLPBroker, что в свою очередь говорит о росте рынка в целом. Так же на рынке есть множество коллекторских организации, которые занимаются досудебной и судебной работой. По данным, предоставленным нашими партнерами, занимающимися управлением сбора долгов более 25 лет, доходность инвестора может достигать до 19% годовых.</p>
        `,
    legalInfoText2: `
        <div class="judicial-slide__stend">
          <div class="judicial-slide__block">
              <div class="judicial-slide__block-title">
                  Был куплен портфель.
              </div>
              <div class="judicial-slide__purchase-list">

                  <div class="judicial-slide__purchase-item">
                      <div class="judicial-slide__purchase-info">
                          Купили за
                      </div>
                      <div class="judicial-slide__purchase-money">
                          € 117 801
                      </div>
                  </div>

                  <div class="judicial-slide__purchase-item">
                      <div class="judicial-slide__purchase-info">
                          Долгов в нем на 
                      </div>
                      <div class="judicial-slide__purchase-money">
                          € 1 328 123
                      </div>
                  </div>
              </div>

              <div class="judicial-slide__explanation">
                      <div class="judicial-slide__explanation-icon">
                          <div class="judicial-slide__explanation-smiley" ></div>
                      </div>
                      <div class="judicial-slide__explanation-text">
                          То есть мы купили портфель <br /> с потенциалом € 1 328 123 за € 117 801
                      </div>
                  </div>

                  <div class="judicial-slide__block-info">
                      <div class="judicial-slide__block-collected">
                          <div class="judicial-slide__collected-title">
                              За первый год мы взыскали:
                          </div>
                          <div class="judicial-slide__collected-money">
                              €&nbsp;143&nbsp;107
                          </div>
                          <div class="judicial-slide__collected-description">
                              что на € 25 306 больше чем наша инвестиция. А это больше 20% годовых
                          </div>
                      </div>

                      <div class="judicial-slide__block-description">
                          <div class="judicial-slide__description-icon">
                              <div class="judicial-slide__description-info-icon"></div>
                          </div>
                          <div class="judicial-slide__block-description-text">
                              После первого года взыскания, мы можем продать оставшиеся в портфеле займы на аукционе за €&nbsp;70&nbsp;343, даст нам в итоге €&nbsp;95&nbsp;649 дохода
                          </div>
                      </div>
                  </div>

                  
                  <div class="judicial-slide__strategy">
                      <div class="judicial-slide__strategy-title">
                          Статистика портфеля
                      </div>
                      <div class="judicial-slide__strategy-diagram">
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  € 117 801
                              </div>
                              <div class="judicial-slide__strategy-block-bottom1">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Стоимость портфеля
                              </div>
                          </div>
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  € 143 107
                              </div>
                              <div class="judicial-slide__strategy-block-bottom2">
                                  Доход €&nbsp;25&nbsp;306
                              </div>
                              <div class="judicial-slide__strategy-block-bottom3">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Взыскали за первый год
                              </div>
                          </div>          
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  € 270 784
                              </div>
                              <div class="judicial-slide__strategy-block-bottom4">
                                  Доход €&nbsp;152&nbsp;983
                              </div>
                              <div class="judicial-slide__strategy-block-bottom3">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Взыскали за второй год
                              </div>
                          </div>          
                      </div>

                      <div class="judicial-slide__strategy-earned">
                          <div class="judicial-slide__strategy-label">
                              Заработано за 2 года:
                          </div>
                          <div class="judicial-slide__strategy-sum">
                              €&nbsp;152&nbsp;983
                          </div>
                      </div>
                  </div>
          </div>
      </div>
        `,
    legalInfoText3: `
          <p>Эта стратегия инвестирования в портфели, состоящие из потребительских кредитов с классификацией В, СС и С, которые находятся в процессе досудебного и судебного взыскания. За счет того, что по этим кредитам есть просроченная задолженность и штрафы, доходность этой стратегии достигает до 19% годовых. Минимальный срок инвестирования 6 месяцев объясняется тем, что судебный процесс и процесс взыскания занимают длительный период времени.</p>
        `,
    legalInfoText4: `
        <strong>
          Риск невозврата кредита / невозврата всей положенной к погашению суммы кредита
        </strong>
        <ul class="legal-list__point">
          <li>Стратегия обеспечена гарантией Deposit back - это обязательство коллекторского агентства вернуть тело инвестиции в полном объеме в конце срока инвестиции и обеспечить минимальную доходность 8% годовых.</li>
          <li>За счет инвестиции в портфель состоящий из большого кол-ва займов, снижен риск неполучения дохода от нескольких договоров, их перекрывают другие займы.</li>
          <li>Начисление ежедневное по 8% годовых, выплаты раз в квартал по фактически полученной доходности до 14,5% годовых.</li>
          <li>Пока собираются деньги на покупку портфеля, мы начисляем доход по 8% годовых - это ваша бонусная доходность к основной до 14,5%. Максимальный срок сбора денег на покупку портфеля - 30 дней.</li>
        </ul>
        `,
    legalInfoText5: `
        <p>Вы выбираете портфель по вашим предпочтениям на витрине и инвестируете в него. Пока портфель находится в процессе сбора денежных средств вам начисляется 8% годовых ежедневно. После окончания сбора вам так же ежедневно начисляются проценты по ставке 8% годовых, а каждые 90 дней мы автоматически рассчитываем фактическую доходность судебных портфелей и доначисляем вам разницу между гарантированной ставкой 8% и фактической ставкой до 14,5% годовых. Таким образом каждые 90 дней вы получаете доход от 8% до 14,5%, на ваш счет Nibble.</p>
        <p>Пример: Инвестировав 1000 евро на 12 месяцев, в конце срока вы получаете обратно весь свой капитал 1000 евро и доход от 90 до 145 евро, которые мы выплатим на ваш счет в Nibble</p>
        `,
    legalInfoText6: `
        <ol class="legal-list__num">
          <li>Boostr собирает судебные портфели из просроченных займов банков и МФО на аукционах, с дисконтом 85%.</li>
          <li>Начинается процесс досудебного взыскания, где агентство связывается с заемщиком и пытается договориться о возврате долга.</li>
          <li>Если договориться не удалось, то начинается процесс судебного делопроизводства, для получения судебного решения о взыскании долга с должника. Который ведет Boostr или его пертнер.</li>
          <li>После получения судебного решения, через службы судебных приставов и банки происходит взыскание долга, процентов и штрафов.</li>
        </ol>
        `,

    refLinkMenu1: `Условия программы`,
    refLinkMenu2: `Мои приглашения`,
    refLinkTab1: `Ожидают`,
    refLinkTab2: `Бонус получен`,
    refLinkTab3: `Бонуса нет`,
    refInviteFriendsTitle1: `Приглашайте друзей`,
    refInviteFriendsSubTitle1: `Получайте вознаграждение`,
    refInviteFriendsText1: `до € 1000 вам и вашему другу`,
    refInviteFriendsBTN1: `Пригласить друзей`,
    refInviteFriendsSubTitle2: `Как это работает?`,
    refInviteFriendsStepTitle1: `Вы приглашаете друга на Nibble`,
    refInviteFriendsStepText1: `Отправьте им вашу ссылку для регистрации`,
    refInviteFriendsStepTitle2: `Он становятся инвестором`,
    refInviteFriendsStepText2: `У друга есть 3 месяца, что бы создать портфель`,
    refInviteFriendsStepTitle3: `Вы с другом получаете бонус`,
    refInviteFriendsStepText3: `Размер бонуса зависит от размера инвестиций друга`,
    refInviteFriendsTitle2: `От чего зависит размер вознаграждения?`,
    refInviteFriendsText2: `Размер бонуса зависит оттого, сколько твой друг проинвестирует в течение 3 месяцев с дня регистрации`,
    refInviteFriendsBonus: `Бонус&nbsp;2%`,
    refInviteFriendsSum: `Сумма инвестиций друга`,
    refInviteFriendsTitle3: `Что еще влияет?`,
    refInviteFriendsInfoTitle1: `Сумма инвестиций`,
    refInviteFriendsInfoText1: `Сумма всех инвестиций друга должна быть больше €500`,
    refInviteFriendsInfoTitle2: `Длительность инвестиций`,
    refInviteFriendsInfoText2: `Учитываются только портфели с длительностью от 3х месяцев`,
    refInviteFriendsBoxTitle1: `Инвестируйте с друзьями в Nibble`,
    refInviteFriendsBoxText1: `Наша платформа подходит как новичкам, там и опытным инвесторам`,
    yourReferralLink: `Ваша реферальная ссылка`,
    refInviteFriendsBTN2: `Скопировать ссылку`,
    refMyInvitationsTitle1: `Мои приглашения`,
    refMyInvitationsTotal: `Всего заработано`,
    refMyInvitationsFriends: `Друзей зарегистрировалось`,
    refMyInvitationsGetBonus: `Бонус получен`,
    refMyInvitationsTitle2: `Ваша реферальная ссылка`,
    refMyInvitationsTitle3: `Мои приглашения`,
    refMyInvitationsNO: `У вас еще нету приглашенных друзей, поделитесь с ними вашей реферальной ссылкой`,
    bonusPeriodEnd: `Конец бонусного периода`,
    yourBonus: `Ваш бонус`,
    bannerTetx: `Юридическая стратегия снова доступна! <span class="banner-BB__text-i">Инвестируйте по высокой процентной </span> ставке и зарабатывайте<span class="banner-BB__text-i"> с Nibble! </span>`,
  },
  EN: {
    Out: "out of",
    PortfolioTitle: "Your portfolios",
    UntilTheEnd: "Until the end of investment",
    TabsActive: "Active",
    TabsClose: "Closed",
    TabsDraft: "Draft",
    LoansInvesting: "Invested loans",
    LoansActive: "Active loans",
    LoansClose: "Closed loans",
    LoansDebt: "Legal",
    LoansBought: "Bought back",
    Hello: "Hello",
    MonthOne: "month",
    MonthSeveral: "months",
    MonthMany: "months",
    Delete: "Delete",
    //
    ResultPaymentErrorTitle: "Transaction refused by the bank.",
    ResultPaymentErrorInfo:
      "You can top up your account using a bank transfer or one of these services:",
    LimitContentTitle:
      "This month, you have already made deposits in the amount of /1/.",
    LimitContentDescription1:
      "According to the standars of the European law, we can accept up to /1/ a month from you.",
    LimitContentList1: "Until /1/ you can top up your account for /2/.",
    LimitContentList2:
      "From /1/ you can top up your account for any sum of money less than /2/.",
    LimitContentDescription2:
      "If you plan on investing more, please contact us in any way you like, and we will help you.",
    //
    DepositTabsTitle1: "card",
    DepositTabsTitle2: "Bank transfer",
    DepositTabsTitle3: `To change your personal information, please contact support.`,
    DepositTabsTitle3_EN: `To change your personal information, please contact support. <br /> 
    Currently, only Mastercard is supported. Withdrawal on Visa is in the process.`,
    DepositTabsTitle4: `The withdrawal of funds will be made to the linked account number.`,
    DepositDescriptionCardDesk:
      "Please keep in mind that your bank may set limits on transactions made by card. If you fail to top-up your account by card, you can contact your bank to solve the problem or deposit your account by bank transfer.",
    DepositDescriptionCardMobile:
      "If you fail to top-up your account by card, you can contact your bank to solve the problem or deposit your account by bank transfer.",
    DepositDescriptionBankDesk:
      "Transfer funds to the indicated bank account. Please, make sure to copy the transaction description.\n" +
      "Deposit of funds is available for SEPA residents only",
    DepositDescriptionBankMobile:
      "Deposit of funds is available for <b>SEPA residents only</b>",
    //
    OtherLabel: "Other",
    RangeInvestmentAmount: "Investment amount /min/ to /max/",
    RangeInvestmentTerm: "Investment period (months) /min/ to /max/",
    ValidationAmountMin: "The minimum amount is /min/",
    ValidationAmountMax: "The maximum amount is /max/",
    ValidationTermMinMax: "From /min/ to /max/ months",
    AvailableForInvesting: "Available for investing",
    WeeklyInterestPay: "Weekly interest payout",
    FirstPayment: "First payout",
    ClassicDescription:
      "Fixed income, secured by a buyback guarantee, amounts to 9.7% per annum. This is a risk-free strategy with guaranteed income on your investments. The reinvestment of the invested funds is enabled by default.",
    BalancedDescription:
      "Income is not fixed and might come up to 13% per annum according to the previous statistics. This is the most balanced strategy in terms of a risk-reward ratio. The reinvestment of the invested funds is enabled by default.",
    SpecialDescription:
      "Income is not fixed and might come up to 17–19% per annum. Though having higher investment risks, this strategy allows compensating for possible losses within the total amount of the investment portfolio. The reinvestment of the invested funds is enabled by default.",
    NextMoreText: "More",
    BackButton: "Back",
    CalculatorInfoTitle: "Thanks for getting started with Nibble!",
    CalculatorInfoDescription:
      "Choose your investment strategy according to your income and risk expectations.",
    CalculatorListTitle: "Create an investment portfolio in three steps:",
    CalculatorListItem1: "Identify yourself with Veriff",
    CalculatorListItem2: "Top up your account balance",
    CalculatorListItem3: "Create your first portfolio.",
    StrategyNameClassic: "Classic",
    StrategyNameBalanced: "Balanced",
    StrategyNameSpecial: "Special",
    IdentifyYourself: "Identify yourself",
    CurrentAnnualRate: "Current annual interest rate",
    //
    IdentificationDescription:
      "According to the standards of European law, we have to verify your identity.",
    //
    bannerAchive: "Summer Rally",
    bannerInfo:
      "Don’t miss an opportunity to earn more – with the rate of 11.7% under the Classic Strategy for the portfolios created&nbsp;the&nbsp;1st&nbsp;July&nbsp;to&nbsp;the&nbsp;31st&nbsp;August&nbsp;2021.",
    //
    PaymentsOpertions_334: "Card account replenishment",
    PaymentsOpertions_150: "Bank transfer account replenishment",
    PaymentsOpertions_355: "Bonus accrual",
    //
    NoLinkDocsAlert:
      'To download the documents you need to fill in the fields of "Personal information" section',
    NoticeDepositingCard:
      "Please keep in mind that your bank may set limits on transactions made by card. If you fail to top-up your account by card, you can contact your bank to solve the problem or deposit your account by bank transfer.",
    //
    AboutTheBorrower: "About the lender",
    AboutVeriff:
      "Veriff is a company which provides a user identification service, and which is trusted by European governments, leading banks, companies and services of the fintech industry and online stores.",
    AccountNumber: "Account number",
    AccountSumAvailable: "available on your account",
    AccuredIncome: "accrued income",
    ActiveLoans: "active loans",
    ActivePortfolio: "current portfolio",
    AdditionalAgreement: "additional agreement",
    Address: "Residential address",
    AddressLine1: "Adress 1",
    AddressLine2: "Adress 2",
    Agreement: "agreement",
    All: "All",
    AlreadyHaveAccount: "Already have an account? Log in",
    AnnualInterestRate: "current annual </br> interest rate",
    AnnualInterestRateClassic: "fixed annual <br> interest rate",
    ApplicationReceivedMessage:
      "We have received your application. Our manager will contact you soon. Thanks!",
    ApplyPromoCode: "Apply a promo code",
    AreYouSure: "Are you sure?",
    Articles: "Articles",
    AverageInterest: "weighted average interest rate",
    Balance: "Balance",
    BalanceReplenishment: "BalanceReplenishment",
    Bank: "Bank",
    BankAccountNumber: "Number of bank account",
    BankName: "Bank name",
    BankTransferReplenishment: "Bank transfer account replenishment",
    BankTransferWithdrawal: "Bank Transfer Withdrawal",
    CardTransferWithdrawal: "Withdrawal by card",
    Basic: "General",
    BirthDate: "Date of birth",
    Borrower: "Borrower",
    BorrowingCompany: "borrowing company",
    BringFriend: "Bring a friend",
    BuybackGuarantee: "BuyBack Guarantee",
    c11: "Russia",
    c12: "Austria",
    c197: "No reinvestment",
    c198: "Full reinvestment",
    c199: "Reinvestment principal",
    c206: "Spain",
    c208: "Belgium",
    c242: "Bulgaria",
    c243: "United Kingdom",
    c244: "Hungary",
    c245: "Germany",
    c246: "Greece",
    c247: "Denmark",
    c248: "Ireland",
    c249: "Italia",
    c250: "Cyprus",
    c251: "Latvia",
    c252: "Lithuania",
    c253: "Luxembourg",
    c254: "Malta",
    c255: "Netherlands",
    c256: "Poland",
    c257: "Portugal",
    c258: "Romania",
    c259: "Slovakia",
    c260: "Slovenia",
    c261: "Finland",
    c262: "France",
    c263: "Croatia",
    c264: "Czechia",
    c265: "Sweden",
    c266: "Switzerland",
    c267: "Estonia",
    c270: "Joymoney Russia (coming soon)",
    c271: "Joymoney Spain",
    c272: "Joymoney Mexico (coming soon)",

    c274: "Photos missing",
    c275: "Face not clearly visible",
    c276: "Full document not visible",
    c277: "Poor image quality",
    c278: "Document damaged",
    c279: "Document type not supported",
    c280: "Document expired",
    c281: "Approved",
    c282: "Other reasons",
    c283: "Expired",

    CalculatorNote:
      "The reinvestment of the invested funds is enabled by default, and all income received from the investment will be transferred to your Nibble account on a weekly basis",
    CapitalReinvestment: "capital reinvestment",
    CardInfo:
      "We are working on expanding ways to deposit funds into your Nibble account. Soon you will be able to deposit from your debit or credit card.",
    CashbackForFriends: "Cashback for a friend's investment",
    CashbackForInvestments: "Cashback for your investments",
    CashDeposit: "Deposit funds",
    ChangePassword: "Change password",
    ChoiceOf70: "Choice of 70% of investors",
    ChoosePortfolioType: "Choose the type of portfolio",
    City: "City",
    ClosedLoans: "Closed loans",
    ClosingDate: "Closing date",
    CompanyHeadName: "Name of head",
    CompanyName: "The name of the company",
    CompleteRegistration:
      "Complete the registration with your identification in order to refill your balance and start investing",
    Confirm: "Confirm",
    ConfirmationLinkSent: "A confirmation link has been sent to your email",
    Continue: "Сontinue",
    ContractsAndDocs: "Documents and agreements",
    Country: "Country",
    CountryOfIssue: "Country of issue",
    CountryOfResidence: "Country of residence",
    Code: "Code",
    CreateAccount: "Create account",
    CreatePortfolio: "Create portfolio",
    CreatePortfolioInfo:
      "If selected, all the income received will be reinvested in order for you to generate even more returns. By default, all the income from investments is deposited to your Nibble account and is available for withdrawal as the loans are repaid.",
    CreateTestPortfolio: "Create a trial portfolio",
    CurrentBalance: "Current Balance",
    CurrentIncome: "Current income",
    CurrentlyOnYourAccount: "currently on your account",
    CurrentPassError: "Current password is invalid",
    CurrentPassword: "Current password",
    DailyReport: "Daily report",
    DateFormat: "Date format",
    DaysLabel: "days",
    DepositAccount: "Deposit the account",
    DepositAccountMobile: "Deposit",
    DepositFunds: "Refill",
    DepositHistory: "Deposit history",
    DepositPortfolio: "Refill the portfolio",
    DepositViaBankAccount: "Deposit via bank account",
    DocBackScan: "Photo of the back of your ID document",
    DocFrontScan: "Photo of the front of your ID document",
    DocPhoto: "Photo of the document",
    DocType: "Document type",
    Document: "Document",
    DownloadAgreement: "Download agreement",
    DownloadWarning: "To download the contract, please provide required",
    DownloadWarningNext: "personal information",
    Email: "Email",
    EmailAlreadyReg: "This email address is already used in the system",
    EmailChangeInfo: "To change your email address, please contact support",
    EnabledByDefault: "enabled by default",
    ERROR_001:
      "You do not have enough funds on your balance to create a portfolio with selected parameters",
    ERROR_002: "No countries selected",
    ERROR_003: "Unknown error",
    ERROR_004: "Not valid amount",
    ERROR_005: "Only one test portfolio is allowed",
    ERROR_006: "Selected investment amount does not match balance sheet",
    ErrorEmailLength: "E-mail cannot be empty",
    ErrorEmailLogin: "Invalid email format",
    ErrorEmailPassLogin: "Email or password mismatch",
    ErrorEmptyFields: "Not all required fields are filled in.",
    ErrorFirstNameLength: "You have not indicated your name.",
    ErrorLastNameLength: "You have not indicated your last name.",
    ErrorLoadDocument:
      "To download the contract, you need to fill in your date of birth and address on the settings page",
    ErrorPhoneFormat: "The phone number is incorrect.",
    ErrorPromoCode: "Invalid promo code is indicated.",
    Exit: "Logout",
    ExpectedAnnualReturn: "Expected annual return",
    ExpectedClosingDate: "Expected closing date",
    ExpectedIncome: "expected income",
    FacePhoto: "Take a selfie",
    Finish: "Finish",
    FirstName: "First name",
    FirstStep: "First step of registration",
    ForBusiness: "for business",
    ForgotPassword: "Forgot your password?",
    FormatDate1: "yyyy-MM-dd",
    FormatDate2: "yyyy/MM/dd",
    FormatDate3: "MM/dd/yyyy",
    FormatDate4: "MM-dd-yyyy",
    From3To60Months: "from 3 to 60 months",
    Full: "Full",
    FundsWithdrawal: "Withdraw funds",
    Gender: "Gender",
    GetSMSCode: "Get the verification code",
    GoIdent: "Pass the user identification process",
    GoToAccount: "Go to your account",
    Help: "Help",
    History: "Transaction History",
    HowItWorks: "How does it work?",
    HugeAmountWarning:
      "Per investire più di 10.000 € devi superare una verifica aggiuntiva",

    HelperRisksTitle: "Classification of Loans by the Risk of Default",
    // eslint-disable-next-line
    HelperRisksText:
      'The companies of the IT Smart Finance holding use scoring models to determine the quality of borrowers.</p> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>AA</strong></td> <td><strong>A</strong></td> </tr> <tr> <td>closed on time</td> <td>closed ahead of schedule</td> </tr> <tr> <td colspan="2">Low-risk loans. As a rule, clients of this category return the money on time or ahead of schedule, so the profitability on them is low, but the risks are also low.</td> </tr> <tr> <td><strong>BB</strong></td> <td><strong>B</strong></td> </tr> <tr> <td>NPL 0-30</td> <td>NPL 30-60</td> </tr> <tr> <td colspan="2">Medium risk loans. Clients of this category&nbsp;can make payment&nbsp;delays (NPL 30 and NPL 60) but almost always return the loans in the end. The risk of default for this category is higher, but the average income is also higher.</td> </tr> <tr> <td><strong>CC</strong></td> <td><strong>C</strong></td> </tr> <tr> <td>NPL 60-90</td> <td>NPL 90-120</td> </tr> <tr> <td colspan="2">Loans with an increased level of risk. In this category there are NPL 60, NPL 90, NPL 120 and loans under litigation, that provide the maximum profitability among all the strategies.</td> </tr> </tbody> </table> <p>All approved loans are appropriately classified and sorted out according to the investment strategies.&nbsp;Once a month the Risk Committee analyses and adjusts the process of loan classification assignment.',
    HelperAnnualRateTitle: "Annual interest rate",
    HelperAnnualRateText:
      "The return rate is specified and approved every month by the Risk Committee and depends on the audited period&#39;s results.",
    HelperStrategyClassicTitle: "Classic Strategy with BuyBack Guarantee",
    HelperStrategyClassicText:
      "You invest in unsecured consumer loans classified as AA, A, BB, for which the borrower&#39;s risk of going into a payment delay is very low. With the buyback guarantee, you are protected from risks and receive a guaranteed income at a fixed interest rate.</p> <p><strong>Associated Risks</strong></p> <p><strong>Risk of non-repayment of the loan/violation of the repayment schedule/non-return of the entire loan amount due to repayment.</strong></p> <p>These investor risks are secured by a buyback guarantee of the received assets and interests. Let&#39;s take a closer look at how it works: the Nibble investor, choosing this strategy, invests in loans issued by the companies of the IT Smart Finance group, which are available on the day of investment. The holding company places the given loan on the Nibble platform to find an investor. The relation between the IT Smart Finance group of companies and the final borrower is governed by a short-term consumer loan agreement with the rights of claim against the borrower arising from it. Based on the Assignment Agreement made with the investor, Nibble assumes obligations to receive payments from the final borrower made to the IT Smart Finance group of companies under short-term consumer loan agreements and then pays them out to the investor in the manner and amount established by the Assignment Agreement.&nbsp;If&nbsp;the borrower does not repay the loan on time or extends the loan repayment period, IT Smart Finance group of companies will buy back the investor&rsquo;s&nbsp;rights to claim in the amount of the invested sum as well as the guaranteed interest income on the investment.",
    HelperStrategyBalancedTitle: "Balanced&nbsp;Strategy",
    HelperStrategyBalancedText:
      "These are investments in consumer loans classified as BB, B and CC. As a rule, the degree of risk of non-repayment of a loan under this strategy is minimal though NPL 30 and NPL 60 might occur. However,&nbsp;they are nearly always paid out. This default risk strategy is low, but the income is significantly higher than that of the strategy with fixed income.</p> <p><strong>Associated Risks</strong></p> <p><strong>No security</strong></p> <p>Under this strategy, investments are not protected by a buyback guarantee and are not insured in any of the state funds. In the event of a loan default by the borrower, the investor bears the risk of losing the invested&nbsp;money&nbsp;or part of it.</p> <p><strong>The risk of making a profit at a rate lower than expected, or no profit at all</strong></p> <p>Nibble does not guarantee any profit from this strategy. The investor buys the rights of claim against the final borrowers. The receipt of interest income directly depends on the borrowers&#39; fulfillment of obligations to repay the loan. If the borrower does not repay the loan partly of in full, the investor may not receive the interest component of the income or the terms for the return of the invested amount and the accrued income will inevitably increase.</p> <p>The actual rate of return for this strategy exceeds the maximum declared rate of 13%.&nbsp;The&nbsp;income generated on top of that is not owned by the Nibble platform and is reinvested to reduce risks and achieve the declared return rate.",
    HelperStrategySpecialTitle: "Special&nbsp;Strategy",
    HelperStrategySpecialText:
      "These are investments in unsecured consumer loans classified as B, CC and C. The degree of loan default risk under this strategy is higher than that in the Balanced one. However, the income that might come up to 19% per annum will definitely compensates for possible losses within the sum of the investment portfolio. The minimum investment period of 12 months is chosen due to the fact that this portfolio includes loans for which a payment delay may arise, and their collection may take a more extended period.</p> <p><strong>Associated Risks</strong></p> <p><strong>No security</strong></p> <p>Under this strategy, investments are not protected by a buyback guarantee and are not insured in any of the state funds. In the event of a loan default by the borrower, the investor bears the risk of losing the invested&nbsp;money&nbsp;or part of it.</p> <p><strong>The risk of making a profit at a rate lower than expected, or no profit at all</strong></p> <p>Nibble does not guarantee any profit from this strategy. The investor buys the rights of claim against the final borrowers. The receipt of interest income directly depends on the borrowers&#39; fulfillment of obligations to repay the loan. If the borrower does not repay the loan partly of in full, the investor may not receive the interest component of the income or the terms for the return of the invested amount and the accrued income will inevitably increase.</p> <p>The actual rate of return for this strategy exceeds the maximum declared rate of 19%.&nbsp;The&nbsp;income generated on top of that is not owned by the Nibble platform and is reinvested to reduce risks and achieve the declared return rate.",

    IdentFailed: "Identification failed.",
    Identification: "Identification",
    IdentificationGoal1: "Comply with the laws of the European Union",
    IdentificationGoal2:
      "Ensure and guarantee the security of your funds and transactions",
    IdentificationGoal3:
      "Simplify the business processes, make them transparent and efficient",
    IdentificationGoalsTitle: "Our common goals for personal identification:",
    IdentificationH1:
      "why do we ask you to provide the photos of the documents?",
    IdentificationLead:
      "Nibble follows the strict standards of the European laws related to the fields of anti-money laundering (AML), user verification, storage and use of personal data.",
    IdentificationProfitsList:
      '<li class="veriffFeature-list__item">Investing is available only to verified users</li> <li class="veriffFeature-list__item">Your data is transmitted over a secure channel and stored in encrypted form</li> <li class="veriffFeature-list__item">We do not share your personal data with third parties</li> <li class="veriffFeature-list__item">We are fully responsible for the safety of your personal data</li>',
    IdentityDocHint:
      "For identification, you can use either your national identity card, passport or a driver’s license.  If you provide a driver’s license as an identity card, please, make sure to take pictures and upload both sides of the card.",
    IDHint:
      "Please, make sure to include the number and series of the selected document",
    ID: "ID",
    IDNumber: "Document series and number",
    Income: "Deposit",
    IncomeCalculation: "Accrual of income",
    IncomeReceived: "received income",
    Individual: "Individual",
    InitialDeposit: "Initial deposit",
    InterestRate: "Interest rate",
    Invest: "Invest",
    InvestedInPortfolio: "Invested in portfolio",
    InvestedLoans: "Invested loans",
    Investing: "Investment",
    InvestingIn: "Investing in [ID X]",
    Investment_amount: "Amount of investment",
    Investment_date: "Date of investment",
    Investment_type: "Type of Investment",
    InvestmentAmount: "investment amount",
    InvestmentPeriod: "Investment period, months",
    InvestmentPeriodDays: "Investment period, days",
    InvestmentPortfolios: "Investment portfolios",
    InvestmentsCountTotal: "invested in total, units.",
    InvestmentsSumTotal: "total investments",
    IHavePromoCode: "I have a promo-code",

    InformationTitleSection1: "Investing with Nibble",
    InformationContentSection1: `
        <p>We can offer you three investment strategies: Classic, Balanced and Legal. They differ in the level of
        annual
        income, the degree of risks and how they are distributed between the platform and the user. Compare our
        strategies and choose the most appropriate one for yourself.</p>
    <ul>
        <li>Even if you have no investment experience, try our investments with a secure income. We will take the risk
            for you.</li>
        <li>If you are already an experienced investor, choose a comfortable strategy in terms of a risk-income ratio.
            We will share the risks with you.</li>
    </ul>
    <h3>Investment Strategies Terms and Conditions</h3>
    <div class="article-table">
        <table border="0" cellpadding="0" cellspacing="0">
            <tbody>
                <tr>
                    <td><strong>Strategy</strong></td>
                    <td><strong>Classic</strong></td>
                    <td><strong>Balanced</strong></td>
                    <td><strong>Legal</strong></td>
                </tr>
                <tr>
                    <td><strong>Annual interest rate</strong></td>
                    <td>8%</td>
                    <td>12.5%</td>
                    <td>14.5%</td>
                </tr>
                <tr>
                    <td><strong>Annotation</strong></td>
                    <td>Secure&nbsp;income</td>
                    <td>Balanced risks</td>
                    <td>High income for patient investors</td>
                </tr>
                <tr>
                    <td><strong>Description</strong></td>
                    <td>Fixed&nbsp;income,secured by a buyback guarantee, amounts to 8% per annum.&nbsp;This is
                        a&nbsp;risk-free strategy with guaranteed income on your investments</td>
                    <td>Income is not fixed and might come up to 12-15% per annum according to the previous statistics.
                        This is the most balanced strategy in terms of a risk-reward ratio</td>
                    <td>
                        <p>This is a strategy for investing in portfolios consisting of consumer loans classified as B,
                            CC and C, which are in the process of pre-trial and judicial recovery. Due to the fact that
                            these loans have overdue debts and fines, the yield of this strategy reaches up to 19% per
                            annum.</p>
                        <p>The litigation and recovery process takes a long period of time, so the minimum investment
                            period is 6 months.</p>
                    </td>
                </tr>
                <tr>
                    <td><strong>Terms of investment&nbsp;</strong></td>
                    <td>1&ndash;6 months</td>
                    <td>7&ndash;60 months</td>
                    <td>6&ndash;60 months</td>
                </tr>
                <tr>
                    <td><strong>Buy-back</strong></td>
                    <td><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOCAyTDcgMTNMMiA4IiBzdHJva2U9IiNCN0Q3NUQiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="
                            alt="check"></td>
                    <td>&mdash;</td>
                    <td>
                        <ul>
                            <li>
                                Deposit back guarantee
                            </li>
                            <li>
                                Minimum guaranteed yield of 8% per annum
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td><strong>Reinvestment</strong></td>
                    <td colspan="2">An automatic reinvestment of the invested funds into new loans</td>
                    <td>
                        <img src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNERTM1MEIiIGN4PSI4IiBjeT0iOCIgcj0iOCIvPjxwYXRoIGQ9Ik05LjQ4NSA4LjA3MWwyLjEyMiAyLjEyMWExIDEgMCAxIDEtMS40MTUgMS40MTVsLTIuMTItMi4xMjItMi4xMjIgMi4xMjJhMSAxIDAgMSAxLTEuNDE0LTEuNDE1bDIuMTItMi4xMi0yLjEyLTIuMTIyQTEgMSAwIDEgMSA1Ljk1IDQuNTM2bDIuMTIxIDIuMTIgMi4xMjEtMi4xMmExIDEgMCAxIDEgMS40MTUgMS40MTRMOS40ODUgOC4wN3oiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+'/>
                    </td>
                </tr>
                <tr>
                    <td><strong>Interest calculation and transfer</strong></td>
                    <td colspan="2">
                        The interest is accrued on a daily basis and is transferred weekly to an
                        investor&rsquo;s Nibble account
                    </td>
                    <td>
                        Daily interest accrual at 8% per annum, payouts every 90 days according to the actual received
                        yield up to 14.5% per annum.
                    </td>
                </tr>
                <tr>
                    <td><strong>NPL classification&nbsp;</strong></td>
                    <td>АА&ndash;А&ndash;ВВ</td>
                    <td>ВВ&ndash;В&ndash;СС</td>
                    <td>В&ndash;СС&ndash;С</td>
                </tr>
                <tr>
                    <td><strong>Predicted default rate</strong></td>
                    <td>&mdash;</td>
                    <td>up to NPL 30</td>
                    <td>NPL 30&ndash;90</td>
                </tr>
                <tr>
                    <td><strong>Investment amount **</strong></td>
                    <td>&euro;10&ndash;10,000&nbsp;</td>
                    <td>&euro;100&ndash;10,000</td>
                    <td>&euro;10&ndash;10,000</td>
                </tr>
                <tr>
                    <td><strong>Minimum&nbsp;</strong><strong>withdrawal&nbsp;</strong><strong>amount</strong></td>
                    <td colspan="3">&euro;50</td>
                </tr>
            </tbody>
        </table>
    </div>
    <p><small>*The return rate is specified and approved every month by the Risk Committee and depends on the audited
            period&#39;s results.&nbsp;<br /> ** If you want to invest over &euro;15,000 we will ask you to provide us
            with extra documents.</small></p>
    <h3>Classic Strategy with BuyBack Guarantee</h3>
    <p>You invest in unsecured consumer loans classified as AA, A, BB, for which the borrower&#39;s risk of going into a
        payment delay is very low. With the buyback guarantee, you are protected from risks and receive a guaranteed
        income at a fixed interest rate.</p>
    <p><strong>Associated Risks</strong></p>
    <p><strong>Risk of non-repayment of the loan/violation of the repayment schedule/non-return of the entire loan
            amount due to repayment.</strong></p>
    <p>These investor risks are secured by a buyback guarantee of the received assets and interests. Let&#39;s take a
        closer look at how it works: the Nibble investor, choosing this strategy, invests in loans issued by the
        companies of the IT Smart Finance group, which are available on the day of investment. The holding company
        places the given loan on the Nibble platform to find an investor. The relation between the IT Smart Finance
        group of companies and the final borrower is governed by a short-term consumer loan agreement with the rights of
        claim against the borrower arising from it. Based on the Assignment Agreement made with the investor, Nibble
        assumes obligations to receive payments from the final borrower made to the IT Smart Finance group of companies
        under short-term consumer loan agreements and then pays them out to the investor in the manner and amount
        established by the Assignment Agreement.&nbsp;If&nbsp;the borrower does not repay the loan on time or extends
        the loan repayment period, IT Smart Finance group of companies will buy back the investor&rsquo;s&nbsp;rights to
        claim in the amount of the invested sum as well as the guaranteed interest income on the investment.</p>
    <h3>Balanced&nbsp;Strategy</h3>
    <p>These are investments in consumer loans classified as BB, B and CC. As a rule, the degree of risk of
        non-repayment of a loan under this strategy is minimal though NPL 30 and NPL 60 might occur. However,&nbsp;they
        are nearly always paid out. This default risk strategy is low, but the income is significantly higher than that
        of the strategy with fixed income.</p>
    <p><strong>Associated Risks</strong></p>
    <p><strong>No security</strong></p>
    <p>Under this strategy, investments are not protected by a buyback guarantee and are not insured in any of the state
        funds. In the event of a loan default by the borrower, the investor bears the risk of losing the
        invested&nbsp;money&nbsp;or part of it.</p>
    <p><strong>The risk of making a profit at a rate lower than expected, or no profit at all</strong></p>
    <p>Nibble does not guarantee any profit from this strategy. The investor buys the rights of claim against the final
        borrowers. The receipt of interest income directly depends on the borrowers&#39; fulfillment of obligations to
        repay the loan. If the borrower does not repay the loan partly of in full, the investor may not receive the
        interest component of the income or the terms for the return of the invested amount and the accrued income will
        inevitably increase.</p>
    <p>The actual rate of return for this strategy exceeds the maximum declared rate of 15%.&nbsp;The&nbsp;income
        generated on top of that is not owned by the Nibble platform and is reinvested to reduce risks and achieve the
        declared return rate.</p>
    <h3>Legal&nbsp;Strategy</h3>
    <p>This is a strategy for investing in portfolios consisting of consumer loans classified as B, CC and C, which are
        in the process of pre-trial and judicial recovery. Due to the fact that these loans have overdue debts and
        fines, the yield of this strategy reaches up to 19% per annum.</p>
    <p>The litigation and recovery process takes a long period of time, so the minimum investment period is 6 months.
        The litigation and collection management is provided by Boostr.</p>
    <p><strong>Associated risks:</strong></p>
    <p><strong>Risk of non-repayment of the loan/default of the entire loan amount</strong></p>
    <p>
    <ul>
        <li>The strategy comes with the deposit back guarantee – this is the obligation of the collection agency to
            return the full investment amount at the end of the investment period and ensure a minimum yield of 8% per
            annum.</li>
        <li>Due to investment into a portfolio consisting of a large number of loans, the risk of not receiving income
            from several contracts is reduced as they are covered by other loans.</li>
        <li>Daily interest accrual at 8% per annum, payouts every 90 days according to the actual received yield up to
            14.5% per annum.</li>
        <li>During the fundraising process for a portfolio purchase, we accrue income at 8% per annum. This is your
            bonus yield to the main one that goes up to 14.5%. The maximum term for fundraising to purchase a portfolio
            is 30 days.</li>
    </ul>
    </p>
    <p><strong>How does it work?</strong></p>
    <p>You earn daily interest at a rate of 8% per annum. Every 90 days we automatically calculate the actual yield of
        the portfolios and grant you the difference between the guaranteed rate of 8% and the actual rate. Thus, every
        90 days you receive an income ranging from 8% to 14.5% to your Nibble account.</p>
    <p>Example: By investing 1000 euro for 12 months, at the end of the term you get back your entire capital of 1000
        euro and income of 90 to 145 euro, which we pay you every 90 days.</p>
        `,
    InformationTitleSection2: "Classification of Loans by the Risk of Default",
    InformationContentSection2:
      '<p>The companies of the IT Smart Finance holding use scoring models to determine the quality of borrowers.</p> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td>AA</td> <td>A</td> <td>BB</td> <td>B</td> <td>CC</td> <td>C</td> </tr> <tr> <td>closed on time</td> <td>closed ahead of schedule</td> <td>NPL 0-30</td> <td>NPL 30-60</td> <td>NPL 60-90</td> <td>NPL 90-120</td> </tr> <tr> <td colspan="2">Low-risk loans. As a rule, clients of this category return the money on time or ahead of schedule, so the profitability on them is low, but the risks are also low.</td> <td colspan="2">Medium risk loans. Clients of this category&nbsp;can make payment&nbsp;delays (NPL 30 and NPL 60) but almost always return the loans in the end. The risk of default for this category is higher, but the average income is also higher.</td> <td colspan="2">Loans with an increased level of risk. In this category there are NPL 60, NPL 90, NPL 120 and loans under litigation, that provide the maximum profitability among all the strategies.</td> </tr> </tbody> </table> </div> <p>All approved loans are appropriately classified and sorted out according to the investment strategies.&nbsp;Once a month the Risk Committee analyses and adjusts the process of loan classification assignment.</p> <h3>The Flexible Investment product&nbsp;provides three investment strategies</h3> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>АА</strong></td> <td><strong>A</strong></td> <td colspan="1"><strong>ВВ</strong></td> <td colspan="1"><strong>В</strong></td> <td colspan="1"><strong>СС</strong></td> <td colspan="1"><strong>С</strong></td> </tr> <tr> <td colspan="3"><strong>Classic Strategy</strong></td> <td colspan="3" rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">65%</td> <td colspan="1">25%</td> <td colspan="1">10%</td> </tr> <tr> <td colspan="2" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Balanced Strategy</strong></td> <td rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">63%</td> <td colspan="1">32%</td> <td colspan="1">5%</td> </tr> <tr> <td colspan="3" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Legal Strategy</strong></td> </tr> <tr> <td colspan="1">54%</td> <td colspan="1">28%</td> <td colspan="1">18%</td> </tr> </tbody> </table> </div> <p>Each investment strategy automatically selects the appropriate type of loan risk. Each strategy can include up to 3 types of NPL, which allows to get the declared income and to ensure the corresponding risk requirements.</p>',
    InformationTitleSection3: "Withdrawing Funds from an Account",
    InformationContentSection3: `<p>Withdrawal of free assets and funds received after the investment portfolio expiration is processed to the investor&#39;s bank account through the Nibble personal account</p> 
      <ul> 
      <li>The minimum withdrawal amount is &euro;50.</li> 
      <li>Nibble only transfers money to the account owned by the investor. This is a necessary measure that protects our investors and prevents illegal money laundering.</li>
      <li>You can change your account number by contacting our support team. In this case, our AML inspector will ask you to provide additional documents.</li> 
      </ul> 
      <h3>Early termination of the investment agreement and withdrawal of funds</h3> 
      <p>You can terminate the investment agreement&nbsp;prior to its expiry date&nbsp;and withdraw funds from the Nibble platform. To do this, you need to apply for early termination of the agreement through your Nibble account. After receiving your request, we will start looking for an investor for your portfolio. The portfolio can be resold only as a whole. If we do not find an investor within 60 calendar days after receiving your request, then on the following day (Day 61) we will pay you out the amount of the invested funds and the related interest from the company&#39;s reserve fund, withholding a commission fee of 3% of the total amount to be paid.</p>`,
    InformationTitleSection4: "Buyback Policy",
    InformationContentSection4: `
        <p>To ensure the return of funds under the Classic strategy, the lender provides a buyback guarantee &mdash; it is
        the lender’s obligation to buy back the loan from the investor if the loan has not been repaid within 60 days of
        the date of investment.</p>
    <p>In this case, the lender will pay the interest due to the investor, together with the initial cost of the loan.
        To ensure these obligations funds are formed in the company&#39;s reserve fund.</p>
    <h3>How does the Buyback Policy Work:</h3>
    <ul>
        <li>Choosing the Classic strategy our investors invest in loans issued by the IT Smart Finance group of
            companies.</li>
        <li>The holding companies allocate their loans on the Nibble platform to find investors.</li>
        <li>The relationship between the companies of the IT Smart Finance group and the borrower is governed by a
            short-term consumer loan agreement with the following rights of claim against the borrower.</li>
        <li>Based on the Assignment Agreement concluded with the investor, Nibble assumes the following obligations:
            <ol>
                <li>to accept payments from the final borrower to the IT Smart Finance group of companies under the
                    short-term consumer loan agreement.</li>
                <li>to pay them to the investor in the order and amount established by the Assignment Agreement.</li>
            </ol>
        </li>
        <li>If&nbsp;the borrower does not repay the loan on time or extends the loan repayment period, the IT Smart
            Finance group of companies&nbsp;will buy&nbsp;back the investor&#39;s right to claim in the amount of the
            investment and the guaranteed interest income on the loan.</li>
    </ul>
    <p>
        <h3>
            Legal Strategy
        </h3>
    </p>
    <p>
        The strategy comes with the deposit back guarantee – this is the obligation of the collection agency to return
        the full investment amount at the end of the investment period and ensure a minimum yield of 8% per annum.
    </p>
    <p>
        <strong>
            How it works?
        </strong>
    </p>
    <p>You earn daily interest at a rate of 8% per annum. Every 90 days we automatically calculate the actual yield of
        the portfolios and grant you the difference between the guaranteed rate of 8% and the actual rate. Thus, every
        90 days you receive an income ranging from 8% to 14.5% to your Nibble account.</p>
    <p>Example: By investing 1000 euro for 12 months, at the end of the term you get back your entire capital of 1000
        euro and income of 90 to 145 euro, which we pay you every 90 days.</p>
        `,
    InformationTitleSection5: "General Risk Policy",
    InformationContentSection5:
      "<p>Risks are shared between the investor and microfinance institutions as follows:</p> <ul> <li>If a strategy implies a buyback guarantee, the risk of default is assumed by the microfinance organization at the expense of the reserve fund</li> <li>If a strategy does not imply a buyback guarantee, default risks are shared between the investor and the microfinance institution in the form of a variable interest rate</li> <li>The microfinance organization bears risks of currency exchange rate changes under the current strategies.</li> </ul>",
    InformationTitleSection6: "Risk Committee",
    InformationContentSection6:
      "<p>The Risk Committee meets at the end of each month to determine the current interest rates for the Balanced and Special strategies.</p> <h3>The Risk Committee includes the heads of the following divisions of the IT Smart Finance group of companies:</h3> <ul> <li>Risk Director</li> <li>Chief Operating Officer</li> <li>Risk&nbsp;Analyst</li> <li>Head of Debt Collection Department</li> <li>Head of Underwriting Department</li> </ul> <h3>The main tasks of the Committee:</h3> <ul> <li>Reviewing and analysing the results of work on NPL 30-60-90-120 for the reporting month.</li> <li>Reconciliation in the period of actual indicators with planned ones.</li> <li>Scoring model analysis.</li> <li>Making a forecast for the next period and calibrating the scoring model.</li> <li>Formation and approval of the current annual rate of return for the&nbsp;Balanced&nbsp;and&nbsp;Special&nbsp;strategies.</li> </ul> <p>The results of the Risk Committee meeting will be&nbsp;published as a&nbsp;report on the website.</p>",
    InformationTitleSection7: "The&nbsp;Reserve Fund&nbsp;Formation",
    InformationContentSection7:
      "<p>The reserve fund is an additional &quot;airbag&quot; for the investor, covering the default loan risks by the final borrower. Thanks to the reserve fund, we offer investors an investment strategy with a buyback guarantee.</p>",
    InformationTitleSection8: "Ensuring Security and Privacy",
    InformationContentSection8:
      '<p>We prioritize the protection of your data and the security of your transactions. Here are some of the guarantees that these priorities are essential:</p> <h3>Security guarantee</h3> <ul> <li>All data is stored in accordance with the security standard ISO 27001:2013</li> <li>All passwords are stored in a secure manner in our system</li> <li>The bank account is linked to the user account upon completion of the initial balance replenishment and cannot be changed without manual identification of the investor</li> <li>In accordance with the laws of the European Union, we are obliged to identify our clients. Nibble uses the contracted services of a third-party called &uml;Veriff&uml;. You can learn about their privacy policy through this&nbsp;<a href="https://www.veriff.com/privacy-policy">link</a></li> </ul> <h3>Privacy guarantee</h3> <ul> <li>The Nibble platform is a personal data processing operator in accordance with the laws of the European Union</li> <li>We do not share investors&rsquo; data with third parties</li> </ul> <h3>Financial risk guarantee</h3> <ul> <li>All investments are attracted by&nbsp;<a href="https://itsmartfinance.com/">IT Smart Finance holding</a></li> <li>The Сlassic strategy provides a buyback guarantee from the reserve fund</li> <li>The investment platform Nibble is a part of the IT Smart Finance holding, which unites lenders from Europe, Asia and Latin America</li> </ul>',

    JoinUs: "Join us",
    JoymoneyInfo:
      "Joymoney ES provides loans for up to 30 days in Spain. All loans are protected by a buyback guarantee. This means that if the loan is not closed within 60 days from the date of investment, Joymoney ES buys out the investor's share, together with accrued interest.",
    Later: "later",
    Legal: "Legal entity",
    literal_bread_reg: "Registration",
    LittleBitLeft: "Only a little bit left.",
    LoanType: "loan type",
    LoginBtn: "Login",
    LoginHead: "Login",
    LongTerm: "Long-term",
    LongTermInvestmensInfo:
      "Long- term investment allows users to get the maximum return due to the reinvestment period as the sum of the closed loans is reinvested (whole or principal amount of the loan, depending on the selected settings).",
    LongTermPortfolio: "Long-term investment",
    LowBalanceAlert:
      "You do not have enough funds on your balance to create a portfolio with selected parameters",
    MessageWithdrawalSuccess:
      "Request received. Withdrawal will be made within 5-7 business days",
    // ResultPaymentSuccessTitle: "The balance has been successfully replenished!",
    MonthlyDeposit: "Monthly deposit",
    MonthlyDepositInfo:
      "You can refill portfolio no later than 3 months before the expiration of your portfolio",
    MonthlyReport: "Monthly report",
    Months: "months",
    MrLabel: "Mr.",
    MsLabel: "Ms.",
    MyAccount: "My account",
    MyInvestments: "My investments",
    NameChangeWarning:
      "You can change your first and last name before you have been identified by Veriff.",
    NeedToVerifyBySMS: "You will need to confirm this phone number by SMS",
    NewPassDlina: "New password length is less than 5 characters",
    NewPassword: "New password",
    NewPasswordInfo:
      "Create a strong password. We recommend adding service symbols, numbers and uppercase letters to your password.",
    NewPasswordSent: "A new password has been sent to your e-mail.",
    NewRepeatPasChange: "Passwords don't match",
    News: "News",
    NewsletterCheckboxLabel: "Receive daily newsletters",
    Next: "Next",
    NibbleAgreement: "Agreement with NIBBLE",
    No: "No",
    Notifications: "Notifications",
    NotLimited: "not limited",
    OnlyActive: "Active only",
    Opened: "Open",
    Operation: "Operation",
    OperationDate: "Date of operation",
    OrEmail: "or email",
    OutputFail: "This amount cannot be withdrawn",
    Page: "Page",
    PageNotExist: "Sorry, the page you have tried to access does not exist.",
    PageNotFound: "Page not found",
    Partial: "Partial",
    PartnerCode: "Share promotional code",
    PartnerCodeSet: "Promotional code for invitation",
    PartnerFaq:
      '<h2 class="title faq__title">Do you have any questions</h2> <div class="box faq-wrapper"> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">How long does a promotional code or a referral link stay valid?</span> <p class="faq-answer__text"> The promotional code/link is valid from the moment that it\'s been generated and won\'t expire.</p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Will I receive any payments if one of my friends invests more than €1000?</span> <p class="faq-answer__text"> In this case, you and your friend will receive 2% of the amount of €1000.</p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Will I get any income if one of my friends invests less than €1000? </span> <p class="faq-answer__text"> If your friend makes an investment of less than €1000, both of you will receive a reward of 2% of the amount of investment. </p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">How many friends can I refer by using my promotional code or referral link? </span> <p class="faq-answer__text"> You can bring an unlimited number of friends by referral through a promotional code or referral link. </p> </div> </div>',
    PartnerInfo:
      '<h1 class="title partner__title">Recommend our service to your friends and receive rewards</h1> <span   class="partner__subtitle"> For you, and your friends</span> <ul class="partner-list">   <li class="partner-item">     <h2 class="partner-item__title">Tell your friends about Nibble</h2>     <p class="partner-item__description"> Recommend our service to your friends and receive rewards</p>   </li>   <li class="partner-item">     <h2 class="partner-item__title">Registration</h2>     <p class="partner-item__description"> Your friends are registered in Nibble by the link or by the promo code during registration on Nibble </p>   </li>   <li class="partner-item">     <h2 class="partner-item__title">Get reward</h2>     <p class="partner-item__description">From every investment made by your friend you and your friend will receive 2 % up to  €1000 </p>   </li> </ul>',
    PartnerLinkSet: "Invitation link",
    PartnerLinkSocial: "Share the link via social networks",
    PartnerTextStep1:
      "Recommend our service to your friends and receive rewards",
    PartnerTextStep2:
      "Your friends are registered in Nibble by the link or by the promo code during registration on Nibble",
    PartnerTextStep3:
      "From every investment made by your friend you and your friend will receive 2 % up to 1000 euros",
    PartnerTitle: "Recommend our service to your friends and receive rewards",
    PartnerTitleStep1: "Tell your friends about Nibble",
    PartnerTitleStep2: "Registration",
    PartnerTitleStep3: "Get reward",
    PartnerTransaction: "transactions",
    PartnerTransactionIncome: "Deposited",
    Password: "Password",
    PasswordChange: "Password reset",
    PasswordChanged: "Password changed",
    PasswordSentMessage: "Password has been sent to your phone number.",
    PasswordsMakeSure: "Make sure the passwords match",
    PaymentOnformation: "Billing Information",
    PaymentPurposeInfo:
      "Transfer funds to the indicated bank account. Please, make sure to copy the transaction description.",
    PeriodInvest: "Investment period",
    PeriodInvest1: "Investment period",
    PersonalData: "Personal data",
    PersonalDataChangeInfo:
      "To change your personal information, please contact support",
    PersonalID: "Personal ID",
    PersonalInfo: "Personal information",
    PersonLastName: "Last name",
    PersonName: "Name",
    Persons: "persons",
    Phone: "Contact phone number",
    Phone1: "Phone number",
    PhoneAlreadyReg: "This phone is already registered",
    PhoneChangeInfo:
      "To change your contact phone number, please contact support",
    PhoneConfirm: "Phone confirmed",
    PhoneNotConfirm: "Phone not confirmed",
    PhoneNotValid: "Phone format is invalid",
    PhoneVerification: "Phone Verification",
    PlacehoderBirthDate: "dd.mm.yyyy",
    PolicyAgreement:
      'I agree to the <a href="/policy_privacy.aspx">Processing of Personal Data</a>',
    PolicyAgreement1:
      'I agree to the <a href="/policy_privacy.aspx">Processing of Personal Data</a>',
    PortfolioConfirmText:
      "Now we will create a portfolio with the specified parameters",
    PortfolioCreated: "Portfolio created",
    PortfolioCreation: "Portfolio creation",
    PortfolioID: "Portfolio",
    PortfolioIncome: "Portfolio Income",
    PortfolioParams: "Portfolio Parameters",
    PortfolioReplenishment: "Portfolio replenishment [ID X]",
    PortfolioReplenishmentOperation: "Portfolio replenishment",
    PotentialProfit: "your possible return",
    Precalculation: "Precalculation of yield",
    Precalculation1: "Precalculation of profitability.",
    PrefferedLanguage: "Preferred language",
    ProductDescription: "Product description",
    ProfitCalc: "Profitability calculation",
    ProgressCompleteInfoDesc:
      "All you have to do is to add a couple of details in your personal profile settings.",
    ProgressCompleteInfoStep: "Complete the information",
    ProgressCompleteInfoTitle: "Your account is activated...",
    ProgressConfirmEmailDesc:
      "Confirm your email address and activate your account. To do this, click on the link in the email we sent you.",
    ProgressConfirmEmailDescRestore: "Send new activation link.",
    ProgressConfirmEmailStep: "Confirm e-mail",
    ProgressIdentifyDesc:
      "Identify yourself with Veriff to top up and start investing",
    ProgressIdentifyStep: "Identify yourself",
    ProgressIdentifyTitle: "The last and most important step...",
    PromoCode: "Promo code",
    PropsContractsDocs: "Details",
    ProvideSMSCode: "Enter verification code from SMS",
    PurposeOfPayment: "Purpose of payment",
    Rate: "Interest rate",
    ReceivingIncomeBy: "Receiving income by [ID X]",
    Referals: "Referrals",
    ReferralTitle: "Referral Program compensation",
    RefillFromCard: "Top-up with VISA/MC card",
    RefillHistory: "Refill history",
    RefillTheAccount:
      '<a href="/depositing.aspx">Refill the account</a> in any convenient way to start investing with Nibble.',
    RefillWithCard: "Top-up by card",
    Registrations: "Registrations",
    RegreshPage: "to refresh the page",
    ReinvestIncome: "reinvest profits",
    Reinvestment: "reinvestment",
    RepeatPassword: "Confirm password",
    Replenishment: "Portfolio replenishment, monthly",
    Replenishments: "Topups",
    ResetPassword: "Reset password",
    RestorePassword: "A new password has been sent to your phone number",
    RestorePasswordEmail: "If email is registered, message was sent to it",
    ReturnDate: "Return date",
    ReturnMainPage: "Return to the main page",
    RevenueFromRegistrationsAndRenewals:
      "Profit from registrations and renewals",
    Risks: "Risks",
    Save: "Save changes",
    ScanHint:
      "Please, upload either a scanned copy or a photo of your passport or driver’s license. Please, upload only readable and detailed images of the documents. Do not cover or distort information in the document.",
    Selfie: "Self-portrait",
    SelfieHint:
      "Please, intent to make the photo of your face look similar to the photo in your passport, without any glare or distortion",
    SendMessageBtn: "Send a message",
    SendRequest: "Send a request",
    SEPAInfo: "Deposit of funds is available for SEPA residents only.",
    ServiceUnavailable: "The service is temporary unavailable. ",
    Settings: "Settings",
    ShareLink: "Share link",
    ShowAllLoans: "Show all loans",
    SkipIdentification: "Previous",
    SmsCode: "SMS code",
    SmsCodeIsSent:
      "An SMS with a verification code was sent to your phone number. Please, enter the code.",
    Sortby: "Sort by:",
    SortbyIncome: "[by] expected income",
    SortbyOpened: "[by] opening date",
    SortbyOperationDate: "[by] date of operation",
    SortbyReturnDate: "[by] return date",
    SortbySum: "[by] amount",
    StartDeposit: "Initial amount",
    Stats: "Statistics",
    Status: "Status",
    STATUS_001: "Closed",
    STATUS_002: "Active",
    STATUS_003: "Overdue",
    STATUS_004: "Completed",
    STATUS_005: "Planned",
    STATUS_006: "Refused",
    StatusCanceled: "Canceled",
    StatusCompleted: "Completed",
    StatusInprocess: "In process",
    Step1: "First step",
    Step2: "Second step",
    StrategyBalancedDescription:
      "Income is not fixed and might come up to 12-15% per annum according to the previous statistics. This is the most balanced strategy in terms of a risk-reward ratio.",
    StrategyBalancedTitle: "Balanced Strategy",
    StrategyClassicDescription:
      "Fixed income, secured by a buyback guarantee, amounts to 8% per annum. This is a risk-free strategy with guaranteed income on your investments.",
    StrategyClassicTitle: "Classic Strategy",
    StrategyDescription:
      "Choose your investment strategy according to your income and risk expectations. <br> Create an investment portfolio in three steps.",
    StrategySpecialDescription:
      "Income is not fixed and might come up to 17–19% per annum. Though having higher investment risks, this strategy allows compensating for possible losses within the total amount of the investment portfolio",
    StrategySpecialTitle: "Special Strategy",
    StrategyStep1: "Step 1: Choose a strategy",
    StrategyStep2: "Step 2: Set up the investment parameters",
    StrategyStep3: "Step 3: Create a portfolio",
    StrategyTitle: "Flexible Investment",
    InviteFriends: "Invite friends",
    OtherStrategy: `Classic / Balanced strategy`,
    LegalStrategy: `Legal strategy`,
    String: "It contains the history of all your cash flows.",
    String1: "",
    SuccessfullySaved: "Your settings have been saved",
    Sum: "Amount",
    SumAmount: "Top-up amount",
    Support: "Support",
    SupportMessageSentMessage:
      "Your message was sent to our support and will be answered by the first free operator during European work hours",
    SupportTextareaPlaceholder: "Message or question text",
    SupportTitle: "We will answer all of your questions",
    SystemSettings: "System settings",
    Term: "Period",
    TermDays: "Period, days",
    TermMonths: "Period, months",
    Test: "Test",
    TestInvestmentsInfo:
      "Test investments allow you to test the service over a short period of time. Each user can create only one test portfolio for a sum of up to €300.",
    ThankyouErrorText:
      "Verification failed. Perhaps we couldn´t recognize the photo of your document or connection failed. Don't worry, you can pass <a target=\"_top\" href='/profile'>verification again.</a> Try using a different document.",
    ThankyouErrorTitle: "Something went wrong...",
    ThankyouSuccessText:
      "Identification is 100% passed - make your first investment with Nibble. Your personal account is set up, you just have to <a target=\"_top\" href='/depositing'>top up your balance</a> and <a target=\"_top\" href='/profile'>create your first investment portfolio</a >.",
    ThankyouSuccessTitle: "Everything went great!",
    ThroughSocialNetworks: "Through social networks",
    ThroughSocialNetworks1: "Through social networks",
    TimeFormat: "Time format",
    Try: "Please, try ",
    TutorialMessage0:
      "We can tell you about the key points of work in the Nibble personal area. Shall we continue?",
    TutorialMessage1:
      "You can calculate the profitability of your portfolio using the calculator.",
    TutorialMessage2:
      "To start investing you need to top up your account balance.",
    TutorialMessage3: 'Manage your portfolios in "My investments" section.',
    TutorialMessage4: "Get even more income with your friends.",
    TutorialMessage5:
      "We will explain how to create an investment portfolio or how the system works in general.",
    Unavailable: "unavailable",
    //UserAgreement: 'By pressing "Continue" button you agree to <a href="https://nibble.finance/user-agreement.html" target="_blank">End-user license agreement</a> and <a href="https://nibble.finance/privacy-policy.html" target="_blank"> NIBBLE privacy policy</a>',
    UserAgreement: {
      text_1: 'By pressing "Continue" button you agree to ',
      text_1_legal: 'By pressing "Send a request" button you agree to ',
      text_link_1: "User Agreement",
      text_2: " and ",
      text_link_2: "NIBBLE privacy policy",
      text_3: " ",
    },
    UserAgreement1:
      'By pressing "Continue" button you agree to <a href="/user_agreement.aspx">End-user license agreement</a> and <a href="/policy_privacy.aspx"> NIBBLE privacy policy</a>',
    VERIFF_274: "Photos missing",
    VERIFF_275: "Face not clearly visible",
    VERIFF_276: "Full document not visible",
    VERIFF_277: "Poor image quality",
    VERIFF_278: "Document damaged",
    VERIFF_279: "Document type not supported",
    VERIFF_280: "Document expired",
    VERIFF_282: "Other reasons",
    VeriffGuarantees: "Veriff guarantees the safety of your personal data.",
    VeriffGuaranteesHtml:
      '<span><u id="veriffLink">Veriff</u> guarantees the safety of your personal data.</span>',
    VeriffInfo:
      "In compliance with European law, Nibble has implemented a verification of identity procedure for each individual or corporate investor. The procedure consists of taking a photo of your identification document and its subsequent check by our partner, Veriff. The whole verification procedure should never take than 10 minutes. Please, have your passport or ID card ready and make sure all the details are clearly visible in the photo you take.",

    VeriffInfoTitle: "Pass instant identification process",
    VeriffInfoDesc:
      "Nibble follows the strict standards of the European laws related to anti-money laundering (AML), user verification, storage, and personal data use. It takes only 2 minutes to verify identity and become an investor.",
    VeriffInfoQuest: "How Simple is Digital Identity Verification?",
    VeriffInfoAsk1:
      "We ask you to take a photo of your ID document (usually a driver's license, passport, or ID card) either with your webcam or smartphone - it's a live process",
    VeriffInfoAsk2:
      "We ask you to take a quick selfie with the same device. We will guide you while taking the selfie to make sure you get it perfect on the first try",
    VeriffInfoAsk3: "You'll receive a decision in seconds.That's it!",
    VeriffStartButton: "Start Verification",
    Cancel: "l'll do it later",

    VeriffInProcess:
      "Your ID document is going through verification process by Veriff. Usually it takes few minutes. </br> Until the verification process is not completed you cannot deposit your account.",
    WeAreDoingAll: "We are doing everything possible to fix it.",
    WeeklyReport: "Weekly report",
    WeEnsureSecurity:
      'We ensure the security of your identification though our partner’s service — <a href="https://www.veriff.com" target="_blank">Veriff</a>',
    WeWorkHonest:
      "We work in an honest and open manner. In the same way, we appreciate when our users reciprocate.",
    WidgetBringFriendLead:
      "Recommend us to your friends and get a reward for each referral",
    WidgetHistoryLead:
      "All the deposits, earnings and withdrawals can be found here",
    WidgetInvestLead: "Central management office for your investments",
    WidgetSupportLead:
      "Our specialists will assist you if you have any questions or doubts",
    WillAddXMonth:
      'my investments<br>for <span class="js-calcMonth">6</span> months',
    WillAddXMonth1: "your investments&nbsp;<br>for",
    WillAddXMonth2: "months",
    Withdrawal: "Withdrawal",
    WithdrawalAmount: "Withdrawal amount",
    WithdrawalHistory: "Withdrawal History",
    WithdrawalInfo1:
      "The withdrawal of funds will be made to the linked account number.",
    WithdrawalInfo2: "The minimum withdrawal amount is <b> €50</b>.",
    WithdrawalInfo3:
      "The withdrawal will be made to the bank account of the first deposit.",
    WithdrawalOfBalances: "Withdrawal of balances from the portfolio",
    WithdrawalViaBankAccount: "Withdrawal via bank account",
    WithdrawFunds: "Withdraw money",
    WithdrawFundsMobile: "Withdraw",
    XActiveLoans: "active loans",
    XClosedLoans: "closed loans",
    XInvestedLoans: "invested loans",
    XOverdueLoans: "overdue loans",
    Yes: "Yes",
    YourInvestmentsXMonth:
      'your investments for <span class="js-calcMonth"></span> months',
    ZIP: "Postcode",
    LowBalanceAlert:
      "You do not have enough funds on your balance to create a portfolio with selected parameters",
    LowBalanceAlertCommon: "You do not have enough funds on your balance",
    NoBankAlert:
      "You haven’t specified bank account details. Please contact support",

    // validation
    required: "Required field",
    regexDate: "Enter correct date",
    regexEmail: "Enter correct email",
    checkbox: "Agree to processing your data",
    regexNot: "Invalid format",
    minlength: "",
    simple: "Simple",
    normal: "Normal",
    hard: "Complicated",
    minSum: "The minimum amount",

    //Tutorial
    step0:
      "Thanks for getting started with Nibble! Identify yourself with Veriff to top up and start investing",
    step1: "To start investing you need to top up your account balance.",
    step2:
      "Now you can calculate the profitability of your portfolio and immediately create your first portfolio.",
    step3: 'Manage your portfolios in the "My investments" section.',
    step4: "This section contains the history of all your cash flows",
    step5: "Get even more income by inviting your friends.",
    step6:
      "We will explain how to create an investment portfolio or how the system works in general.",
    step7:
      "You can create a trial portfolio with a maximum investment amount of €300 for 21 days.",
    TutorialCancel: "l'll do it later",
    TutorialConfirm: "Confirm now",
    TutorialPrev: "Previous",
    TutorialNext: "Next",
    TutorialFinal: "Finish",

    NoticeMaxSum: "The maximum amount is",
    NoticeMinSum: "The minimum amount is",

    // GradePopup
    GradeTitle: "Thank you for investing with Nibble",
    GradeText: "Could you rate your experience of using our platform?",
    GradeThanks1: "Thank you!",
    GradeThanks2:
      "Thank you! We really try our best to provide a better service for you. Please leave your feedback about us on TrustPilot.",
    GradeOk: "Ok",
    GradeLater: "Later",
    GradeFeedback: "Leave feedback",
    StrategyTitleInvestClassic: "Classic",
    StrategyTitleInvestBalanced: "Balanced",

    // ------ Судебная ------

    JudicialTitle: `Available portfolios`,
    JudicialPanelTitle: `Invest`,
    JudicialBabberTitle: `Nibble introduces new investment Strategy - Legal`,
    JudicialSlideBtn: `Invest`,
    JudicialCollection: `ХХХ1 of ХХХ2 remaining for fundraising`,
    JudicialCollectionCompleted: `Fundraising process is completed.`,
    JudicialCollectionCompletedSub: `You can invest in a new portfolio.`,
    JudicialBtnText: `Invest`,
    JudicialLabel: `Investment amount`,
    JudicialSubTitle: `strategy `,
    JudicialCollectionEnd: `until the end of fundraising`,
    JudicialCollectionEnd2: `Until the end of fundraising`,
    StrategyJudicialTitle: `Legal Strategy`,
    StrategyJudicialPanelTitle: `Legal`,
    TaglineStrategyJudicialPanel: `High income`,
    TaglineStrategyOtherPanel: `Balanced risks`,
    JudicialMoreStrategy: `More about the strategy`,
    JudicialGuarantee: `All portfolios have a`,
    JudicialGuaranteeDb: `deposit back guarantee`,
    JudicialState1: `Fundraising to buy a portfolio`,
    JudicialState2: `Buying portfolio`,
    JudicialState3: `Pre-trial recovery`,
    JudicialStateSub3: `Negotiations with borrowers`,
    JudicialState4: `Submission of documents to court`,
    JudicialState5: `Receiving a court decision`,
    JudicialState6: `Debt recovery by court decision through banks and bailiffs`,
    JudicialState7: `Debts collected`,
    JudicialAgreement: `Agreement`,
    JudicialGarantText: `Deposit back guarantee`,
    JudicialInfo: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>This is a strategy for investing in portfolios consisting of consumer loans classified as B, CC and C, which are in the process of pre-trial and judicial recovery. Due to the fact that these loans have overdue debts and fines, the yield of this strategy reaches up to 19% per annum.</p>
        <p>The litigation and recovery process takes a long period of time, so the minimum investment period is 6 months. The litigation and collection management is provided by Boostr.</p>
        <p>Associated risks: Risk of non-repayment of the loan/default of the entire loan amount</p>

        <ul>
            <li>The strategy comes with the deposit back guarantee – this is the obligation of the collection agency to return the full investment amount at the end of the investment period and ensure a minimum yield of 8% per annum.</li>
            <li>Due to investment into a portfolio consisting of a large number of loans, the risk of not receiving income from several contracts is reduced as they are covered by other loans.</li>
            <li>Daily interest accrual at 8% per annum, payouts every 90 days according to the actual received yield up to 14.5% per annum.</li>
            <li>During the fundraising process for a portfolio purchase, we accrue income at 8% per annum. This is your bonus yield to the main one that goes up to 14.5%. The maximum term for fundraising to purchase a portfolio is 30 days.</li>
        </ul>
        <p>How does it work?</p>
        <p>You earn daily interest at a rate of 8% per annum. Every 90 days we automatically calculate the actual yield of the portfolios and grant you the difference between the guaranteed rate of 8% and the actual rate. Thus, every 90 days you receive an income ranging from 8% to 14.5% to your Nibble account.</p>
        <p>Example: By investing 1000 euro for 12 months, at the end of the term you get back your entire capital of 1000 euro and income of 90 to 145 euro, which we pay you every 90 days.</p>
        </div></div></div>`,
    JudiciaDb: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>Legal Strategy</p>
        <p>The strategy comes with the deposit back guarantee – this is the obligation of the collection agency to return the full investment amount at the end of the investment period and ensure a minimum yield of 8% per annum.</p>
        <p>How it works?</p>
        <p>You earn daily interest at a rate of 8% per annum. Every 90 days we automatically calculate the actual yield of the portfolios and grant you the difference between the guaranteed rate of 8% and the actual rate. Thus, every 90 days you receive an income ranging from 8% to 14.5% to your Nibble account.</p>
        <p>Example: By investing 1000 euro for 12 months, at the end of the term you get back your entire capital of 1000 euro and income of 90 to 145 euro, which we pay you every 90 days.</p>
        </div></div></div>`,
    JudicialSlide: `
        <div class="judicial-slide__title">
        <div class="judicial-slide__title-head">
            Nibble introduces new investment Strategy - Legal
        </div>
        <div class="judicial-slide__title-sub">
            <p>From now on, a new investment strategy is available to our investors, featuring a high and predictable return of up to 14.5% per annum and a deposit back guarantee.</p>
            <p>Also, in order to maintain profitability in the current market situation and the requirements of the regulator, we update interest rates for the new portfolios of the Classic and Balanced strategies. Rates for existing portfolios do not change.</p>
        </div>
        
        
        <div class="judicial-slide__title-mini">
            Classic - 8% per annum
        </div>
        <div class="judicial-slide__title-mini">
            Balanced - 12,5% per annum
        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                About the product
            </div>

            <div class="judicial-slide__sub-text">
                <p>Any financial company specializing in lending inevitably faces loans that are not repaid within the terms specified in the contract. Many companies sell such loans in large portfolios at auctions with 85% discount, in order to quickly return a part of the money to the business.</p>
                <p>Boostr buys such portfolios at auctions.</p>
                <p>Thanks to the deep experience and technologies developed by Boostr, it is possible to achieve a high percentage of capital return. In Eurasia the company has more than 5 years of experience and more than 80 employees.</p>
                <p>In Europe Boostr works in partnership with collection agencies, who specialize on the debt recovery of European loans.</p>
                <p>Since 2019, auction platforms for the sale of debts, such as Debex and NLPBroker, have begun to actively appear on the Spanish market, which shows the growth of the market. Also there are many other collection agencies on the market specializing in debt recovery. According to information provided by our partners from this industry with more then 25 years of experience, the investor's return can reach up to 19% per annum.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Historical profitability
            </div>

            <div class="judicial-slide__stend">
                <div class="judicial-slide__block">
                    <div class="judicial-slide__block-title">
                        A portfolio has been purchased.
                    </div>
                    <div class="judicial-slide__purchase-list">

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Bought for
                            </div>
                            <div class="judicial-slide__purchase-money">
                                € 117 801
                            </div>
                        </div>

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Debts sum 
                            </div>
                            <div class="judicial-slide__purchase-money">
                                € 1 328 123
                            </div>
                        </div>
                    </div>

                    <div class="judicial-slide__explanation">
                            <div class="judicial-slide__explanation-icon">
                                <div class="judicial-slide__explanation-smiley" ></div>
                            </div>
                            <div class="judicial-slide__explanation-text">
                                This means, we bought a portfolio with <br /> a potential of €1,328,123 for €117,801
                            </div>
                        </div>

                        <div class="judicial-slide__block-info">
                            <div class="judicial-slide__block-collected">
                                <div class="judicial-slide__collected-title">
                                    Within the first year we recovered:
                                </div>
                                <div class="judicial-slide__collected-money">
                                    €&nbsp;143&nbsp;107
                                </div>
                                <div class="judicial-slide__collected-description">
                                    of debt which is €25,306 more than our investment and more than 20% per annum
                                </div>
                            </div>

                            <div class="judicial-slide__block-description">
                                <div class="judicial-slide__description-icon">
                                    <div class="judicial-slide__description-info-icon"></div>
                                </div>
                                <div class="judicial-slide__block-description-text">
                                    After the first year of debt recovery, we can sell the remaining loans in the portfolio at auction for €70,343, earning €95,649 in total
                                </div>
                            </div>
                        </div>

                        
                        <div class="judicial-slide__strategy">
                            <div class="judicial-slide__strategy-title">
                                Portfolio statistics
                            </div>
                            <div class="judicial-slide__strategy-diagram">
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        € 117 801
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom1">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Total investments
                                    </div>
                                </div>
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        € 143 107
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom2">
                                        Income €&nbsp;25&nbsp;306
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Recovered within the first year
                                    </div>
                                </div>          
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        € 270 784
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom4">
                                        Income €&nbsp;152&nbsp;983
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Recovered within the second year
                                    </div>
                                </div>          
                            </div>

                            <div class="judicial-slide__strategy-earned">
                                <div class="judicial-slide__strategy-label">
                                    Earned within 2 years:
                                </div>
                                <div class="judicial-slide__strategy-sum">
                                    €&nbsp;152&nbsp;983
                                </div>
                            </div>
                        </div>
                </div>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Based on this business, we have developed a Legal Strategy.
            </div>

            <div class="judicial-slide__sub-text">
                <p>This is a strategy for investing in portfolios consisting of consumer loans classified as B, CC and C, which are in the process of pre-trial and judicial recovery. Due to the fact that these loans have overdue debts and fines, the yield of this strategy reaches up to 19% per annum.</p>
                <p>The litigation and recovery process takes a long period of time, so the minimum investment period is 6 months.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Associated risks:
            </div>

            <div class="judicial-slide__title-small">
                Risk of non-repayment of the loan/default of the entire loan amount
            </div>

            <div class="judicial-slide__sub-text">
                <ul class="judicial-slide__roll">
                    <li class="judicial-slide__element">The strategy comes with the deposit back guarantee – this is the obligation of the collection agency to return the full investment amount at the end of the investment period and ensure a minimum yield of 8% per annum.</li>
                    <li class="judicial-slide__element">Due to investment into a portfolio consisting of a large number of loans, the risk of not receiving income from several contracts is reduced as they are covered by other loans.</li>
                    <li class="judicial-slide__element">Daily interest accrual at 8% per annum, payouts every 90 days according to the actual received yield up to 14.5% per annum.</li>
                    <li class="judicial-slide__element">During the fundraising process for a portfolio purchase, we accrue income at 8% per annum. This is your bonus yield to the main one that goes up to 14.5%. The maximum term for fundraising to purchase a portfolio is 30 days.</li>
                </ul>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                How does it work?
            </div>

            <div class="judicial-slide__sub-text">
                You choose a portfolio according to your preferences and invest in it. While the portfolio is in the fundraising process, you daily receive an interest of 8% per annum. After the end of the process, you also receive daily interest at a rate of 8% per annum and every 90 days, we automatically calculate the actual yield of portfolios and grant you the difference between the guaranteed rate of 8% and the actual rate of up to 14.5%. Thus, every 90 days you receive an income ranging between 8% and 14.5% onto your Nibble account.
            </div>

            <div class="judicial-slide__sub-text-mini">
                Example: By investing 1000 euro for 12 months, at the end of the term you get back your entire capital of 1000 euro and receive an income between 90 and 145 euro, which will be added straight onto your Nibble account.
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                How we make money for investors:
            </div>

            <div class="judicial-slide__sub-text">
                <ol class="judicial-slide__roll">
                    <li class="judicial-slide__element">Boostr buys overdue loans from banks and MFOs at auctions, with a discount of 85%</li>
                    <li class="judicial-slide__element">The pre-trial process begins, when the agency contacts the borrower and tries to agree on the return of the debt.</li>
                    <li class="judicial-slide__element"> If it was not possible find a solution, then the process of court proceedings begins to obtain a court decision on the debt collection from the debtor, which is managed by Boostr or its partner.</li>
                    <li class="judicial-slide__element">After receiving a judicial order, debt, interest, and fines are collected through the bailiff services and banks.</li>
                </ol>
            </div>

        </div>
    </div>
        `,
    legalTitle: `Legal strategy`,
    legalInfoTitle1: `About the product`,
    legalInfoTitle2: `Historical profitability`,
    legalInfoTitle3: `Based on this business, we have developed a Legal Strategy.`,
    legalInfoTitle4: `Associated risks`,
    legalInfoTitle5: `How does it work?`,
    legalInfoTitle6: `How we make money for investors`,
    legalInfoText1: `
        <p>Any financial company specializing in lending inevitably faces loans that are not repaid within the terms specified in the contract. Many companies sell such loans in large portfolios at auctions with 85% discount, in order to quickly return a part of the money to the business.</p>
        <p>Boostr buys such portfolios at auctions.</p>
        <p>Thanks to the deep experience and technologies developed by Boostr, it is possible to achieve a high percentage of capital return. In Eurasia the company has more than 5 years of experience and more than 80 employees.</p>
        <p>In Europe Boostr works in partnership with collection agencies, who specialize on the debt recovery of European loans.</p>
        <p>Since 2019, auction platforms for the sale of debts, such as Debex and NLPBroker, have begun to actively appear on the Spanish market, which shows the growth of the market. Also there are many other collection agenies on the market specializing in debt recovery. According to information provided by our partners from this industry with more then 25 years of experience, the investor's return can reach up to 19% per annum.</p>
        `,
    legalInfoText2: `
        <div class="judicial-slide__stend">
          <div class="judicial-slide__block">
              <div class="judicial-slide__block-title">
                  A portfolio has been purchased.
              </div>
              <div class="judicial-slide__purchase-list">

                  <div class="judicial-slide__purchase-item">
                      <div class="judicial-slide__purchase-info">
                          Bought for
                      </div>
                      <div class="judicial-slide__purchase-money">
                          € 117 801
                      </div>
                  </div>

                  <div class="judicial-slide__purchase-item">
                      <div class="judicial-slide__purchase-info">
                          Debts sum 
                      </div>
                      <div class="judicial-slide__purchase-money">
                          € 1 328 123
                      </div>
                  </div>
              </div>

              <div class="judicial-slide__explanation">
                      <div class="judicial-slide__explanation-icon">
                          <div class="judicial-slide__explanation-smiley" ></div>
                      </div>
                      <div class="judicial-slide__explanation-text">
                          This means, we bought a portfolio with <br /> a potential of €1,328,123 for €117,801
                      </div>
                  </div>

                  <div class="judicial-slide__block-info">
                      <div class="judicial-slide__block-collected">
                          <div class="judicial-slide__collected-title">
                              Within the first year we recovered:
                          </div>
                          <div class="judicial-slide__collected-money">
                              €&nbsp;143&nbsp;107
                          </div>
                          <div class="judicial-slide__collected-description">
                              of debt which is €25,306 more than our investment and more than 20% per annum
                          </div>
                      </div>

                      <div class="judicial-slide__block-description">
                          <div class="judicial-slide__description-icon">
                              <div class="judicial-slide__description-info-icon"></div>
                          </div>
                          <div class="judicial-slide__block-description-text">
                              After the first year of debt recovery, we can sell the remaining loans in the portfolio at auction for €70,343, earning €95,649 in total
                          </div>
                      </div>
                  </div>

                  
                  <div class="judicial-slide__strategy">
                      <div class="judicial-slide__strategy-title">
                          Portfolio statistics
                      </div>
                      <div class="judicial-slide__strategy-diagram">
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  € 117 801
                              </div>
                              <div class="judicial-slide__strategy-block-bottom1">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Total investments
                              </div>
                          </div>
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  € 143 107
                              </div>
                              <div class="judicial-slide__strategy-block-bottom2">
                                  Income €&nbsp;25&nbsp;306
                              </div>
                              <div class="judicial-slide__strategy-block-bottom3">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Recovered within the first year
                              </div>
                          </div>          
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  € 270 784
                              </div>
                              <div class="judicial-slide__strategy-block-bottom4">
                                  Income €&nbsp;152&nbsp;983
                              </div>
                              <div class="judicial-slide__strategy-block-bottom3">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Recovered within the second year
                              </div>
                          </div>          
                      </div>

                      <div class="judicial-slide__strategy-earned">
                          <div class="judicial-slide__strategy-label">
                              Earned within 2 years:
                          </div>
                          <div class="judicial-slide__strategy-sum">
                              €&nbsp;152&nbsp;983
                          </div>
                      </div>
                  </div>
          </div>
      </div>
        `,
    legalInfoText3: `
        <p>This is a strategy for investing in portfolios consisting of consumer loans classified as B, CC and C, which are in the process of pre-trial and judicial recovery. Due to the fact that these loans have overdue debts and fines, the yield of this strategy reaches up to 19% per annum.</p>
        <p>The litigation and recovery process takes a long period of time, so the minimum investment period is 6 months.</p>
        `,
    legalInfoText4: `
      <strong>
        Risk of non-repayment of the loan/default of the entire loan amount
      </strong>
      <ul class="legal-list__point">
        <li>The strategy comes with the deposit back guarantee – this is the obligation of the collection agency to return the full investment amount at the end of the investment period and ensure a minimum yield of 8% per annum.</li>
        <li>Due to investment into a portfolio consisting of a large number of loans, the risk of not receiving income from several contracts is reduced as they are covered by other loans.</li>
        <li>Daily interest accrual at 8% per annum, payouts every 90 days according to the actual received yield up to 14.5% per annum.</li>
        <li>During the fundraising process for a portfolio purchase, we accrue income at 8% per annum. This is your bonus yield to the main one that goes up to 14.5%. The maximum term for fundraising to purchase a portfolio is 30 days.</li>
      </ul>
      `,
    legalInfoText5: `
      <p>You choose a portfolio according to your preferences and invest in it. While the portfolio is in the fundraising process, you daily receive an interest of 8% per annum. After the end of the process, you also receive daily interest at a rate of 8% per annum and every 90 days, we automatically calculate the actual yield of portfolios and grant you the difference between the guaranteed rate of 8% and the actual rate of up to 14.5%. Thus, every 90 days you receive an income ranging between 8% and 14.5% onto your Nibble account.</p>
      <p>Example: By investing 1000 euro for 12 months, at the end of the term you get back your entire capital of 1000 euro and receive an income between 90 and 145 euro, which will be added straight onto your Nibble account.</p>
      `,
    legalInfoText6: `
      <ol class="legal-list__num">
        <li>Boostr buys overdue loans from banks and MFOs at auctions, with a discount of 85%.</li>
        <li>The pre-trial process begins, when the agency contacts the borrower and tries to agree on the return of the debt.</li>
        <li> If it was not possible find a solution, then the process of court proceedings begins to obtain a court decision on the debt collection from the debtor, which is managed by Boostr or its partner.</li>
        <li>After receiving a judicial order, debt, interest, and fines are collected through the bailiff services and banks.</li>
      </ol>
      `,
    refLinkMenu1: `Program conditions`,
    refLinkMenu2: `My invitations`,
    refLinkTab1: `Pending`,
    refLinkTab2: `Bonus accrued`,
    refLinkTab3: `No bonus`,
    refInviteFriendsTitle1: `Invite friends`,
    refInviteFriendsSubTitle1: `Get a reward`,
    refInviteFriendsText1: `up to €1.000 for you and your friend`,
    refInviteFriendsBTN1: `Invite friends`,
    refInviteFriendsSubTitle2: `How does it work?`,
    refInviteFriendsStepTitle1: `You invite your friend to Nibble`,
    refInviteFriendsStepText1: `Send them your link for registration`,
    refInviteFriendsStepTitle2: `Your friend becomes an investor`,
    refInviteFriendsStepText2: `The friend has 3 months to create a portfolio`,
    refInviteFriendsStepTitle3: `You and your friend receive a bonus`,
    refInviteFriendsStepText3: `Bonus depends on the amount of friend's investments`,
    refInviteFriendsTitle2: `What does the reward amount depend on?`,
    refInviteFriendsText2: `The bonus depends on how much your friend invests in 3 months after the registration`,
    refInviteFriendsBonus: `Bonus&nbsp;2%`,
    refInviteFriendsSum: `Friend's investments`,
    refInviteFriendsTitle3: `What else can affect?`,
    refInviteFriendsInfoTitle1: `Sum of investments`,
    refInviteFriendsInfoText1: `The sum of all your friend's investments must be bigger than €500`,
    refInviteFriendsInfoTitle2: `Period of investments`,
    refInviteFriendsInfoText2: `Only portfolios created for 3 months or longer are taken into consideration`,
    refInviteFriendsBoxTitle1: `Invest on Nibble with your friends`,
    refInviteFriendsBoxText1: `Our platform is suitable for both beginners and experienced investors`,
    yourReferralLink: `Your referral link`,
    refInviteFriendsBTN2: `Copy the link`,
    refMyInvitationsTitle1: `My invitations`,
    refMyInvitationsTotal: `Total earned`,
    refMyInvitationsFriends: `Friends registered`,
    refMyInvitationsGetBonus: `Bonus accrued`,
    refMyInvitationsTitle2: `Your referral link`,
    refMyInvitationsTitle3: `My invitations`,
    refMyInvitationsNO: `You don't have any invited friends yet, share your referral link with them`,
    bonusPeriodEnd: `End of the bonus period`,
    yourBonus: `Your bonus`,
    bannerTetx: `Legal strategy is available again<span class="banner-BB__text-i">!</span> Invest <span class="banner-BB__text-i">at a</span> high interest rate <span class="banner-BB__text-i">and</span> earn <span class="banner-BB__text-i">with Nibble!</span>`,
  },

  ES: {
    Out: "de",
    PortfolioTitle: "Tus carteras",
    UntilTheEnd: "Hasta el final de la inversión",
    TabsActive: "Activas",
    TabsClose: "Cerradas",
    TabsDraft: "Borrador",
    LoansInvesting: "Préstamos invertidos",
    LoansActive: "Préstamos activos",
    LoansClose: "Préstamos cerrados",
    LoansDebt: "Recobro",
    LoansBought: "Recomprado",
    Hello: "Hola,",
    MonthOne: "mes",
    MonthSeveral: "meses",
    MonthMany: "meses",
    Delete: "Eliminar",
    //
    ResultPaymentErrorTitle: "Transacción rechazada por el banco.",
    ResultPaymentErrorInfo:
      "Puedes recargar tu cuenta mediante transferencia bancaria o uno de estos servicios:",
    LimitContentTitle:
      "Este mes ya has realizado depósitos por importe de /1/.",
    LimitContentDescription1:
      "De acuerdo con los estándares de la ley europea, puedes invertir hasta /1/ al mes.",
    LimitContentList1: "Hasta el /1/ puedes recargar tu cuenta por /2/.",
    LimitContentList2:
      "A partir del /1/ puedes recargar tu cuenta por cualquier importe hasta /2/.",
    LimitContentDescription2:
      "Si quieres invertir más, ponte en contacto con nosotros de la forma que deseas y te ayudaremos a hacerlo.",
    //
    DepositTabsTitle1: "Tarjeta",
    DepositTabsTitle2: "Transferencia bancaria",
    DepositTabsTitle3: `Para cambiar tu información personal, ponte en contacto con el servicio de atención al cliente.`,
    DepositTabsTitle3_EN: `To change your personal information, please contact support. <br /> 
    Currently, only Mastercard is supported. Withdrawal on Visa is in the process.`,
    DepositTabsTitle4: `El retiro se realizará al número de la cuenta vinculado. Importe mínimo de retiro <strong>50 EUR</strong>.`,
    DepositDescriptionCardDesk:
      "Ten en cuenta que tu banco puede establecer límites a las transacciones realizadas con tarjeta. Si no logras recargar tu cuenta con tarjeta, puedes ponerte en contacto con tu banco para solucionar el problema o depositar tu cuenta mediante transferencia bancaria.",
    DepositDescriptionCardMobile:
      "Si no logras recargar tu cuenta con tarjeta, puedes ponerte en contacto con tu banco para solucionar el problema o depositar tu cuenta mediante transferencia bancaria.",
    DepositDescriptionBankDesk:
      "Transfiere dinero a los requisitos indicados. Asegúrate de copiar el propósito de pago.\n" +
      "Solo pueden depositar los residentes de SEPA.",
    DepositDescriptionBankMobile:
      "Solo pueden depositar <b>los residentes de SEPA.</b>",
    //
    OtherLabel: "Otro",
    RangeInvestmentAmount: "Importe de inversión entre /min/ y /max/",
    RangeInvestmentTerm: "Plazo de inversión (meses) entre /min/ y /max/",
    ValidationAmountMin: "El importe mínimo es de /min/",
    ValidationAmountMax: "El importe máximo es de /max/",
    ValidationTermMinMax: "Entre /min/ y /max/ meses",
    AvailableForInvesting: "Disponible para invertir",
    WeeklyInterestPay: "Pago semanal de intereses",
    FirstPayment: "Primer pago",
    ClassicDescription:
      "La rentabilidad de esta estrategia es fija, respaldada por una garantía de recompra y asciende al 9.7% anual. La estrategia asegura la ausencia de riesgos y la rentabilidad garantizada. La reinversión de los fondos invertidos está activada de forma predeterminada.",
    BalancedDescription:
      "La rentabilidad no es fija y, según las estadísticas de periodos anteriores, puede ascender al 13% anual. La estrategia más equilibrada en relación riesgo-rentabilidad. La reinversión de los fondos invertidos está activada de forma predeterminada.",
    SpecialDescription:
      "La rentabilidad no es fija y puede alcanzar el 17–19% anual. Los riesgos de inversión son mayores, pero al mismo tiempo, la rentabilidad permite recuperar las pérdidas dentro del importe total de la cartera de inversiones. La reinversión de los fondos invertidos está activada de forma predeterminada.",
    NextMoreText: "Más",
    BackButton: "Volver",
    CalculatorInfoTitle: "¡Gracias por unirte a Nibble!",
    CalculatorInfoDescription:
      "Elige una estrategia de inversión de acuerdo a tu preferencia de rendimiento y riesgo.",
    CalculatorListTitle: "Crea una cartera de inversiones en tres pasos:",
    CalculatorListItem1: "Identifícate mediante Veriff",
    CalculatorListItem2: "Recarga el saldo",
    CalculatorListItem3: "Crea tu primera cartera de inversiones",
    StrategyNameClassic: "Clásica",
    StrategyNameBalanced: "Equilibrada",
    StrategyNameSpecial: "Especial",
    IdentifyYourself: "Identificarse",
    CurrentAnnualRate: "Tasa de interés anual actual",
    //
    IdentificationDescription:
      "De acuerdo con los estándares de la ley europea, tenemos que verificar tu identidad.",
    //

    bannerAchive: "Promoción de verano",
    bannerInfo:
      "No pierdas la oportunidad de ganar más, con una tasa del 11,7% de la Estrategia Clásica para las carteras creadas&nbsp;del&nbsp;1&nbsp;de&nbsp;julio&nbsp;al&nbsp;31&nbsp;de&nbsp;agosto&nbsp;de&nbsp;2021",
    //
    PaymentsOpertions_334: "Recarga con tarjeta",
    PaymentsOpertions_150: "Recarga mediante transferencia bancaria",
    PaymentsOpertions_355: "Bonificación",
    //
    NoLinkDocsAlert:
      'Para descargar los documentos es necesario completar los campos de la sección "Información personal',
    NoticeDepositingCard:
      "Ten en cuenta que tu banco puede establecer límites a las transacciones realizadas con tarjeta. Si no logras recargar tu cuenta con tarjeta, puedes ponerte en contacto con tu banco para solucionar el problema o depositar tu cuenta mediante transferencia bancaria.",
    //
    AboutTheBorrower: "Sobre el prestatario",
    AboutVeriff:
      "Veriff es una compañía que realiza la identificación, en la cual confían los gobiernos europeos, bancos principales, empresas y servicios de la industria fintech y tiendas online",
    AccountNumber: "Número de la cuenta",
    AccountSumAvailable: "Disponible en tu cuenta",
    AccuredIncome: "ingreso devengado",
    ActiveLoans: "préstamos activos",
    ActivePortfolio: "cartera activa",
    AdditionalAgreement: "Contrato adicional",
    Address: "Domicilio",
    AddressLine1: "Dirección 1",
    AddressLine2: "Dirección 2",
    Agreement: "contrato",
    All: "Todas",
    AlreadyHaveAccount: "¿Ya tienes una cuenta? Inicia la sesión",
    AnnualInterestRate: "tasa de </br> interés anual actual",
    AnnualInterestRateClassic: "tasa de interés <br> anual fija",
    ApplicationReceivedMessage:
      "Hemos recibido tu solicitud. Nuestro especialista te contactará en breve. ¡Gracias!",
    ApplyPromoCode: "Aplicar un código de promoción",
    AreYouSure: "¿Estás seguro?",
    Articles: "Artículos",
    AverageInterest: "Tipo de interés medio ponderado",
    Balance: "Balance",
    BalanceReplenishment: "BalanceReplenishment",
    Bank: "Banco",
    BankAccountNumber: "Número de la cuenta bancaria",
    BankName: "Nombre del Banco",
    BankTransferReplenishment: "Reposición mediante una transferencia bancaria",
    BankTransferWithdrawal: "Retiro mediante una transferencia bancaria",
    CardTransferWithdrawal: "Withdrawal by card",
    Basic: "Principales",
    BirthDate: "Fecha de nacimiento",
    Borrower: "Prestatario",
    BorrowingCompany: "Compañía prestataria",
    BringFriend: "Trae a tu amigo",
    BuybackGuarantee: "Garantía BuyBack",
    c11: "Rusia",
    c12: "Austria",
    c197: "No reinvestment",
    c198: "Reinversión total",
    c199: "No reinvertir los intereses",
    c206: "España",
    c208: "Bélgica",
    c242: "Bulgaria",
    c243: "Reino Unido",
    c244: "Hungría",
    c245: "Alemania",
    c246: "Grecia",
    c247: "Dinamarca",
    c248: "Irlanda",
    c249: "Italy",
    c250: "Chipre",
    c251: "Letonia",
    c252: "Lituania",
    c253: "Luxemburgo",
    c254: "Malta",
    c255: "Países Bajos",
    c256: "Polonia",
    c257: "Portugal",
    c258: "Rumanía",
    c259: "Eslovaquia",
    c260: "Eslovenia",
    c261: "Finlandia",
    c262: "Francia",
    c263: "Croacia",
    c264: "República Checa",
    c265: "Suecia",
    c266: "Suiza",
    c267: "Estonia",
    c270: "Joymoney Rusia (próximamente)",
    c271: "Joymoney España",
    c272: "Joymoney México (próximamente)",
    c274: "Falta enviar una foto",
    c275: "No se visualiza correctamente la foto de la cara",
    c276: "El documento enviado no se visualiza correctamente",
    c277: "Baja calidad de imágen",
    c278: "El documento está dañado",
    c279: "Este formato de imágen no está soportado",
    c280: "El documento ha expirado",
    c281: "Approved",
    c282: "Otras razones",
    c283: "Expired",
    CalculatorNote:
      "La reinversión de los fondos invertidos está activada de forma predeterminada, y todos los ingresos recibidos de la inversión serán transferidos a tu cuenta de Nibble semanalmente",
    CapitalReinvestment: "reinversión del capital principal",
    CardInfo:
      "Estamos trabajando en la ampliación de las formas de depositar fondos en tu cuenta Nibble. Pronto podrás depositar con tu tarjeta de débito o crédito.",
    CashbackForFriends: "Cashback por inversiones de tu amigo",
    CashbackForInvestments: "Cashback por tus inversiones",
    CashDeposit: "Depósito de fondos",
    ChangePassword: "Cambiar la clave",
    ChoiceOf70: "Elige el 70% de inversores",
    ChoosePortfolioType: "Seleccionar el tipo de cartera",
    City: "Ciudad",
    ClosedLoans: "Préstamos cerrados",
    ClosingDate: "Fecha de cierre",
    CompanyHeadName: "Nombre completo del dirigente",
    CompanyName: "Nombre de la compañía",
    CompleteRegistration:
      "Completa el registro con tu identificación para recargar el saldo y empezar a invertir",
    Confirm: "Confirmar",
    ConfirmationLinkSent: "Un enlace de confirmación se ha enviado a tu email",
    Continue: "Continuar",
    ContractsAndDocs: "Documentos y contratos",
    Country: "País",
    CountryOfIssue: "País de emisión",
    CountryOfResidence: "País de residencia",
    Code: "Código",
    CreateAccount: "Crear una cuenta",
    CreatePortfolio: "Crear una cartera",
    CreatePortfolioInfo:
      "Si está seleccionado, todos los ingresos recibidos serán reinvertidos para que pueda obtener más. Por defecto, todos los ingresos de las inversiones se depositan en su cuenta de Nibble y están disponibles para ser retirados a medida que se cierren los préstamos.",
    CreateTestPortfolio: "Crear una cartera de test",
    CurrentBalance: "Balance actual",
    CurrentIncome: "Ingresos actuales",
    CurrentlyOnYourAccount: "Actualmente en tu cuenta",
    CurrentPassError: "La contraseña actual es incorrecta",
    CurrentPassword: "Clave actual",
    DailyReport: "Informe diario",
    DateFormat: "Formato de fecha",
    DaysLabel: "días",
    DepositAccount: "Reponer la cuenta",
    DepositAccountMobile: "Reponer",
    DepositFunds: "Recargar",
    DepositHistory: "Historial de fondos depositados",
    DepositPortfolio: "Reponer la cartera",
    DepositViaBankAccount: "Depositar por medio de una cuenta bancaria",
    DocBackScan: "Haz una foto de la cara trasera de tu carnet de identidad",
    DocFrontScan: "Haz una foto de la cara frontal de tu carnet de identidad",
    DocPhoto: "Foto del documento",
    DocType: "Tipo de documento",
    Document: "Documento",
    DownloadAgreement: "Descargar el contrato",
    DownloadWarning: "Para descargar el contrato, indica los datos",
    DownloadWarningNext: "personales requeridos",
    Email: "Correo electrónico",
    EmailAlreadyReg: "Este email se utiliza ya en el sistema",
    EmailChangeInfo:
      "Para cambiar tu correo electrónico, ponte en contacto con el servicio de atención al cliente",
    EnabledByDefault: "activada de forma predeterminada",
    ERROR_001:
      "En tu cuenta no hay saldo suficiente para crear una cartera con los parámetros elegidos",
    ERROR_002: "No has elegido ningún país",
    ERROR_003: "Error desconocido",
    ERROR_004: "Cantidad incorrecta",
    ERROR_005: "Puedes crear solo una cartera de test",
    ERROR_006: "La cantidad de inversión elegida no corresponde al saldo",
    ErrorEmailLength: "El campo de email no puede quedarse vacío",
    ErrorEmailLogin: "Ingresa un email válido",
    ErrorEmailPassLogin: "Correo electrónico o clave incorrecta",
    ErrorEmptyFields: "No todos los campos obligatorios están completados",
    ErrorFirstNameLength: "No has indicado tu nombre",
    ErrorLastNameLength: "No has indicado tu apellido",
    ErrorLoadDocument:
      "Para descargar el contrato hace falta indicar la fecha de nacimiento y la dirección en la página de configuración",
    ErrorPhoneFormat: "Número de teléfono incorrecto",
    ErrorPromoCode: "Código promocional inválido",
    Exit: "Fin de Sesión",
    ExpectedAnnualReturn: "Retorno anual esperado",
    ExpectedClosingDate: "Fecha del cierre programada",
    ExpectedIncome: "ingresos esperados",
    FacePhoto: "Hazte una selfie",
    Finish: "Finalizar",
    FirstName: "Tu nombre",
    FirstStep: "Primer paso del registro",
    ForBusiness: "Para negocios",
    ForgotPassword: "¿Olvidaste tu clave?",
    FormatDate1: "aaaa-mm-dd",
    FormatDate2: "aaaa/mm/dd",
    FormatDate3: "mm/dd/aaaa",
    FormatDate4: "mm-dd-aaaa",
    From3To60Months: "entre 3 y 60 meses",
    Full: "Total",
    FundsWithdrawal: "Retiro de fondos",
    Gender: "Sexo",
    GetSMSCode: "Recibir un código de verificación",
    GoIdent: "Pasar la identificación personal",
    GoToAccount: "Acceder a tu área personal",
    Help: "Ayuda",
    History: "Historial de operaciones",
    HowItWorks: "Cómo funciona",
    HugeAmountWarning:
      "Para invertir más de 10.000 euros tienes que pasar una prueba adicional",
    // eslint-disable-next-line
    HelperRisksTitle:
      "Clasificaci&oacute;n de pr&eacute;stamos por riesgo de morosidad: NPL 30, 60, 90, 120+",
    HelperRisksText:
      'Las empresas del holding IT Smart Finance utilizan modelos de puntuaci&oacute;n para determinar la calidad de los prestatarios. A todos los pr&eacute;stamos aprobados se les asigna una clasificaci&oacute;n correspondiente.</p> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>AA</strong></td> <td><strong>A</strong></td> </tr> <tr> <td>pagados a tiempo</td> <td>pagados con anticipaci&oacute;n</td> </tr> <tr> <td colspan="2">Pr&eacute;stamos de bajo riesgo. Los clientes de esta categor&iacute;a normalmente devuelven el dinero a tiempo o con anticipaci&oacute;n, por lo tanto su rentabilidad no es alta, pero los riesgos tampoco.</td> </tr> <tr> <td><strong>ВВ</strong></td> <td><strong>В</strong></td> </tr> <tr> <td>vencidos, NPL 0&ndash;30</td> <td>vencidos, NPL 30&ndash;60</td> </tr> <tr> <td colspan="2">Pr&eacute;stamos de riesgo medio. Los clientes de esta categor&iacute;a pueden incurrir en morosidad (NPL30 y NPL60), pero casi siempre terminan devolviendo los pr&eacute;stamos. El riesgo de impago para esta categor&iacute;a es mayor, pero la rentabilidad media tambi&eacute;n es mayor.</td> </tr> <tr> <td><strong>СС</strong></td> <td><strong>С</strong></td> </tr> <tr> <td>vencidos, NPL 60&ndash;90</td> <td>vencidos, NPL 90&ndash;120</td> </tr> <tr> <td colspan="2">Pr&eacute;stamos con mayor nivel de riesgo. Entre los pr&eacute;stamos en esta categor&iacute;a se encuentran NPL 60, NPL90, NPL120 y pr&eacute;stamos en litigio, lo que proporciona la mayor rentabilidad entre todas las categor&iacute;as.</td> </tr> </tbody> </table> <p>Una vez al mes el Comit&eacute; de Riesgos analiza y revisa el proceso de asignaci&oacute;n de la clasificaci&oacute;n a los pr&eacute;stamos. Despu&eacute;s, los pr&eacute;stamos emitidos se dividen por estrategias.',
    HelperAnnualRateTitle: "Tasa de inter&eacute;s anual",
    HelperAnnualRateText:
      "La tasa de rentabilidad se fija y se aprueba mensualmente por el Comit&eacute; de Riesgos interno y depende de los resultados del per&iacute;odo bajo revisi&oacute;n.",
    HelperStrategyClassicTitle:
      "Estrategia Cl&aacute;sica con garant&iacute;a de recompra (BuyBack)",
    HelperStrategyClassicText:
      "Inviertes en los pr&eacute;stamos al consumo sin garant&iacute;a clasificados como AA, A, BB, para los cuales el riesgo de que el prestatario incurra en morosidad es extremadamente bajo. Con la garant&iacute;a de recompra, est&aacute;s protegido contra riesgos y recibes ingresos garantizados a una tasa de inter&eacute;s fija.</p> <p><strong>Riesgos&nbsp;asociados​</strong></p> <p><strong>Riesgo de impago del pr&eacute;stamo / de incumplimiento del calendario de pago / de no devoluci&oacute;n de la cantidad total del pr&eacute;stamo adeudado</strong></p> <p>Estos riesgos del inversor est&aacute;n cubiertos de una garant&iacute;a de recompra de los activos recibidos e intereses. Vamos a ver c&oacute;mo funciona: el inversor de la plataforma Nibble eligiendo esta estrategia invierte en pr&eacute;stamos emitidos por las empresas del grupo IT Smart Finance que est&aacute;n disponibles para el d&iacute;a. La empresa del holding coloca el pr&eacute;stamo emitido en la plataforma Nibble para encontrar un inversor. La relaci&oacute;n entre las empresas del grupo IT Smart Finance y el prestatario final se rige por un contrato de pr&eacute;stamo al consumo a corto plazo con los consiguientes derechos de reclamaci&oacute;n contra el prestatario. Sobre la base del contrato de cesi&oacute;n celebrado con el inversor, Nibble asume la obligaci&oacute;n de recibir los pagos del prestatario final realizados a las empresas del grupo IT Smart Finance de acuerdo con los contratos de pr&eacute;stamos al consumo a corto plazo y luego pagarlos al inversor en la forma y por valor establecidos por el contrato de cesi&oacute;n. Si el prestatario no reembolsa el pr&eacute;stamo a tiempo o prolonga su per&iacute;odo de reembolso, las empresas del grupo IT Smart Finance compran el derecho de reclamaci&oacute;n del inversor de Nibble por el importe de la inversi&oacute;n y los ingresos garantizados de la estrategia.",
    HelperStrategyBalancedTitle: "Estrategia Equilibrada",
    HelperStrategyBalancedText:
      "Inviertes en los pr&eacute;stamos al consumo clasificados como BB, B y CC. Normalmente el grado del riesgo de impago de un pr&eacute;stamo con esta clasificaci&oacute;n es extremadamente bajo, para tales pr&eacute;stamos son posibles retrasos en los pagos, NPL30 y NPL60, pero casi siempre se pagan. El riesgo de incumplimiento en esta estrategia es bajo, pero la rentabilidad es significativamente mayor que en la estrategia con la rentabilidad fija.</p> <p><strong>Riesgos&nbsp;asociados​</strong></p> <p><strong>Sin&nbsp;garant&iacute;a​</strong></p> <p>Las inversiones en esta estrategia no tienen garant&iacute;a de recompra, ni est&aacute;n aseguradas por ning&uacute;n fondo estatal, es decir, si el prestatario no devuelve el pr&eacute;stamo, el inversor corre el riesgo de perder el capital invertido o parte del mismo.</p> <p><strong>Riesgo de obtener ingresos a una tasa inferior a la esperada o no obtener ningunos ingresos​</strong></p> <p>Nibble no garantiza ingresos en esta estrategia. El inversor compra los derechos de reclamaci&oacute;n contra los prestatarios finales y los ingresos que recibe dependen directamente del cumplimiento de las obligaciones de devolver el pr&eacute;stamo por parte de los prestatarios. Si el prestatario no reembolsa el pr&eacute;stamo en su totalidad o en parte, es posible que el inversor no reciba los ingresos o el plazo de devoluci&oacute;n del importe invertido y de los ingresos devengados aumente.</p> <p>La tasa de rentabilidad real de esta estrategia supera la tasa de rentabilidad m&aacute;xima declarada del 13%. Los ingresos generados en exceso no son propiedad de la plataforma Nibble y se reinvierten para reducir el riesgo y lograr la tasa de rentabilidad establecida.",
    HelperStrategySpecialTitle: "Estrategia Especial",
    HelperStrategySpecialText:
      "Inviertes en los pr&eacute;stamos al consumo sin garant&iacute;a clasificados como B, CC y C. En esta estrategia el riesgo de impago del pr&eacute;stamo es mayor que en la estrategia Equilibrada, pero al mismo tiempo la rentabilidad es de hasta el 19% anual, lo que recupera posibles p&eacute;rdidas dentro del importe de la cartera de inversiones. El plazo m&iacute;nimo de inversi&oacute;n de 12 meses se explica por el hecho de que esta estrategia contiene pr&eacute;stamos que pueden tener un retraso en el pago y su cobro puede demorar m&aacute;s tiempo.</p> <p><strong>Riesgos&nbsp;asociados​</strong></p> <p><strong>Sin&nbsp;garant&iacute;a​</strong></p> <p>Las inversiones en esta estrategia no tienen garant&iacute;a de recompra, ni est&aacute;n aseguradas por ning&uacute;n fondo estatal, es decir, si el prestatario no devuelve el pr&eacute;stamo, el inversor corre el riesgo de perder el capital invertido o parte del mismo.</p> <p><strong>Riesgo de obtener ingresos a una tasa inferior a la esperada o no obtener ningunos ingresos​</strong></p> <p>Nibble no garantiza ingresos en esta estrategia. El inversor compra los derechos de reclamaci&oacute;n contra los prestatarios finales y los ingresos que recibe dependen directamente del cumplimiento de las obligaciones de devolver el pr&eacute;stamo por parte de los prestatarios. Si el prestatario no reembolsa el pr&eacute;stamo en su totalidad o en parte, es posible que el inversor no reciba los ingresos o el plazo de devoluci&oacute;n del importe invertido y de los ingresos devengados aumente.</p> <p>La tasa de rentabilidad real de esta estrategia supera la tasa de rentabilidad m&aacute;xima declarada del 19%. Los ingresos generados en exceso no son propiedad de la plataforma Nibble y se reinvierten para reducir el riesgo y lograr la tasa de rentabilidad establecida.",

    IdentFailed: "Identificación fallida.",
    Identification: "Identificación",
    IdentificationGoal1: "Cumplir con las leyes de la Unión Europea",
    IdentificationGoal2:
      "Garantizar la seguridad de tus fondos y transacciones",
    IdentificationGoal3:
      "Simplificar los procesos comerciales haciendolos transparentes y eficientes",
    IdentificationGoalsTitle:
      "Nuestros objetivos generales de la identificación personal:",
    IdentificationH1:
      "¿por qué te pedimos que nos proporciones las fotografías de los documentos?",
    IdentificationLead:
      "Nibble sigue rigurosamente los estándares estrictos de la ley europea en cuanto al blanqueo de dinero (AML), la verificación de usuarios, el almacenamiento y el uso de los datos personales.",
    IdentificationProfitsList:
      '<li class="veriffFeature-list__item">La inversión está disponible solo para los usuarios verificados</li> <li class="veriffFeature-list__item">Tus datos se transmiten mediante un canal protegido y se almacenan de una forma cifrada</li> <li class="veriffFeature-list__item">No compartimos tus datos personales con los terceros</li> <li class="veriffFeature-list__item">Asumimos toda la responsabilidad por la seguridad de tus datos personales</li>',
    IdentityDocHint:
      "Para la identificación personal puedes utilizar tanto una tarjeta de identidad como una licencia de conducir. Si proporcionas una licencia de conducir, asegúrate de sacar y cargar las fotos de ambos lados de la licencia.",
    IDHint:
      "Por favor, asegúrate de indicar el número y la serie del documento seleccionado",
    ID: "ID",
    IDNumber: "Serie y número de documento",
    Income: "Depósito",
    IncomeCalculation: "Devengo de ingresos",
    IncomeReceived: "ingresos recibidos",
    Individual: "Individuo",
    InitialDeposit: "Depósito inicial",
    InterestRate: "Tipo de interés",
    Invest: "Invertir",
    InvestedInPortfolio: "Invertido en la cartera",
    InvestedLoans: "Préstamos invertidos",
    Investing: "Inversión",
    InvestingIn: "Invertir en ( I D X)",
    Investment_amount: "Cantidad de inversión",
    Investment_date: "Fecha de inversión",
    Investment_type: "Tipo de inversión",
    InvestmentAmount: "Cantidad de inversión",
    InvestmentPeriod: "Plazo de inversión, meses",
    InvestmentPeriodDays: "Plazo de inversión, días",
    InvestmentPortfolios: "Carteras de inversión",
    InvestmentsCountTotal: "Total invertido, número",
    InvestmentsSumTotal: "total de inversiones",
    IHavePromoCode: "Tengo un código promocional",

    InformationTitleSection1: "Inversiones con Nibble",
    InformationContentSection1: `
        <p>Te ofrecemos tres estrategias de inversión: Clásica, Equilibrada y Estrategia Legal. Se diferencian no solo
        por el nivel de rentabilidad anual, sino tambi&eacute;n por el nivel de riesgos y c&oacute;mo se distribuyen
        estos riesgos entre la plataforma y el usuario. Compara nuestras estrategias y elige la que m&aacute;s te
        convenga.</p>
    <ul>
        <li>Hasta si no tienes experiencia en inversiones, prueba inversiones con ingresos protegidos y nosotros
            asumimos los riesgos.</li>
        <li>Si ya eres un inversor experimentado, elige una estrategia que se te adapte mejor en relaci&oacute;n
            riesgo&ndash;rentabilidad. Compartimos los riesgos contigo.</li>
    </ul>
    <h3>Condiciones de las estrategias de inversi&oacute;n</h3>
    <div class="article-table">
        <table border="0" cellpadding="0" cellspacing="0">
            <tbody>
                <tr>
                    <td><strong>Estrategia</strong></td>
                    <td><strong>Cl&aacute;sica</strong></td>
                    <td><strong>Equilibrada</strong></td>
                    <td><strong>Estrategia Legal</strong></td>
                </tr>
                <tr>
                    <td><strong>Tasa de inter&eacute;s anual</strong></td>
                    <td>8%</td>
                    <td>12.5%</td>
                    <td>14.5%</td>
                </tr>
                <tr>
                    <td><strong>Resumen</strong></td>
                    <td>Ingresos&nbsp;protegidos</td>
                    <td>Riesgos equilibrados</td>
                    <td>Alto rendimiento para inversores pacientes</td>
                </tr>
                <tr>
                    <td><strong>Descripci&oacute;n</strong></td>
                    <td>La rentabilidad de esta estrategia es fija, respaldada por una garant&iacute;a de recompra y
                        asciende al 8% anual. La estrategia asegura la ausencia de riesgos y la rentabilidad
                        garantizada.</td>
                    <td>La rentabilidad no es fija y, seg&uacute;n las estad&iacute;sticas de periodos anteriores, puede
                        ascender al 12-15% anual. La estrategia m&aacute;s equilibrada en relaci&oacute;n
                        riesgo&ndash;rentabilidad.</td>
                    <td>
                        <p>Esta es una estrategia para invertir en carteras compuestas por préstamos de consumo
                            clasificados como B, CC y C, que se encuentran en proceso de recuperación tanto
                            extrajudicial como judicial. Debido a que estos préstamos tienen morosidad y multas, la
                            rentabilidad de esta estrategia alcanza hasta un 19% anual.</p>
                        <p>El período mínimo de inversión de 6 meses se explica por el hecho de que el proceso de
                            litigio y recuperación toma un largo período de tiempo.</p>
                    </td>
                </tr>
                <tr>
                    <td><strong>Plazo de inversi&oacute;n</strong></td>
                    <td>1&ndash;6 meses</td>
                    <td>7&ndash;60 meses</td>
                    <td>6&ndash;60 meses</td>
                </tr>
                <tr>
                    <td><strong>Garant&iacute;a de recompra (BuyBack)</strong></td>
                    <td><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOCAyTDcgMTNMMiA4IiBzdHJva2U9IiNCN0Q3NUQiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="
                            alt="check"></td>
                    <td>&mdash;</td>
                    <td>
                        <ul>
                            <li>
                                Garantía de devolución del depósito
                            </li>
                            <li>
                                Rendimiento mínimo garantizado del 8% anual
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td><strong>Reinversi&oacute;n</strong></td>
                    <td colspan="2">reinversi&oacute;n autom&aacute;tica de los fondos invertidos en nuevos
                        pr&eacute;stamos</td>
                    <td>
                        <img src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNERTM1MEIiIGN4PSI4IiBjeT0iOCIgcj0iOCIvPjxwYXRoIGQ9Ik05LjQ4NSA4LjA3MWwyLjEyMiAyLjEyMWExIDEgMCAxIDEtMS40MTUgMS40MTVsLTIuMTItMi4xMjItMi4xMjIgMi4xMjJhMSAxIDAgMSAxLTEuNDE0LTEuNDE1bDIuMTItMi4xMi0yLjEyLTIuMTIyQTEgMSAwIDEgMSA1Ljk1IDQuNTM2bDIuMTIxIDIuMTIgMi4xMjEtMi4xMmExIDEgMCAxIDEgMS40MTUgMS40MTRMOS40ODUgOC4wN3oiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+'/>
                    </td>
                </tr>
                <tr>
                    <td><strong>Devengo y transferencia de intereses</strong></td>
                    <td colspan="2">los intereses se devengan diariamente y se transfieren semanalmente a la cuenta del
                        inversor de Nibble</td>
                    <td>
                        Devengo diario de intereses a una tasa del 8% anual, pagos cada 90 días según el rendimiento de
                        hecho recibido hasta el 14,5% anual.
                    </td>
                </tr>
                <tr>
                    <td><strong>Clasificaci&oacute;n de pr&eacute;stamos por riesgo de morosidad (NPL)</strong></td>
                    <td>АА&ndash;А&ndash;ВВ</td>
                    <td>ВВ&ndash;В&ndash;СС</td>
                    <td>В&ndash;СС&ndash;С</td>
                </tr>
                <tr>
                    <td><strong>Tasa de impago prevista</strong></td>
                    <td>&mdash;</td>
                    <td>hasta NPL 30</td>
                    <td>NPL 30&ndash;90</td>
                </tr>
                <tr>
                    <td><strong>Importe de inversi&oacute;n **</strong></td>
                    <td>10&ndash;10 000 &euro;</td>
                    <td>100&ndash;10 000 &euro;</td>
                    <td>10&ndash;10 000 &euro;</td>
                </tr>
                <tr>
                    <td><strong>Importe m&iacute;nimo de retiro</strong></td>
                    <td colspan="3">50 &euro;</td>
                </tr>
            </tbody>
        </table>
    </div>
    <p><small>*&nbsp;La tasa de rentabilidad se fija y se aprueba mensualmente por el Comit&eacute; de Riesgos interno y
            depende de los resultados del per&iacute;odo bajo revisi&oacute;n.<br /> **&nbsp;Si deseas invertir
            m&aacute;s de 15.000 &euro;, te pediremos que proporciones documentos adicionales.</small></p>
    <h3>Estrategia Cl&aacute;sica con garant&iacute;a de recompra (BuyBack)</h3>
    <p>Inviertes en los pr&eacute;stamos al consumo sin garant&iacute;a clasificados como AA, A, BB, para los cuales el
        riesgo de que el prestatario incurra en morosidad es extremadamente bajo. Con la garant&iacute;a de recompra,
        est&aacute;s protegido contra riesgos y recibes ingresos garantizados a una tasa de inter&eacute;s fija.</p>
    <p><strong>Riesgos&nbsp;asociados​</strong></p>
    <p><strong>Riesgo de impago del pr&eacute;stamo / de incumplimiento del calendario de pago / de no devoluci&oacute;n
            de la cantidad total del pr&eacute;stamo adeudado</strong></p>
    <p>Estos riesgos del inversor est&aacute;n cubiertos de una garant&iacute;a de recompra de los activos recibidos e
        intereses. Vamos a ver c&oacute;mo funciona: el inversor de la plataforma Nibble eligiendo esta estrategia
        invierte en pr&eacute;stamos emitidos por las empresas del grupo IT Smart Finance que est&aacute;n disponibles
        para el d&iacute;a. La empresa del holding coloca el pr&eacute;stamo emitido en la plataforma Nibble para
        encontrar un inversor. La relaci&oacute;n entre las empresas del grupo IT Smart Finance y el prestatario final
        se rige por un contrato de pr&eacute;stamo al consumo a corto plazo con los consiguientes derechos de
        reclamaci&oacute;n contra el prestatario. Sobre la base del contrato de cesi&oacute;n celebrado con el inversor,
        Nibble asume la obligaci&oacute;n de recibir los pagos del prestatario final realizados a las empresas del grupo
        IT Smart Finance de acuerdo con los contratos de pr&eacute;stamos al consumo a corto plazo y luego pagarlos al
        inversor en la forma y por valor establecidos por el contrato de cesi&oacute;n. Si el prestatario no reembolsa
        el pr&eacute;stamo a tiempo o prolonga su per&iacute;odo de reembolso, las empresas del grupo IT Smart Finance
        compran el derecho de reclamaci&oacute;n del inversor de Nibble por el importe de la inversi&oacute;n y los
        ingresos garantizados de la estrategia.</p>
    <h3>Estrategia Equilibrada</h3>
    <p>Inviertes en los pr&eacute;stamos al consumo clasificados como BB, B y CC. Normalmente el grado del riesgo de
        impago de un pr&eacute;stamo con esta clasificaci&oacute;n es extremadamente bajo, para tales pr&eacute;stamos
        son posibles retrasos en los pagos, NPL30 y NPL60, pero casi siempre se pagan. El riesgo de incumplimiento en
        esta estrategia es bajo, pero la rentabilidad es significativamente mayor que en la estrategia con la
        rentabilidad fija.</p>
    <p><strong>Riesgos&nbsp;asociados​</strong></p>
    <p><strong>Sin&nbsp;garant&iacute;a​</strong></p>
    <p>Las inversiones en esta estrategia no tienen garant&iacute;a de recompra, ni est&aacute;n aseguradas por
        ning&uacute;n fondo estatal, es decir, si el prestatario no devuelve el pr&eacute;stamo, el inversor corre el
        riesgo de perder el capital invertido o parte del mismo.</p>
    <p><strong>Riesgo de obtener ingresos a una tasa inferior a la esperada o no obtener ningunos ingresos​</strong></p>
    <p>Nibble no garantiza ingresos en esta estrategia. El inversor compra los derechos de reclamaci&oacute;n contra los
        prestatarios finales y los ingresos que recibe dependen directamente del cumplimiento de las obligaciones de
        devolver el pr&eacute;stamo por parte de los prestatarios. Si el prestatario no reembolsa el pr&eacute;stamo en
        su totalidad o en parte, es posible que el inversor no reciba los ingresos o el plazo de devoluci&oacute;n del
        importe invertido y de los ingresos devengados aumente.</p>
    <p>La tasa de rentabilidad real de esta estrategia supera la tasa de rentabilidad m&aacute;xima declarada del 15%.
        Los ingresos generados en exceso no son propiedad de la plataforma Nibble y se reinvierten para reducir el
        riesgo y lograr la tasa de rentabilidad establecida.</p>
    <h3>Estrategia Legal</h3>
    <p>Esta es una estrategia para invertir en carteras compuestas por préstamos de consumo clasificados como B, CC y C,
        que se encuentran en proceso de recuperación tanto extrajudicial como judicial. Debido a que estos préstamos
        tienen morosidad y multas, la rentabilidad de esta estrategia alcanza hasta un 19% anual.</p>
    <p>El período mínimo de inversión de 6 meses se explica por el hecho de que el proceso de litigio y recuperación
        toma un largo período de tiempo. La gestión de litigios y cobranzas la proporciona Boostr.</p>
    <p><strong>Riesgos&nbsp;asociados:​</strong></p>
    <p><strong>Riesgo de impago del préstamo/incumplimiento de la totalidad del importe del préstamo​</strong></p>
    <p>
    <ul>
        <li>La estrategia está respaldada por una garantía de devolución del depósito. Esta es la obligación de la
            agencia de cobro de devolver el monto total de la inversión al final del período de inversión y garantizar
            un rendimiento mínimo del 8% anual.</li>
        <li>Debido a la inversión en una cartera compuesta por un gran número de préstamos, se reduce el riesgo de no
            recibir ingresos de varios contratos, se cubren con otros préstamos.</li>
        <li>Devengo diario de intereses a una tasa del 8% anual, pagos cada 90 días según el rendimiento de hecho
            recibido hasta el 14,5% anual.</li>
        <li>Mientras se recauda dinero para comprar una cartera, te devengamos ingresos a una tasa del 8% anual. Este es
            tu rendimiento de bonificación al principal hasta el 14,5%. El plazo máximo de recaudación de dinero para
            comprar una cartera es de 30 días.</li>
    </ul>
    </p>
    <p><strong>¿Cómo funciona?​</strong></p>
    <p>Te devengamos intereses diarios a una tasa del 8% anual. Cada 90 días calculamos automáticamente el rendimiento
        de hecho de las carteras y te devengamos adicionalmente la diferencia entre la tasa garantizada del 8% y la tasa
        de hecho. Así, cada 90 días recibes un ingreso del 8% al 14,5% a tu cuenta de Nibble.</p>
    <p>Ejemplo: Al invertir 1000 euros para 12 meses, al final del plazo recuperas todo tu capital de 1000 euros y
        recibes ingresos de 90 a 145 euros, que te pagamos cada 90 días.</p>
        `,
    InformationTitleSection2:
      "Clasificaci&oacute;n de pr&eacute;stamos por riesgo de morosidad: NPL 30, 60, 90, 120+",
    InformationContentSection2:
      '<p>Las empresas del holding IT Smart Finance utilizan modelos de puntuaci&oacute;n para determinar la calidad de los prestatarios. A todos los pr&eacute;stamos aprobados se les asigna una clasificaci&oacute;n correspondiente.</p> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>AA</strong></td> <td><strong>A</strong></td> <td><strong>ВВ</strong></td> <td><strong>В</strong></td> <td><strong>СС</strong></td> <td><strong>С</strong></td> </tr> <tr> <td>pagados a tiempo</td> <td>pagados con anticipaci&oacute;n</td> <td>vencidos, NPL 0&ndash;30</td> <td>vencidos, NPL 30&ndash;60</td> <td>vencidos, NPL 60&ndash;90</td> <td>vencidos, NPL 90&ndash;120</td> </tr> <tr> <td colspan="2">Pr&eacute;stamos de bajo riesgo. Los clientes de esta categor&iacute;a normalmente devuelven el dinero a tiempo o con anticipaci&oacute;n, por lo tanto su rentabilidad no es alta, pero los riesgos tampoco.</td> <td colspan="2">Pr&eacute;stamos de riesgo medio. Los clientes de esta categor&iacute;a pueden incurrir en morosidad (NPL30 y NPL60), pero casi siempre terminan devolviendo los pr&eacute;stamos. El riesgo de impago para esta categor&iacute;a es mayor, pero la rentabilidad media tambi&eacute;n es mayor.</td> <td colspan="2">Pr&eacute;stamos con mayor nivel de riesgo. Entre los pr&eacute;stamos en esta categor&iacute;a se encuentran NPL 60, NPL90, NPL120 y pr&eacute;stamos en litigio, lo que proporciona la mayor rentabilidad entre todas las categor&iacute;as.</td> </tr> </tbody> </table> </div> <p>Una vez al mes el Comit&eacute; de Riesgos analiza y revisa el proceso de asignaci&oacute;n de la clasificaci&oacute;n a los pr&eacute;stamos. Despu&eacute;s, los pr&eacute;stamos emitidos se dividen por estrategias.</p> <h3>El producto Inversi&oacute;n flexible incluye tres estrategias de inversi&oacute;n</h3> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>АА</strong></td> <td><strong>A</strong></td> <td colspan="1"><strong>ВВ</strong></td> <td colspan="1"><strong>В</strong></td> <td colspan="1"><strong>СС</strong></td> <td colspan="1"><strong>С</strong></td> </tr> <tr> <td colspan="3"><strong>Estrategia&nbsp;Cl&aacute;sica</strong></td> <td colspan="3" rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">65%</td> <td colspan="1">25%</td> <td colspan="1">10%</td> </tr> <tr> <td colspan="2" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Estrategia&nbsp;Equilibrada</strong></td> <td rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">63%</td> <td colspan="1">32%</td> <td colspan="1">5%</td> </tr> <tr> <td colspan="3" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Estrategia Legal</strong></td> </tr> <tr> <td colspan="1">54%</td> <td colspan="1">28%</td> <td colspan="1">18%</td> </tr> </tbody> </table> </div> <p>Para cada estrategia se seleccionan autom&aacute;ticamente los pr&eacute;stamos de la clasificaci&oacute;n correspondiente. Cada estrategia puede incluir hasta 3 tipos de NPL, lo que permite recibir los ingresos declarados y asegurar los requisitos de riesgo correspondientes.</p>',
    InformationTitleSection3: "Retiro de fondos de la cuenta",
    InformationContentSection3: `<p>El retiro de los fondos no invertidos y de los ingresos recibidos despu&eacute;s del vencimiento de la cartera de inversiones se realiza a la cuenta bancaria del inversor a trav&eacute;s del &aacute;rea personal de Nibble.</p> 
      <ul> 
      <li>El importe m&iacute;nimo de retiro es de 50 &euro;</li>  
      <li>Nibble transfiere dinero solo a la cuenta perteneciente al inversor. Es una medida necesaria que protege a nuestros inversores y previene el blanqueo de capitales.</li> 
      <li>Se puede cambiar el n&uacute;mero de la cuenta al ponerse en contacto con nuestro servicio de atenci&oacute;n al cliente. En este caso, nuestro inspector AML solicitar&aacute; documentos adicionales.</li> 
      </ul> 
      <h3>Resoluci&oacute;n anticipada del acuerdo de inversi&oacute;n y retiro de fondos</h3> 
      <p>Puedes resolver anticipadamente el acuerdo de inversi&oacute;n y retirar fondos de la plataforma Nibble. Para hacerlo, debes enviar una solicitud de resoluci&oacute;n anticipada del acuerdo a trav&eacute;s de tu &aacute;rea personal de Nibble. Despu&eacute;s de recibir tu solicitud, comenzaremos a buscar un inversor para tu cartera. La cartera solo se puede revender en su totalidad. Si no encontramos un inversor dentro de los 60 d&iacute;as naturales posteriores a la recepci&oacute;n de la solicitud de resoluci&oacute;n del acuerdo, al d&iacute;a 61 te pagaremos el importe de los activos invertidos y el inter&eacute;s correspondiente del fondo de reserva de la empresa, descontando una comisi&oacute;n del 3% del importe total a pagar.</p>`,
    InformationTitleSection4: "Pol&iacute;tica de recompra (BuyBack)",
    InformationContentSection4: `
        <p>Para asegurar la devoluci&oacute;n de los fondos en la estrategia Cl&aacute;sica, el prestamista proporciona una
        garant&iacute;a de recompra. Es una obligaci&oacute;n del prestamista de recomprar el pr&eacute;stamo al
        inversor si el pr&eacute;stamo no ha sido pagado dentro de los 60 d&iacute;as a partir de la fecha de la
        inversi&oacute;n.</p>
    <p>En este caso junto con el importe inicial del pr&eacute;stamo, el prestamista pagar&aacute; los intereses
        correspondientes al inversor. Los fondos para garantizar estas obligaciones se acumulan en el fondo de reserva
        de la empresa.</p>
    <h3>C&oacute;mo funciona la pol&iacute;tica de recompra:</h3>
    <ul>
        <li>Eligiendo una estrategia Cl&aacute;sica nuestros inversores invierten en los pr&eacute;stamos emitidos por
            las empresas del grupo IT Smart Finance.</li>
        <li>Las empresas del holding colocan los pr&eacute;stamos emitidos en la plataforma Nibble para encontrar
            inversores.</li>
        <li>La relaci&oacute;n entre las empresas del grupo IT Smart Finance y el prestatario se rige por un contrato de
            pr&eacute;stamo al consumo a corto plazo con los derechos de reclamaci&oacute;n contra el prestatario
            derivados del mismo.</li>
        <li>Bas&aacute;ndose en el contrato de cesi&oacute;n celebrado con el inversor, Nibble asume las siguientes
            obligaciones: <ol>
                <li>recibir pagos del prestatario final realizados a las empresas del grupo IT Smart Finance de acuerdo
                    con el contrato de pr&eacute;stamo al consumo a corto plazo</li>
                <li>transferirlos al inversor en la forma e importe establecidos por el contrato de cesi&oacute;n.</li>
            </ol>
        </li>
        <li>Si el prestatario no devuelve el pr&eacute;stamo a tiempo o extiende el plazo del pr&eacute;stamo, las
            empresas del grupo IT Smart Finance recompran el derecho de reclamaci&oacute;n del inversor de Nibble por el
            importe de la inversi&oacute;n y los intereses garantizados del pr&eacute;stamo.</li>
    </ul>
    <p>
        <h3>
            Estrategia Legal
        </h3>
    </p>
    <p>
        La estrategia está respaldada por una garantía de devolución del depósito. Esta es la obligación de la agencia
        de cobro de devolver el monto total de la inversión al final del período de inversión y garantizar un
        rendimiento mínimo del 8% anual.
    </p>
    <p>
        <strong>
            ¿Cómo funciona?
        </strong>
    </p>
    <p>Te devengamos intereses diarios a una tasa del 8% anual. Cada 90 días calculamos automáticamente el rendimiento
        de hecho de las carteras y te devengamos adicionalmente la diferencia entre la tasa garantizada del 8% y la tasa
        de hecho. Así, cada 90 días recibes un ingreso del 8% al 14,5% a tu cuenta de Nibble.</p>
    <p>Ejemplo: Al invertir 1000 euros para 12 meses, al final del plazo recuperas todo tu capital de 1000 euros y
        recibes ingresos de 90 a 145 euros, que te pagamos cada 90 días.</p>
        `,
    InformationTitleSection5: "Pol&iacute;tica general de riesgos",
    InformationContentSection5:
      "<p>Los riesgos se comparten entre el inversor y las instituciones microfinancieras de la siguiente manera:</p> <ul> <li>Si la estrategia ofrece una garant&iacute;a de recompra, el riesgo de incumplimiento lo asume la instituci&oacute;n microfinanciera a expensas del fondo de reserva</li> <li>Si la estrategia no prev&eacute; una garant&iacute;a de recompra, el riesgo de impago se comparte entre el inversor y la instituci&oacute;n microfinanciera y se expresa en forma de la tasa de inter&eacute;s variable</li> <li>El riesgo de variaci&oacute;n de tipos de cambio en las estrategias actuales se asume por la instituci&oacute;n microfinanciera</li> </ul>",
    InformationTitleSection6: "Comit&eacute; de Riesgos",
    InformationContentSection6:
      "<p>El Comit&eacute; de Riesgos se re&uacute;ne al final de cada mes para determinar las tasas de inter&eacute;s actuales para las estrategias Equilibrada y Especial.</p> <h3>El Comit&eacute; de Riesgos est&aacute; compuesto por los jefes de los siguientes departamentos del grupo de empresas IT Smart Finance:</h3> <ul> <li>Director de Riesgos</li> <li>Director Operativo</li> <li>Jefe del Departamento de Cobros</li> <li>Jefe del Departamento de Underwriting</li> <li>Analista de Riesgos</li> </ul> <h3>Principales tareas del Comit&eacute;:&nbsp;</h3> <ul> <li>Estudiar y analizar los resultados del trabajo realizado en cuanto a NPL 30-60-90-120 del mes de reporte.</li> <li>Comparar los indicadores reales con los programados del periodo.</li> <li>Analizar el modelo de puntuaci&oacute;n.</li> <li>Hacer una previsi&oacute;n para el periodo posterior y calibrar el modelo de puntuaci&oacute;n.</li> <li>Fijar y aprobar la tasa de rentabilidad anual actual para la estrategia Equilibrada y Especial.</li> </ul> <p>Los resultados de la reuni&oacute;n del Comit&eacute; de Riesgos se publican en forma de reporte en el sitio web</p>",
    InformationTitleSection7: "Creaci&oacute;n del fondo de reserva",
    InformationContentSection7:
      "<p>El fondo de reserva es un &laquo;colch&oacute;n de seguridad&raquo; adicional para el inversor, que cubre los riesgos de impago del pr&eacute;stamo por parte del prestatario final. Gracias al fondo de reserva ofrecemos a los inversores una estrategia de inversi&oacute;n con una garant&iacute;a de recompra.</p>",
    InformationTitleSection8: "Garant&iacute;as de seguridad y privacidad",
    InformationContentSection8:
      '<p>Priorizamos la protecci&oacute;n de tus datos personales y la seguridad de tus transacciones. Estas son algunas de las garant&iacute;as de que estas prioridades son importantes:</p> <h3>Garant&iacute;as de seguridad</h3> <ul> <li>Los datos se almacenan de acuerdo con la norma de seguridad ISO 27001: 2013</li> <li>Todas las contrase&ntilde;as se almacenan en el sistema de una manera protegida</li> <li>La cuenta bancaria se vincula a la cuenta al hacer la primera reposici&oacute;n de saldo y solo puede ser cambiada despu&eacute;s de la identificaci&oacute;n manual del inversor</li> <li>De acuerdo con las leyes de la Uni&oacute;n Europea estamos obligados a identificar a los clientes. Nibble utiliza servicios de una empresa contratista Veriff. Se puede encontrar la informaci&oacute;n sobre su pol&iacute;tica de privacidad aqu&iacute;:&nbsp;<a href="https://www.veriff.com/privacy-policy">https://www.veriff.com/privacy-policy</a></li> </ul> <h3>Garant&iacute;as de privacidad</h3> <ul> <li>La plataforma Nibble es un operador del tratamiento de datos personales seg&uacute;n las leyes de la Uni&oacute;n Europea</li> <li>No comunicamos datos personales de los inversores a terceros</li> </ul> <h3>Garant&iacute;as en cuanto a los riesgos financieros</h3> <ul> <li>Todas las inversiones se atraen por el grupo de empresas del&nbsp;<a href="https://itsmartfinance.com/">IT Smart Finance Holding</a></li> <li>La estrategia Cl&aacute;sica proporciona una garant&iacute;a de recompra desde el fondo de reserva</li> <li>La plataforma de inversi&oacute;n Nibble es una parte del holding IT Smart Finance que une a los prestamistas de Eurasia, Europa y Am&eacute;rica Latina</li> </ul>',

    JoinUs: "Únete a nosotros",
    JoymoneyInfo:
      "La compañía Joymoney Es concede préstamos con el plazo máximo de 30 días en el territorio de España. Todos los préstamos están protegidos con la garantía de recompra, en caso de que el préstamo no haya sido cerrado durante 60 días desde el día de la inversión, Joymoney Es recompra la parte del inversor junto con los interéses devengados.",
    Later: "más tarde",
    Legal: "Entidad legal",
    literal_bread_reg: "Registro",
    LittleBitLeft: "Sólo queda un poco",
    LoanType: "Tipo de préstamo",
    LoginBtn: "Iniciar",
    LoginHead: "Iniciar sesión",
    LongTerm: "A largo plazo",
    LongTermInvestmensInfo:
      "Las inversiones a largo plazo permiten recibir el ingreso máximo debido a que durante el período de reinversión el importe de los préstamos cerrados se reinvierte de nuevo (en su totalidad o solo el monto principal de la deuda, depende de los parámetros).",
    LongTermPortfolio: "Inversiones a largo plazo",
    LowBalanceAlert:
      "En tu cuenta no hay saldo suficiente para crear una cartera con los parámetros elegidos",
    MessageWithdrawalSuccess:
      "La solicitud está recibida. El dinero se retira en 5-7 días hábiles",
    // ResultPaymentSuccessTitle: "The balance has been successfully replenished!",
    MonthlyDeposit: "Depósito mensual",
    MonthlyDepositInfo:
      "Puedes recargar tu cartera no más tarde de 3 meses antes de que termine el período de la cartera",
    MonthlyReport: "Informe mensual",
    Months: "meses",
    MrLabel: "Sr.",
    MsLabel: "Sra.",
    MyAccount: "Mi cuenta",
    MyInvestments: "Mis inversiones",
    NameChangeWarning:
      "Puedes cambiar tu nombre y apellido hasta que hayas verificado tu identidad con Veriff",
    NeedToVerifyBySMS:
      "Hace falta confirmar el teléfono indicado mediante un SMS",
    NewPassDlina: "Nueva contraseña contiene menos de 5 caracteres",
    NewPassword: "Nueva clave",
    NewPasswordInfo:
      "Crea una contraseña segura. Te recomendamos que incluyas símbolos, números y mayúsculas",
    NewPasswordSent: "La nueva contraseña ha sido enviada a tu e-mail",
    NewRepeatPasChange: "Las contraseñas no coinciden",
    News: "Noticias",
    NewsletterCheckboxLabel: "Recibir boletines diarios",
    Next: "Siguiente",
    NibbleAgreement: "Acuerdo con Nibble",
    No: "No",
    Notifications: "Notificaciones",
    NotLimited: "sin límites",
    OnlyActive: "Solo las activas",
    Opened: "Abierto",
    Operation: "Operación",
    OperationDate: "Fecha de la operación",
    OrEmail: "OrEmail",
    OutputFail: "No se puede retirar esta cantidad",
    Page: "Página",
    PageNotExist: "Lo sentimos, la página requerida no existe.",
    PageNotFound: "Página no encontrada",
    Partial: "Parcial",
    PartnerCode: "Compartir el código promocional",
    PartnerCodeSet: "Código promocional de invitación",
    PartnerFaq:
      '<h2 class="title faq__title">¿Tienes alguna duda?</h2> <div class="box faq-wrapper"> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">¿Cuál es el período de validez de un código promocional o enlace de referencia?</span> <p class="faq-answer__text"> El código promocional/enlace es válido desde el momento de la generación y no tiene fecha de vencimiento. </p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Cuando uno de mis amigos invierte más de 1000 euros, ¿no recibiré mi remuneración?</span> <p class="faq-answer__text"> En este caso tu amigo y tú recibiréis el 2% del importe de 1000 euros. </p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">¿Recibiré ingresos si uno de mis amigos invierte menos de 1.000 euros?</span> <p class="faq-answer__text"> Si tu amigo realiza una inversión de menos de 1000 euros, recibiréis los dos una remuneración del 2% de la cantidad invertida. </p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">¿Cuántos amigos puedo traer utilizando el código promocional o enlace de referencia? </span> <p class="faq-answer__text"> Puedes traer un número ilimitado de amigos utilizando el código promocional o enlace de referencia. </p> </div> </div>',
    PartnerInfo:
      '<h1 class="title partner__title">Cuéntales a tus amigos sobre nuestro servicio y obtén tu remuneración</h1> <span         class="partner__subtitle">Para tus amigos y para ti</span> <ul class="partner-list">         <li class="partner-item">                 <h2 class="partner-item__title">Cuéntales a tus amigos sobre Nibble</h2>                 <p class="partner-item__description">Puedes compartir tu enlace de referencia con los amigos o enviarles                         un código promocional</p>         </li>         <li class="partner-item">                 <h2 class="partner-item__title">Registro</h2>                 <p class="partner-item__description">Tus amigos se registran en Nibble a través del enlace o el código promocional</p>         </li>         <li class="partner-item">                 <h2 class="partner-item__title">Obtén tu remuneración</h2>                 <p class="partner-item__description">Recibirás el 2% de cada inversión realizada por tu amigo por un importe de hasta 1000 euros. </p>         </li> </ul>',
    PartnerLinkSet: "Enlace de invitación",
    PartnerLinkSocial: "Compartir el enlace en las redes sociales",
    PartnerTextStep1:
      "Puedes compartir tu enlace de referencia con los amigos o enviarles un código promocional",
    PartnerTextStep2:
      "Tus amigos se registran en Nibble a través del enlace o el código promocional",
    PartnerTextStep3:
      "Recibirás el 2% de cada inversión realizada por tu amigo por un importe de hasta 1000 euros.",
    PartnerTitle:
      "Cuéntales a tus amigos sobre nuestro servicio y obtén tu remuneración",
    PartnerTitleStep1: "Cuéntales a tus amigos sobre Nibble",
    PartnerTitleStep2: "Registro",
    PartnerTitleStep3: "Obtén tu remuneración",
    PartnerTransaction: "operaciones",
    PartnerTransactionIncome: "Ingresado",
    Password: "Clave",
    PasswordChange: "Cambiar la clave",
    PasswordChanged: "La contraseña está cambiada",
    PasswordSentMessage:
      "La contraseña ha sido enviada al número de teléfono indicado",
    PasswordsMakeSure: "Asegúrate de que las claves coincidan",
    PaymentOnformation: "Información de pago",
    PaymentPurposeInfo:
      "Transfiere dinero a los requisitos indicados. Asegúrate de copiar el propósito de pago.",
    PeriodInvest: "Plazo de inversión",
    PeriodInvest1: "Plazo de inversión",
    PersonalData: "Datos personales",
    PersonalDataChangeInfo:
      "Para cambiar tu información personal, ponte en contacto con el servicio de atención al cliente",
    PersonalID: "Número de documento",
    PersonalInfo: "Información personal",
    PersonLastName: "Apellido",
    PersonName: "Nombre",
    Persons: "personas",
    Phone: "Teléfono de contacto",
    Phone1: "Tu teléfono",
    PhoneAlreadyReg: "Teléfono ya registrado",
    PhoneChangeInfo:
      "Para cambiar tu número de teléfono, ponte en contacto con el servicio de atención al cliente",
    PhoneConfirm: "Teléfono verificado",
    PhoneNotConfirm: "Teléfono no verificado",
    PhoneNotValid: "Formato de teléfono no válido",
    PhoneVerification: "Verificación del número de teléfono",
    PlacehoderBirthDate: "dd.mm.aaaa",
    PolicyAgreement:
      'Consentimiento para <a href="/policy_privacy.aspx"> el procesamiento de datos personales </a>',
    PolicyAgreement1:
      'Consentimiento para <a href="/policy_privacy.aspx"> el procesamiento de datos personales </a>',
    PortfolioConfirmText:
      "Ahora crearemos una cartera con los parámetros especificados",
    PortfolioCreated: "La cartera está creada",
    PortfolioCreation: "Creación de cartera",
    PortfolioID: "Cartera",
    PortfolioIncome: "Ingresos de la cartera",
    PortfolioParams: "Parámetros de la cartera",
    PortfolioReplenishment: "Reposición de la cartera [ID X]",
    PortfolioReplenishmentOperation: "Recarga de la cartera",
    PotentialProfit: "tu posible retorno",
    Precalculation: "Cálculo previo del rendimiento",
    Precalculation1: "Cálculo previo del rendimiento",
    PrefferedLanguage: "Idioma preferido",
    ProductDescription: "Descripción del producto",
    ProfitCalc: "Cálculo de rentabilidad",
    ProgressCompleteInfoDesc:
      "Te queda especificar unos detalles en la configuración de tu cuenta",
    ProgressCompleteInfoStep: "Añadir información",
    ProgressCompleteInfoTitle: "Tu cuenta está activada",
    ProgressConfirmEmailDesc:
      "Confirma tu e-mail y activa tu cuenta. Para hacerlo, haz clic en el enlace del correo que te enviamos.",
    ProgressConfirmEmailDescRestore: "Enviar un nuevo enlace de activación.",
    ProgressConfirmEmailStep: "Confirmar e-mail",
    ProgressIdentifyDesc:
      "Identifícate mediante Veriff para recargar el saldo y empezar a invertir",
    ProgressIdentifyStep: "Identificarse",
    ProgressIdentifyTitle: "El último y más importante paso...",
    PromoCode: "Código de promoción",
    PropsContractsDocs: "Requisitos",
    ProvideSMSCode: "Introduce el código de verificación del SMS",
    PurposeOfPayment: "Propósito de pago",
    Rate: "Tipo de interés",
    ReceivingIncomeBy: "Recibo de ingresos por ( I D X)",
    Referals: "Referidos",
    ReferralTitle: "Remuneración por el Programa de Referencia",
    RefillFromCard: "Reposición con la tarjeta VISA/MC",
    RefillHistory: "Historial de reposiciones",
    RefillTheAccount:
      '<a href="/depositing.aspx">Recarga el saldo</a> de una manera conveniente para empezar a invertir con Nibble',
    RefillWithCard: "Reponer con tarjeta",
    Registrations: "Registros",
    RegreshPage: "actualizar la página",
    ReinvestIncome: "Reinvertir tus ingresos",
    Reinvestment: "reinversión",
    RepeatPassword: "Repite la clave",
    Replenishment: "Reposición de la cartera, mensual",
    Replenishments: "Reposiciones",
    ResetPassword: "Cambiar la clave",
    RestorePassword: "Nueva contraseña ha sido enviada a tu teléfono",
    RestorePasswordEmail: "Si tu email está registrado te llegará un correo",
    ReturnDate: "Fecha de retorno",
    ReturnMainPage: "Volver a la página principal",
    RevenueFromRegistrationsAndRenewals: "Ingresos de registros y reposiciones",
    Risks: "Riesgos",
    Save: "Guardar los cambios",
    ScanHint:
      "Carga tu licencia de conducir o tu pasaporte, escaneado o en foto. Por favor, sube las imágenes legibles y detalladas de los documentos. Es importante que no cubras ni distorsiones la información del documento.",
    Selfie: "Autorretrato",
    SelfieHint:
      "Por favor, intenta que la foto de tu cara se vea aproximadamente igual que en la foto de tu pasaporte, sin deslumbramiento ni distorsión.",
    SendMessageBtn: "Enviar un mensaje",
    SendRequest: "Enviar una solicitud",
    SEPAInfo: "Solo pueden depositar los residentes de SEPA.",
    ServiceUnavailable: "El servicio no está disponible temporalmente",
    Settings: "Ajustes",
    ShareLink: "Compartir el enlace",
    ShowAllLoans: "Mostrar todos los préstamos",
    SkipIdentification: "Anterior",
    SmsCode: "Código SMS",
    SmsCodeIsSent:
      "Se ha enviado un SMS con un código de verificación al número de teléfono que has especificado. Ingresa el código recibido.",
    Sortby: "Filtrar por:",
    SortbyIncome: "(por) ingresos esperados",
    SortbyOpened: "(por) fecha de apertura",
    SortbyOperationDate: "[por] fecha de la operación",
    SortbyReturnDate: "(por) fecha de retorno",
    SortbySum: "(por) cantidad",
    StartDeposit: "Cantidad inicial",
    Stats: "Estadísticas",
    Status: "Estado",
    STATUS_001: "Cerrado",
    STATUS_002: "Activo",
    STATUS_003: "Vencido",
    STATUS_004: "Realizada",
    STATUS_005: "Programada",
    STATUS_006: "Rechazada",
    StatusCanceled: "Cancelado",
    StatusCompleted: "Completado",
    StatusInprocess: "En el proceso",
    Step1: "Primer paso",
    Step2: "Segundo paso",
    StrategyBalancedDescription:
      "La rentabilidad no es fija y, según las estadísticas de periodos anteriores, puede ascender al 12–15% anual. La estrategia más equilibrada en relación riesgo-rentabilidad.",
    StrategyBalancedTitle: "Estrategia Equilibrada",
    StrategyClassicDescription:
      "La rentabilidad de esta estrategia es fija, respaldada por una garantía de recompra y asciende al 8% anual. La estrategia asegura la ausencia de riesgos y la rentabilidad garantizada.",
    StrategyClassicTitle: "Estrategia Clásica",
    StrategyDescription:
      "Elige una estrategia de inversión de acuerdo a tu preferencia de rendimiento y riesgo. <br> Crea una cartera de inversiones en tres pasos.",
    StrategySpecialDescription:
      "La rentabilidad no es fija y puede alcanzar el 17–19% anual. Los riesgos de inversión son mayores, pero al mismo tiempo, la rentabilidad permite recuperar las pérdidas dentro del importe total de la cartera de inversiones",
    StrategySpecialTitle: "Estrategia Especial",
    StrategyStep1: "Paso 1: Elige una estrategia",
    StrategyStep2: "Paso 2: Establece los parámetros de inversión",
    StrategyStep3: "Paso 3: Crea una cartera",
    StrategyTitle: "Inversión flexible",
    InviteFriends: "Invita a tus amigos",
    OtherStrategy: `Equilibrada estrategia`,
    LegalStrategy: `Legal estrategia`,
    String:
      "Aquí se guarda el historial de todos los movimientos de tus fondos",
    SuccessfullySaved: "Tus ajustes se han guardado con éxito",
    Sum: "Cantidad",
    SumAmount: "Cantidad de reposición",
    Support: "Servicio de atención al cliente",
    SupportMessageSentMessage:
      "Tu mensaje ha sido entregado a los operadores. El primer operador libre te responderá en el horario comercial europeo.",
    SupportTextareaPlaceholder: "Texto del mensaje o pregunta",
    SupportTitle: "Responderemos a todas tus preguntas",
    SystemSettings: "Ajustes del sistema",
    Term: "Plazo",
    TermDays: "Plazo, días",
    TermMonths: "Plazo, meses",
    Test: "De test",
    TestInvestmentsInfo:
      "Las inversiones de test permiten probar el servicio en un corto plazo. Un usuario puede crear solo una cartera de test por un importe no más de 300 EUR.",
    ThankyouErrorText:
      "Verificación fallida. Quizás no hayamos reconocido la foto de tu documento o haya ocurrido un problema de conexión. No te preocupes, <a target=\"_top\" href='/profile'>intenta identificarte de nuevo</a> o utiliza un documento diferente. ",
    ThankyouErrorTitle: "Parece que algo ha ido mal...",
    ThankyouSuccessText:
      "Identificación terminada al 100% - haz tu primera inversión en Nibble. Ya hemos configurado tu área personal y solo tienes que <a target=\"_top\" href='/depositing'>recargar el saldo</a> y <a target=\"_top\" href='/profile'>crear tu primera cartera de inversión.</a > ",
    ThankyouSuccessTitle: "¡Todo ha salido perfecto!",
    ThroughSocialNetworks: "ThroughSocialNetworks",
    ThroughSocialNetworks1: "A través de redes sociales",
    TimeFormat: "Formato de hora",
    Try: "Intenta ",
    TutorialMessage0:
      "Podemos contarte los puntos principales de funcionamiento del área personal de Nibble. ¿Continuamos?",
    TutorialMessage1:
      "Puedes calcular la rentabilidad de tu cartera en la calculadora",
    TutorialMessage2:
      "Para empezar a invertir necesitas recargar el saldo de tu cuenta",
    TutorialMessage3: 'Maneja tus carteras en "Mis inversiones"',
    TutorialMessage4: "Obtén aún más ingresos con tus amigos",
    TutorialMessage5:
      "Te contamos como crear una cartera de inversión o cómo funciona el sistema en general",
    Unavailable: "no disponible",
    //UserAgreement: 'Al hacer clic en el botón "Continuar", aceptas el <a href="https://nibble.finance/user-agreement.html" target="_blank">Acuerdo de usuario</a>, así como la <a href="https://nibble.finance/privacy-policy.html" target="_blank">Política de privacidad de Nibble</a>',
    UserAgreement: {
      text_1: 'Al hacer clic en el botón "Continuar", aceptas el ',
      text_1_legal:
        'Al hacer clic en el botón "Enviar una solicitud", aceptas el ',
      text_link_1: "Acuerdo de usuario",
      text_2: ", así como la ",
      text_link_2: "Política de privacidad de Nibble",
      text_3: " ",
    },
    UserAgreement1:
      'Al hacer clic en el botón "Continuar", aceptas el <a href="/user_agreement.aspx">Acuerdo de usuario</a>, así como la <a href="/policy_privacy.aspx">Política de privacidad de Nibble</a>',
    VERIFF_274: "Falta enviar una foto",
    VERIFF_275: "No se visualiza correctamente la foto de la cara",
    VERIFF_276: "El documento enviado no se visualiza correctamente",
    VERIFF_277: "Baja calidad de imágen",
    VERIFF_278: "El documento está dañado",
    VERIFF_279: "Este formato de imágen no está soportado",
    VERIFF_280: "El documento ha expirado",
    VERIFF_282: "Otras razones",
    VeriffGuarantees: "Veriff protege tus datos personales.",
    VeriffGuaranteesHtml:
      '<span><u id="veriffLink">Veriff</u> protege tus datos personales.</span>',
    VeriffInfo:
      "En cumplimiento de la normativa legal europea, Nibble ha implementado un procedimiento de verificación de identidad para cada inversor particular o corporativo. El procedimiento consiste en tomar una foto de tu documento de identidad y su posterior verificación por nuestro socio, Veriff. Todo el proceso de verificación no debería ocuparte más de 10 minutos. Prepara tu pasaporte o tarjeta de identidad y asegúrate de que todos los detalles estén claramente visibles cuando tomes la foto.",

    VeriffInfoTitle: "Pasar por el proceso de identificación instantánea.",
    VeriffInfoDesc:
      "Nibble sigue rigurosamente los estándares estrictos de la ley europea en cuanto al blanqueo de dinero (AML), la verificación de usuarios, el almacenamiento y el uso de los datos personales. Se requieren 2 minutos para verificarte y convertirte en inversor",
    VeriffInfoQuest: "Es fácil identificarse de forma digital?",
    VeriffInfoAsk1:
      "Te pedimos que hagas una foto de tu documento de identidad (una licencia de conducir, pasaporte o tarjeta de identidad) ya sea con tu cámara web o smartphone – es un proceso en vivo",
    VeriffInfoAsk2:
      "Te pedimos que te hagas una selfie rápida con el mismo dispositivo. Te guiaremos mientras te haces la selfie para asegurarnos de que la obtengas perfecta en el primer intento.",
    VeriffInfoAsk3: "Recibirás una decisión muy rápido. ¡Y ya está!",
    VeriffStartButton: "Iniciar la verificación",
    Cancel: "Lo haré más tarde",

    VeriffInProcess:
      "Tu documento de identidad está pasando por un proceso de verificación por parte de Veriff. Suele tardar unos minutos. </br>Hasta que no se complete el proceso de verificación, no puedes depositar tu cuenta.",
    WeAreDoingAll: "Hacemos todo lo posible para arreglarlo.",
    WeeklyReport: "Informe semanal",
    WeEnsureSecurity:
      'Nosotros realizamos tu identificación de una manera segura junto con nuestro socio, el servicio — <a href="https://www.veriff.com" target="_blank">Veriff</a>',
    WeWorkHonest:
      "Trabajamos de una manera honesta y abierta y apreciamos cuando nuestros usuarios nos responden con reciprocidad.",
    WidgetBringFriendLead:
      "Recomiéndanos a tus amigos y obtén una remuneración por cada recomendación",
    WidgetHistoryLead:
      "Puedes encontrar aquí todas las recargas de la cuenta, devengo de ingresos y retiros de fondos",
    WidgetInvestLead: "Punto central de la gestión de tus inversiones",
    WidgetSupportLead:
      "Nuestros especialistas te ayudarán si tienes cualquier pregunta o duda",
    WillAddXMonth1: "tus inversiones&nbsp;<br>durante",
    WillAddXMonth2: "meses",
    Withdrawal: "Cargo",
    WithdrawalAmount: "Cantidad de retiro",
    WithdrawalHistory: "Historial de fondos retirados",
    WithdrawalInfo1: "El retiro se realizará al número de la cuenta vinculado.",
    WithdrawalInfo2: "Importe mínimo de retiro <b> 50 EUR</b>",
    WithdrawalInfo3:
      "El retiro se realiza a la cuenta desde la cual se realizó el primer depósito",
    WithdrawalOfBalances: "Retiro de saldo de la cartera",
    WithdrawalViaBankAccount: "Retiro via la cuenta bancaria",
    WithdrawFunds: "Retirar dinero",
    WithdrawFundsMobile: "Retirar dinero",
    XActiveLoans: "préstamos activos",
    XClosedLoans: "préstamos cerrados",
    XInvestedLoans: "préstamos invertidos",
    XOverdueLoans: "préstamos vencidos",
    Yes: "Sí",
    YourInvestmentsXMonth:
      'tus inversiones durante <span class="js-calcMonth"></span> meses',
    ZIP: "Código postal",
    LowBalanceAlert:
      "En tu cuenta no hay saldo suficiente para crear una cartera con los parámetros elegidos",
    LowBalanceAlertCommon: "En tu cuenta no hay saldo suficiente",
    NoBankAlert:
      "No has especificado los datos de la cuenta bancaria. Ponte en contacto con el servicio de atención al cliente",

    // validation
    required: "Campo obligatorio",
    regexDate: "Ingresa una fecha válida",
    regexEmail: "Ingresa un email válido",
    checkbox:
      "Marca la casilla de consentimiento para el procesamiento de datos",
    regexNot: "Formato inválido",
    minlength: "",
    simple: "Débil",
    normal: "Normal",
    hard: "Fuerte",
    minSum: "Importe minimo",
    //Tutorial
    step0:
      "¡Gracias por unirte a Nibble! Identifícate mediante Veriff para recargar el saldo y empezar a invertir",
    step1: "Para empezar a invertir necesitas recargar el saldo de tu cuenta",
    step2: "Puedes calcular la rentabilidad de tu cartera en la calculadora",
    step3: 'Maneja tus carteras en "Mis inversiones"',
    step4: "Aquí se guarda el historial de todos los movimientos de tus fondos",
    step5: "Obtén aún más ingresos con tus amigos",
    step6:
      "Te contamos como crear una cartera de inversión o cómo funciona el sistema en general",
    step7:
      "Puedes crear una cartera de test con una inversión máxima de 300 EUR por un plazo de 21 días.",
    TutorialCancel: "Lo haré más tarde",
    TutorialConfirm: "Confirmo ahora",
    TutorialPrev: "Anterior",
    TutorialNext: "Siguiente",
    TutorialFinal: "Finalizar",

    NoticeMaxSum: "El importe máximo es de",
    NoticeMinSum: "El importe mínimo es de",
    StrategyTitleInvestClassic: "Clásica",
    StrategyTitleInvestBalanced: "Equilibrada",

    // ------ Судебная ------

    JudicialTitle: `Carteras disponibles`,
    JudicialPanelTitle: `Invierte`,
    JudicialBabberTitle: `Nibble presenta una nueva estrategia de inversión - Legal`,
    JudicialSlideBtn: `Invertir`,
    JudicialBtnText: `Invertir`,
    JudicialLabel: `Cantidad de inversión`,
    JudicialCollection: `Queda por recaudar ХХХ1 de ХХХ2`,
    JudicialCollectionEnd: `Hasta el final de la recaudación`,
    JudicialCollectionEnd2: `Hasta el final de la recaudación`,
    JudicialCollectionCompleted: `La recaudación está completada.`,
    JudicialCollectionCompletedSub: `Puedes invertir en una nueva cartera.`,
    JudicialSubTitle: `estrategia`,
    StrategyJudicialTitle: `Estrategia Legal`,
    StrategyJudicialPanelTitle: `Legal`,
    TaglineStrategyJudicialPanel: `Alto rendimiento`,
    TaglineStrategyOtherPanel: `Riesgos equilibrados`,
    JudicialMoreStrategy: `Más sobre la estrategia`,
    JudicialGuarantee: `Todas las carteras están protegidas por la garantía de`,
    JudicialGuaranteeDb: `devolución del depósito`,
    JudicialState1: `Recaudamos fondos para comprar una cartera`,
    JudicialState2: `Compramos una cartera`,
    JudicialState3: `Negociamos con los prestatarios`,
    JudicialStateSub3: `Cobranza extrajudicial`,
    JudicialState4: `Presentamos documentos al juzgado`,
    JudicialState5: `Recibimos una resolución judicial`,
    JudicialState6: `Recuperamos la deuda a través de los servicios judiciales y bancos`,
    JudicialState7: `Deudas cobradas`,
    JudicialAgreement: `Contrato`,
    JudicialGarantText: `Garantía de devolución del depósito`,
    JudicialInfo: ` 
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>Esta es una estrategia para invertir en carteras compuestas por préstamos de consumo clasificados como B, CC y C, que se encuentran en proceso de recuperación tanto extrajudicial como judicial. Debido a que estos préstamos tienen morosidad y multas, la rentabilidad de esta estrategia alcanza hasta un 19% anual.</p>
        <p>El período mínimo de inversión de 6 meses se explica por el hecho de que el proceso de litigio y recuperación toma un largo período de tiempo. La gestión de litigios y cobranzas la proporciona Boostr.</p>
        <p>Riesgos asociados: Riesgo de impago del préstamo/incumplimiento de la totalidad del importe del préstamo</p>

        <ul>
            <li>La estrategia está respaldada por una garantía de devolución del depósito. Esta es la obligación de la agencia de cobro de devolver el monto total de la inversión al final del período de inversión y garantizar un rendimiento mínimo del 8% anual.</li>
            <li>Debido a la inversión en una cartera compuesta por un gran número de préstamos, se reduce el riesgo de no recibir ingresos de varios contratos, se cubren con otros préstamos.</li>
            <li>Devengo diario de intereses a una tasa del 8% anual, pagos cada 90 días según el rendimiento de hecho recibido hasta el 14,5% anual.</li>
            <li>Mientras se recauda dinero para comprar una cartera, te devengamos ingresos a una tasa del 8% anual. Este es tu rendimiento de bonificación al principal hasta el 14,5%. El plazo máximo de recaudación de dinero para comprar una cartera es de 30 días.</li>
        </ul>
        <p>¿Cómo funciona?</p>
        <p>Te devengamos intereses diarios a una tasa del 8% anual. Cada 90 días calculamos automáticamente el rendimiento de hecho de las carteras y te devengamos adicionalmente la diferencia entre la tasa garantizada del 8% y la tasa de hecho. Así, cada 90 días recibes un ingreso del 8% al 14,5% a tu cuenta de Nibble.</p>
        <p>Ejemplo: Al invertir 1000 euros para 12 meses, al final del plazo recuperas todo tu capital de 1000 euros y recibes ingresos de 90 a 145 euros, que te pagamos cada 90 días.</p>
        </div></div></div>`,
    JudiciaDb: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>Estrategia Legal</p>
        <p>La estrategia está respaldada por una garantía de devolución del depósito. Esta es la obligación de la agencia de cobro de devolver el monto total de la inversión al final del período de inversión y garantizar un rendimiento mínimo del 8% anual.</p>
        <p>¿Cómo funciona?</p>
        <p>Te devengamos intereses diarios a una tasa del 8% anual. Cada 90 días calculamos automáticamente el rendimiento de hecho de las carteras y te devengamos adicionalmente la diferencia entre la tasa garantizada del 8% y la tasa de hecho. Así, cada 90 días recibes un ingreso del 8% al 14,5% a tu cuenta de Nibble.</p>
        <p>Ejemplo: Al invertir 1000 euros para 12 meses, al final del plazo recuperas todo tu capital de 1000 euros y recibes ingresos de 90 a 145 euros, que te pagamos cada 90 días.</p>
        </div></div></div>`,
    JudicialSlide: `
        <div class="judicial-slide__title">
        <div class="judicial-slide__title-head">
            Nibble presenta una nueva estrategia de inversión - Legal
        </div>
        <div class="judicial-slide__title-sub">
            <p>A partir de hoy, una nueva estrategia de inversión está disponible para nuestros inversores, con un rendimiento alto y predecible de hasta el 14,5% anual y una garantía de devolución del depósito.</p>
            <p>Asimismo, con el fin de mantener un equilibrio de rentabilidad en la situación actual del mercado y seguir los requerimientos de los órganos reguladores, actualizamos las tasas de interés para las nuevas carteras de las estrategias Clásica y Equilibrada. Las tasas para las carteras ya creadas no cambian.</p>
        </div>
        
        
        <div class="judicial-slide__title-mini">
            Estrategia Clásica - 8% anual
        </div>
        <div class="judicial-slide__title-mini">
            Estrategia Equilibrada - 12,5% anual
        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Sobre el producto
            </div>

            <div class="judicial-slide__sub-text">
                <p>Cualquier empresa financiera especializada en préstamos se enfrenta inevitablemente a préstamos que no se devuelven en los términos especificados en el contrato. Muchas empresas venden este tipo de préstamos en grandes carteras en subastas con un descuento de hasta el 85% para devolver rápidamente una parte del dinero al negocio.</p>
                <p>Boostr compra dichas carteras en subastas.</p>
                <p>Gracias a la experiencia acumulada y las tecnologías desarrolladas por Boostr, es posible alcanzar un alto porcentaje de retorno del capital. En Eurasia la empresa cuenta con más de 5 años de experiencia y más de 80 empleados.</p>
                <p>En Europa Boostr trabaja en colaboración con agencias de cobro, que se especializan en la recuperación de deuda de préstamos europeos.</p>
                <p>Desde 2019, plataformas de subastas para la venta de deudas, como Debex y NLPBroker, han comenzado a aparecer activamente en el mercado español, lo que demuestra el crecimiento del mercado. También existen muchas otras agencias de cobro en el mercado especializadas en la recuperación de deudas por via tanto extrajudicial como judicial. Según los datos proporcionados por nuestros colaboradores involucrados en la gestión de cobro de deudas durante más de 25 años, la rentabilidad del inversor puede llegar hasta el 19% anual.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Rentabilidad histórica
            </div>

            <div class="judicial-slide__stend">
                <div class="judicial-slide__block">
                    <div class="judicial-slide__block-title">
                        Se ha comprado una cartera
                    </div>
                    <div class="judicial-slide__purchase-list">

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Comprado por
                            </div>
                            <div class="judicial-slide__purchase-money">
                                117.801 €
                            </div>
                        </div>

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Importe de deudas 
                            </div>
                            <div class="judicial-slide__purchase-money">
                                1.328.123 €
                            </div>
                        </div>
                    </div>

                    <div class="judicial-slide__explanation">
                            <div class="judicial-slide__explanation-icon">
                                <div class="judicial-slide__explanation-smiley" ></div>
                            </div>
                            <div class="judicial-slide__explanation-text">
                            Es decir, compramos una cartera con <br /> un potencial de 1.328.123 € por 117.801 €
                            </div>
                        </div>

                        <div class="judicial-slide__block-info">
                            <div class="judicial-slide__block-collected">
                                <div class="judicial-slide__collected-title">
                                    En el primer año recuperamos:
                                </div>
                                <div class="judicial-slide__collected-money">
                                    143.107&nbsp;€
                                </div>
                                <div class="judicial-slide__collected-description">
                                    de la deuda que son 25.306 € más que nuestra inversión. Y esto es más del 20% anual.
                                </div>
                            </div>

                            <div class="judicial-slide__block-description">
                                <div class="judicial-slide__description-icon">
                                    <div class="judicial-slide__description-info-icon"></div>
                                </div>
                                <div class="judicial-slide__block-description-text">
                                    Pasado el primer año de cobranza, podemos vender en subasta el resto de préstamos de la cartera por 70.343&nbsp;€, lo que nos proporcionará unos ingresos totales de 95.649&nbsp;€.
                                </div>
                            </div>
                        </div>

                        
                        <div class="judicial-slide__strategy">
                            <div class="judicial-slide__strategy-title">
                                Estadísticas de la cartera
                            </div>
                            <div class="judicial-slide__strategy-diagram">
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        117.801 €
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom1">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Total de inversiones
                                    </div>
                                </div>
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        143.107 €
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom2">
                                        Ingresos 25.306&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Recuperado durante el primer año
                                    </div>
                                </div>          
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        270.784 €
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom4">
                                        Ingresos 152.983&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Recuperado durante el segundo año
                                    </div>
                                </div>          
                            </div>

                            <div class="judicial-slide__strategy-earned">
                                <div class="judicial-slide__strategy-label">
                                    Ganado en 2 años:
                                </div>
                                <div class="judicial-slide__strategy-sum">
                                    152.983&nbsp;€
                                </div>
                            </div>
                        </div>
                </div>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                En base a este negocio, hemos desarrollado una Estrategia Legal
            </div>

            <div class="judicial-slide__sub-text">
                <p>Esta es una estrategia para invertir en carteras compuestas por préstamos de consumo clasificados como B, CC y C, que se encuentran en proceso de recuperación tanto extrajudicial como judicial. Debido a que estos préstamos tienen morosidad y multas, la rentabilidad de esta estrategia alcanza hasta un 19% anual.</p>
                <p>El período mínimo de inversión de 6 meses se explica por el hecho de que el proceso de litigio y recuperación toma un largo período de tiempo.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Riesgos asociados:
            </div>

            <div class="judicial-slide__title-small">
                Riesgo de impago del préstamo/incumplimiento de la totalidad del importe del préstamo
            </div>

            <div class="judicial-slide__sub-text">
                <ul class="judicial-slide__roll">
                    <li class="judicial-slide__element">La estrategia está respaldada por una garantía de devolución del depósito. Esta es la obligación de la agencia de cobro de devolver el monto total de la inversión al final del período de inversión y garantizar un rendimiento mínimo del 8% anual.</li>
                    <li class="judicial-slide__element">Debido a la inversión en una cartera compuesta por un gran número de préstamos, se reduce el riesgo de no recibir ingresos de varios contratos, se cubren con otros préstamos.</li>
                    <li class="judicial-slide__element">Devengo diario de intereses a una tasa del 8% anual, pagos cada 90 días según el rendimiento de hecho recibido hasta el 14,5% anual.</li>
                    <li class="judicial-slide__element">Mientras se recauda dinero para comprar una cartera, te devengamos ingresos a una tasa del 9% anual. Este es tu rendimiento de bonificación al principal hasta el 14,5%. El plazo máximo de recaudación de dinero para comprar una cartera es de 30 días.</li>
                </ul>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                ¿Cómo funciona?
            </div>

            <div class="judicial-slide__sub-text">
                Eliges una cartera de acuerdo con tus preferencias e inviertes en ella. Mientras la cartera está en proceso de recaudación de fondos, recibes diariamente un ingreso del 8% anual. Después del final del proceso, también recibes ingresos diarios a una tasa del 8% anual, y cada 90 días calculamos automáticamente la rentabilidad de hecho de las carteras y te devengamos la diferencia entre la tasa garantizada del 8% y la tasa de hecho de hasta el 14,5% anual. Así, cada 90 días recibes un ingreso del 8% al 14,5% a tu cuenta de Nibble.
            </div>

            <div class="judicial-slide__sub-text-mini">
                Ejemplo: Al invertir 1000 euros para 12 meses, al final del plazo recuperas todo tu capital de 1000 euros y recibes ingresos de 90 a 145 euros, que te ingresaremos a tu cuenta de Nibble.
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Cómo ganamos dinero para los inversores:
            </div>

            <div class="judicial-slide__sub-text">
                <ol class="judicial-slide__roll">
                    <li class="judicial-slide__element">Boostr compra préstamos vencidos de bancos e IMF en subastas con un descuento del 85 %</li>
                    <li class="judicial-slide__element">Se inicia el proceso de cobranza extrajudicial. La agencia contacta con el prestatario y trata de acordar la devolución de la deuda.</li>
                    <li class="judicial-slide__element">Si no es posible ponerse de acuerdo, comienza el proceso judicail para obtener una sentencia judicial sobre el cobro de la deuda organizado por Boostr o su colaborador.</li>
                    <li class="judicial-slide__element">Después de recibir una sentencia judicial, la deuda, intereses y multas se cobran a través de los servicios judiciales y bancos.</li>
                </ol>
            </div>

        </div>
    </div>
        `,
    legalTitle: `Legal estrategia`,
    legalInfoTitle1: `Sobre el producto`,
    legalInfoTitle2: `Rentabilidad histórica`,
    legalInfoTitle3: `En base a este negocio, hemos desarrollado una Estrategia Legal`,
    legalInfoTitle4: `Riesgos asociados`,
    legalInfoTitle5: `¿Cómo funciona?`,
    legalInfoTitle6: `Cómo ganamos dinero para los inversores`,
    legalInfoText1: `
        <p>Cualquier empresa financiera especializada en préstamos se enfrenta inevitablemente a préstamos que no se devuelven en los términos especificados en el contrato. Muchas empresas venden este tipo de préstamos en grandes carteras en subastas con un descuento de hasta el 85% para devolver rápidamente una parte del dinero al negocio.</p>
        <p>Boostr compra dichas carteras en subastas.</p>
        <p>Gracias a la experiencia acumulada y las tecnologías desarrolladas por Boostr, es posible alcanzar un alto porcentaje de retorno del capital. En Eurasia la empresa cuenta con más de 5 años de experiencia y más de 80 empleados.</p>
        <p>En Europa Boostr trabaja en colaboración con agencias de cobro, que se especializan en la recuperación de deuda de préstamos europeos.</p>
        <p>Desde 2019, plataformas de subastas para la venta de deudas, como Debex y NLPBroker, han comenzado a aparecer activamente en el mercado español, lo que demuestra el crecimiento del mercado. También existen muchas otras agencias de cobro en el mercado especializadas en la recuperación de deudas por via tanto extrajudicial como judicial. Según los datos proporcionados por nuestros colaboradores involucrados en la gestión de cobro de deudas durante más de 25 años, la rentabilidad del inversor puede llegar hasta el 19% anual.</p>
        `,
    legalInfoText2: `
        <div class="judicial-slide__stend">
        <div class="judicial-slide__block">
            <div class="judicial-slide__block-title">
                Se ha comprado una cartera
            </div>
            <div class="judicial-slide__purchase-list">

                <div class="judicial-slide__purchase-item">
                    <div class="judicial-slide__purchase-info">
                        Comprado por
                    </div>
                    <div class="judicial-slide__purchase-money">
                        117.801 €
                    </div>
                </div>

                <div class="judicial-slide__purchase-item">
                    <div class="judicial-slide__purchase-info">
                        Importe de deudas 
                    </div>
                    <div class="judicial-slide__purchase-money">
                        1.328.123 €
                    </div>
                </div>
            </div>

            <div class="judicial-slide__explanation">
                    <div class="judicial-slide__explanation-icon">
                        <div class="judicial-slide__explanation-smiley" ></div>
                    </div>
                    <div class="judicial-slide__explanation-text">
                    Es decir, compramos una cartera con <br /> un potencial de 1.328.123 € por 117.801 €
                    </div>
                </div>

                <div class="judicial-slide__block-info">
                    <div class="judicial-slide__block-collected">
                        <div class="judicial-slide__collected-title">
                            En el primer año recuperamos:
                        </div>
                        <div class="judicial-slide__collected-money">
                            143.107&nbsp;€
                        </div>
                        <div class="judicial-slide__collected-description">
                            de la deuda que son 25.306 € más que nuestra inversión. Y esto es más del 20% anual.
                        </div>
                    </div>

                    <div class="judicial-slide__block-description">
                        <div class="judicial-slide__description-icon">
                            <div class="judicial-slide__description-info-icon"></div>
                        </div>
                        <div class="judicial-slide__block-description-text">
                            Pasado el primer año de cobranza, podemos vender en subasta el resto de préstamos de la cartera por 70.343&nbsp;€, lo que nos proporcionará unos ingresos totales de 95.649&nbsp;€.
                        </div>
                    </div>
                </div>

                
                <div class="judicial-slide__strategy">
                    <div class="judicial-slide__strategy-title">
                        Estadísticas de la cartera
                    </div>
                    <div class="judicial-slide__strategy-diagram">
                        <div class="judicial-slide__strategy-column">
                            <div class="judicial-slide__strategy-money">
                                117.801 €
                            </div>
                            <div class="judicial-slide__strategy-block-bottom1">

                            </div>
                            <div class="judicial-slide__strategy-info">
                                Total de inversiones
                            </div>
                        </div>
                        <div class="judicial-slide__strategy-column">
                            <div class="judicial-slide__strategy-money">
                                143.107 €
                            </div>
                            <div class="judicial-slide__strategy-block-bottom2">
                                Ingresos 25.306&nbsp;€
                            </div>
                            <div class="judicial-slide__strategy-block-bottom3">

                            </div>
                            <div class="judicial-slide__strategy-info">
                                Recuperado durante el primer año
                            </div>
                        </div>          
                        <div class="judicial-slide__strategy-column">
                            <div class="judicial-slide__strategy-money">
                                270.784 €
                            </div>
                            <div class="judicial-slide__strategy-block-bottom4">
                                Ingresos 152.983&nbsp;€
                            </div>
                            <div class="judicial-slide__strategy-block-bottom3">

                            </div>
                            <div class="judicial-slide__strategy-info">
                                Recuperado durante el segundo año
                            </div>
                        </div>          
                    </div>

                    <div class="judicial-slide__strategy-earned">
                        <div class="judicial-slide__strategy-label">
                            Ganado en 2 años:
                        </div>
                        <div class="judicial-slide__strategy-sum">
                            152.983&nbsp;€
                        </div>
                    </div>
                </div>
        </div>
    </div>
        `,
    legalInfoText3: `
          <p>Esta es una estrategia para invertir en carteras compuestas por préstamos de consumo clasificados como B, CC y C, que se encuentran en proceso de recuperación tanto extrajudicial como judicial. Debido a que estos préstamos tienen morosidad y multas, la rentabilidad de esta estrategia alcanza hasta un 19% anual.</p>
          <p>El período mínimo de inversión de 6 meses se explica por el hecho de que el proceso de litigio y recuperación toma un largo período de tiempo.</p>
          `,
    legalInfoText4: `
        <strong>
          Riesgo de impago del préstamo/incumplimiento de la totalidad del importe del préstamo
        </strong>
        <ul class="legal-list__point">
          <li>La estrategia está respaldada por una garantía de devolución del depósito. Esta es la obligación de la agencia de cobro de devolver el monto total de la inversión al final del período de inversión y garantizar un rendimiento mínimo del 8% anual.</li>
          <li>Debido a la inversión en una cartera compuesta por un gran número de préstamos, se reduce el riesgo de no recibir ingresos de varios contratos, se cubren con otros préstamos.</li>
          <li>Devengo diario de intereses a una tasa del 8% anual, pagos cada 90 días según el rendimiento de hecho recibido hasta el 14,5% anual.</li>
          <li>Mientras se recauda dinero para comprar una cartera, te devengamos ingresos a una tasa del 8% anual. Este es tu rendimiento de bonificación al principal hasta el 14,5%. El plazo máximo de recaudación de dinero para comprar una cartera es de 30 días.</li>
        </ul>
        `,
    legalInfoText5: `
        <p>Eliges una cartera de acuerdo con tus preferencias e inviertes en ella. Mientras la cartera está en proceso de recaudación de fondos, recibes diariamente un ingreso del 8% anual. Después del final del proceso, también recibes ingresos diarios a una tasa del 8% anual, y cada 90 días calculamos automáticamente la rentabilidad de hecho de las carteras y te devengamos la diferencia entre la tasa garantizada del 8% y la tasa de hecho de hasta el 14,5% anual. Así, cada 90 días recibes un ingreso del 8% al 14,5% a tu cuenta de Nibble.</p>
        <p>Ejemplo: Al invertir 1000 euros para 12 meses, al final del plazo recuperas todo tu capital de 1000 euros y recibes ingresos de 90 a 145 euros, que te ingresaremos a tu cuenta de Nibble.</p>
        `,
    legalInfoText6: `
        <ol class="legal-list__num">
          <li>Boostr compra préstamos vencidos de bancos e IMF en subastas con un descuento del 85 %.</li>
          <li>Se inicia el proceso de cobranza extrajudicial. La agencia contacta con el prestatario y trata de acordar la devolución de la deuda.</li>
          <li>Si no es posible ponerse de acuerdo, comienza el proceso judicail para obtener una sentencia judicial sobre el cobro de la deuda organizado por Boostr o su colaborador.</li>
          <li>Después de recibir una sentencia judicial, la deuda, intereses y multas se cobran a través de los servicios judiciales y bancos.</li>
        </ol>
        `,
    refLinkMenu1: `Condiciones del programa`,
    refLinkMenu2: `Mis invitaciones`,
    refLinkTab1: `Pendientes`,
    refLinkTab2: `Bono recibido`,
    refLinkTab3: `Sin bono`,
    refInviteFriendsTitle1: `Invita a tus amigos`,
    refInviteFriendsSubTitle1: `Obtened una recompensa`,
    refInviteFriendsText1: `de hasta 1.000 € tu amigo y tú`,
    refInviteFriendsBTN1: `Invitar amigos`,
    refInviteFriendsSubTitle2: `¿Cómo funciona?`,
    refInviteFriendsStepTitle1: `Invitas a tu amigo a Nibble`,
    refInviteFriendsStepText1: `Envíales tu enlace para que se registren`,
    refInviteFriendsStepTitle2: `Tu amigo se convierte en inversor`,
    refInviteFriendsStepText2: `Tu amigo tiene 3 meses para crear una cartera`,
    refInviteFriendsStepTitle3: `Tú y tu amigo reciben un bono`,
    refInviteFriendsStepText3: `El bono depende del importe de inversiones de tu amigo`,
    refInviteFriendsTitle2: `¿De qué depende el importe de la recompensa?`,
    refInviteFriendsText2: `El bono depende de cuánto invertirá tu amigo durante 3 meses después del registro`,
    refInviteFriendsBonus: `Bono&nbsp;2%`,
    refInviteFriendsSum: `Inversiones del amigo`,
    refInviteFriendsTitle3: `¿Qué más influye?`,
    refInviteFriendsInfoTitle1: `Importe de inversiones`,
    refInviteFriendsInfoText1: `El importe de todas las inversiones de tu amigo debe ser superior a 500 €`,
    refInviteFriendsInfoTitle2: `Periodo de inversiones`,
    refInviteFriendsInfoText2: `Solo se tienen en cuenta las carteras creadas para 3 meses o más`,
    refInviteFriendsBoxTitle1: `Invierte en Nibble con tus amigos`,
    refInviteFriendsBoxText1: `Nuestra plataforma es adecuada tanto para principiantes como para inversores experimentados`,
    yourReferralLink: `Tu enlace de referencia`,
    refInviteFriendsBTN2: `Copiar el enlace`,
    refMyInvitationsTitle1: `Mis invitaciones`,
    refMyInvitationsTotal: `Total ganado`,
    refMyInvitationsFriends: `Amigos registrados`,
    refMyInvitationsGetBonus: `Bono recibido`,
    refMyInvitationsTitle2: `Tu enlace de referencia`,
    refMyInvitationsTitle3: `Mis invitaciones`,
    refMyInvitationsNO: `Todavía no tienes amigos invitados, comparte tu enlace de referencia con ellos`,
    bonusPeriodEnd: `Fin del período de bonificación`,
    yourBonus: `Tu bono`,
    bannerTetx: `<span class="banner-BB__text-i">¡</span>La estrategia legal está disponible de nuevo<span class="banner-BB__text-i">! ¡</span>Invierte <span class="banner-BB__text-i">a una</span> tasa de interés alta <span class="banner-BB__text-i">y</span> gana <span class="banner-BB__text-i">con Nibble!</span>`,
  },
  DE: {
    Out: "von",
    PortfolioTitle: "Ihre Portfolios",
    UntilTheEnd: "Bis zum Ende der Investition",
    TabsActive: "Aktiv",
    TabsClose: "Geschlossen",
    TabsDraft: "Entwurf",
    LoansInvesting: "Kredite wurden investiert",
    LoansActive: "Aktive Kredite",
    LoansClose: "Kredite sind geschlossen",
    LoansDebt: "Legal",
    LoansBought: "Zurückgekauft",
    Hello: "Hallo",
    MonthOne: "Monat",
    MonthSeveral: "Monate",
    MonthMany: "Monate",
    Delete: "Löschen",
    //
    ResultPaymentErrorTitle: "Transaktion von der Bank abgelehnt.",
    ResultPaymentErrorInfo:
      "Sie können Ihr Kontoguthaben per Überweisung oder mit einem der folgenden Dienste aufstocken:",
    LimitContentTitle:
      "In diesem Monat haben Sie bereits Einzahlungen in Höhe von /1/ getätigt.",
    LimitContentDescription1:
      "Nach den Vorgaben des europäischen Rechts dürfen wir bis zu /1/ pro Monat von Ihnen annehmen.",
    LimitContentList1:
      "Bis zum /1/ können Sie Ihr Kontoguthaben mit /2/ aufstocken.",
    LimitContentList2:
      "Ab dem /1/ können Sie Ihr Kontoguthaben mit einem beliebigen Betrag unter /2/ aufstocken.",
    LimitContentDescription2:
      "Falls Sie vorhaben, mehr zu investieren, nehmen Sie bitte Kontakt mit uns auf, und wir werden Ihnen helfen.",
    //
    DepositTabsTitle1: "Karte",
    DepositTabsTitle2: "Banküberweisung",
    DepositTabsTitle3: `Um Ihre persönlichen Daten zu ändern, kontaktieren Sie bitte unseren Kundendienst.`,
    DepositTabsTitle3_EN: `To change your personal information, please contact support. <br /> 
    Currently, only Mastercard is supported. Withdrawal on Visa is in the process.`,
    DepositTabsTitle4: `Die Abbuchung wird auf die hinterlegte Bankkontonummer erfolgen. Der Mindestbetrag zum Abheben beträgt <strong>50 €</strong>.`,
    DepositDescriptionCardDesk:
      "Bitte beachten Sie, dass Ihre Bank Grenzen für Kartentransaktionen festlegen kann. Falls Sie Ihr Kontoguthaben nicht per Karte erhöhen können, sollten Sie sich an Ihre Bank wenden, um das Problem zu lösen, oder Ihr Guthaben per Überweisung erhöhen.",
    DepositDescriptionCardMobile:
      "Falls Sie Ihr Kontoguthaben nicht per Karte erhöhen können, sollten Sie sich an Ihre Bank wenden, um das Problem zu lösen, oder Ihr Guthaben per Überweisung erhöhen.",
    DepositDescriptionBankDesk:
      "Überweisung mit den dargestellten Angaben. Stellen Sie bitte sicher, dass Sie den Zahlungszweck eintragen.\n" +
      "Einzahlungen von Guthaben sind nur Kunden im SEPA-Gebiet möglich.",
    DepositDescriptionBankMobile:
      "Einzahlungen von Guthaben sind nur Kunden <b>im SEPA-Gebiet möglich.</b>",
    //
    OtherLabel: "Andere",
    RangeInvestmentAmount: "Anlagebetrag /min/ bis /max/ ",
    RangeInvestmentTerm: "Anlagedauer (Monate) /min/ bis /max/",
    ValidationAmountMin: "Der Mindestbetrag ist /min/",
    ValidationAmountMax: "Der Höchstbetrag ist /max/",
    ValidationTermMinMax: "Von /min/ bis /max/ Monaten",
    AvailableForInvesting: "Verfügbar zum Investieren",
    WeeklyInterestPay: "Wöchentliche Zinsauszahlung",
    FirstPayment: "Erste Auszahlung",
    ClassicDescription:
      "Fixes Einkommen, das durch eine Rückkaufgarantie abgesichert ist, mit 9.7% pro Jahr. Es handelt sich um eine risikofreie Strategie mit garantiertem Einkommen aus Ihren Investitionen. Die Reinvestition der investierten Gelder ist standardmäßig aktiviert.",
    BalancedDescription:
      "Das Einkommen ist nicht fix und kann laut den vorherigen Statistiken 13% pro Jahr betragen. Dies ist die ausgeglichenste Strategie in Bezug auf das Risiko-Ertrags-Verhältnis. Die Reinvestition der investierten Gelder ist standardmäßig aktiviert.",
    SpecialDescription:
      "Das Einkommen ist nicht fix und kann 17–19% pro Jahr betragen. Obwohl diese Strategie ein höheres Investitionsrisiko aufweist, erlaubt sie es, mögliche Verluste innerhalb des Gesamtwerts des Portfolios auszugleichen. Die Reinvestition der investierten Gelder ist standardmäßig aktiviert.",
    NextMoreText: "Mehr",
    BackButton: "Zurück",
    CalculatorInfoTitle: "Danke, dass Sie sich für Nibble entschieden haben!",
    CalculatorInfoDescription:
      "Wählen Sie Ihre Anlagestrategie entsprechend Ihren Einkommens- und Risikoerwartungen.",
    CalculatorListTitle:
      "Erstellen Sie ein Investitionsportfolios in zwei Schritten:",
    CalculatorListItem1:
      "Schließen Sie die Veriff-Prüfung ab, um Ihr Guthaben aufladen und investieren zu können",
    CalculatorListItem2: "Anlageportfolio erstellen",
    // CalculatorListItem3: 'Anlageportfolio erstellen',
    StrategyNameClassic: "Klassische",
    StrategyNameBalanced: "Ausgewogen",
    StrategyNameSpecial: "Speziell",
    IdentifyYourself: "Verifizierung starten",
    CurrentAnnualRate: "Derzeitiger jährlicher zinssatz",
    //
    IdentificationDescription:
      "Gemäß den Normen des europäischen Rechts müssen wir Ihre Identität verifizieren.",
    //
    bannerAchive: "Sommer-Rallye",
    bannerInfo:
      "Verpassen Sie nicht die Gelegenheit, mehr zu verdienen – mit einem Zins von 11,7 % bei der Klassik-Strategie für die Portfolios, die&nbsp;vom&nbsp;1.&nbsp;Juli&nbsp;bis&nbsp;zum&nbsp;31.&nbsp;August&nbsp;2021&nbsp;angelegt&nbsp;werden.",
    //
    PaymentsOpertions_334: "Einzahlung per Karte",
    PaymentsOpertions_150: "Einzahlung durch Überweisung",
    PaymentsOpertions_355: "Bonus",
    //
    NoLinkDocsAlert:
      'Um die Dokumente herunterzuladen, müssen Sie die Felder im Bereich "Persönliche Angaben" ausfüllen',
    NoticeDepositingCard:
      "Bitte beachten Sie, dass Ihre Bank Grenzen für Kartentransaktionen festlegen kann. Falls Sie Ihr Kontoguthaben nicht per Karte erhöhen können, sollten Sie sich an Ihre Bank wenden, um das Problem zu lösen, oder Ihr Guthaben per Überweisung erhöhen.",
    //
    AboutTheBorrower: "Über den Kreditnehmer",
    AboutVeriff:
      "Veriff wurde bereits für den Verifizierungsprozess von europäischen Regierungen ausgewählt. Darüber hinaus auch von vielen führenden Banken und Unternehmen der FinTech- und der E-Commerce-Branche.",
    AccountNumber: "Kontonummer",
    AccountSumAvailable: "Guthaben auf Ihrem Konto",
    AccuredIncome: "Erzieltes Einkommen",
    ActiveLoans: "Aktive Kredite",
    ActivePortfolio: "Aktives Portfolio",
    AdditionalAgreement: "Zusätzliche Vereinbarung",
    Address: "Adresse",
    AddressLine1: "Adresse 1",
    AddressLine2: "Adresse 2",
    Agreement: "vertrag",
    All: "Alle",
    AlreadyHaveAccount: "Bereits registriert? Einloggen",
    AnnualInterestRate: "derzeitiger jährlicher Zinssatz",
    AnnualInterestRateClassic: "fester jährlicher Zinssatz",
    ApplicationReceivedMessage:
      "Ihr Antrag wurde angenommen und unser Manager wird Sie in Kürze kontaktieren. Vielen Dank!",
    ApplyPromoCode: "Promo-Code einlösen",
    AreYouSure: "Sind Sie sich sicher?",
    Articles: "Artikel",
    AverageInterest: "Gewichteter durchschnittlicher Zinssatz",
    Balance: "Guthaben",
    BalanceReplenishment: "BalanceReplenishment",
    Bank: "Bank",
    BankAccountNumber: "Kontonummer",
    BankName: "Bankname",
    BankTransferReplenishment: "Einzahlung durch Überweisung",
    BankTransferWithdrawal: "Abhebung auf Bankkonto",
    CardTransferWithdrawal: "Withdrawal by card",
    Basic: "Allgemeine Einstellungen",
    BirthDate: "Geburtsdatum",
    Borrower: "Kreditgeber",
    BorrowingCompany: "Kreditunternehmen",
    BringFriend: "Laden Sie einen Freund ein",
    BuybackGuarantee: "Rückkauf-Garantie",
    c11: "Russland",
    c12: "Österreich",
    c197: "Keine Wiederanlage",
    c198: "Vollständige Wiederanlage",
    c199: "Grundbetrag der Reinvestition",
    c206: "Spanien",
    c208: "Belgien",
    c242: "Bulgarien",
    c243: "Vereinigtes Königreich",
    c244: "Ungarn",
    c245: "Deutschland",
    c246: "Griechenland",
    c247: "Dänemark",
    c248: "Irland",
    c249: "Italien",
    c250: "Zypern",
    c251: "Lettland",
    c252: "Litauen",
    c253: "Luxemburg",
    c254: "Malta",
    c255: "Niederlande",
    c256: "Polen",
    c257: "Portugal",
    c258: "Rumänien",
    c259: "Slowakei",
    c260: "Slowenien",
    c261: "Finnland",
    c262: "Frankreich",
    c263: "Kroatien",
    c264: "Tschechien",
    c265: "Schweden",
    c266: "Schweiz",
    c267: "Estland",
    c270: "Joymoney Russland (demnächst)",
    c271: "Joymoney Spanien",
    c272: "Joymoney Mexiko (demnächst)",
    c274: "Fehlende Fotos",
    c275: "Das Gesicht ist nicht eindeutig erkennbar",
    c276: "Das Dokument ist nicht vollständig abgebildet",
    c277: "Schlechte Bildqualität",
    c278: "Das Dokument ist beschädigt",
    c279: "Dieser Dateityp wird nicht unterstützt",
    c280: "Das Dokument ist abgelaufen",
    c281: "Akzeptiert",
    c282: "Andere Gründe",
    c283: "Abgelaufen",
    CalculatorNote:
      "Die Reinvestition der investierten Gelder ist standardmäßig aktiviert und alle Einnahmen aus der Investition werden wöchentlich auf Ihr Nibble-Konto überwiesen",
    CapitalReinvestment: "Kapitalreinvestition",
    CardInfo:
      "Wir arbeiten an weiteren Möglichkeiten zur Einzahlung von Guthaben auf Ihr Nibble-Konto. Bald wird es Ihnen möglich sein, Einzahlungen von Ihrer Giro- oder Kreditkarte vorzunehmen.",
    CashbackForFriends: "Cashback von der Investition eines Freundes",
    CashbackForInvestments: "Cashback von Ihren Investitionen",
    CashDeposit: "Geld einzahlen",
    ChangePassword: "Passwort ändern",
    ChoiceOf70: "Von 70 % der Investoren gewählt",
    ChoosePortfolioType: "Wählen Sie die Portfolioart",
    ChoosePortfolioType1: "Wählen Sie die Portfolioart",
    City: "Stadt",
    ClosedLoans: "Abgeschlossene Kredite",
    ClosingDate: "Abschlusstag",
    CompanyHeadName: "Vollständiger Name des Hauptgeschäftsführers",
    CompanyName: "Name des Unternehmens",
    CompleteRegistration:
      "Schließen Sie die Registrierung durch Ihre Verifizierung ab, um Ihr Guthaben einzahlen und mit dem Investieren beginnen zu können.",
    Confirm: "Bestätigen",
    ConfirmationLinkSent:
      "Ein Bestätigungslink wurde an Ihre E-Mail-Adresse gesendet",
    Continue: "Weiter",
    ContractsAndDocs: "Dokumente und Vereinbarungen",
    Country: "Land",
    CountryOfIssue: "Ausstellungsland",
    CountryOfResidence: "Land",
    Code: "Code",
    CreateAccount: "Profil erstellen",
    CreatePortfolio: "Portfolio erstellen",
    CreatePortfolioInfo:
      "Falls ausgewählt, werden alle erzielten Einnahmen wiederangelegt, um Ihnen umso mehr Einnahmen einzubringen. Mit der Standardeinstellung werden die aus Investitionen erzielten Einnahmen auf Ihr Nibble-Profil ausgezahlt und stehen nach der Kreditfälligkeit zur Abhebung bereit.",
    CreateTestPortfolio: "Test-Portfolio erstellen",
    CurrentBalance: "Kontostand",
    CurrentIncome: "Aktuelle Einnahmen",
    CurrentlyOnYourAccount: "Aktuell auf Ihrem Konto",
    CurrentPassError: "Das aktuelle Passwort ist falsch",
    CurrentPassword: "Aktuelles Passwort",
    DailyReport: "Täglicher Bericht",
    DateFormat: "Datumsformat",
    DaysLabel: "Tage",
    DepositAccount: "Auf Konto einzahlen",
    DepositAccountMobile: "Einzahlen",
    DepositFunds: "Aufladen",
    DepositHistory: "Einzahlungshistorie",
    DepositPortfolio: "Portfolio aufladen",
    DepositViaBankAccount: "Einzahlen durch ein Bankkonto",
    DocBackScan: "Rückseite des Dokuments",
    DocFrontScan: "Vorderseite des Dokuments",
    DocPhoto: "Foto des Dokuments",
    DocType: "Art des Dokuments",
    Document: "Dokument",
    DownloadAgreement: "Vertrag herunterladen",
    DownloadWarning:
      "Um den Vertrag herunterzuladen, geben Sie bitte die benötigten",
    DownloadWarningNext: "persönliche Informationen",
    Email: "E-Mail",
    EmailAlreadyReg: "Diese E-Mail-Adresse wird im System bereits geführt",
    EmailChangeInfo:
      "Um Ihre E-Mail-Adresse zu ändern, kontaktieren Sie bitte den technischen Kundendienst.",
    EnabledByDefault: "Aktiviert (Standard)",
    ERROR_001:
      "Sie haben nicht genügend Guthaben in Ihrem Konto, um ein Portfolio mit den ausgewählten Einstellungen zu erstellen",
    ERROR_002: "Kein Land ausgewählt",
    ERROR_003: "Unbekannter Fehler",
    ERROR_004: "Ungültiger Betrag",
    ERROR_005: "Nur ein Test-Portfolio erlaubt",
    ERROR_006:
      "Der ausgewählte Investitionsbetrag liegt über Ihrem verfügbaren Guthaben",
    ErrorEmailLength: "E-Mail-Feld darf nicht leer sein",
    ErrorEmailLogin: "Geben Sie eine gültige E-Mail-Adresse ein",
    ErrorEmailPassLogin: "Ungültige E-Mail-Adresse oder ungültiges Passwort",
    ErrorEmptyFields: "Es wurden nicht alle Felder ausgefüllt",
    ErrorFirstNameLength: "Sie haben Ihren Vornamen nicht angegeben",
    ErrorLastNameLength: "Sie haben Ihren Nachnamen nicht angegeben",
    ErrorLoadDocument:
      "Um den Vertrag herunterzuladen, bitte auf der Einstellungsseite das Geburtsdatum und die Adresse eingeben.",
    ErrorPhoneFormat: "Die Telefonnummer ist nicht korrekt",
    ErrorPromoCode: "Angabe eines ungültigen Promo-Codes",
    Exit: "Ausloggen",
    ExpectedAnnualReturn: "Erwartete jährliche Rendite",
    ExpectedClosingDate: "Erwartetes Rückzahlungsdatum",
    ExpectedIncome: "Erwartete Einnahmen",
    FacePhoto: "Bild des Gesichts",
    Finish: "Abschließen",
    FirstName: "Vorname",
    FirstStep: "Erster Schritt der Registrierung",
    ForBusiness: "geschäftlich",
    ForgotPassword: "Passwort vergessen?",
    FormatDate1: "jjjj-mm-tt",
    FormatDate2: "jjjj/mm/tt",
    FormatDate3: "mm/tt/jjjj",
    FormatDate4: "mm-tt-jjjj",
    From3To60Months: "von 3 bis 60 Monate",
    Full: "Vollständig",
    FundsWithdrawal: "Geld abheben",
    Gender: "Geschlecht",
    GetSMSCode: "Verifizierungscode erhalten",
    GoIdent: "Verifizierung bestehen",
    GoToAccount: "Zu meinem Konto",
    Help: "Hilfe",
    History: "Umsatzanzeige",
    HowItWorks: "Funktionsweise",
    HugeAmountWarning:
      "Für Investitionen über 10.000 € ist eine weitere Überprüfung notwendig",
    // eslint-disable-next-line
    HelperRisksTitle:
      "Einstufung von Krediten nach dem Risiko der &Uuml;berf&auml;lligkeit nach NPL 30, 60, 90, 120+",
    HelperRisksText:
      'Die Unternehmen der IT Smart Finance Holding verwenden Scoring-Modelle, um die Kreditnehmerqualit&auml;t zu bestimmen. Alle genehmigten Kredite werden entsprechend klassifiziert und nach den Anlagestrategien geordnet.</p> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>AA</strong></td> <td><strong>A</strong></td> </tr> <tr> <td>p&uuml;nktlich geschlossen</td> <td>vorzeitig geschlossen</td> </tr> <tr> <td colspan="2">Kredite mit geringem Risiko. In der Regel geben Kunden dieser Kategorie die Einnahmen p&uuml;nktlich oder vorzeitig zur&uuml;ck, so dass die Rendite f&uuml;r sie gering ist, aber auch die Risiken gering sind.</td> </tr> <tr> <td><strong>ВВ</strong></td> <td><strong>В</strong></td> </tr> <tr> <td>&uuml;berf&auml;lliger NPL 0&ndash;30</td> <td>&uuml;berf&auml;lliger NPL 30&ndash;60</td> </tr> <tr> <td colspan="2">Kredite mit mittlerem Risiko. Kunden dieser Kategorie k&ouml;nnen mit einem &uuml;berf&auml;lligen NPL 30 und NPL 60 in Verzug geraten, geben die Kredite am Ende aber fast immer zur&uuml;ck. Das Risiko einer Einholung ist bei dieser Kategorie h&ouml;her, aber auch das Durchschnittseinkommen ist h&ouml;her.</td> </tr> <tr> <td><strong>СС</strong></td> <td><strong>С</strong></td> </tr> <tr> <td>&uuml;berf&auml;lliger NPL 60&ndash;90</td> <td>&uuml;berf&auml;lliger NPL 90&ndash;120</td> </tr> <tr> <td colspan="2">Kredite mit einem erh&ouml;hten Risiko. In dieser Kategorie gibt es Kredite mit einem &uuml;berf&auml;lligen NPL 60, NPL 90, NPL 120 und solche, die sich in einem Rechtsstreit befinden, die unter allen Strategien die maximale Rentabilit&auml;t bieten.</td> </tr> </tbody> </table> <p>Einmal im Monat analysiert der Risikoausschuss den Prozess der Zuordnung der Kreditklassifizierung und passt ihn an. Als Ergebnis der Bewertung werden die bewilligten Kredite in die folgenden Kategorien eingeteilt.',
    HelperAnnualRateTitle: "Jahreszinssatz",
    HelperAnnualRateText:
      "Die Rendite wird monatlich vom Risikogremium festgelegt und h&auml;ngt von den Ergebnissen der gepr&uuml;ften Periode ab.",
    HelperStrategyClassicTitle:
      "Klassische<strong>&nbsp;</strong>Strategie mit R&uuml;ckkaufgarantie",
    HelperStrategyClassicText:
      "Sie investieren in unbesicherte Verbraucherkredite, die als AA, A oder BB klassifiziert sind und bei denen das Risiko eines Zahlungsverzugs des Kreditnehmer sehr gering ist. Mit der R&uuml;ckkaufgarantie sind Sie vor Risiken gesch&uuml;tzt und erhalten ein garantiertes Einkommen zu einem festen Zinssatz.</p> <p><strong>Damit verbundene Risiken​</strong></p> <p><strong>Risiko der Nicht- bzw. Teilr&uuml;ckzahlung des Kredits und Verletzung des R&uuml;ckzahlungsplans&nbsp;</strong></p> <p>Diese Investorenrisiken sind durch eine R&uuml;ckkaufgarantie f&uuml;r die erhaltenen Verm&ouml;genswerte und Zinsen abgesichert. Sehen wir uns die Funktionsweise genauer an: Der Nibble-Investor, der sich f&uuml;r diese Strategie entscheidet, investiert in Kredite, die von den Unternehmen des IT Smart Finance-Konzerns vergeben werden und am Tag der Investition zur Verf&uuml;gung stehen. Die Holdinggesellschaft stellt den vergebenen Kredit auf die Nibble-Plattform, um einen Investor zu finden. Die Beziehung zwischen den Unternehmen des IT-Smart Finance-Konzerns und dem Endkreditnehmer wird durch einen Vertrag &uuml;ber einen kurzfristigen Verbraucherkredit mit den sich daraus ergebenden Forderungsrechten gegen&uuml;ber dem Kreditnehmer geregelt. Auf der Grundlage des mit dem Investor abgeschlossenen Abtretungsvertrages &uuml;bernimmt Nibble die Verpflichtungen zum Erhalt von Zahlungen des Endkreditnehmers, die im Rahmen des Kreditvertrags an die IT Smart Finance-Unternehmensgruppe geleistet werden. Nibble zahlt diese dann in der durch den Abtretungsvertrag festgelegten Art und H&ouml;he an den Investor aus. Falls der Kreditnehmer den Kredit nicht fristgerecht zur&uuml;ckzahlt oder die Kreditr&uuml;ckzahlungsfrist verl&auml;ngert, kauft die IT Smart Finance-Unternehmensgruppe die Anspr&uuml;che des Investors in H&ouml;he der investierten Summe sowie der garantierten Zinseinnahmen aus der Investition zur&uuml;ck.",
    HelperStrategyBalancedTitle: "Ausgewogene<strong>&nbsp;</strong>Strategie",
    HelperStrategyBalancedText:
      "Mit dieser werden Investitionen in Verbraucherkredite vorgenommen, die als BB, B und CC klassifiziert werden. In der Regel ist das Risiko der Nichtr&uuml;ckzahlung eines Kredits im Rahmen dieser Strategie minimal, obwohl NPL 30 und NPL 60 auftreten k&ouml;nnen. Sie werden jedoch schlussendlich fast immer zur&uuml;ckgezahlt. Das Ausfallrisiko ist gering, aber die Ertr&auml;ge sind deutlich h&ouml;her als bei der Strategie mit fixen Einnahmen.</p> <p><strong>Damit verbundene Risiken​</strong></p> <p><strong>Keine Sicherheit​</strong></p> <p>Bei dieser Strategie sind die Investitionen nicht durch eine R&uuml;ckkaufgarantie gesch&uuml;tzt und werden auch nicht durch staatliche Sicherungsfonds abgefedert. Bei einem Ausfall eines Kredits durch den Kreditnehmer tr&auml;gt der Investor das Risiko, einen Teil bzw. das gesamte investierte Geld zu verlieren.</p> <p><strong>Das Risiko, einen unerwartet niedrigen oder gar keinen Gewinn zu erzielen​</strong></p> <p>Nibble garantiert keinen Gewinn aus dieser Strategie. Der Investor kauft die Forderungsrechte gegen&uuml;ber den Endkreditnehmern. Der Erhalt von Zinsertr&auml;gen h&auml;ngt direkt von der Erf&uuml;llung der R&uuml;ckzahlungsverpflichtungen des Kreditnehmers ab. Falls der Kreditnehmer den Kredit nur teilweise zur&uuml;ckzahlt, erh&auml;lt der Investor m&ouml;glicherweise nicht die erwartete Zinskomponente der Einnahmen, oder die Laufzeit f&uuml;r die R&uuml;ckzahlung des investierten Betrags bzw. der ausstehende Zahlungsbetrag werden sich zwangsl&auml;ufig erh&ouml;hen.</p> <p>Die tats&auml;chliche Rendite f&uuml;r diese Strategie &uuml;bersteigt die angegebene maximale Rendite von 13%. Die dar&uuml;ber hinaus erwirtschafteten Einnahmen befinden sich nicht im Besitz der Nibble-Plattform und werden reinvestiert, um Risiken zu reduzieren und die ausgewiesene Rendite zu erreichen.",
    HelperStrategySpecialTitle: "Spezielle&nbsp;Strategie",
    HelperStrategySpecialText:
      "Dabei handelt es sich um Investitionen in unbesicherte Verbraucherkredite, die als B, CC und C eingestuft werden. Der Grad des Kreditausfallrisikos ist bei dieser Strategie h&ouml;her als bei der ausgewogenen Strategie. Die Einnahmen, die bis zu 19 % pro Jahr betragen k&ouml;nnen, kompensieren jedoch auf jeden Fall m&ouml;gliche Verluste des Investitionsportfoliowertes. Die Mindestinvestitionsdauer von 12 Monate wurde gew&auml;hlt, da dieses Portfolio Kredite enth&auml;lt, bei denen ein Zahlungsverzug auftreten und deren Einziehung einen l&auml;ngeren Zeitraum in Anspruch nehmen kann.</p> <p><strong>Damit verbundene Risiken​</strong></p> <p><strong>Keine Sicherheit​</strong></p> <p>Bei dieser Strategie sind die Investitionen nicht durch eine R&uuml;ckkaufgarantie gesch&uuml;tzt und werden auch nicht durch staatliche Sicherungsfonds abgefedert. Bei einem Ausfall eines Kredits durch den Kreditnehmer tr&auml;gt der Investor das Risiko, einen Teil bzw. das gesamte investierte Geld zu verlieren.</p> <p><strong>Das Risiko, einen unerwartet niedrigen oder gar keinen Gewinn zu erzielen​</strong></p> <p>Nibble garantiert keinen Gewinn aus dieser Strategie. Der Investor kauft die Forderungsrechte gegen&uuml;ber den Endkreditnehmern. Der Erhalt von Zinsertr&auml;gen h&auml;ngt direkt von der Erf&uuml;llung der R&uuml;ckzahlungsverpflichtungen des Kreditnehmers ab. Falls der Kreditnehmer den Kredit nur teilweise zur&uuml;ckzahlt, erh&auml;lt der Investor m&ouml;glicherweise nicht die erwartete Zinskomponente der Einnahmen, oder die Laufzeit f&uuml;r die R&uuml;ckzahlung des investierten Betrags bzw. der ausstehende Zahlungsbetrag werden sich zwangsl&auml;ufig erh&ouml;hen.</p> <p>Die tats&auml;chliche Rendite f&uuml;r diese Strategie &uuml;bersteigt die angegebene maximale Rendite von 19 %. Die dar&uuml;ber hinaus erwirtschafteten Einnahmen befinden sich nicht im Besitz der Nibble-Plattform und werden reinvestiert, um Risiken zu reduzieren und die ausgewiesene Rendite zu erreichen.",

    IdentFailed: "Verifizierung fehlgeschlagen",
    Identification: "Verifizierung",
    IdentificationGoal1: "Einhalten der EU-Gesetze",
    IdentificationGoal2:
      "Das Garantieren der Sicherheit Ihres Guthabens und Ihrer Transaktionen",
    IdentificationGoal3:
      "Das Vereinfachen von Geschäftsprozessen, um sie transparenter und effizienter zu machen",
    IdentificationGoalsTitle:
      "Unsere grundsätzlichen Ziele bei der persönlichen Verifizierung:",
    IdentificationH1:
      "warum bitten wir Sie, uns Bilder Ihrer Dokumente zur Verfügung zu stellen?",
    IdentificationLead:
      "Nibble hält sich genauestens an die Europäischen Vorschriften im Bezug auf Geldwäsche (AML), Verifizierung der Nutzer sowie dem Speichern und der Nutzung personenbezogener Daten.",
    IdentificationProfitsList:
      '<li class="veriffFeature-list__item">Investitionen sind nur verifizierten Nutzern möglich</li> <li class="veriffFeature-list__item">Ihre Daten werden verschlüsselt übertragen und gespeichert</li> <li class="veriffFeature-list__item">Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter</li> <li class="veriffFeature-list__item">Wir übernehmen die volle Verantwortung für die Sicherheit Ihrer personenbezogenen Daten</li>',
    IdentityDocHint:
      "Zur Verifizierung können Sie Ihren Personalausweis oder Führerschein verwenden. Sollten Sie sich für die Verifizierung mittels Führerschein entscheiden, stellen Sie bitte sicher, dass Sie sowohl die Vorder- als auch die Rückseite fotografieren und hochladen.",
    IDHint: "Bitte geben Sie die Ausweisnummer des ausgewählten Dokuments ein",
    ID: "ID",
    IDNumber: "Seriennummer des Dokuments",
    Income: "Gutschrift",
    IncomeCalculation: "Einnahmenabgrenzung",
    IncomeReceived: "Erzielte Einnahmen",
    Individual: "Natürliche Person",
    InitialDeposit: "Einzahlung",
    InterestRate: "Zinssatz",
    Invest: "Investieren",
    InvestedInPortfolio: "Investieren im Portfolio",
    InvestedLoans: "Investierte Kredite",
    Investing: "Investition",
    InvestingIn: "Investitionen in ID X",
    Investment_amount: "Höhe der Investition",
    Investment_date: "Tag der Investition",
    Investment_type: "Art der Investition",
    InvestmentAmount: "Investitionssumme",
    InvestmentPeriod: "Investitionsdauer, Monate.",
    InvestmentPeriodDays: "Investitionsdauer, Tage",
    InvestmentPortfolios: "Investitionsportfolios",
    InvestmentsCountTotal: "Insgesamt investiert, Einheiten",
    InvestmentsSumTotal: "gesamte Investitionen",
    IHavePromoCode: "Ich habe einen Aktionscode",

    InformationTitleSection1: "Investieren mit Nibble",
    InformationContentSection1: `
        <p>Wir können Ihnen drei Anlagestrategien anbieten: Klassisch, Ausgewogen und Rechtliches. Diese unterscheiden
        sich in der H&ouml;he des Jahreseinkommens, im Risiko und dessen Verteilung zwischen der Plattform und dem
        Nutzer. Vergleichen Sie unsere Strategien und w&auml;hlen Sie die f&uuml;r Sie am besten geeignete aus.</p>
    <ul>
        <li>Auch falls Sie keine Anlageerfahrung haben, sollten Sie unsere Anlagen mit einem sicheren Einkommen
            ausprobieren. Wir &uuml;bernehmen das Risiko f&uuml;r Sie.</li>
        <li>Falls Sie bereits ein erfahrener Anleger sind, w&auml;hlen Sie eine komfortable Strategie in Bezug auf das
            Risiko-Einnahme-Verh&auml;ltnis. Wir teilen das Risiko mit Ihnen.</li>
    </ul>
    <h3>Beschreibung der Strategien</h3>
    <div class="article-table">
        <table border="0" cellpadding="0" cellspacing="0">
            <tbody>
                <tr>
                    <td><strong>Strategie</strong></td>
                    <td><strong>Klassisch</strong></td>
                    <td><strong>Ausgewogen</strong></td>
                    <td><strong>Rechtliches</strong></td>
                </tr>
                <tr>
                    <td><strong>Jahreszinssatz</strong></td>
                    <td>8%</td>
                    <td>12.5%</td>
                    <td>14.5%</td>
                </tr>
                <tr>
                    <td><strong>Erkl&auml;rung</strong></td>
                    <td>Sicheres Einkommen</td>
                    <td>Ausgewogene Risiken</td>
                    <td>Hohes Einkommen f&uuml;r geduldige Investoren</td>
                </tr>
                <tr>
                    <td><strong>Beschreibung</strong></td>
                    <td>Fixes Einkommen, das durch eine R&uuml;ckkaufgarantie abgesichert ist, mit 8% pro
                        Jahr.&nbsp;Es handelt sich um eine risikofreie Strategie mit garantiertem Einkommen aus Ihren
                        Investitionen.</td>
                    <td>Das Einkommen ist nicht fix und kann laut den vorherigen Statistiken 12&ndash;15 % pro Jahr
                        betragen. Dies ist die ausgeglichenste Strategie in Bezug auf das Risiko-<br />
                        Ertrags-Verh&auml;ltnis.</td>
                    <td>
                        <p>Es handelt sich um eine Strategie für Investitionen in Portfolios, die aus
                            Verbraucherkrediten der Kategorien B, CC und C bestehen, die sich in einem vorgerichtlichen
                            bzw. gerichtlichen Inkassoverfahren befinden. Da diese Kredite überfällige Zahlungen und
                            Geldstrafen aufweisen, erreicht die Rendite dieser Strategie bis zu 19 % pro Jahr.</p>
                        <p>Die Gerichts- und Inkassoprozesse nehmen eine lange Zeit in Anspruch, sodass die
                            Mindestanlagedauer 6 Monate beträgt.</p>
                    </td>
                </tr>
                <tr>
                    <td><strong>Investitionslaufzeit</strong></td>
                    <td>1&ndash;6 Monate</td>
                    <td>7&ndash;60 Monate</td>
                    <td>6&ndash;60 Monate</td>
                </tr>
                <tr>
                    <td><strong>R&uuml;ckkauf</strong></td>
                    <td><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOCAyTDcgMTNMMiA4IiBzdHJva2U9IiNCN0Q3NUQiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="
                            alt="check"></td>
                    <td>&mdash;</td>
                    <td>
                        <ul>
                            <li>Einlagengarantie</li>
                            <li>Garantierte Mindestrendite von 8% pro Jahr</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td><strong>Reinvestition&nbsp;</strong></td>
                    <td colspan="2">Automatische Reinvestition der investierten Mittel in neue Kredite</td>
                    <td>
                        <img src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNERTM1MEIiIGN4PSI4IiBjeT0iOCIgcj0iOCIvPjxwYXRoIGQ9Ik05LjQ4NSA4LjA3MWwyLjEyMiAyLjEyMWExIDEgMCAxIDEtMS40MTUgMS40MTVsLTIuMTItMi4xMjItMi4xMjIgMi4xMjJhMSAxIDAgMSAxLTEuNDE0LTEuNDE1bDIuMTItMi4xMi0yLjEyLTIuMTIyQTEgMSAwIDEgMSA1Ljk1IDQuNTM2bDIuMTIxIDIuMTIgMi4xMjEtMi4xMmExIDEgMCAxIDEgMS40MTUgMS40MTRMOS40ODUgOC4wN3oiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+'/>
                    </td>
                </tr>
                <tr>
                    <td><strong>Zinsberechnung und -&uuml;berweisung</strong></td>
                    <td colspan="2">Die Zinsen fallen t&auml;glich an und werden w&ouml;chentlich auf das Nibble-Konto
                        eines Investors &uuml;berwiesen</td>
                    <td>
                        Tägliche Verzinsung mit 8% p. a., Auszahlung alle 90 Tage entsprechend der tatsächlich
                        erzielten Rendite, bis zu 14,5 % p. a.
                    </td>
                </tr>
                <tr>
                    <td><strong>NPL-Einstufung&nbsp;</strong></td>
                    <td>АА&ndash;А&ndash;ВВ</td>
                    <td>ВВ&ndash;В&ndash;СС</td>
                    <td>В&ndash;СС&ndash;С</td>
                </tr>
                <tr>
                    <td><strong>Erwartete Ausfallrate</strong></td>
                    <td>&mdash;</td>
                    <td>bis zu&nbsp;NPL 30</td>
                    <td>NPL 30&ndash;90</td>
                </tr>
                <tr>
                    <td><strong>Investitionsbetrag&nbsp;**</strong></td>
                    <td>10&ndash;10 000 &euro;</td>
                    <td>100&ndash;10 000 &euro;</td>
                    <td>10&ndash;10 000 &euro;</td>
                </tr>
                <tr>
                    <td><strong>Mindest-Abhebungsbetrag</strong></td>
                    <td colspan="3">50 &euro;</td>
                </tr>
            </tbody>
        </table>
    </div>
    <p><small>*&nbsp;Die Rendite wird monatlich vom Risikogremium festgelegt und h&auml;ngt von den Ergebnissen der
            gepr&uuml;ften Periode ab.<br /> **&nbsp;Falls Sie mehr als 15.000 &euro; investieren m&ouml;chten, werden
            wir Sie um Bereitstellung zus&auml;tzlicher Unterlagen bitten.</small></p>
    <h3>Klassische<strong>&nbsp;</strong>Strategie mit R&uuml;ckkaufgarantie</h3>
    <p>Sie investieren in unbesicherte Verbraucherkredite, die als AA, A oder BB klassifiziert sind und bei denen das
        Risiko eines Zahlungsverzugs des Kreditnehmer sehr gering ist. Mit der R&uuml;ckkaufgarantie sind Sie vor
        Risiken gesch&uuml;tzt und erhalten ein garantiertes Einkommen zu einem festen Zinssatz.</p>
    <p><strong>Damit verbundene Risiken​</strong></p>
    <p><strong>Risiko der Nicht- bzw. Teilr&uuml;ckzahlung des Kredits und Verletzung des
            R&uuml;ckzahlungsplans&nbsp;</strong></p>
    <p>Diese Investorenrisiken sind durch eine R&uuml;ckkaufgarantie f&uuml;r die erhaltenen Verm&ouml;genswerte und
        Zinsen abgesichert. Sehen wir uns die Funktionsweise genauer an: Der Nibble-Investor, der sich f&uuml;r diese
        Strategie entscheidet, investiert in Kredite, die von den Unternehmen des IT Smart Finance-Konzerns vergeben
        werden und am Tag der Investition zur Verf&uuml;gung stehen. Die Holdinggesellschaft stellt den vergebenen
        Kredit auf die Nibble-Plattform, um einen Investor zu finden. Die Beziehung zwischen den Unternehmen des
        IT-Smart Finance-Konzerns und dem Endkreditnehmer wird durch einen Vertrag &uuml;ber einen kurzfristigen
        Verbraucherkredit mit den sich daraus ergebenden Forderungsrechten gegen&uuml;ber dem Kreditnehmer geregelt. Auf
        der Grundlage des mit dem Investor abgeschlossenen Abtretungsvertrages &uuml;bernimmt Nibble die Verpflichtungen
        zum Erhalt von Zahlungen des Endkreditnehmers, die im Rahmen des Kreditvertrags an die IT Smart
        Finance-Unternehmensgruppe geleistet werden. Nibble zahlt diese dann in der durch den Abtretungsvertrag
        festgelegten Art und H&ouml;he an den Investor aus. Falls der Kreditnehmer den Kredit nicht fristgerecht
        zur&uuml;ckzahlt oder die Kreditr&uuml;ckzahlungsfrist verl&auml;ngert, kauft die IT Smart
        Finance-Unternehmensgruppe die Anspr&uuml;che des Investors in H&ouml;he der investierten Summe sowie der
        garantierten Zinseinnahmen aus der Investition zur&uuml;ck.</p>
    <h3>Ausgewogene<strong>&nbsp;</strong>Strategie</h3>
    <p>Mit dieser werden Investitionen in Verbraucherkredite vorgenommen, die als BB, B und CC klassifiziert werden. In
        der Regel ist das Risiko der Nichtr&uuml;ckzahlung eines Kredits im Rahmen dieser Strategie minimal, obwohl NPL
        30 und NPL 60 auftreten k&ouml;nnen. Sie werden jedoch schlussendlich fast immer zur&uuml;ckgezahlt. Das
        Ausfallrisiko ist gering, aber die Ertr&auml;ge sind deutlich h&ouml;her als bei der Strategie mit fixen
        Einnahmen.</p>
    <p><strong>Damit verbundene Risiken​</strong></p>
    <p><strong>Keine Sicherheit​</strong></p>
    <p>Bei dieser Strategie sind die Investitionen nicht durch eine R&uuml;ckkaufgarantie gesch&uuml;tzt und werden auch
        nicht durch staatliche Sicherungsfonds abgefedert. Bei einem Ausfall eines Kredits durch den Kreditnehmer
        tr&auml;gt der Investor das Risiko, einen Teil bzw. das gesamte investierte Geld zu verlieren.</p>
    <p><strong>Das Risiko, einen unerwartet niedrigen oder gar keinen Gewinn zu erzielen​</strong></p>
    <p>Nibble garantiert keinen Gewinn aus dieser Strategie. Der Investor kauft die Forderungsrechte gegen&uuml;ber den
        Endkreditnehmern. Der Erhalt von Zinsertr&auml;gen h&auml;ngt direkt von der Erf&uuml;llung der
        R&uuml;ckzahlungsverpflichtungen des Kreditnehmers ab. Falls der Kreditnehmer den Kredit nur teilweise
        zur&uuml;ckzahlt, erh&auml;lt der Investor m&ouml;glicherweise nicht die erwartete Zinskomponente der Einnahmen,
        oder die Laufzeit f&uuml;r die R&uuml;ckzahlung des investierten Betrags bzw. der ausstehende Zahlungsbetrag
        werden sich zwangsl&auml;ufig erh&ouml;hen.</p>
    <p>Die tats&auml;chliche Rendite f&uuml;r diese Strategie &uuml;bersteigt die angegebene maximale Rendite von 15 %.
        Die dar&uuml;ber hinaus erwirtschafteten Einnahmen befinden sich nicht im Besitz der Nibble-Plattform und werden
        reinvestiert, um Risiken zu reduzieren und die ausgewiesene Rendite zu erreichen.</p>
    <h3>Rechtsstrategie</h3>
    <p>Es handelt sich um eine Strategie für Investitionen in Portfolios, die aus Verbraucherkrediten der Kategorien B,
        CC und C bestehen, die sich in einem vorgerichtlichen bzw. gerichtlichen Inkassoverfahren befinden. Da diese
        Kredite überfällige Zahlungen und Geldstrafen aufweisen, erreicht die Rendite dieser Strategie bis zu 19 % pro
        Jahr.</p>
    <p>Die Gerichts- und Inkassoprozesse nehmen eine lange Zeit in Anspruch, sodass die Mindestanlagedauer 6 Monate
        beträgt. Die gesamte Prozessverwaltung und das Inkasso werden von Boostr übernommen.</p>
    <p><strong>Verbundene Risiken:</strong></p>
    <p><strong>Risiko der Nicht-Rückzahlung des Kredits/Verlust des gesamten Kreditbetrags​</strong></p>
    <p>
    <ul>
        <li>Die Strategie unterliegt der Einlagengarantie. Dies ist die Verpflichtung des Inkassobüros, den gesamten
            Anlagebetrag am Ende des Anlagezeitraums zurückzuzahlen und eine Mindestrendite von 8% pro Jahr zu
            gewährleisten.</li>
        <li>Durch die Investition in ein Portfolio, das aus einer Vielzahl von Krediten besteht, wird das Risiko, dass
            die Erträge aus mehreren Verträgen ausbleiben, verringert, da die Erträge durch andere Kredite gedeckt sind.
        </li>
        <li>Tägliche Verzinsung mit 8% p. a., Auszahlung alle 90 Tage entsprechend der tatsächlich erzielten Rendite,
            bis zu 14,5 % p. a.</li>
        <li>Während der Mittelbeschaffung für einen Portfoliokauf fallen Erträge in Höhe von 8% p. a. an. Dazu erhalten
            Sie eine Bonusrendite zur Hauptrendite. Beide zusammen erreichen bis zu 14,5 %. Die maximale Frist für die
            Mittelbeschaffung für einen Portfoliokauf beträgt 30 Tage.</li>
    </ul>
    </p>
    <p><strong>Wie funktioniert das?​</strong></p>
    <p>Sie verdienen täglich Zinsen zu einem Satz von 8% p. a. Alle 90 Tage berechnen wir automatisch die tatsächliche
        Rendite der Portfolios und gewähren Ihnen die Differenz zwischen dem garantierten Satz von 8% und dem
        tatsächlichen Satz. So erhalten Sie alle 90 Tage einen Ertrag zwischen 8% und 14,5 % auf Ihr Nibble-Konto.</p>
    <p>Beispiel: Wenn Sie 1.000 Euro für 12 Monate investieren, erhalten Sie am Ende der Laufzeit Ihr gesamtes Kapital
        von 1.000 Euro zurück und zusätzlich einen Ertrag zwischen 90 und 145 Euro, den wir Ihnen alle 90 Tage
        auszahlen.</p>
        `,
    InformationTitleSection2:
      "Einstufung von Krediten nach dem Risiko der &Uuml;berf&auml;lligkeit nach NPL 30, 60, 90, 120+",
    InformationContentSection2:
      '<p>Die Unternehmen der IT Smart Finance Holding verwenden Scoring-Modelle, um die Kreditnehmerqualit&auml;t zu bestimmen. Alle genehmigten Kredite werden entsprechend klassifiziert und nach den Anlagestrategien geordnet.</p> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>AA</strong></td> <td><strong>A</strong></td> <td><strong>ВВ</strong></td> <td><strong>В</strong></td> <td><strong>СС</strong></td> <td><strong>С</strong></td> </tr> <tr> <td>p&uuml;nktlich geschlossen</td> <td>vorzeitig geschlossen</td> <td>&uuml;berf&auml;lliger NPL 0&ndash;30</td> <td>&uuml;berf&auml;lliger NPL 30&ndash;60</td> <td>&uuml;berf&auml;lliger NPL 60&ndash;90</td> <td>&uuml;berf&auml;lliger NPL 90&ndash;120</td> </tr> <tr> <td colspan="2">Kredite mit geringem Risiko. In der Regel geben Kunden dieser Kategorie die Einnahmen p&uuml;nktlich oder vorzeitig zur&uuml;ck, so dass die Rendite f&uuml;r sie gering ist, aber auch die Risiken gering sind.</td> <td colspan="2">Kredite mit mittlerem Risiko. Kunden dieser Kategorie k&ouml;nnen mit einem &uuml;berf&auml;lligen NPL 30 und NPL 60 in Verzug geraten, geben die Kredite am Ende aber fast immer zur&uuml;ck. Das Risiko einer Einholung ist bei dieser Kategorie h&ouml;her, aber auch das Durchschnittseinkommen ist h&ouml;her.</td> <td colspan="2">Kredite mit einem erh&ouml;hten Risiko. In dieser Kategorie gibt es Kredite mit einem &uuml;berf&auml;lligen NPL 60, NPL 90, NPL 120 und solche, die sich in einem Rechtsstreit befinden, die unter allen Strategien die maximale Rentabilit&auml;t bieten.</td> </tr> </tbody> </table> </div> <p>Einmal im Monat analysiert der Risikoausschuss den Prozess der Zuordnung der Kreditklassifizierung und passt ihn an. Als Ergebnis der Bewertung werden die bewilligten Kredite in die folgenden Kategorien eingeteilt.</p> <h3>Das Produkt Flexible Anlage bietet drei Anlagestrategien</h3> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>АА</strong></td> <td><strong>A</strong></td> <td colspan="1"><strong>ВВ</strong></td> <td colspan="1"><strong>В</strong></td> <td colspan="1"><strong>СС</strong></td> <td colspan="1"><strong>С</strong></td> </tr> <tr> <td colspan="3"><strong>Klassische Strategie​</strong></td> <td colspan="3" rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">65%</td> <td colspan="1">25%</td> <td colspan="1">10%</td> </tr> <tr> <td colspan="2" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Ausgewogen Strategie​</strong></td> <td rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">63%</td> <td colspan="1">32%</td> <td colspan="1">5%</td> </tr> <tr> <td colspan="3" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Rechtsstrategie​</strong></td> </tr> <tr> <td colspan="1">54%</td> <td colspan="1">28%</td> <td colspan="1">18%</td> </tr> </tbody> </table> </div> <p>Jede Anlagestrategie w&auml;hlt automatisch die geeignete Art eines Kreditrisikos aus. Jede Strategie kann bis zu 3 Arten von NPLs beinhalten, was es erm&ouml;glicht, die ausgewiesenen Einnahmen zu erhalten und die entsprechenden Risikoanforderungen zu gew&auml;hrleisten.</p>',
    InformationTitleSection3: "Geldabhebung von einem Konto",
    InformationContentSection3: `<p>Die Abhebung von freien Guthaben und Geldern, die nach Ablauf des Investitionsportfolios eingehen, wird &uuml;ber das pers&ouml;nliche Nibble-Konto des Investors auf sein Bankkonto vorgenommen</p> 
      <ul>
      <li>Der Mindestbetrag f&uuml;r die Abhebung betr&auml;gt &euro; 50.</li>
      <li>Nibble &uuml;berweist nur Geld auf ein Konto, das dem Anleger geh&ouml;rt. Dies ist eine notwendige Ma&szlig;nahme, die unsere Anleger sch&uuml;tzt und illegale Geldw&auml;sche verhindert.</li>
      <li>Sie k&ouml;nnen Ihre Kontonummer &auml;ndern, indem Sie unseren Kundendienst kontaktieren. In diesem Fall wird Sie unser AML-Beauftragter bitten, zus&auml;tzliche Dokumente vorzulegen.</li>
      </ul>
      <h3>Vorzeitige Beendigung des Anlagevertrags und Abhebung von Geldern</h3>
      <p>Sie k&ouml;nnen den Investitionsvertrag vor seinem Ablaufdatum k&uuml;ndigen und Gelder von der Nibble-Plattform abheben. Dazu m&uuml;ssen Sie &uuml;ber Ihr Nibble-Konto eine vorzeitige Beendigung des Vertrags beantragen. Nachdem wir Ihren Antrag erhalten haben, werden wir mit der Suche nach einem Investor f&uuml;r Ihr Portfolio beginnen. Das Portfolio kann nur als Ganzes weiterverkauft werden. Finden wir innerhalb von 60 Kalendertagen nach Erhalt Ihres Antrags keinen Investor, zahlen wir Ihnen am darauffolgenden Tag (61. Tag) den Betrag der investierten Gelder und die damit verbundenen Zinsen aus dem Reservefonds des Unternehmens aus, wobei wir eine Provisionsgeb&uuml;hr von 3% des zu zahlenden Gesamtbetrags einbehalten.</p>`,
    InformationTitleSection4: "Richtlinien zur R&uuml;ckkaufsicherheit",
    InformationContentSection4: `
        <p>Um die Rendite der Gelder im Rahmen der Classic-Strategie sicherzustellen, bietet der Kreditgeber eine
        Rückkaufgarantie — der Kreditgeber ist verpflichtet, den Kredit vom Investor zurückzukaufen, falls der Kredit
        nicht innerhalb von 60 Tagen nach dem Investitionsdatum zurückgezahlt wurde.</p>
    <p>In diesem Fall zahlt der Kreditgeber dem Investor die f&auml;lligen Zinsen zusammen mit den anf&auml;nglichen
        Kosten des Kredits. Um diese Verpflichtungen decken zu k&ouml;nnen, werden Mittel im Reservefonds des
        Unternehmens gebildet.</p>
    <h3>Wie funktioniert die R&uuml;ckkaufpolitik:</h3>
    <ul>
        <li>Bei der Wahl der Klassik-Strategie investieren unsere Anleger in Kredite, die von der IT Smart
            Finance-Unternehmensgruppe vergeben werden.</li>
        <li>Die Holdinggesellschaften platzieren ihre Kredite auf der Nibble-Plattform, um Investoren zu finden.</li>
        <li>Die Beziehung zwischen den Unternehmen der IT-Smart Finance-Gruppe und dem Kreditnehmer wird durch einen
            Vertrag &uuml;ber einen kurzfristigen Verbraucherkredit mit daraus folgenden Anspr&uuml;chen gegen den
            Kreditnehmer geregelt.</li>
        <li>Gest&uuml;tzt auf den mit dem Investor abgeschlossenen Abtretungsvertrag &uuml;bernimmt Nibble die folgenden
            Verpflichtungen: <ol>
                <li>a. Annahme von Zahlungen des Endkreditnehmers an die IT Smart Finance-Unternehmensgruppe im Rahmen
                    des kurzfristigen Konsumentenkreditvertrages.</li>
                <li>b. Auszahlung dieser an den Investor in der durch den Abtretungsvertrag festgelegten Reihenfolge und
                    H&ouml;he.</li>
            </ol>
        </li>
        <li>Falls der Kreditnehmer den Kredit nicht fristgerecht zur&uuml;ckzahlt oder die Kreditr&uuml;ckzahlungsfrist
            verl&auml;ngert, kauft die IT Smart Finance-Unternehmensgruppe das Anspruchsrecht des Investors in H&ouml;he
            der Investition und des garantierten Zinseinkommens auf den Kredit zur&uuml;ck.</li>
    </ul>
    <p>
        <h3>
            Rechtsstrategie
        </h3>
    </p>
    <p>
        The strategy comes with the deposit back guarantee – this is the obligation of the collection agency to return
        the full investment amount at the end of the investment period and ensure a minimum yield of 8% per annum.
    </p>
    <p>
        <strong>
            Wie funktioniert sie?
        </strong>
    </p>
    <p>Sie verdienen täglich Zinsen zu einem Satz von 8% p. a. Alle 90 Tage berechnen wir automatisch die tatsächliche
        Rendite der Portfolios und gewähren Ihnen die Differenz zwischen dem garantierten Satz von 8% und dem
        tatsächlichen Satz. So erhalten Sie alle 90 Tage einen Ertrag zwischen 8% und 14,5 % auf Ihr Nibble-Konto.</p>
    <p>Beispiel: Wenn Sie 1.000 Euro für 12 Monate investieren, erhalten Sie am Ende der Laufzeit Ihr gesamtes Kapital
        von 1.000 Euro zurück und zusätzlich einen Ertrag zwischen 90 und 145 Euro, den wir Ihnen alle 90 Tage
        auszahlen.</p>
        `,
    InformationTitleSection5: "Richtlinien zum allgemeinen Risiko",
    InformationContentSection5:
      "<p>Die Risiken werden zwischen dem Investor, der Investitionsplattform Nibble und den Mikrofinanzinstitutionen wie folgt aufgeteilt:</p> <ul> <li>Falls eine Strategie eine R&uuml;ckkaufgarantie bietet, wird das Ausfallrisiko von der Mikrofinanzorganisation auf Kosten des Reservefonds &uuml;bernommen</li> <li>Falls eine Strategie keine R&uuml;ckkaufgarantie beinhaltet, werden die Ausfallrisiken zwischen dem Investor und der Mikrofinanzinstitution in Form eines variablen Zinssatzes aufgeteilt</li> <li>Die Mikrofinanzorganisation tr&auml;gt bei den laufenden Strategien das Risiko von Wechselkurs&auml;nderungen</li> </ul>",
    InformationTitleSection6: "Risiko-Gremium",
    InformationContentSection6:
      "<p>Der Risikoausschuss tritt am Ende jedes Monats zusammen, um die aktuellen Zinss&auml;tze f&uuml;r die ausgewogene sowie spezielle Strategie festzulegen.</p> <h3>Dem Risikoausschuss geh&ouml;ren die Leiter der folgenden Abteilungen der IT Smart Finance-Unternehmensgruppe an:</h3> <ul> <li>Leiter Risikoabteilung</li> <li>Leitender Gesch&auml;ftsf&uuml;hrer</li> <li>Leiter der Inkasso-Abteilung</li> <li>Leiter der Underwriting-Abteilung</li> <li>Risiko-Analytiker</li> </ul> <h3>Die Hauptaufgaben des Gremiums:</h3> <ul> <li>&Uuml;berpr&uuml;fung und Analyse der Arbeitsergebnisse der NPL 30-60-90-120 (s&auml;umige Kredite von 30 bis 120 Tagen) f&uuml;r den Berichtsmonat.</li> <li>Abstimmung der tats&auml;chlichen Indikatoren mit den geplanten Indikatoren in der Berichtsperiode.</li> <li>Analyse des Bewertungsmodells.</li> <li>Abgabe einer Prognose f&uuml;r die n&auml;chste Periode und Kalibrierung des Scoring-Modells.</li> <li>Erstellung und Genehmigung der fristgerechten j&auml;hrlichen Einnahmen f&uuml;r die ausgewogene sowie spezielle Strategie.</li> </ul> <p>Die Ergebnisse der Sitzung des Risikoausschusses werden als Bericht auf der Webseite ver&ouml;ffentlicht.</p>",
    InformationTitleSection7: "Bildung des Reservefonds",
    InformationContentSection7:
      "<p>Der Reservefonds ist ein zus&auml;tzlicher &laquo;Airbag&raquo; f&uuml;r den Investor, der die Risiken eines Kreditausfalls durch den Endkreditnehmer abdeckt. Dank des Reservefonds bieten wir den Anlegern eine Anlagestrategie mit R&uuml;ckkaufgarantie.</p>",
    InformationTitleSection8:
      "Gew&auml;hrleistung von Sicherheit und Privatsph&auml;re",
    InformationContentSection8:
      '<p>Wir r&auml;umen dem Schutz Ihrer Daten und der Sicherheit Ihrer Transaktionen Priorit&auml;t ein. Folgend einige der Punkte, die die Wichtigkeit unterstreichen:</p> <h3>Sicherheitsgarantien</h3> <ul> <li>Die Daten werden gem&auml;&szlig; den ISO 27001:2013-Sicherheitsbestimmungen gespeichert</li> <li>Alle Passw&ouml;rter sind im System verschl&uuml;sselt hinterlegt</li> <li>Das Bankkonto wird mit dem Profil verlinkt, sobald die erste Zahlung eingeht, und kann nur ge&auml;ndert werden, wenn der Investor manuell identifiziert wurde</li> <li>Entsprechend der Gesetze der Europ&auml;ischen Union sind wir verpflichtet, unsere Kunden zu identifizieren. Als Vertragspartner arbeitet Veriff f&uuml;r Nibble. Hier k&ouml;nnen Sie unsere Sicherheitsrichtlinien nachlesen:&nbsp;<a href="https://www.veriff.com/privacy-policy">https://www.veriff.com/privacy-policy</a></li> </ul> <h3>Datenschutzgarantien</h3> <ul> <li>Die Nibble-Plattform ist eine Anwendung, die pers&ouml;nliche Daten gem&auml;&szlig; den Gesetzen der Europ&auml;ischen Union weiterverarbeitet</li> <li>Wir geben keine Investoren-Daten an Dritte weiter</li> </ul> <h3>Garantien zum finanziellen Risiko</h3> <ul> <li>Alle Investitionen gehen an eine Gruppe von Unternehmen der Holding&nbsp;<a href="https://itsmartfinance.com/">IT Smart Finance</a></li> <li>Die klassische Strategie bietet eine R&uuml;ckkaufgarantie durch den Reservefonds</li> <li>Die Investitionsplattform Nibble ist Teil der IT Smart Finance-Holding, die Kreditgeber aus Europa, Asien und Lateinamerika vereint</li> </ul>',

    JoinUs: "Schließen Sie sich uns an",
    JoymoneyInfo:
      "Joymoney ES stellt in Spanien Kredite mit einer Laufzeit von bis zu 30 Tagen zur Verfügung. Alle Kredite sind durch eine Rückkaufgarantie abgesichert. Sollte der Kredit nicht innerhalb von 60 Tagen nach der Investition abgeschlossen sein, erstattet Joymoney ES dem Investor seinen Kreditanteil zusammen mit den aufgelaufenen Zinsen.",
    Later: "Später",
    Legal: "Juristische Person",
    literal_bread_reg: "Registrieren",
    LittleBitLeft: "Nur noch wenig übrig",
    LoanType: "Kreditart",
    LoginBtn: "Einloggen",
    LoginHead: "Einloggen",
    LongTerm: "Langzeit",
    LongTermInvestmensInfo:
      "Langzeit-Investitionen erlauben es Ihnen, den maximalen Profit zu erzielen, indem Sie während der Wiederanlage-Phase den Betrag aus zurückgezahlten Krediten in neue Kredite reinvestieren (vollständig oder teilweise; abhängig von Ihren Einstellungen).",
    LongTermPortfolio: "Langzeit-Investition",
    LowBalanceAlert:
      "Sie verfügen nicht über genug Guthaben, um ein Portfolio mit den gewählten Parametern zu erstellen",
    MessageWithdrawalSuccess:
      "Anfrage erhalten. Abhebung erfolgt innerhalb von 5-7 Werktagen",
    // ResultPaymentSuccessTitle: "The balance has been successfully replenished!",
    MonthlyDeposit: "Monatliche Aufladung",
    MonthlyDepositInfo:
      "Sie können Ihr Portfolio nicht früher als 3 Monate vor Ablauf des Portfolios aufladen.",
    MonthlyReport: "Monatlicher Bericht",
    Months: "Monate",
    MrLabel: "Hr.",
    MsLabel: "Fr.",
    MyAccount: "Mein Profil",
    MyInvestments: "Meine Investitionen",
    NameChangeWarning:
      "Sie können Ihren Vor- und Nachnamen ändern, bis Sie Ihre Identität durch Veriff bestätigt haben.",
    NeedToVerifyBySMS: "Sie müssen diese Telefonnummer per SMS bestätigen",
    NewPassDlina: "Das neue Passwort hat weniger als 5 Zeichen",
    NewPassword: "Neues Passwort",
    NewPasswordInfo:
      "Erstellen Sie ein starkes Passwort. Wir empfehlen die Nutzung von Sonderzeichen, Zahlen und Großbuchstaben in Ihrem Passwort.",
    NewPasswordSent:
      "Ein neues Passwort wurde an Ihre E-Mail-Adresse geschickt",
    NewRepeatPasChange: "Passwörter stimmen nicht überein",
    News: "Neuigkeiten",
    NewsletterCheckboxLabel: "Täglichen Newsletter erhalten",
    Next: "Weiter",
    NibbleAgreement: "Vereinbarung mit Nibble",
    No: "Nein",
    Notifications: "Benachrichtigungen",
    NotLimited: "unbegrenzt",
    OnlyActive: "Nur aktive",
    Opened: "Offen",
    Operation: "Vorgang",
    OperationDate: "Datum der Kontobewegung",
    OrEmail: "Oder E-Mail",
    OutputFail: "Diese Summe kann nicht abgehoben werden",
    Page: "Seite",
    PageNotExist:
      "Entschuldigung, die von Ihnen angefragte Seite existiert nicht.",
    PageNotFound: "Seite nicht gefunden",
    Partial: "Anteilig",
    PartnerCode: "Promo-Code teilen",
    PartnerCodeSet: "Promo-Code zum Einladen",
    PartnerFaq:
      '<h2 class="title faq__title">Haben Sie Fragen?</h2> <div class="box faq-wrapper"> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Wie lange sind ein Promo-Code oder ein Referenz-Link gültig?</span> <p class="faq-answer__text"> Der Promo-Code bzw. der Link sind unbegrenzt nach der Generierung gültig. </p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Werde ich keine Belohnung erhalten, falls mein Freund mehr als 1.000 € investieren sollte?</span> <p class="faq-answer__text"> In diesem Fall erhalten Sie und Ihr Freund eine Belohnung in Höhe von 2 % der Belohnungsobergrenze von 1.000 €.</p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Werde ich belohnt, wenn einer meiner Freunde weniger als 1.000 € investiert?</span> <p class="faq-answer__text"> Wenn Ihr Freund eine Investition von weniger als 1.000 € tätigt, erhalten Sie beide eine Belohnung in Höhe von 2 % der investierten Summe. </p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">An wie viele Freunde kann ich Nibble über den Promo-Code bzw. den Referenz-Link weiterempfehlen?</span> <p class="faq-answer__text"> Sie können eine unbegrenzte Zahl an Freunden durch das Nutzen des Promo-Codes bzw. des Referenz-Links auf Nibble aufmerksam machen. </p> </div> </div>',
    PartnerInfo:
      '<h1 class="title partner__title">Empfehlen Sie uns an Ihre Freunde weiter und erhalten Sie Belohnungen</h1> <span class="partner__subtitle">für sich und Ihre Freunde</span> <ul class="partner-list"> <li class="partner-item"> <h2 class="partner-item__title">Erzählen Sie Ihren Freunden von Nibble</h2> <p class="partner-item__description">Sie können einen Referenz-Link mit Ihren Freunden teilen oder ihnen einen Promo-Code senden</p> </li> <li class="partner-item"> <h2 class="partner-item__title">Registrierung</h2> <p class="partner-item__description">Ihre Freunde registrieren sich auf Nibble über den Link oder den Promo-Code</p> </li> <li class="partner-item"> <h2 class="partner-item__title">Belohnung erhalten</h2> <p class="partner-item__description">Für jede Investition, die Ihr Freund tätigt, erhalten Sie 2 % von bis zu 1.000 €. </p> </li> </ul>',
    PartnerLinkSet: "Einladungslink",
    PartnerLinkSocial: "Link über soziale Netzwerke verbreiten",
    PartnerTextStep1:
      "Sie können einen Referenz-Link mit Ihren Freunden teilen oder ihnen einen Promo-Code senden",
    PartnerTextStep2:
      "Ihre Freunde sind über den Link oder den Promocode bei Nibble registriert worden",
    PartnerTextStep3:
      "Für jede Investition, die Ihr Freund tätigt, erhalten Sie 2 % von bis zu 1.000 €.",
    PartnerTitle:
      "Empfehlen Sie uns an Ihre Freunde weiter und erhalten Sie Belohnungen",
    PartnerTitleStep1: "Erzählen Sie Ihren Freunden von Nibble",
    PartnerTitleStep2: "Registrierung",
    PartnerTitleStep3: "Belohnung erhalten",
    PartnerTransaction: "vorgänge",
    PartnerTransactionIncome: "eingegangen",
    Password: "Passwort",
    PasswordChange: "Passwort ändern",
    PasswordChanged: "Passwort geändert",
    PasswordSentMessage: "Das Passwort wurde an Ihre Telefonnummer gesendet",
    PasswordsMakeSure: "Stellen Sie sicher, dass die Passwörter übereinstimmen",
    PaymentOnformation: "Zahlungsinformationen",
    PaymentPurposeInfo:
      "Überweisung mit den dargestellten Angaben. Stellen Sie bitte sicher, dass Sie den Zahlungszweck eintragen.",
    PeriodInvest: "Investitionslaufzeit",
    PeriodInvest1: "Investitionslaufzeit",
    PersonalData: "Persönliche Informationen",
    PersonalDataChangeInfo:
      "Um Ihre persönlichen Daten zu ändern, kontaktieren Sie bitte unseren Kundendienst",
    PersonalID: "Ausweisnummer",
    PersonalInfo: "Persönliche Informationen",
    PersonLastName: "Nachname",
    PersonName: "Vorname",
    Persons: "personen",
    Phone: "Kontakt-Telefonnummer",
    Phone1: "Telefonnummer",
    PhoneAlreadyReg: "Telefonnummer bereits hinterlegt",
    PhoneChangeInfo:
      "Um Ihre Telefonnummer zu ändern, kontaktieren Sie bitte den technischen Kundendienst",
    PhoneConfirm: "Telefonnummer bestätigt",
    PhoneNotConfirm: "Telefonnummer nicht bestätigt",
    PhoneNotValid: "Ungültiges Format der Telefonnummer",
    PhoneVerification: "Telefonnummer verifizieren",
    PlacehoderBirthDate: "tt.mm.jjjj",
    PolicyAgreement:
      'Einwilligung zur <a href="/policy_privacy.aspx"> Weiterverarbeitung personenbezogener Daten </a>',
    PolicyAgreement1:
      'Einwilligung zur <a href="/policy_privacy.aspx"> Weiterverarbeitung personenbezogener Daten </a>',
    PortfolioConfirmText:
      "Wir werden nun ein Portfolio anhand Ihrer angegebenen Parameter erstellen",
    PortfolioCreated: "Portfolio erstellt",
    PortfolioCreation: "Portfolio erstellen",
    PortfolioID: "Portfolio",
    PortfolioIncome: "Einnahmen des Portfolios",
    PortfolioParams: "Portfolio-Einstellungen",
    PortfolioReplenishment: "Portfolio Ergänzung [ID X]",
    PortfolioReplenishmentOperation: "Portfolio Ergänzung",
    PotentialProfit: "Ihre mögliche Rendite",
    Precalculation: "Kalkulation der erwarteten Einnahmen",
    Precalculation1: "Kalkulation der erwarteten Einnahmen",
    PrefferedLanguage: "Bevorzugte Sprache",
    ProductDescription: "Produktbeschreibung",
    ProfitCalc: "Berechnung der Profitabilität",
    ProgressCompleteInfoDesc:
      "Es gibt noch ein paar fehlende Angaben in Ihrem persönlichen Profil.",
    ProgressCompleteInfoStep: "Angaben hinzufügen",
    ProgressCompleteInfoTitle: "Ihr Konto ist aktiviert ...",
    ProgressConfirmEmailDesc:
      "Bestätigen Sie Ihre E-Mail-Adresse und aktivieren Sie Ihr Konto. Um dies zu tun, klicken Sie auf den Link in der E-Mail, die wir Ihnen geschickt haben.",
    ProgressConfirmEmailDescRestore: "Neuen Aktivierungslink senden",
    ProgressConfirmEmailStep: "E-Mail-Adresse bestätigen",
    ProgressIdentifyDesc:
      "Schließen Sie die Veriff-Prüfung ab, um Ihr Guthaben aufladen und investieren zu können",
    ProgressIdentifyStep: "Verifizierung starten",
    ProgressIdentifyTitle: "Der letzte und wichtigste Schritt",
    PromoCode: "Angebotscode",
    PropsContractsDocs: "Details",
    ProvideSMSCode: "Geben Sie den Verifizierungscode aus der SMS ein",
    PurposeOfPayment: "Zahlungszweck",
    Rate: "Zinssatz",
    ReceivingIncomeBy: "Einnahmen erhalten durch ID X",
    Referals: "Empfehlungen",
    ReferralTitle: "Belohnung für Weiterempfehlungen",
    RefillFromCard: "Einzahlung durch VISA/MC-Karte",
    RefillHistory: "Einzahlungsübersicht",
    RefillTheAccount:
      '<a href="/depositing.aspx">Laden Sie Ihr Guthaben</a> einfach und bequem auf, um mit dem Investieren auf Nibble zu beginnen.',
    RefillWithCard: "Einzahlung per Karte",
    Registrations: "Registrierungen",
    RegreshPage: "erneutes Laden der Seite",
    ReinvestIncome: "Gewinne wiederanlegen",
    Reinvestment: "Wiederanlage",
    RepeatPassword: "Neues Passwort wiederholen",
    Replenishment: "Portfolio-Ergänzung, monatlich",
    Replenishments: "Einzahlungen",
    ResetPassword: "Passwort zurücksetzen",
    RestorePassword: "Ein neues Passwort wurde an Ihr Telefon gesendet",
    RestorePasswordEmail:
      "Falls die E-Mail-Adresse hinterlegt ist, wurde eine Nachricht an diese verschickt.",
    ReturnDate: "Rückzahlungsdatum",
    ReturnMainPage: "Zurück zur Startseite",
    RevenueFromRegistrationsAndRenewals:
      "Einnahmen aus Registrierungen und Einzahlungen",
    Risks: "Risiken",
    Save: "Änderungen speichern",
    ScanHint:
      "Laden Sie einen Scan oder ein Foto Ihres Personalausweises oder Führerscheins hoch. Bitte achten Sie auf die Les- und Sichtbarkeit aller Details auf dem Bild Ihres Dokuments. Keinerlei Informationen des Dokuments sollten verdeckt oder abgeschnitten sein.",
    Selfie: "Passfoto",
    SelfieHint:
      "Stellen Sie möglichst das Bild Ihres Ausweisdokuments nach und achten Sie auf Schärfe und Lichtverhältnisse",
    SendMessageBtn: "Nachricht senden",
    SendRequest: "Anfrage senden",
    SEPAInfo:
      "Einzahlungen von Guthaben sind nur Kunden im SEPA-Gebiet möglich.",
    ServiceUnavailable: "Der Service ist vorübergehend nicht erreichbar",
    Settings: "Einstellungen",
    ShareLink: "Link verbreiten",
    ShowAllLoans: "Alle Kredite anzeigen",
    SkipIdentification: "früherer",
    SmsCode: "SMS-Code",
    SmsCodeIsSent:
      "Eine SMS mit einem Verifizierungscode wurde an die von Ihnen hinterlegte Telefonnummer gesendet. Geben Sie bitte den erhaltenen Code ein.",
    Sortby: "Sortieren nach:",
    SortbyIncome: "Erwarteten Einnahmen",
    SortbyOpened: "Eröffnungsdatum",
    SortbyOperationDate: "Datum der Kontobewegung",
    SortbyReturnDate: "Rückzahlungsdatum",
    SortbySum: "Betrag",
    StartDeposit: "Ursprüngliche Summe",
    Stats: "Statistiken",
    Status: "Status",
    STATUS_001: "Geschlossen",
    STATUS_002: "Aktiv",
    STATUS_003: "Abgelaufen",
    STATUS_004: "Abgeschlossen",
    STATUS_005: "Geplant",
    STATUS_006: "Abgelehnt",
    StatusCanceled: "Abgebrochen",
    StatusCompleted: "Abgeschlossen",
    StatusInprocess: "In Bearbeitung",
    Step1: "Erster Schritt",
    Step2: "Zweiter Schritt",
    StrategyBalancedDescription:
      "Das Einkommen ist nicht fix und kann laut den vorherigen Statistiken 12–15 % pro Jahr betragen. Dies ist die ausgeglichenste Strategie in Bezug auf das Risiko-Ertrags-Verhältnis",
    StrategyBalancedTitle: "Ausgewogen Strategie",
    StrategyClassicDescription:
      "Fixes Einkommen, das durch eine Rückkaufgarantie abgesichert ist, mit 8 % pro Jahr. Es handelt sich um eine risikofreie Strategie mit garantiertem Einkommen aus Ihren Investitionen",
    StrategyClassicTitle: "Klassische Strategie",
    StrategyDescription:
      "Wählen Sie Ihre Anlagestrategie entsprechend Ihren Einkommens- und Risikoerwartungen. <br> Erstellen Sie ein Investitionsportfolios in drei Schritten.",
    StrategySpecialDescription:
      "Das Einkommen ist nicht fix und kann 17–19% pro Jahr betragen. Obwohl diese Strategie ein höheres Investitionsrisiko aufweist, erlaubt sie es, mögliche Verluste innerhalb des Gesamtwerts des Portfolios auszugleichen",
    StrategySpecialTitle: "Speziell Strategie",
    StrategyStep1: "Schritt 1: Strategie wählen",
    StrategyStep2: "Schritt 2: Investitionsparameter einstellen",
    StrategyStep3: "Schritt 3: Portfolio erstellen",
    StrategyTitle: "Flexible Investitionen",
    InviteFriends: "Freunde einladen",
    OtherStrategy: `Klassische / Ausgewogen strategie`,
    LegalStrategy: `Rechtliches strategie`,
    String: "Dies beinhaltet Ihre gesamte Cash-Flow-Historie",
    SuccessfullySaved: "Ihre Einstellungen wurden gespeichert",
    Sum: "Summe",
    SumAmount: "Aufladebetrag",
    Support: "Technischer Kundendienst",
    SupportMessageSentMessage:
      "Ihre Anfrage wurde an unseren Kundendienst gesendet und wird vom ersten freien Mitarbeiter während unserer Bürozeiten beantwortet.",
    SupportTextareaPlaceholder: "Text der Beschwerde oder Frage",
    SupportTitle: "Wir werden alle Ihre Fragen beantworten",
    SystemSettings: "Systemeinstellungen",
    Term: "Dauer",
    TermDays: "Dauer, Tage",
    TermMonths: "Laufzeit, Monate",
    Test: "Test",
    TestInvestmentsInfo:
      "Test-Investitionen erlauben es Ihnen, den Service eine Zeit lang auszuprobieren. Ein Nutzer kann nur ein Test-Portfolio mit insgesamt nicht mehr als 300 € Investitionsguthaben erstellen.",
    ThankyouErrorText:
      "Verifizierung fehlgeschlagen. Wahrscheinlich konnten wir das Foto Ihres Dokuments nicht erkennen oder <a target=\"_top\" href='/profile'>die Verbindung ist unterbrochen worden</a>. Keine Sorge, Sie können die Verifizierung erneut durchführen. Versuchen Sie es mit einem anderen Dokument.",
    ThankyouErrorTitle: "Es ist etwas schiefgegangen...",
    ThankyouSuccessText:
      "Die Identifikation ist zu 100 % bestanden – tätigen Sie Ihre erste Investition mit Nibble. Ihr persönliches Konto ist eingerichtet, Sie müssen nur <a target=\"_top\" href='/depositing'>Ihr Guthaben aufladen</a> und <a target=\"_top\" href='/profile'>Ihr erstes Investitionsportfolio erstellen</a >. ",
    ThankyouSuccessTitle: "Vorgang erfolgreich abgeschlossen!",
    ThroughSocialNetworks: "ThroughSocialNetworks",
    ThroughSocialNetworks1: "Über Soziale Netzwerke",
    TimeFormat: "Zeitformat",
    Try: "Versuchen Sie es später mit einem",
    TutorialMessage0:
      "Wir können Ihnen über die wichtigsten Punkte der Arbeit im persönlichen Bereich von Nibble berichten. Sollen wir fortfahren?",
    TutorialMessage1:
      "Mit dem Rechner können Sie die Rentabilität Ihres Portfolios berechnen.",
    TutorialMessage2:
      "Um mit den Investitionen zu beginnen, müssen Sie Ihren Kontostand aufstocken.",
    TutorialMessage3:
      'Verwalten Sie Ihre Portfolios im Bereich "Meine Anlagen".',
    TutorialMessage4: "Erzielen Sie mit Ihren Freunden noch mehr Einnahmen.",
    TutorialMessage5:
      "Wir werden Ihnen erklären, wie Sie ein Anlageportfolio erstellen bzw. wie das System im Allgemeinen funktioniert.",
    Unavailable: "nicht verfügbar",
    //UserAgreement: 'Wenn Sie auf „Weiter“ klicken, stimmen <a href="https://nibble.finance/user-agreement.html" target="_blank">Sie den Nutzungsbedingungen </a> sowie der <a href="https://nibble.finance/privacy-policy.html" target="_blank">Nibble Datenschutz-Richtlinie</a> zu.',
    UserAgreement: {
      text_1: "Wenn Sie auf „Weiter“ klicken, stimmen ",
      text_1_legal: "Wenn Sie auf „Anfrage senden“ klicken, stimmen ",
      text_link_1: "Sie den Nutzungsbedingungen",
      text_2: " sowie der ",
      text_link_2: "Nibble Datenschutz-Richtlinie",
      text_3: " zu.",
    },
    UserAgreement1:
      'Wenn Sie auf „Weiter“ klicken, stimmen <a href="/user_agreement.aspx">Sie den Nutzungsbedingungen </a> sowie der <a href="/policy_privacy.aspx">Nibble Datenschutz-Richtlinie</a> zu.',
    VERIFF_274: "Fehlende Fotos",
    VERIFF_275: "Das Gesicht ist nicht eindeutig erkennbar",
    VERIFF_276: "Das Dokument ist nicht vollständig abgebildet",
    VERIFF_277: "Schlechte Bildqualität",
    VERIFF_278: "Das Dokument ist beschädigt",
    VERIFF_279: "Dieser Dateityp wird nicht unterstützt",
    VERIFF_280: "Das Dokument ist abgelaufen",
    VERIFF_282: "Andere Gründe",
    VeriffGuarantees:
      "Der Veriff-Service garantiert die Sicherheit Ihrer Daten.",
    VeriffGuaranteesHtml:
      '<span>Der <u id="veriffLink">Veriff-Service</u> garantiert die Sicherheit Ihrer Daten. </span>',
    VeriffInfo:
      "Entsprechend der EU-Richtlinien muss jeder Investor seine Identität bestätigen, bevor er mit dem Investieren beginnen kann. Der Prozess beinhaltet zwei Schritte: Sie laden Bilder Ihres Identitätsnachweises hoch und anschließend prüft unser Partner Veriff diese. Der komplette Verifizierungsprozess nimmt weniger als 10 Minuten in Anspruch. Bitte halten Sie Ihren Pass oder Ihren Personalausweis bereit und stellen Sie sicher, dass alle Informationen auf den Bildern deutlich dargestellt sind.",

    VeriffInfoTitle: "Sofort-Identifikationsprozess durchführen",
    VeriffInfoDesc:
      "Nibble hält sich genauestens an die Europäischen Vorschriften im Bezug auf Geldwäsche (AML), Verifizierung der Nutzer sowie dem Speichern und der Nutzung personenbezogener Daten. Es dauert nur 2 Minuten, um sich zu verifizieren und Investor zu werden.",
    VeriffInfoQuest: "Wie einfach ist die digitale Identitätsüberprüfung?",
    VeriffInfoAsk1:
      "Wir bitten Sie, ein Foto Ihres Ausweisdokuments (Führerschein, Reisepass oder Personalausweis) entweder mit Ihrer Webcam oder Ihrem Smartphone zu machen – es handelt sich um einen Prozess in Echtzeit.",
    VeriffInfoAsk2:
      "Wir bitten Sie, mit dem gleichen Gerät ein Selfie zu machen und werden Sie bei dessen Erstellung unterstützen, um sicherzustellen, dass Sie es beim ersten Versuch perfekt hinbekommen.",
    VeriffInfoAsk3:
      "Sie erhalten innerhalb von Sekunden eine Entscheidung. Das war's.",
    VeriffStartButton: "Verifizierung starten",
    Cancel: "Später erledigen",

    VeriffInProcess:
      "Ihr Ausweisdokument durchläuft den Verifizierungsprozess von Veriff. Dies dauert in der Regel nur wenige Minuten. </br> Solange der Verifizierungsprozess nicht abgeschlossen ist, können Sie nicht auf Ihr Konto einzahlen.",
    WeAreDoingAll: "Wir geben alles, um das Problem zu beheben.",
    WeeklyReport: "Wöchentlicher Bericht",
    WeEnsureSecurity:
      'Gemeinsam mit unserem Partner <a href="https://www.veriff.com" target="_blank">Veriff</a> bieten wir einen Service zur sicheren Verifizierung an.',
    WeWorkHonest:
      "Wir arbeiten ehrlich, offen und begrüßen es, wenn unsere Nutzer die gleiche Einstellung haben.",
    WidgetBringFriendLead:
      "Empfehlen Sie uns an Ihre Freunde weiter und erhalten Sie eine Prämie für jede Weiterempfehlung.",
    WidgetHistoryLead:
      "Alle Einzahlungen, Einnahmen und Abhebungen können hier eingesehen werden.",
    WidgetInvestLead: "Zentrales Kontrollbüro für Ihre Investitionen",
    WidgetSupportLead:
      "Unsere Spezialisten werden Ihnen zur Seite stehen, falls Sie Fragen oder Zweifel haben.",
    WillAddXMonth:
      'Sie fügen<br>in <span class="js-calcMonth">6</span> Monate hinzu',
    WillAddXMonth1: "Sie fügen&nbsp;<br>in",
    WillAddXMonth2: "Monate hinzu",
    Withdrawal: "Lastschrift",
    WithdrawalAmount: "Abhebebetrag",
    WithdrawalHistory: "Kontobewegungen",
    WithdrawalInfo1:
      "Die Abbuchung wird auf die hinterlegte Bankkontonummer erfolgen.",
    WithdrawalInfo2: "Der Mindestbetrag zum Abheben beträgt <b>50 €</b>.",
    WithdrawalInfo3:
      "Die Auszahlung erfolgt auf das Konto, von dem aus die erste Einzahlung erfolgte.",
    WithdrawalOfBalances: "Abhebung des Guthabens vom Portfolio",
    WithdrawalViaBankAccount: "Abbuchung auf ein Bankkonto",
    WithdrawFunds: "Geld abheben",
    WithdrawFundsMobile: "Geld abheben",
    XActiveLoans: "Kredite sind aktiv",
    XClosedLoans: "Kredite sind geschlossen",
    XInvestedLoans: "Kredite wurden investiert",
    XOverdueLoans: "Kredite sind in Verzug",
    Yes: "Ja",
    YourInvestmentsXMonth:
      'Ihre Investitionen für <span class="js-calcMonth"></span> Monate',
    ZIP: "Index",
    LowBalanceAlert:
      "Sie haben nicht genügend Guthaben in Ihrem Konto, um ein Portfolio mit den ausgewählten Einstellungen zu erstellen",
    LowBalanceAlertCommon: "Sie haben nicht genügend Guthaben in Ihrem Konto",
    NoBankAlert:
      "Sie haben keine Kontodaten angegeben. Bitte kontaktieren Sie den Support",

    // Validation
    required: "Pflichtfeld",
    regexDate: "Geben Sie ein gültiges Datum ein",
    regexEmail: "Geben Sie eine gültige E-Mail-Adresse ein",
    checkbox: "Stimmen Sie der Datenverarbeitung zu",
    regexNot: "ungültiges Format",
    minlength: "",
    simple: "Schwach",
    normal: "Normal",
    hard: "Stark",
    minSum: "Der Mindestbetrag",
    //Tutorial
    step0:
      "Danke, dass Sie sich für Nibble entschieden haben! Schließen Sie die Veriff-Prüfung ab, um Ihr Guthaben aufladen und investieren zu können",
    step1:
      "Um mit dem Investieren zu beginnen, müssen Sie zunächst das Guthaben Ihres Profils aufladen.",
    step2:
      "Sie können den Rechner benutzen, um die Rentabilität Ihres Portfolios zu berechnen.",
    step3: 'Organisieren Sie Ihre Portfolios in "Meine Investitionen".',
    step4: "Hier sehen Sie einen Überblick über all Ihre Aktivitäten.",
    step5: "Erzielen Sie umso mehr Einkommen mithilfe Ihrer Freunde.",
    step6:
      "Wir werden erklären, wie Sie ein Investitions-Portfolio erstellen können und wie das System im Allgemeinen funktioniert.",
    step7:
      "Sie können ein Testportfolio mit einem maximalen Investitionsbetrag von 300 EUR für 21 Tage erstellen",
    TutorialCancel: "Später erledigen",
    TutorialConfirm: "Jetzt bestätigen",
    TutorialPrev: "früherer",
    TutorialNext: "Weiter",
    TutorialFinal: "Fertig",

    NoticeMaxSum: "Der Höchstbetrag ist",
    NoticeMinSum: "Der Mindestbetrag ist",
    StrategyTitleInvestClassic: "Klassische",
    StrategyTitleInvestBalanced: "Ausgewogen",

    // ------ Судебная ------

    JudicialTitle: `Verfügbare Portfolios`,
    JudicialPanelTitle: `Investieren`,
    JudicialBabberTitle: `Nibble stellt neue Anlagestrategie vor – Rechtliches`,
    JudicialSlideBtn: `Investieren`,
    JudicialBtnText: `Investieren`,
    JudicialLabel: `Investitionssumme`,
    JudicialCollection: `Noch ХХХ1 von ХХХ2 verbleiben für die Mittelbeschaffung`,
    JudicialCollectionEnd: `bis zum Ende der Mittelbeschaffung`,
    JudicialCollectionEnd2: `Ende der Mittelbeschaffung`,
    JudicialCollectionCompleted: `Die Mittelbeschaffung ist abgeschlossen.`,
    JudicialCollectionCompletedSub: `Sie können in ein neues Portfolio investieren.`,
    StrategyJudicialTitle: `Rechtsstrategie`,
    StrategyJudicialPanelTitle: `Rechtliches`,
    TaglineStrategyJudicialPanel: `Hohes Einkommen`,
    TaglineStrategyOtherPanel: `Ausgewogene Risiken`,
    JudicialSubTitle: `strategie`,
    JudicialMoreStrategy: `Mehr über die Strategie`,
    JudicialGuarantee: `Für alle Portfolios gilt eine`,
    JudicialGuaranteeDb: `Einlagengarantie`,
    JudicialState1: `Mittelbeschaffung für den Kauf eines Portfolios`,
    JudicialState2: `Kauf eines Portfolios`,
    JudicialState3: `Vorgerichtliche Einziehung`,
    JudicialStateSub3: `Verhandlungen mit Kreditnehmern`,
    JudicialState4: `Einreichung von Dokumenten bei Gericht`,
    JudicialState5: `Erhalt eines Gerichtsbeschlusses`,
    JudicialState6: `Inkasso durch Gerichtsbeschluss über Banken und Gerichtsvollzieher`,
    JudicialState7: `Eingezogene Schulden`,
    JudicialAgreement: `Vertrag`,
    JudicialGarantText: `Einlagengarantie`,
    JudicialInfo: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>Es handelt sich um eine Strategie für Investitionen in Portfolios, die aus Verbraucherkrediten der Kategorien B, CC und C bestehen, die sich in einem vorgerichtlichen bzw. gerichtlichen Inkassoverfahren befinden. Da diese Kredite überfällige Zahlungen und Geldstrafen aufweisen, erreicht die Rendite dieser Strategie bis zu 19 % pro Jahr.</p>
        <p>Die Gerichts- und Inkassoprozesse nehmen eine lange Zeit in Anspruch, sodass die Mindestanlagedauer 6 Monate beträgt. Die gesamte Prozessverwaltung und das Inkasso werden von Boostr übernommen.</p>
        <p>Verbundene Risiken: Risiko der Nicht-Rückzahlung des Kredits/Verlust des gesamten Kreditbetrags</p>

        <ul>
            <li>Die Strategie unterliegt der Einlagengarantie. Dies ist die Verpflichtung des Inkassobüros, den gesamten Anlagebetrag am Ende des Anlagezeitraums zurückzuzahlen und eine Mindestrendite von 8% pro Jahr zu gewährleisten.</li>
            <li>Durch die Investition in ein Portfolio, das aus einer Vielzahl von Krediten besteht, wird das Risiko, dass die Erträge aus mehreren Verträgen ausbleiben, verringert, da die Erträge durch andere Kredite gedeckt sind.</li>
            <li>Tägliche Verzinsung mit 8% p. a., Auszahlung alle 90 Tage entsprechend der tatsächlich erzielten Rendite, bis zu 14,5 % p. a.</li>
            <li>Während der Mittelbeschaffung für einen Portfoliokauf fallen Erträge in Höhe von 8% p. a. an. Dazu erhalten Sie eine Bonusrendite zur Hauptrendite. Beide zusammen erreichen bis zu 14,5 %. Die maximale Frist für die Mittelbeschaffung für einen Portfoliokauf beträgt 30 Tage.</li>
        </ul>
        <p>Wie funktioniert das?</p>
        <p>Sie verdienen täglich Zinsen zu einem Satz von 8% p. a. Alle 90 Tage berechnen wir automatisch die tatsächliche Rendite der Portfolios und gewähren Ihnen die Differenz zwischen dem garantierten Satz von 8% und dem tatsächlichen Satz. So erhalten Sie alle 90 Tage einen Ertrag zwischen 8% und 14,5 % auf Ihr Nibble-Konto.</p>
        <p>Beispiel: Wenn Sie 1.000 Euro für 12 Monate investieren, erhalten Sie am Ende der Laufzeit Ihr gesamtes Kapital von 1.000 Euro zurück und zusätzlich einen Ertrag zwischen 90 und 145 Euro, den wir Ihnen alle 90 Tage auszahlen.</p>
        </div></div></div>`,
    JudiciaDb: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>Rechtsstrategie</p>
        <p>Die Strategie unterliegt der Einlagengarantie. Dies ist die Verpflichtung des Inkassobüros, den gesamten Anlagebetrag am Ende des Anlagezeitraums zurückzuzahlen und eine Mindestrendite von 8% pro Jahr zu gewährleisten.</p>
        <p>Wie funktioniert sie?</p>
        <p>Sie verdienen täglich Zinsen zu einem Satz von 8% p. a. Alle 90 Tage berechnen wir automatisch die tatsächliche Rendite der Portfolios und gewähren Ihnen die Differenz zwischen dem garantierten Satz von 8% und dem tatsächlichen Satz. So erhalten Sie alle 90 Tage einen Ertrag zwischen 8% und 14,5 % auf Ihr Nibble-Konto.</p>
        <p>Beispiel: Wenn Sie 1.000 Euro für 12 Monate investieren, erhalten Sie am Ende der Laufzeit Ihr gesamtes Kapital von 1.000 Euro zurück und zusätzlich einen Ertrag zwischen 90 und 145 Euro, den wir Ihnen alle 90 Tage auszahlen.</p>
        </div></div></div>`,
    JudicialSlide: `
        <div class="judicial-slide__title">
        <div class="judicial-slide__title-head">
            Nibble stellt neue Anlagestrategie vor – Rechtliches
        </div>
        <div class="judicial-slide__title-sub">
            <p>Ab sofort steht unseren Anlegern eine neue Anlagestrategie zur Verfügung, die sich durch eine hohe und vorhersehbare Rendite von bis zu 14,5 % p. a. und eine Einlagengarantie auszeichnet.</p>
            <p>Um ein Gleichgewicht zwischen Rentabilität in der aktuellen Marktsituation und den Anforderungen der Regulierungsbehörde zu wahren, aktualisieren wir außerdem die Zinssätze für die neuen Portfolios der klassischen und ausgewogenen Strategien. Die Zinssätze für bestehende Portfolios ändern sich nicht.</p>
        </div>
        
        
        <div class="judicial-slide__title-mini">
            Klassisch – 8 % p. a.
        </div>
        <div class="judicial-slide__title-mini">
            Ausgewogen – 12,5 % p. a.
        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Über das Produkt
            </div>

            <div class="judicial-slide__sub-text">
                <p>Jedes Finanzunternehmen, das sich auf die Vergabe von Krediten spezialisiert hat, verfügt zwangsläufig über Kredite, die nicht innerhalb der im Vertrag festgelegten Fristen zurückgezahlt werden. Viele Unternehmen verkaufen solche Kredite in großen Portfolios auf Auktionen mit einem Abschlag von 85 %, um einen Teil des Geldes schnell wieder in den Betrieb investieren zu können.</p>
                <p>Solche Portfolios kauft Boostr auf Auktionen.</p>
                <p>Dank der umfangreichen Erfahrung und der von Boostr entwickelten Technologien ist es möglich, eine hohe Kapitalrendite zu erzielen. In Eurasien verfügt das Unternehmen über mehr als 5 Jahre Erfahrung und mehr als 80 Mitarbeiter.</p>
                <p>In Europa arbeitet Boostr mit Inkassobüros, die sich auf das Inkasso von Forderungen aus europäischen Krediten spezialisiert haben.</p>
                <p>Seit 2019 sind Auktionsplattformen für den Verkauf von Forderungen, wie Debex und NLPBroker, auf dem spanischen Markt aktiv, was das Wachstum des Marktes widerspiegelt. Außerdem gibt es viele weitere Inkassobüros auf dem Markt, die sich auf die Eintreibung von Forderungen spezialisiert haben. Nach Angaben unserer Partner aus dieser Branche mit mehr als 25 Jahren Erfahrung kann die Rendite für Investoren bis zu 19 % pro Jahr erreichen.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Historische Rentabilität
            </div>

            <div class="judicial-slide__stend">
                <div class="judicial-slide__block">
                    <div class="judicial-slide__block-title">
                        Es wurde ein Portfolio gekauft.
                    </div>
                    <div class="judicial-slide__purchase-list">

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Kaufbetrag
                            </div>
                            <div class="judicial-slide__purchase-money">
                                117.801 €
                            </div>
                        </div>

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Schuldsumme 
                            </div>
                            <div class="judicial-slide__purchase-money">
                                1.328.123 €
                            </div>
                        </div>
                    </div>

                    <div class="judicial-slide__explanation">
                            <div class="judicial-slide__explanation-icon">
                                <div class="judicial-slide__explanation-smiley" ></div>
                            </div>
                            <div class="judicial-slide__explanation-text">
                                Das heißt, wir haben ein Portfolio mit einem <br /> Potenzial von 1.328.123 € für 117.801 € gekauft.
                            </div>
                        </div>

                        <div class="judicial-slide__block-info">
                            <div class="judicial-slide__block-collected">
                                <div class="judicial-slide__collected-title">
                                    Im ersten Jahr konnten wir:
                                </div>
                                <div class="judicial-slide__collected-money">
                                    143.107&nbsp;€
                                </div>
                                <div class="judicial-slide__collected-description">
                                    an Schulden eintreiben, was 25.306 € über unserer Investition liegt und eine Rendite von mehr als 20 % p. a. ergibt.
                                </div>
                            </div>

                            <div class="judicial-slide__block-description">
                                <div class="judicial-slide__description-icon">
                                    <div class="judicial-slide__description-info-icon"></div>
                                </div>
                                <div class="judicial-slide__block-description-text">
                                    Nach dem ersten Jahr des Inkassos können wir die verbleibenden Kredite des Portfolios für 70.343&nbsp;€ versteigern, was insgesamt 95.649&nbsp;€ einbringt.
                                </div>
                            </div>
                        </div>

                        
                        <div class="judicial-slide__strategy">
                            <div class="judicial-slide__strategy-title">
                                Portfolio-Statistiken
                            </div>
                            <div class="judicial-slide__strategy-diagram">
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        117.801&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom1">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Gesamte Investitionen
                                    </div>
                                </div>
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        143.107&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom2">
                                        Einnahmen 25&nbsp;306&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Eingetrieben im ersten Jahr
                                    </div>
                                </div>          
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        270.784&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom4">
                                        Einnahmen 152.983&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Eingetrieben im zweiten Jahr
                                    </div>
                                </div>          
                            </div>

                            <div class="judicial-slide__strategy-earned">
                                <div class="judicial-slide__strategy-label">
                                    Einnahmen aus 2 Jahren:
                                </div>
                                <div class="judicial-slide__strategy-sum">
                                    152.983&nbsp;€
                                </div>
                            </div>
                        </div>
                </div>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Auf der Grundlage dieses Geschäfts haben wir eine Rechtsstrategie entwickelt.
            </div>

            <div class="judicial-slide__sub-text">
                <p>Es handelt sich um eine Strategie für Investitionen in Portfolios, die aus Verbraucherkrediten der Kategorien B, CC und C bestehen, die sich in einem vorgerichtlichen bzw. gerichtlichen Inkassoverfahren befinden. Da diese Kredite überfällige Zahlungen und Geldstrafen aufweisen, erreicht die Rendite dieser Strategie bis zu 19 % pro Jahr.</p>
                <p>Die Gerichts- und Inkassoprozesse nehmen eine lange Zeit in Anspruch, sodass die Mindestanlagedauer 6 Monate beträgt.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Verbundene Risiken:
            </div>

            <div class="judicial-slide__title-small">
                Risiko der Nicht-Rückzahlung des Kredits/Verlust des gesamten Kreditbetrags
            </div>

            <div class="judicial-slide__sub-text">
                <ul class="judicial-slide__roll">
                    <li class="judicial-slide__element">Die Strategie unterliegt der Einlagengarantie. Dies ist die Verpflichtung des Inkassobüros, den gesamten Anlagebetrag am Ende des Anlagezeitraums zurückzuzahlen und eine Mindestrendite von 8% pro Jahr zu gewährleisten.</li>
                    <li class="judicial-slide__element">Durch die Investition in ein Portfolio, das aus einer Vielzahl von Krediten besteht, wird das Risiko, dass die Erträge aus mehreren Verträgen ausbleiben, verringert, da die Erträge durch andere Kredite gedeckt sind.</li>
                    <li class="judicial-slide__element">Tägliche Verzinsung mit 8% p. a., Auszahlung alle 90 Tage entsprechend der tatsächlich erzielten Rendite, bis zu 14,5 % p. a.</li>
                    <li class="judicial-slide__element">Während der Mittelbeschaffung für einen Portfoliokauf fallen Erträge in Höhe von 8% p. a. an. Dazu erhalten Sie eine Bonusrendite zur Hauptrendite. Beide zusammen erreichen bis zu 14,5 %. Die maximale Frist für die Mittelbeschaffung für einen Portfoliokauf beträgt 30 Tage.</li>
                </ul>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Wie funktioniert sie?
            </div>

            <div class="judicial-slide__sub-text">
                Sie wählen ein Portfolio nach Ihren Präferenzen aus und investieren in dieses. Während sich das Portfolio in der Mittelbeschaffungsphase befindet, erhalten Sie täglich 8% p. a. Nach Abschluss dieser Phase erhalten Sie ebenfalls tägliche Zinsen in Höhe von 8% p. a. Alle 90 Tage berechnen wir automatisch die tatsächliche Rendite der Portfolios und zahlen Ihnen die Differenz zwischen dem garantierten Satz von 8% und dem tatsächlichen Satz, der bis zu 14,5 % erreichen kann. So erhalten Sie alle 90 Tage einen Ertrag zwischen 8% und 14,5 % auf Ihr Nibble-Konto.
            </div>

            <div class="judicial-slide__sub-text-mini">
                Beispiel: Wenn Sie 1.000 Euro für 12 Monate investieren, erhalten Sie am Ende der Laufzeit Ihr gesamtes Kapital von 1.000 Euro zurück und zusätzlich einen Ertrag zwischen 90 und 145 Euro, der direkt auf Ihr Nibble-Konto gutgeschrieben wird.
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                So verdienen wir Geld für Investoren:
            </div>

            <div class="judicial-slide__sub-text">
                <ol class="judicial-slide__roll">
                    <li class="judicial-slide__element">Boostr kauft überfällige Kredite von Banken und MFOs bei Auktionen mit einem Abschlag von 85 %.</li>
                    <li class="judicial-slide__element">Die außergerichtliche Einigung beginnt, indem die Agentur mit dem Kreditnehmer Kontakt aufnimmt und versucht, sich über die Rückzahlung der Schulden zu einigen.</li>
                    <li class="judicial-slide__element">Wenn keine Einigung erzielt werden konnte, beginnt das Gerichtsverfahren, um eine gerichtliche Entscheidung über die Eintreibung der Schulden beim Schuldner zu erwirken, die von Boostr oder seinem Partner verfolgt wird.</li>
                    <li class="judicial-slide__element">Nach Erhalt eines Gerichtsbeschlusses werden die Schulden, Zinsen und Bußgelder durch Gerichtsvollzieher und Banken eingezogen.</li>
                </ol>
            </div>

        </div>
    </div>
        `,
    legalTitle: `Rechtliches strategie`,
    legalInfoTitle1: `Über das Produkt`,
    legalInfoTitle2: `Historische Rentabilität`,
    legalInfoTitle3: `Auf der Grundlage dieses Geschäfts haben wir eine Rechtsstrategie entwickelt`,
    legalInfoTitle4: `Verbundene Risiken`,
    legalInfoTitle5: `Wie funktioniert sie?`,
    legalInfoTitle6: `So verdienen wir Geld für Investoren`,
    legalInfoText1: `
        <p>Jedes Finanzunternehmen, das sich auf die Vergabe von Krediten spezialisiert hat, verfügt zwangsläufig über Kredite, die nicht innerhalb der im Vertrag festgelegten Fristen zurückgezahlt werden. Viele Unternehmen verkaufen solche Kredite in großen Portfolios auf Auktionen mit einem Abschlag von 85 %, um einen Teil des Geldes schnell wieder in den Betrieb investieren zu können.</p>
        <p>Solche Portfolios kauft Boostr auf Auktionen.</p>
        <p>Dank der umfangreichen Erfahrung und der von Boostr entwickelten Technologien ist es möglich, eine hohe Kapitalrendite zu erzielen. In Eurasien verfügt das Unternehmen über mehr als 5 Jahre Erfahrung und mehr als 80 Mitarbeiter.</p>
        <p>In Europa arbeitet Boostr mit Inkassobüros, die sich auf das Inkasso von Forderungen aus europäischen Krediten spezialisiert haben.</p>
        <p>Seit 2019 sind Auktionsplattformen für den Verkauf von Forderungen, wie Debex und NLPBroker, auf dem spanischen Markt aktiv, was das Wachstum des Marktes widerspiegelt. Außerdem gibt es viele weitere Inkassobüros auf dem Markt, die sich auf die Eintreibung von Forderungen spezialisiert haben. Nach Angaben unserer Partner aus dieser Branche mit mehr als 25 Jahren Erfahrung kann die Rendite für Investoren bis zu 19 % pro Jahr erreichen.</p>
        `,
    legalInfoText2: `
        <div class="judicial-slide__stend">
          <div class="judicial-slide__block">
              <div class="judicial-slide__block-title">
                  Es wurde ein Portfolio gekauft.
              </div>
              <div class="judicial-slide__purchase-list">

                  <div class="judicial-slide__purchase-item">
                      <div class="judicial-slide__purchase-info">
                          Kaufbetrag
                      </div>
                      <div class="judicial-slide__purchase-money">
                          117.801 €
                      </div>
                  </div>

                  <div class="judicial-slide__purchase-item">
                      <div class="judicial-slide__purchase-info">
                          Schuldsumme 
                      </div>
                      <div class="judicial-slide__purchase-money">
                          1.328.123 €
                      </div>
                  </div>
              </div>

              <div class="judicial-slide__explanation">
                      <div class="judicial-slide__explanation-icon">
                          <div class="judicial-slide__explanation-smiley" ></div>
                      </div>
                      <div class="judicial-slide__explanation-text">
                          Das heißt, wir haben ein Portfolio mit einem <br /> Potenzial von 1.328.123 € für 117.801 € gekauft.
                      </div>
                  </div>

                  <div class="judicial-slide__block-info">
                      <div class="judicial-slide__block-collected">
                          <div class="judicial-slide__collected-title">
                              Im ersten Jahr konnten wir:
                          </div>
                          <div class="judicial-slide__collected-money">
                              143.107&nbsp;€
                          </div>
                          <div class="judicial-slide__collected-description">
                              an Schulden eintreiben, was 25.306 € über unserer Investition liegt und eine Rendite von mehr als 20 % p. a. ergibt.
                          </div>
                      </div>

                      <div class="judicial-slide__block-description">
                          <div class="judicial-slide__description-icon">
                              <div class="judicial-slide__description-info-icon"></div>
                          </div>
                          <div class="judicial-slide__block-description-text">
                              Nach dem ersten Jahr des Inkassos können wir die verbleibenden Kredite des Portfolios für 70.343&nbsp;€ versteigern, was insgesamt 95.649&nbsp;€ einbringt.
                          </div>
                      </div>
                  </div>

                  
                  <div class="judicial-slide__strategy">
                      <div class="judicial-slide__strategy-title">
                          Portfolio-Statistiken
                      </div>
                      <div class="judicial-slide__strategy-diagram">
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  117.801&nbsp;€
                              </div>
                              <div class="judicial-slide__strategy-block-bottom1">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Gesamte Investitionen
                              </div>
                          </div>
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  143.107&nbsp;€
                              </div>
                              <div class="judicial-slide__strategy-block-bottom2">
                                  Einnahmen 25&nbsp;306&nbsp;€
                              </div>
                              <div class="judicial-slide__strategy-block-bottom3">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Eingetrieben im ersten Jahr
                              </div>
                          </div>          
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  270.784&nbsp;€
                              </div>
                              <div class="judicial-slide__strategy-block-bottom4">
                                  Einnahmen 152.983&nbsp;€
                              </div>
                              <div class="judicial-slide__strategy-block-bottom3">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Eingetrieben im zweiten Jahr
                              </div>
                          </div>          
                      </div>

                      <div class="judicial-slide__strategy-earned">
                          <div class="judicial-slide__strategy-label">
                              Einnahmen aus 2 Jahren:
                          </div>
                          <div class="judicial-slide__strategy-sum">
                              152.983&nbsp;€
                          </div>
                      </div>
                  </div>
          </div>
      </div>

        </div>
    </div>
        `,
    legalInfoText3: `
          <p>Es handelt sich um eine Strategie für Investitionen in Portfolios, die aus Verbraucherkrediten der Kategorien B, CC und C bestehen, die sich in einem vorgerichtlichen bzw. gerichtlichen Inkassoverfahren befinden. Da diese Kredite überfällige Zahlungen und Geldstrafen aufweisen, erreicht die Rendite dieser Strategie bis zu 19 % pro Jahr.</p>
          <p>Die Gerichts- und Inkassoprozesse nehmen eine lange Zeit in Anspruch, sodass die Mindestanlagedauer 6 Monate beträgt.</p>
          `,
    legalInfoText4: `
        <strong>
          Risiko der Nicht-Rückzahlung des Kredits/Verlust des gesamten Kreditbetrags
        </strong>
        <ul class="legal-list__point">
          <li>Die Strategie unterliegt der Einlagengarantie. Dies ist die Verpflichtung des Inkassobüros, den gesamten Anlagebetrag am Ende des Anlagezeitraums zurückzuzahlen und eine Mindestrendite von 8% pro Jahr zu gewährleisten.</li>
          <li>Durch die Investition in ein Portfolio, das aus einer Vielzahl von Krediten besteht, wird das Risiko, dass die Erträge aus mehreren Verträgen ausbleiben, verringert, da die Erträge durch andere Kredite gedeckt sind.</li>
          <li>Tägliche Verzinsung mit 8% p. a., Auszahlung alle 90 Tage entsprechend der tatsächlich erzielten Rendite, bis zu 14,5 % p. a.</li>
          <li>Während der Mittelbeschaffung für einen Portfoliokauf fallen Erträge in Höhe von 8% p. a. an. Dazu erhalten Sie eine Bonusrendite zur Hauptrendite. Beide zusammen erreichen bis zu 14,5 %. Die maximale Frist für die Mittelbeschaffung für einen Portfoliokauf beträgt 30 Tage.</li>
        </ul>
        `,
    legalInfoText5: `
        <p>Sie wählen ein Portfolio nach Ihren Präferenzen aus und investieren in dieses. Während sich das Portfolio in der Mittelbeschaffungsphase befindet, erhalten Sie täglich 8% p. a. Nach Abschluss dieser Phase erhalten Sie ebenfalls tägliche Zinsen in Höhe von 8% p. a. Alle 90 Tage berechnen wir automatisch die tatsächliche Rendite der Portfolios und zahlen Ihnen die Differenz zwischen dem garantierten Satz von 8% und dem tatsächlichen Satz, der bis zu 14,5 % erreichen kann. So erhalten Sie alle 90 Tage einen Ertrag zwischen 8% und 14,5 % auf Ihr Nibble-Konto.</p>
        <p>Beispiel: Wenn Sie 1.000 Euro für 12 Monate investieren, erhalten Sie am Ende der Laufzeit Ihr gesamtes Kapital von 1.000 Euro zurück und zusätzlich einen Ertrag zwischen 90 und 145 Euro, der direkt auf Ihr Nibble-Konto gutgeschrieben wird.</p>
        `,
    legalInfoText6: `
        <ol class="legal-list__num">
          <li>Boostr kauft überfällige Kredite von Banken und MFOs bei Auktionen mit einem Abschlag von 85%.</li>
          <li>Die außergerichtliche Einigung beginnt, indem die Agentur mit dem Kreditnehmer Kontakt aufnimmt und versucht, sich über die Rückzahlung der Schulden zu einigen.</li>
          <li>Wenn keine Einigung erzielt werden konnte, beginnt das Gerichtsverfahren, um eine gerichtliche Entscheidung über die Eintreibung der Schulden beim Schuldner zu erwirken, die von Boostr oder seinem Partner verfolgt wird.</li>
          <li>Nach Erhalt eines Gerichtsbeschlusses werden die Schulden, Zinsen und Bußgelder durch Gerichtsvollzieher und Banken eingezogen.</li>
        </ol>
        `,
    refLinkMenu1: `Program conditions`,
    refLinkMenu2: `Meine Einladungen`,
    refLinkTab1: `Ausstehend`,
    refLinkTab2: `Bonus angesammelt`,
    refLinkTab3: `Kein Bonus`,
    refInviteFriendsTitle1: `Freunde einladen`,
    refInviteFriendsSubTitle1: `Prämie`,
    refInviteFriendsText1: `von bis zu 1.000 Euro für Sie und Ihren Freund erhalten`,
    refInviteFriendsBTN1: `Freunde einladen`,
    refInviteFriendsSubTitle2: `Wie funktioniert es?`,
    refInviteFriendsStepTitle1: `Sie laden Ihren Freund zu`,
    refInviteFriendsStepText1: `Nibble ein, indem Sie den Registrierungslink senden`,
    refInviteFriendsStepTitle2: `Ihr Freund wird Investor`,
    refInviteFriendsStepText2: `Der Freund hat 3 Monate Zeit, ein Portfolio zu erstellen`,
    refInviteFriendsStepTitle3: `Sie und Ihr Freund erhalten einen Bonus`,
    refInviteFriendsStepText3: `Der Bonus hängt von der Höhe der Investitionen des Freundes ab`,
    refInviteFriendsTitle2: `Wovon hängt die Höhe der Prämie ab?`,
    refInviteFriendsText2: `Der Bonus hängt davon ab, wie viel Ihr Freund innerhalb von 3 Monaten nach der Registrierung investiert`,
    refInviteFriendsBonus: `Bonus&nbsp;2%`,
    refInviteFriendsSum: `Investitionen des Freundes`,
    refInviteFriendsTitle3: `What else can affect?`,
    refInviteFriendsInfoTitle1: `Die Summe der Investitionen`,
    refInviteFriendsInfoText1: `Die Summe aller Anlagen Ihres Freundes muss größer als 500 € sein`,
    refInviteFriendsInfoTitle2: `Zeitraum der Investitionen`,
    refInviteFriendsInfoText2: `Es werden nur Portfolios berücksichtigt, die seit mindestens 3 Monaten angelegt sind`,
    refInviteFriendsBoxTitle1: `Investieren Sie auf Nibble mit Ihren Freunden`,
    refInviteFriendsBoxText1: `Unsere Plattform ist sowohl für Anfänger als auch erfahrene Anleger geeignet`,
    yourReferralLink: `Your referral link`,
    refInviteFriendsBTN2: `Kopieren Sie den Link`,
    refMyInvitationsTitle1: `Meine Einladungen`,
    refMyInvitationsTotal: `Total earned`,
    refMyInvitationsFriends: `Friends registered`,
    refMyInvitationsGetBonus: `Bonus angesammelt`,
    refMyInvitationsTitle2: `Your referral link`,
    refMyInvitationsTitle3: `Meine Einladungen`,
    refMyInvitationsNO: `Sie haben noch keine eingeladenen Freunde. Teilen Sie Ihren Empfehlungslink mit ihnen`,
    bonusPeriodEnd: `Ende des Bonuszeitraums`,
    yourBonus: `Ihr Bonus`,
    bannerTetx: `Legal strategy is available again<span class="banner-BB__text-i">!</span> Invest <span class="banner-BB__text-i">at a</span> high interest rate <span class="banner-BB__text-i">and</span> earn <span class="banner-BB__text-i">with Nibble!</span>`,
  },
  IT: {
    Out: "su",
    PortfolioTitle: "I tuoi portafogli",
    UntilTheEnd: "Fino alla fine dell'investimento",
    TabsActive: "Attivi",
    TabsClose: "Estinti",
    TabsDraft: "Bozza",
    LoansInvesting: "Prestiti investiti",
    LoansActive: "Prestiti attivi",
    LoansClose: "Prestiti estinti",
    LoansDebt: "Recupero del debito",
    LoansBought: "Riacquistato",
    Hello: "Ciao,",
    MonthOne: "mese",
    MonthSeveral: "mesi",
    MonthMany: "mesi",
    Delete: "Eliminare",
    //
    ResultPaymentErrorTitle: "Transazione è stata rifiutata dalla banca.",
    ResultPaymentErrorInfo:
      "Inoltre, puoi ricaricare il tuo saldo, usando bonifico bancario o uno di questi servizi:",
    LimitContentTitle: "Questo mese hai già ricaricato il saldo di /1/.",
    LimitContentDescription1:
      "Secondo gli standard del diritto europeo, possiamo accetare fino a /1/ al mese da te.",
    LimitContentList1: "Fino al /1/ puoi ricaricare il saldo di /2/.",
    LimitContentList2:
      "Da /1/ puoi ricaricare il saldo di ogni somma di denaro fino a /2/.",
    LimitContentDescription2:
      "Se intendi di investire più di /1/, contattaci per favore in qualsiasi modo conveniente per te, e ti aiuteremo a farlo.",
    //
    DepositTabsTitle1: "Carta",
    DepositTabsTitle2: "Bonifico bancario",
    DepositTabsTitle3: `Per modificare le informazioni personali, si prega di contattare l'assistenza.`,
    DepositTabsTitle3_EN: `To change your personal information, please contact support. <br /> 
    Currently, only Mastercard is supported. Withdrawal on Visa is in the process.`,
    DepositTabsTitle4: `Il prelievo di fondi verrà effettuato sul numero di conto collegato. L'importo minimo di prelievo è <strong>50 EURO</strong>.`,
    DepositDescriptionCardDesk:
      "Per favore, tieni a mente che la tua banca potrebbe fissare dei limiti alle transazioni effettuate con carta. Se non riesci a ricaricare il saldo tramite carta, puoi contattare la tua banca per risolvere il problema o depositare il tuo account tramite bonifico bancario.",
    DepositDescriptionCardMobile:
      "Se non riesci a ricaricare il saldo tramite carta, puoi contattare la tua banca per risolvere il problema o depositare il tuo account tramite bonifico bancario.",
    DepositDescriptionBankDesk:
      "Trasferisci i fondi sul conto bancario indicato. Assicurati di copiare la descrizione della transazione.\n" +
      "Il deposito dei fondi è disponibile solo per i residenti SEPA.",
    DepositDescriptionBankMobile:
      "Il deposito dei fondi è disponibile <b>solo per i residenti SEPA.</b>",
    //
    OtherLabel: "Altro",
    RangeInvestmentAmount: "Importo di investimento da /min/ a /max/",
    RangeInvestmentTerm: "Periodo di investimento (mesi) da /min/ a /max/",
    ValidationAmountMin: "L'importo minimo è di /min/",
    ValidationAmountMax: "L'importo massimo è di /max/",
    ValidationTermMinMax: "Da /min/ a /max/ mesi",
    AvailableForInvesting: "Disponibile per investire",
    WeeklyInterestPay: "Pagamento settimanale degli interessi",
    FirstPayment: "Il primo pagamento",
    ClassicDescription:
      "La redditività di questa strategia è fissa, assistita da una garanzia di riacquisto e ammonta al 9.7% annuo. Questa strategia garantisce l'assenza di rischi e la redditività è garantita. Il reinvestimento dei fondi investiti è abilitato per impostazione predefinita.",
    BalancedDescription:
      "La redditività non è fissa e, secondo le statistiche dei periodi precedenti, può raggiungere il 13% annuo. La strategia più equilibrata considerando il rapporto rischio-rendimento. Il reinvestimento dei fondi investiti è abilitato per impostazione predefinita.",
    SpecialDescription:
      "La redditività non è fissa e può raggiungere il 17–19% annuo. I rischi di investimento sono più elevati, ma allo stesso tempo la redditività consente di compensare le perdite all'interno dell'importo totale del portafoglio di investimenti. Il reinvestimento dei fondi investiti è abilitato per impostazione predefinita.",
    NextMoreText: "Più dettagli",
    BackButton: "Indietro",
    CalculatorInfoTitle: "Grazie per aver unito Nibble!",
    CalculatorInfoDescription:
      "Scegli una strategia di investimento in base alle tue preferenze in termini di redditività e rischio.",
    CalculatorListTitle: "Crea un portafoglio di investimenti in tre passi:",
    CalculatorListItem1: "Esegui verificazione dell’identità attraverso Veriff",
    CalculatorListItem2: "Ricarica il saldo",
    CalculatorListItem3: "Crea il tuo primo portafoglio di investimenti",
    StrategyNameClassic: "Classica",
    StrategyNameBalanced: "Equilibrata",
    StrategyNameSpecial: "Speciale",
    IdentifyYourself: "Verifica dell’identità",
    CurrentAnnualRate: "Tasso d’interesse annuo attuale",
    //
    IdentificationDescription:
      "Secondo gli standard del diritto europeo, dobbiamo verificare la tua identità.",
    //
    bannerAchive: "Promozione estiva",
    bannerInfo:
      "Non perdere l'occasione di guadagnare di più, con un tasso dell'11,7% della Strategia Classica per portafogli creati&nbsp;dal&nbsp;1luglio&nbsp;al&nbsp;31agosto&nbsp;2021",
    //
    PaymentsOpertions_334: "Deposito con carta",
    PaymentsOpertions_150: "Deposito con bonifico bancario",
    PaymentsOpertions_355: "Bonus",
    //
    NoLinkDocsAlert:
      'Per scaricare i documenti è necessario compilare i campi della sezione "Informazioni personali',
    NoticeDepositingCard:
      "Tieni presente che la tua banca potrebbe fissare dei limiti alle transazioni effettuate con carta. Se non riesci a ricaricare il tuo account tramite carta, puoi contattare la tua banca per risolvere il problema o depositare il tuo account tramite bonifico bancario.",
    //
    AboutTheBorrower: "Informazioni sul mutuatario",
    AboutVeriff:
      "Veriff è una società considerata affidabile dal processo di identificazione dei governi europei, principali banche, aziende e servizi del settore fintech e negozi online. .",
    AccountNumber: "Numero di conto",
    AccountSumAvailable: "Disponibile sul tuo account",
    AccuredIncome: "reddito maturato",
    ActiveLoans: "prestiti attivi",
    ActivePortfolio: "portafoglio attuale",
    AdditionalAgreement: "Accordo addizionale",
    Address: "Indirizzo di residenza",
    AddressLine1: "Indirizzo 1",
    AddressLine2: "Indirizzo 2",
    Agreement: "accordo",
    All: "Tutti",
    AlreadyHaveAccount: "Hai già un account? Accedi",
    AnnualInterestRate: "tasso d’interesse </br> annuo attuale",
    AnnualInterestRateClassic: "tasso d’interesse <br> annuo fisso",
    ApplicationReceivedMessage:
      "La tua domanda è stata accettata, il nostro responsabile ti contatterà a breve. Grazie!",
    ApplyPromoCode: "Applica il codice promozionale",
    AreYouSure: "Sei sicuro?",
    Articles: "Articoli",
    AverageInterest: "tasso di interesse medio ponderato",
    Balance: "Saldo",
    Bank: "Banca",
    BankAccountNumber: "Numero del conto bancario",
    BankName: "Nome della banca",
    BankTransferReplenishment: "Deposito con bonifico bancario",
    BankTransferWithdrawal: "Prelievo con bonifico bancario",
    CardTransferWithdrawal: "Withdrawal by card",
    Basic: "Generale",
    BirthDate: "Data di nascita",
    Borrower: "Mutuatario",
    BorrowingCompany: "azienda mutuataria",
    BringFriend: "Porta un amico",
    BuybackGuarantee: "Garanzia BuyBack",
    c11: "Russia",
    c12: "Austria",
    c197: "Senza reinvestimento",
    c198: "Reinvestimento totale",
    c199: "Importo principale del reinvestimento",
    c206: "Spagna",
    c208: "Belgio",
    c242: "Bulgaria",
    c243: "Gran Bretagna",
    c244: "Ungheria",
    c245: "Germania",
    c246: "Grecia",
    c247: "Danimarca",
    c248: "Irlanda",
    c249: "Italia",
    c250: "Cipro",
    c251: "Lettonia",
    c252: "Lituania",
    c253: "Lussemburgo",
    c254: "Malta",
    c255: "Olanda",
    c256: "Polonia",
    c257: "Portogallo",
    c258: "Romania",
    c259: "Slovacchia",
    c260: "Slovenia",
    c261: "Finlandia",
    c262: "Francia",
    c263: "Croazia",
    c264: "Repubblica Ceca",
    c265: "Svezia",
    c266: "Svizzera",
    c267: "Estonia",
    c270: "Joymoney RU (prossimamente)",
    c271: "Joymoney ES",
    c272: "Joymoney MX (prossimamente)",
    c274: "Non c’è nessuna foto",
    c275: "Immagine del viso non riconosciuta",
    c276: "Il documento non è visualizzato completamente.",
    c277: "Scarsa qualità dell'immagine",
    c278: "Il documento è danneggiato",
    c279: "Spiacente, questo tipo di documento non è supportato.",
    c280: "Il documento è scaduto",
    c281: "Approvato",
    c282: "Altri motivi",
    c283: "Scaduto",
    CalculatorNote:
      "Il reinvestimento dei fondi investiti è abilitato per impostazione predefinita e tutto il reddito ricevuto dall'investimento verrà trasferito sul tuo conto Nibble su base settimanale",
    CapitalReinvestment: "reinvestire il capitale",
    CardInfo:
      "Stiamo lavorando per aumentare le modalità di deposito fondi sul conto Nibble. Presto sarai in grado di depositare dalla tua carta di debito o di credito.",
    CashbackForFriends: "Cashback per gli investimenti di un amico",
    CashbackForInvestments: "Cashback per i tuoi investimenti",
    CashDeposit: "Ricariche",
    ChangePassword: "Cambia la password",
    ChoiceOf70: "Scelto dal 70% degli investitori",
    ChoosePortfolioType: "Scegli il tipo di portafoglio",
    City: "Città",
    ClosedLoans: "Prestiti estinti",
    ClosingDate: "Data di chiusura",
    CompanyHeadName: "Nome del direttore",
    CompanyName: "Il nome dell'azienda",
    CompleteRegistration:
      "Completa il processo di registrazione con la tua identificazione al fine di ricaricare il tuo credito e iniziare a investire.",
    Confirm: "Conferma",
    ConfirmationLinkSent: "Un link di conferma è stato inviato alla tua email",
    Continue: "Continua",
    ContractsAndDocs: "Documenti e accordi",
    Country: "Nazione",
    CountryOfIssue: "Paese d’emissione",
    CountryOfResidence: "Paese di residenza",
    Code: "Codice",
    CreateAccount: "Crea un account",
    CreatePortfolio: "Crea portafoglio",
    CreatePortfolioInfo:
      "Se selezionato, tutte le entrate guadagnate verranno reinvestite per offrirti maggiori entrate. Invece con l'impostazione predefinita, il reddito derivante dagli investimenti viene erogato sul profilo Nibble e sarà disponibile per l'addebito dopo la scadenza dei prestiti.",
    CreateTestPortfolio: "Crea un portafoglio di prova",
    CurrentBalance: "saldo",
    CurrentIncome: "Entrate correnti",
    CurrentlyOnYourAccount: "Attualmente sul tuo conto",
    CurrentPassError: "La password attuale non è corretta",
    CurrentPassword: "Password attuale",
    DailyReport: "Rapporto giornaliero",
    DateFormat: "Formato data",
    DaysLabel: "giorni",
    DepositAccount: "Depositare il conto",
    DepositAccountMobile: "Depositare",
    DepositFunds: "Ricarica",
    DepositHistory: "Cronologia dei depositi",
    DepositPortfolio: "Ricarica portafoglio",
    DepositViaBankAccount: "Deposito tramite conto bancario",
    DocBackScan: "Una foto parte retro del documento",
    DocFrontScan: "Una foto del documento",
    DocPhoto: "Foto del documento",
    DocType: "Tipo di documento",
    Document: "Documento",
    DownloadAgreement: "Scarica il contratto",
    DownloadWarning:
      "Per scaricare il contratto, inserisci le informazioni personali richieste",
    DownloadWarningNext: "personali richieste",
    Email: "E-mail",
    EmailAlreadyReg: "Questo indirizzo email è già utilizzato nel sistema.",
    EmailChangeInfo:
      "Per modificare il tuo indirizzo email, contatta l'assistenza",
    EnabledByDefault: "Impostazioni predefinite",
    ERROR_001:
      "Non ci sono fondi sufficienti sul tuo bilancio per creare un portafoglio con i parametri selezionati",
    ERROR_002: "Nessun paese selezionato",
    ERROR_003: "Errore sconosciuto",
    ERROR_004: "Importo specificato non corretto",
    ERROR_005: "Solo un portafoglio di prova può essere creato",
    ERROR_006:
      "L'importo dell'investimento selezionato non corrisponde al saldo",
    ErrorEmailLength: "Il campo e-mail non può essere vuoto",
    ErrorEmailLogin: "La email inserita non è corretta",
    ErrorEmailPassLogin: "Email o password non validi",
    ErrorEmptyFields: "Non tutti i campi obbligatori sono stati compilati",
    ErrorFirstNameLength: "Non hai specificato il tuo nome",
    ErrorLastNameLength: "Non hai specificato il tuo cognome",
    ErrorLoadDocument:
      "Per scaricare il contratto, è necessario inserire la data di nascita e l'indirizzo nella pagina delle impostazioni!",
    ErrorPhoneFormat: "Numero di telefono non corretto",
    ErrorPromoCode: "Codice promozionale non valido",
    Exit: "Esci",
    ExpectedAnnualReturn: "Rendimento annuo previsto",
    ExpectedClosingDate: "Data di rimborso prevista",
    ExpectedIncome: "reddito atteso",
    FacePhoto: "Foto del viso",
    Finish: "Completa",
    First: "Prima",
    FirstName: "Il tuo nome",
    FirstStep: "Primo passo per la registrazione",
    ForBusiness: "per affari",
    ForgotPassword: "Password dimenticata?",
    FormatDate1: "aaaa-mm-gg",
    FormatDate2: "aaaa/mm/gg",
    FormatDate3: "mm/gg/aaaa",
    FormatDate4: "mm-gg-aaaa",
    From3To60Months: "da 3 a 60 mesi",
    Full: "Totale",
    FundsWithdrawal: "Prelievo fondi",
    Gender: "Genere",
    GetSMSCode: "Ottieni il codice di verifica",
    GoIdent: "Verifica <br> dell’identità",
    GoToAccount: "Accedi all'area riservata",
    Help: "Aiuto",
    History: "Cronologia delle transazioni",
    HowItWorks: "Come funziona",
    HelperRisksTitle:
      "Classificazione dei prestiti per rischio di insolvenza: NPL 30, 60, 90, 120+",
    HelperRisksText:
      'Le societ&agrave; della holding IT Smart Finance utilizzano modelli di punteggio per determinare la qualit&agrave; dei mutuatari. A tutti i prestiti approvati viene assegnata una classificazione personalizzata.</p> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>AA</strong></td> <td><strong>A</strong></td> </tr> <tr> <td>rimborsati in data stabilita</td> <td>rimborsati prima del previsto</td> </tr> <tr> <td colspan="2">Prestiti a basso rischio. I clienti di questa categoria, di solito, restituiscono il denaro in tempo o prima del previsto, quindi la redditivit&agrave; su di essi &egrave; bassa e di conseguenza anche i rischi lo sono.</td> </tr> <tr> <td><strong>ВВ</strong></td> <td><strong>В</strong></td> </tr> <tr> <td>scaduti, NPL 0-30</td> <td>scaduti, NPL 30&ndash;60</td> </tr> <tr> <td colspan="2">Prestiti a medio rischio. I clienti di questa categoria possono essere in ritardo nei pagamenti (NPL30 e NPL60), ma quasi sempre finiscono per rimborsare i prestiti. Il rischio di insolvenza per questa categoria &egrave; maggiore, e di conseguenza anche il reddito medio lo &egrave;.</td> </tr> <tr> <td><strong>СС</strong></td> <td><strong>С</strong></td> </tr> <tr> <td>scaduti, NPL 60&ndash;90</td> <td>scaduti, NPL 90&ndash;120</td> </tr> <tr> <td colspan="2">Prestiti con un livello di rischio aumentato. Tra i prestiti di questa categoria ci sono NPL 60, NPL90, NPL120 ed i prestiti in contenzioso che garantiscono il rendimento pi&ugrave; elevato tra tutte le categorie.</td> </tr> </tbody> </table> <p>Inoltre, i prestiti emessi sono ordinati in base alla strategia. Una volta al mese, il Comitato Rischi analizza e aggiorna il processo di assegnazione di una classificazione ai crediti.',
    HelperAnnualRateTitle: "Tasso d&rsquo;interesse annuale",
    HelperAnnualRateText:
      "Il tasso di redditivit&agrave; &egrave; stabilito e approvato mensilmente dal Comitato Rischi interno e dipende dai risultati del periodo in esame.",
    HelperStrategyClassicTitle: "Tasso d&rsquo;interesse annuale",
    HelperStrategyClassicText:
      "Il tasso di redditivit&agrave; &egrave; stabilito e approvato mensilmente dal Comitato Rischi interno e dipende dai risultati del periodo in esame.</p> <h2>Strategia Classica con garanzia di riacquisto&nbsp;(BuyBack)</h2> <p>Consente di investire in prestiti al consumo non garantiti, classificati come AA, A, BB, per i quali il rischio che il mutuatario sia insolvente &egrave; estremamente basso. Con la garanzia di riacquisto sei protetto dai rischi e ricevi un reddito garantito a un tasso di interesse fisso.</p> <p><strong>Rischi associati</strong></p> <p><strong>Rischio di insolvenza del prestito /&nbsp;violazione del piano di rientro /mancato rimborso dell&#39;intero importo del prestito&nbsp;</strong></p> <p>Questi rischi dell&#39;investitore sono coperti da una garanzia di riacquisto delle attivit&agrave; ricevute e degli interessi. Vediamo pi&ugrave; da vicino come funziona: l&#39;investitore della piattaforma Nibble scegliendo questa strategia investe in prestiti emessi dalle societ&agrave; del gruppo IT Smart Finance che sono disponibili il giorno stesso dell&#39;investimento. Le societ&agrave; della holding collocano il prestito emesso sulla piattaforma Nibble per trovare un investitore. Il rapporto tra le societ&agrave; del gruppo IT Smart Finance e il mutuatario finale &egrave; regolato da un contratto di prestito al consumo a breve termine con i conseguenti diritti di reclamo nei confronti del mutuatario. Sulla base del contratto di cessione concluso con l&#39;investitore, Nibble si assume l&#39;obbligo di ricevere i pagamenti dal mutuatario finale effettuati alle societ&agrave; del gruppo IT Smart Finance in conformit&agrave; con il contratto di prestito al consumo a breve termine e poi li versa all&#39;Investitore con le modalit&agrave; e l&#39;importo stabilito dal contratto di cessione. Se il mutuatario non rimborsa il prestito in tempo o ne prolunga il periodo, le societ&agrave; del gruppo IT Smart Finance&nbsp;riacquistano&nbsp;il diritto di reclamo dell&#39;investitore di Nibble nell&rsquo;importo totale dell&#39;investimento ed il reddito derivato dagli interessi garantiti sul prodotto stesso.",
    HelperStrategyBalancedTitle: "Strategia Equilibrata",
    HelperStrategyBalancedText:
      "Investi in prestiti al consumo classificati come BB, B e CC. Il grado di rischio per il mancato rimborso di un prestito con questa classificazione &egrave;, di regola, estremamente basso, tali prestiti classificati come NPL30 e NPL60, possono essere scaduti, ma quasi sempre finiscono per essere chiusi. Il rischio di insolvenza per questa strategia &egrave; basso, ma il rendimento &egrave; significativamente pi&ugrave; alto rispetto alla strategia&nbsp;con un reddito garantito a un tasso di interesse fisso.</p> <p><strong>Rischi associati</strong></p> <p><strong>Nessuna garanzia​</strong></p> <p>Gli investimenti nell&#39;ambito di questa strategia non sono protetti da una garanzia di riacquisto e non sono assicurati in alcun fondo statale, ovvero, in caso di insolvenza del prestito da parte del mutuatario, l&#39;investitore si assume il rischio di perdere il capitale investito o parte di esso.</p> <p><strong>Il rischio di realizzare un profitto a un tasso inferiore al previsto o nessun profitto​</strong></p> <p>Il profitto di questa strategia non &egrave; garantito da Nibble. L&#39;investitore acquista i diritti di reclamo nei confronti dei mutuatari finali e la ricezione degli interessi attivi dipende direttamente dall&#39;adempimento degli obblighi da parte dei mutuatari di rimborsare il prestito. Se il mutuatario non rimborsa il prestito in tutto o in parte, l&#39;investitore potrebbe non ricevere la componente di interesse del reddito oppure i termini per la restituzione dell&#39;importo investito e il reddito maturato aumenteranno.</p> <p>Il tasso di rendimento effettivo su questa strategia supera il tasso di rendimento massimo dichiarato del 13%. Eventuali proventi in eccesso non sono di propriet&agrave; della piattaforma Nibble e vengono reinvestiti per mitigare il rischio e raggiungere il tasso di rendimento dichiarato.",
    HelperStrategySpecialTitle: "Strategia Speciale",
    HelperStrategySpecialText:
      "Investi in prestiti al consumo non garantiti classificati come B, CC e C. In questa strategia, il rischio di insolvenza del prestito &egrave; maggiore rispetto alla strategia Equilibrata, ma allo stesso tempo lo &egrave; anche il rendimento fino al 19% annuo e non solo, compensa inoltre eventuali perdite all&#39;interno dell&#39;ammontare del portafoglio di investimento. Il periodo minimo di investimento di 12 mesi &egrave; giustificato dal fatto che questo portafoglio contiene prestiti per i quali potrebbe esserci un ritardo nel pagamento e la sua chiusura potrebbe richiedere un periodo pi&ugrave; lungo.</p> <p><strong>Rischi associati</strong></p> <p><strong>Nessuna garanzia​</strong></p> <p>Gli investimenti nell&#39;ambito di questa strategia non sono protetti da una garanzia di riacquisto e non sono assicurati in alcun fondo statale, ovvero, in caso di insolvenza del prestito da parte del mutuatario, l&#39;investitore si assume il rischio di perdere il capitale investito o parte di esso.</p> <p><strong>Il rischio di realizzare un profitto a un tasso inferiore al previsto o nessun profitto​</strong></p> <p>Il profitto di questa strategia non &egrave; garantito da Nibble. L&#39;investitore acquista i diritti di reclamo nei confronti dei mutuatari finali e la ricezione degli interessi attivi dipende direttamente dall&#39;adempimento degli obblighi da parte dei mutuatari di rimborsare il prestito. Se il mutuatario non rimborsa il prestito in tutto o in parte, l&#39;investitore potrebbe non ricevere la componente di interesse del reddito oppure i termini per la restituzione dell&#39;importo investito e il reddito maturato aumenteranno.</p> <p>Il tasso di rendimento effettivo su questa strategia supera il tasso di rendimento massimo dichiarato del 19%. Eventuali proventi in eccesso non sono di propriet&agrave; della piattaforma Nibble e vengono reinvestiti per mitigare il rischio e raggiungere il tasso di rendimento dichiarato.",

    IdentFailed: "Identificazione fallita",
    Identification: "Identificazione",
    IdentificationGoal1: "rispetto delle leggi dell'Unione Europea",
    IdentificationGoal2:
      "garanzia della sicurezza dei fondi e delle transazioni",
    IdentificationGoal3:
      "semplificazione dei processi aziendali, trasparenza ed efficienza",
    IdentificationGoalsTitle:
      "I nostri obiettivi comuni dell'identificazione dei dati personali:",
    IdentificationH1: "perché ti chiediamo di fornire foto dei documenti?",
    IdentificationLead:
      "Nibble aderisce rigorosamente alle norme del diritto europeo in materia di lotta contro il riciclaggio di denaro (AML), verifica della clientela, archiviazione e utilizzo dei dati personali.",
    IdentificationProfitsList:
      '<li class="veriffFeature-list__item">Gli investimenti sono disponibili solo per gli utenti verificati</li> <li class="veriffFeature-list__item">3. Non comunichiamo i tuoi dati personali a terze parti</li> <li class="veriffFeature-list__item">I tuoi dati vengono trasmessi attraverso un canale sicuro e archiviati in forma crittografata</li> <li class="veriffFeature-list__item">Siamo pienamente responsabili della sicurezza dei tuoi dati personali</li>',
    IdentityDocHint:
      "Per la verifica è possibile utilizzare sia la carta d'identità che la patente di guida. Se per identificarti usi una patente di guida, assicurati di fotografare e caricare entrambi i lati (fronte/retro) del documento.",
    IDHint:
      "Assicurati di aver indicato numero serie del documento selezionato.",
    ID: "ID",
    IDNumber: "Serie e numero del documento",
    Income: "Deposito",
    IncomeCalculation: "Accantonamento",
    IncomeReceived: "entrate ricevute",
    Individual: "Persona fisica",
    InitialDeposit: "deposito iniziale",
    InterestRate: "Tasso di interesse",
    InvalidFormat: "Formato non valido",
    Invest: "Investire",
    InvestedInPortfolio: "Investi nel portafoglio",
    InvestedLoans: "Prestiti investiti",
    Investing: "Investimento",
    InvestingIn: "Investire in [ID X]",
    Investment_amount: "Importo dell'investimento",
    Investment_date: "Data dell'investimento",
    Investment_type: "Tipo di investimento",
    InvestmentAmount: "importo dell'investimento",
    InvestmentPeriod: "Periodo di investimento, mesi",
    InvestmentPeriodDays: "Periodo di investimento, giorni",
    InvestmentPortfolios: "Portafogli di investimento",
    InvestmentsCountTotal: "Investiti in totale, quantità",
    InvestmentsSumTotal: "Investimenti totali",
    IHavePromoCode: "Ho un codice promozionale",

    InformationTitleSection1: "Investire con Nibble",
    InformationContentSection1: `
        <p>Ti offriamo tre strategie di investimento: Classica, Equilibrata e Legale. Differiscono tra loro non
        solo per
        il livello di redditivit&agrave; annuale, ma anche per il livello di rischio e per come questi rischi sono
        distribuiti tra la piattaforma finanziaria e l&#39;utente. Confronta le nostre strategie e scegli quella
        pi&ugrave; adatta a te.</p>
    <ul>
        <li>Anche se non hai esperienza nell&#39;investimento, prova a investire con rendimenti protetti. Ci assumiamo
            noi i rischi.</li>
        <li>Se sei gi&agrave; un investitore esperto, scegli una strategia comoda in termini di rapporto
            rischio-rendimento. Condivideremo i rischi con te.</li>
    </ul>
    <h3>Condiciones de las estrategias de inversi&oacute;n</h3>
    <div class="article-table">
        <table border="0" cellpadding="0" cellspacing="0">
            <tbody>
                <tr>
                    <td><strong>Strategia</strong></td>
                    <td><strong>Classica</strong></td>
                    <td><strong>Equilibrata</strong></td>
                    <td><strong>Legale</strong></td>
                </tr>
                <tr>
                    <td><strong>Tasso d&rsquo;interesse annuale​</strong></td>
                    <td>8%</td>
                    <td>12.5%</td>
                    <td>14.5%</td>
                </tr>
                <tr>
                    <td><strong>Note</strong></td>
                    <td>Redditivit&agrave; protetta</td>
                    <td>Rischi equilibrati</td>
                    <td>Rendimento elevato per investitori pazienti</td>
                </tr>
                <tr>
                    <td><strong>Descrizione</strong></td>
                    <td>La redditivit&agrave; di questa strategia &egrave; fissa, assistita da una garanzia di
                        riacquisto e ammonta al 8% annuo. Questa strategia garantisce l&#39;assenza di rischi e la
                        redditivit&agrave; &egrave; garantita.</td>
                    <td>La redditivit&agrave; non &egrave; fissa e, secondo le statistiche dei periodi precedenti,
                        pu&ograve; raggiungere il 12-15% annuo. La strategia pi&ugrave; equilibrata considerando il
                        &nbsp;rapporto rischio-rendimento.</td>
                    <td>
                        <p>É una strategia di investimento in portafogli costituiti da prestiti al consumo con
                            classificazione B, CC e C, che sono in fase di esibizione preliminare e giudiziaria. A causa
                            del fatto che questi prestiti hanno gli arretrati e le multe, il rendimento di questa
                            strategia raggiunge il 19% annuo.</p>
                        <p>Il periodo minimo di investimento di 6 mesi è dovuto al fatto che il processo legale e il
                            processo di esazione richiedono un lungo periodo di tempo.</p>
                    </td>
                </tr>
                <tr>
                    <td><strong>Periodo di investimento​</strong></td>
                    <td>1&ndash;6 mesi</td>
                    <td>7&ndash;60 mesi</td>
                    <td>6&ndash;60 mesi</td>
                </tr>
                <tr>
                    <td><strong>Garanzia di riacquisto (BuyBack)</strong></td>
                    <td><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOCAyTDcgMTNMMiA4IiBzdHJva2U9IiNCN0Q3NUQiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="
                            alt="check"></td>
                    <td>&mdash;</td>
                    <td>
                        <ul>
                            <li>Garanzia di restituzione del deposito</li>
                            <li>Redditività minima garantita del 8% annuo</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td><strong>Reinvestimento</strong></td>
                    <td colspan="2">reinvestimento automatico dei fondi investiti in nuovi prestiti</td>
                    <td>
                        <img src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNERTM1MEIiIGN4PSI4IiBjeT0iOCIgcj0iOCIvPjxwYXRoIGQ9Ik05LjQ4NSA4LjA3MWwyLjEyMiAyLjEyMWExIDEgMCAxIDEtMS40MTUgMS40MTVsLTIuMTItMi4xMjItMi4xMjIgMi4xMjJhMSAxIDAgMSAxLTEuNDE0LTEuNDE1bDIuMTItMi4xMi0yLjEyLTIuMTIyQTEgMSAwIDEgMSA1Ljk1IDQuNTM2bDIuMTIxIDIuMTIgMi4xMjEtMi4xMmExIDEgMCAxIDEgMS40MTUgMS40MTRMOS40ODUgOC4wN3oiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+'/>
                    </td>
                </tr>
                <tr>
                    <td><strong>Maturazione e trasferimento di interessi</strong></td>
                    <td colspan="2">gli interessi maturano giornalmente e vengono trasferiti settimanalmente sul conto
                        Nibble dell&#39;investitore</td>
                    <td>
                        Maturazione giornaliera degli interessi al tasso dell'8% annuo, pagamenti ogni 90 giorni in base
                        al rendimento effettivamente ricevuto fino al 14,5% annuo.
                    </td>
                </tr>
                <tr>
                    <td><strong>Classificazione dei prestiti per rischio di insolvenza (NPL)​</strong></td>
                    <td>АА&ndash;А&ndash;ВВ</td>
                    <td>ВВ&ndash;В&ndash;СС</td>
                    <td>В&ndash;СС&ndash;С</td>
                </tr>
                <tr>
                    <td><strong>Tasso di default previsto​</strong></td>
                    <td>&mdash;</td>
                    <td>fino a NPL 30</td>
                    <td>NPL 30&ndash;90</td>
                </tr>
                <tr>
                    <td><strong>Importo dell&#39;investimento&nbsp;​ **</strong></td>
                    <td>10&ndash;10 000 &euro;</td>
                    <td>100&ndash;10 000 &euro;</td>
                    <td>10&ndash;10 000 &euro;</td>
                </tr>
                <tr>
                    <td><strong>Min. importo del prelievo​</strong></td>
                    <td colspan="3">50 &euro;</td>
                </tr>
            </tbody>
        </table>
    </div>
    <p><small>*&nbsp;Il tasso di redditivit&agrave; &egrave; stabilito e approvato mensilmente dal Comitato Rischi
            interno e dipende dai risultati del periodo in esame.<br /> **&nbsp;Se vuoi investire oltre 15.000 &euro;,
            ti chiederemo di fornire un pacchetto di documenti aggiuntivo.</small></p>
    <h3>Strategia Classica con garanzia di riacquisto&nbsp;(BuyBack)</h3>
    <p>Consente di investire in prestiti al consumo non garantiti, classificati come AA, A, BB, per i quali il rischio
        che il mutuatario sia insolvente &egrave; estremamente basso. Con la garanzia di riacquisto sei protetto dai
        rischi e ricevi un reddito garantito a un tasso di interesse fisso.</p>
    <p><strong>Rischi associati</strong></p>
    <p><strong>Rischio di insolvenza del prestito /&nbsp;violazione del piano di rientro /mancato rimborso
            dell&#39;intero importo del prestito&nbsp;</strong></p>
    <p>Questi rischi dell&#39;investitore sono coperti da una garanzia di riacquisto delle attivit&agrave; ricevute e
        degli interessi. Vediamo pi&ugrave; da vicino come funziona: l&#39;investitore della piattaforma Nibble
        scegliendo questa strategia investe in prestiti emessi dalle societ&agrave; del gruppo IT Smart Finance che sono
        disponibili il giorno stesso dell&#39;investimento. Le societ&agrave; della holding collocano il prestito emesso
        sulla piattaforma Nibble per trovare un investitore. Il rapporto tra le societ&agrave; del gruppo IT Smart
        Finance e il mutuatario finale &egrave; regolato da un contratto di prestito al consumo a breve termine con i
        conseguenti diritti di reclamo nei confronti del mutuatario. Sulla base del contratto di cessione concluso con
        l&#39;investitore, Nibble si assume l&#39;obbligo di ricevere i pagamenti dal mutuatario finale effettuati alle
        societ&agrave; del gruppo IT Smart Finance in conformit&agrave; con il contratto di prestito al consumo a breve
        termine e poi li versa all&#39;Investitore con le modalit&agrave; e l&#39;importo stabilito dal contratto di
        cessione. Se il mutuatario non rimborsa il prestito in tempo o ne prolunga il periodo, le societ&agrave; del
        gruppo IT Smart Finance&nbsp;riacquistano&nbsp;il diritto di reclamo dell&#39;investitore di Nibble
        nell&rsquo;importo totale dell&#39;investimento ed il reddito derivato dagli interessi garantiti sul prodotto
        stesso.</p>
    <h3>Strategia Equilibrata</h3>
    <p>Investi in prestiti al consumo classificati come BB, B e CC. Il grado di rischio per il mancato rimborso di un
        prestito con questa classificazione &egrave;, di regola, estremamente basso, tali prestiti classificati come
        NPL30 e NPL60, possono essere scaduti, ma quasi sempre finiscono per essere chiusi. Il rischio di insolvenza per
        questa strategia &egrave; basso, ma il rendimento &egrave; significativamente pi&ugrave; alto rispetto alla
        strategia&nbsp;con un reddito garantito a un tasso di interesse fisso.</p>
    <p><strong>Rischi associati</strong></p>
    <p><strong>Nessuna garanzia​</strong></p>
    <p>Gli investimenti nell&#39;ambito di questa strategia non sono protetti da una garanzia di riacquisto e non sono
        assicurati in alcun fondo statale, ovvero, in caso di insolvenza del prestito da parte del mutuatario,
        l&#39;investitore si assume il rischio di perdere il capitale investito o parte di esso.</p>
    <p><strong>Il rischio di realizzare un profitto a un tasso inferiore al previsto o nessun profitto​</strong></p>
    <p>Il profitto di questa strategia non &egrave; garantito da Nibble. L&#39;investitore acquista i diritti di reclamo
        nei confronti dei mutuatari finali e la ricezione degli interessi attivi dipende direttamente
        dall&#39;adempimento degli obblighi da parte dei mutuatari di rimborsare il prestito. Se il mutuatario non
        rimborsa il prestito in tutto o in parte, l&#39;investitore potrebbe non ricevere la componente di interesse del
        reddito oppure i termini per la restituzione dell&#39;importo investito e il reddito maturato aumenteranno.</p>
    <p>Il tasso di rendimento effettivo su questa strategia supera il tasso di rendimento massimo dichiarato del 15%.
        Eventuali proventi in eccesso non sono di propriet&agrave; della piattaforma Nibble e vengono reinvestiti per
        mitigare il rischio e raggiungere il tasso di rendimento dichiarato.</p>

    <h3>Strategia Legale</h3>
    <p>É una strategia di investimento in portafogli costituiti da prestiti al consumo con classificazione B, CC e C,
        che sono in fase di esibizione preliminare e giudiziaria. A causa del fatto che questi prestiti hanno gli
        arretrati e le multe, il rendimento di questa strategia raggiunge il 19% annuo.</p>
    <p>l periodo minimo di investimento di 6 mesi è dovuto al fatto che il processo legale e il processo di esazione
        richiedono un lungo periodo di tempo. Tutto il processo legale e processo dell'esazione sono forniti dalla
        società Boostr.</p>
    <p><strong>Rischi associati</strong></p>
    <p><strong>Rischio di insolvenza del prestito / violazione del piano di rientro /mancato rimborso dell'intero
            importo del prestito​</strong></p>
    <p>
    <ul>
        <li>La strategia è assicurata dalla garanzia di restituzione del deposito - è l'obbligo delle agenzie di
            recupero creditidi restituire l’importo dell’investimento in pieno alla fine del periodo di investimento e
            di garantire una redditività annua minima del 8%.</li>
        <li>A causa di investimenti in un portafoglio costituito da un gran numero di prestiti, il rischio di mancato
            ricevimento del reddito da diversi contratti è ridotto, si sovrappongono dagli altri prestiti.</li>
        <li>Maturazione giornaliera degli interessi al tasso dell'8% annuo, pagamenti ogni 90 giorni in base al
            rendimento effettivamente ricevuto fino al 14,5% annuo.</li>
        <li>Mentre i soldi sono raccolti per l'acquisto di un portafoglio, noi maturiamo un reddito di 8% annuo, questo
            è il tuo rendimento bonus con quello principale fino al 14,5%. Il periodo massimo di una raccolta dei soldi
            per l'acquisto di un portafoglio è di 30 giorni.</li>
    </ul>
    </p>
    <p><strong>Come funziona?​</strong></p>
    <p>Ogni giorno ti viene maturato un tasso di interesse dell'8% annuo. Ogni 90 giorni calcoliamo automaticamente il
        rendimento effettivo dei portafogli e ti maturiamo la differenza tra il tasso garantito dell'8% e il tasso
        effettivo. In questo modo, ogni 90 giorni ti ottieni un reddito compreso tra l'8% e il 14,5% sul tuo conto
        Nibble.</p>
    <p>Per esempio: dopo aver investito 1000 euro per 12 mesi, alla fine del periodo di investimento ti ottieni indietro
        tutto il capitale di 1000 euro e il reddito da 90 a 145 euro, che ti paghiamo ogni 90 giorni.</p>
        `,
    InformationTitleSection2:
      "Classificazione dei prestiti per rischio di insolvenza: NPL 30, 60, 90, 120+",
    InformationContentSection2:
      '<p>Le societ&agrave; della holding IT Smart Finance utilizzano modelli di punteggio per determinare la qualit&agrave; dei mutuatari. A tutti i prestiti approvati viene assegnata una classificazione personalizzata.</p> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>AA</strong></td> <td><strong>A</strong></td> <td><strong>ВВ</strong></td> <td><strong>В</strong></td> <td><strong>СС</strong></td> <td><strong>С</strong></td> </tr> <tr> <td>rimborsati in data stabilita</td> <td>rimborsati prima del previsto</td> <td>scaduti, NPL 0-30</td> <td>scaduti, NPL 30&ndash;60</td> <td>scaduti, NPL 60&ndash;90</td> <td>scaduti, NPL 90&ndash;120</td> </tr> <tr> <td colspan="2">Prestiti a basso rischio. I clienti di questa categoria, di solito, restituiscono il denaro in tempo o prima del previsto, quindi la redditivit&agrave; su di essi &egrave; bassa e di conseguenza anche i rischi lo sono.</td> <td colspan="2">Prestiti a medio rischio. I clienti di questa categoria possono essere in ritardo nei pagamenti (NPL30 e NPL60), ma quasi sempre finiscono per rimborsare i prestiti. Il rischio di insolvenza per questa categoria &egrave; maggiore, e di conseguenza anche il reddito medio lo &egrave;.</td> <td colspan="2">Prestiti con un livello di rischio aumentato. Tra i prestiti di questa categoria ci sono NPL 60, NPL90, NPL120 ed i prestiti in contenzioso che garantiscono il rendimento pi&ugrave; elevato tra tutte le categorie.</td> </tr> </tbody> </table> </div> <p>Inoltre, i prestiti emessi sono ordinati in base alla strategia. Una volta al mese, il Comitato Rischi analizza e aggiorna il processo di assegnazione di una classificazione ai crediti.</p> <h3>Il prodotto Investimento flessibile fornisce tre differenti strategie di investimento</h3> <div class="article-table"> <table border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td><strong>АА</strong></td> <td><strong>A</strong></td> <td colspan="1"><strong>ВВ</strong></td> <td colspan="1"><strong>В</strong></td> <td colspan="1"><strong>СС</strong></td> <td colspan="1"><strong>С</strong></td> </tr> <tr> <td colspan="3"><strong>Strategia Classica​</strong></td> <td colspan="3" rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">65%</td> <td colspan="1">25%</td> <td colspan="1">10%</td> </tr> <tr> <td colspan="2" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Strategia Equilibrata</strong></td> <td rowspan="2">&nbsp;</td> </tr> <tr> <td colspan="1">63%</td> <td colspan="1">32%</td> <td colspan="1">5%</td> </tr> <tr> <td colspan="3" rowspan="2">&nbsp;</td> <td colspan="3"><strong>Strategia Legale​</strong></td> </tr> <tr> <td colspan="1">54%</td> <td colspan="1">28%</td> <td colspan="1">18%</td> </tr> </tbody> </table> </div> <p>Ogni strategia seleziona automaticamente i prestiti in base alla classificazione appropriata. Ognuna di esse pu&ograve; includere fino a 3 tipologie di NPL che consentono di ricevere il reddito dichiarato inizialmente e garantire i corrispondenti requisiti di rischio.</p>',
    InformationTitleSection3: "Prelevare fondi da un conto",
    InformationContentSection3: `<p>Il prelievo di fondi non investiti e redditi ricevuti dopo la scadenza del portafoglio di investimento viene effettuato sul conto bancario dell&#39;investitore tramite il conto personale su Nibble.</p> 
      <ul> 
      <li>L&#39;importo minimo del prelievo &egrave; di 50 &euro;.</li> 
      <li>Nibble trasferisce denaro solo sul conto di propriet&agrave; dell&#39;investitore. Questa &egrave; una misura necessaria che protegge i nostri investitori e previene il riciclaggio di denaro illegale.</li> 
      <li>&Egrave; possibile modificare il numero di conto contattando il nostro servizio di supporto. In questo caso il nostro ispettore AML ti chieder&agrave; di fornire documenti aggiuntivi.</li> 
      </ul> 
      <h3>Risoluzione anticipata del contratto di investimento e ritiro dei fondi</h3> 
      <p>Puoi terminare anticipatamente il contratto di investimento e prelevare fondi dalla piattaforma Nibble. Per fare ci&ograve;, &egrave; necessario presentare una domanda per la risoluzione anticipata del contratto tramite il conto personale su Nibble. Dopo aver ricevuto la tua richiesta, inizieremo a cercare un investitore per il tuo portafoglio. Il portafoglio pu&ograve; essere rivenduto solo nella sua interezza. Se non troviamo un investitore entro 60 giorni di calendario dalla ricezione della richiesta di risoluzione del contratto, il sessantunesimo giorni ti pagheremo l&#39;importo delle attivit&agrave; investite e gli interessi corrispondenti con il fondo di riserva della societ&agrave;, trattenendo una commissione dell&#39;3% dell&#39;importo totale pagabile.</p>`,
    InformationTitleSection4: "Politica di riacquisto",
    InformationContentSection4: `
        <p>Per garantire il ritorno dei fondi nella strategia Classica, il prestatore fornisce una garanzia di riacquisto:
        questo &egrave; l&#39;obbligo del prestatore di riacquistare il prestito dalldall&#39;investitore se il prestito
        non &egrave; stato rimborsato entro 60 giorni dalla data delldall&#39;investimento.</p>
    <p>In questo caso, insieme al costo iniziale del prestito, il creditore pagher&agrave; gli interessi dovuti
        all&#39;investitore. I fondi per garantire questi obblighi vengono accumulati nel fondo di riserva della
        societ&agrave;.</p>
    <h3>Come funziona la politica di riacquisto:</h3>
    <ul>
        <li>Gli investitori che scelgono la strategia Classica investono in prestiti emessi dalle società del gruppo IT
            Smart Finance.</li>
        <li>Le societ&agrave; della holding collocano i prestiti emessi sulla piattaforma Nibble per trovare
            investitori.</li>
        <li>Il rapporto tra le societ&agrave; del gruppo IT Smart Finance e il mutuatario &egrave; ben regolato da un
            contratto di prestito al consumo a breve termine con i diritti di reclamo nei confronti del mutuatario.</li>
        <li>Sulla base del&nbsp;contratto&nbsp;di cessione siglato con l&#39;investitore, Nibble si assume i seguenti
            obblighi: <ol>
                <li>accettare pagamenti dal mutuatario finale in conformit&agrave; con il contratto di prestito al
                    consumo a breve termine</li>
                <li>pagarli all&#39;investitore secondo le modalit&agrave; e l&#39;importo stabiliti dal contratto di
                    cessione.</li>
            </ol>
        </li>
        <li>Se il mutuatario non rimborsa il prestito in tempo o estende il periodo di rimborso del prestito, le
            societ&agrave; del gruppo IT Smart Finance riacquistano il diritto di&nbsp;reclamodell&#39;investitore di
            Nibble nell&rsquo;importo totale dell&#39;investimento ed il reddito derivato dagli interessi garantiti
            sul&nbsp;prestito.</li>
    </ul>
    <p>
        <h3>
            Strategia Legale
        </h3>
    </p>
    <p>
        La strategia è assicurata dalla garanzia di restituzione del deposito - è l'obbligo delle agenzie di recupero
        creditidi restituire l’importo dell’investimento in pieno alla fine del periodo di investimento e di garantire
        una redditività annua minima del 8%.
    </p>
    <p>
        <strong>
            Come funziona?
        </strong>
    </p>
    <p>Ogni giorno ti viene maturato un tasso di interesse dell'8% annuo. Ogni 90 giorni calcoliamo automaticamente il
        rendimento effettivo dei portafogli e ti maturiamo la differenza tra il tasso garantito dell'8% e il tasso
        effettivo. In questo modo, ogni 90 giorni ti ottieni un reddito compreso tra l'8% e il 14,5% sul tuo conto
        Nibble.</p>
    <p>Per esempio: dopo aver investito 1000 euro per 12 mesi, alla fine del periodo di investimento ti ottieni indietro
        tutto il capitale di 1000 euro e il reddito da 90 a 145 euro, che ti paghiamo ogni 90 giorni.</p>
        `,
    InformationTitleSection5: "Politica generale sui rischi",
    InformationContentSection5:
      "<p>I rischi vengono ripartiti tra l&#39;investitore e le organizzazioni di microfinanza come segue:</p> <ul> <li>Se la strategia offre una garanzia di riacquisto, il rischio di insolvenza &egrave; a carico dell&#39; organizzazioni di microfinanza a spese del fondo di riserva</li> <li>Se la strategia non prevede una garanzia di riacquisto, il rischio di insolvenza &egrave; condiviso tra l&#39;investitore e l&#39;organizzazione di microfinanza ed &egrave; espresso sotto forma di tasso di interesse variabile</li> <li>Il rischio di variazione dei tassi di cambio nelle strategie attuali &egrave; assunto dall&#39;organizzazione di microfinanza</li> </ul>",
    InformationTitleSection6: "Comitato Rischi",
    InformationContentSection6:
      "<p>Per determinare il tasso di interesse corrente per le strategie Equilibrata e Speciale, il Comitato Rischi si riunisce alla fine di ogni mese.</p> <h3>Il Comitato Rischi comprende i responsabili delle seguenti divisioni del gruppo IT Smart Finance:</h3> <ul> <li>Direttore di rischio</li> <li>Direttore operativo</li> <li>Responsabile del Dipartimento Recupero Crediti</li> <li>Responsabile del Dipartimento di Underwriting</li> <li>Analista di rischio</li> </ul> <h3>I principali compiti del Comitato:</h3> <ul> <li>Considerazione e analisi dei risultati&nbsp;del lavoro svolto&nbsp;sui NPL 30-60-90-120 per il mese di rendicontazione.</li> <li>Riconciliazione periodica tra obiettivi effettivi e quelli pianificati.</li> <li>Analisi del modello di punteggio.</li> <li>Previsione per il periodo successivo e calibrazione del modello di punteggio.</li> <li>Formazione e approvazione dell&#39;attuale tasso di rendimento annuo per le strategie Equilibrata e Speciale.</li> </ul> <p>I risultati della riunione del Comitato Rischi sono pubblicati sotto forma di relazione sul sito web.</p>",
    InformationTitleSection7: "Creazione di un fondo di riserva",
    InformationContentSection7:
      "<p>Il fondo di riserva &egrave; un addizionale &laquo;cuscino di sicurezza&raquo; per l&#39;investitore, che copre i rischi di mancato pagamento del prestito da parte del mutuatario finale. Grazie al fondo di riserva offriamo agli investitori una strategia di investimento con garanzia di riacquisto</p>",
    InformationTitleSection8: "Garanzia di sicurezza e privacy",
    InformationContentSection8:
      '<p>Diamo priorit&agrave; alla protezione dei tuoi dati personali e alla sicurezza delle tue transazioni. Ecco alcune garanzie che queste priorit&agrave; sono importanti:</p> <h3>Garanzie di sicurezza</h3> <ul> <li>I dati vengono archiviati in conformit&agrave; con lo standard di sicurezza ISO 27001: 2013</li> <li>Tutte le password sono memorizzate nel sistema in un formato sicuro</li> <li>Il conto bancario &egrave; collegato all&#39;account utente al momento del primo deposito dei fondi e non pu&ograve; essere modificato senza l&#39;identificazione manuale dell&#39;investitore</li> <li>In conformit&agrave; con le leggi dell&#39;Unione Europea, siamo obbligati a effettuare la&nbsp; verifica della clientela e l&#39;identificazione del cliente. A tal fine Nibble ha un contratto di servizi con l&rsquo;azienda &laquo;Veriff&raquo;.&nbsp; Puoi conoscere la loro politica sulla privacy tramite questo link:&nbsp;<a href="https://www.veriff.com/privacy-policy">https://www.veriff.com/privacy-policy</a></li> </ul> <h3>Garanzie sulla privacy</h3> <ul> <li>La piattaforma Nibble ottempera al trattamento dei dati personali in conformit&agrave; con le leggi dell&#39;Unione Europea</li> <li>I dati degli investitori non vengono concessi in nessun modo a terzi</li> </ul> <h3>Garanzie Finanziarie</h3> <ul> <li>Tutti gli investimenti sono attratti da un gruppo di societ&agrave; appartenenti alla&nbsp;<a href="https://itsmartfinance.com/">IT Smart Finance</a></li> <li>La strategia Classica prevede una garanzia di riacquisto dal fondo di riserva</li> <li>La piattaforma di investimento Nibble fa parte della holding IT Smart Finance che riunisce istituti di credito in Eurasia, Europa e America Latina</li> </ul>',

    JoymoneyInfo:
      "Joymoney ES concede prestiti per un massimo di 30 giorni in Spagna. Tutti i prestiti sono protetti da una garanzia di riacquisto: se il prestito non è stato estinto entro 60 giorni dalla data dell'investimento, Joymoney ES riscatta la quota dell'investitore insieme agli interessi maturati.",
    Last: "Ultima",
    Later: "più tardi.",
    Legal: "Persona giuridica",
    literal_bread_reg: "Iscrizione",
    LittleBitLeft: "Solo un po'di più.",
    LoanType: "tipo di prestito",
    LoginBtn: "Accedi",
    LoginHead: "Accesso all'area personale",
    LongTerm: "Lungo termine",
    LongTermInvestmensInfo:
      "Gli investimenti a lungo termine consentono di ottenere il massimo rendimento grazie ad un lungo periodo di reinvestimento, infatti la somma dei prestiti estinti viene reinvestita nuovamente (completamente o solo l'importo principale del debito, a seconda delle impostazioni).",
    LongTermPortfolio: "Portafoglio a lungo termine",
    LowBalanceAlert:
      "Non ci sono fondi sufficienti sul tuo bilancio per creare un portafoglio con i parametri selezionati",
    MessageWithdrawalSuccess:
      "Richiesta ricevuta. I fondi saranno prelevati entro 5-7 giorni lavorativi.",
    // ResultPaymentSuccessTitle: "The balance has been successfully replenished!",
    MonthlyDeposit: "Deposito mensile",
    MonthlyDepositInfo:
      "La ricarica mensile è disponibile per i portafogli con una durata a partire da 4 mesi",
    MonthlyDepositInfo1:
      "Puoi ricaricare il portafoglio entro e non oltre 3 mesi prima della scadenza del portafoglio",
    MonthlyReport: "Rapporto mensile",
    Months: "mesi",
    MrLabel: "Signore",
    MsLabel: "Signora",
    MyAccount: "Il mio account",
    MyInvestments: "I miei investimenti",
    NameChangeWarning:
      "Puoi cambiare il tuo nome e cognome prima della verifica Veriff.",
    NeedToVerifyBySMS:
      "Il telefono specificato dovrà essere confermato tramite SMS",
    NewPassDlina: "La nuova password contiene meno di 5 caratteri",
    NewPassword: "Nuova password",
    NewPasswordInfo:
      "Crea una password complessa. Si consiglia di aggiungere simboli, numeri e lettere maiuscole alla password.",
    NewPasswordSent: "Una nuova password è stata inviata alla tua email.",
    NewRepeatPasChange: "Le password non corrispondono",
    News: "Notizie",
    NewsletterCheckboxLabel: "Ricevi la newsletter giornaliera",
    Next: "Continuare",
    Next1: "Successiva",
    NibbleAgreement: "Accordo con Nibble",
    No: "No",
    Notifications: "Notifiche",
    NotLimited: "senza limiti",
    OnlyActive: "Solo attivi",
    Opened: "Aperto",
    Operation: "Operazione",
    OperationDate: "Data dell'operazione",
    OutputFail: "Impossibile prelevare l'importo specificato",
    Page: "Pagina",
    PageNotExist:
      "Siamo spiacenti, la pagina da te richiesta non è stata trovata.",
    PageNotFound: "Pagina non trovata",
    Partial: "Parziale",
    PartnerCode: "Condividi il codice promozionale",
    PartnerCodeSet: "Codice promozionale per invitare",
    PartnerFaq:
      '<h2 class="title faq__title">Hai altre domande?</h2> <div class="box faq-wrapper"> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text"> Per quanto è valido un codice promozionale oppure il link di riferimento?</span> <p class="faq-answer__text">Il codice / link promozionale non ha data di scadenza.</p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Quando uno dei miei amici investe OLTRE 1000 euro, non riceverò una ricompensa?</span> <p class="faq-answer__text">In tal caso, la ricompensa sarà il 2% di 1000 euro..</p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Quale sarà la mia ricompensa se un mio amico investe MENO di mille euro?</span> <p class="faq-answer__text"> Se il tuo amico effettua un investimento MINORE di 1000 euro, riceverete entrambi una ricompensa del 2% dell\'importo dell\'investimento. </p> </div> <!-- Вопрос-ответ--> <div class="faq-block"> <span class="faq-quest__text">Quanti amici posso invitare usando un codice promozionale o un link di riferimento?</span> <p class="faq-answer__text">Puoi invitare tutti gli amici che vuoi usando un codice o un link promozionale, non c’è limite. </p> </div> </div>',
    PartnerInfo:
      '<h1 class="title partner__title">Racconta ai tuoi amici della nostra piattaforma e ricevi un premio</h1> <span class="partner__subtitle">Per te e i tuoi amici</span> <ul class="partner-list"> <li class="partner-item"> <h2 class="partner-item__title">Racconta ai tuoi amici di Nibble</h2> <p class="partner-item__description">Puoi condividere con gli amici il tuo link di riferimento o inviargli un codice promozionale</p> </li> <li class="partner-item"> <h2 class="partner-item__title">Iscrizione</h2> <p class="partner-item__description">I tuoi amici si iscrivono a Nibble tramite il link di riferimento o con il codice promozionale </p> </li> <li class="partner-item"> <h2 class="partner-item__title">Ottieni la ricompensa</h2> <p class="partner-item__description">Il tuo amico e tu riceverete il 2% su ogni investimento effettuato dal tuo amico per un importo fino a 1000 euro.. </p> </li> </ul>',
    PartnerLinkSet: "Link invito",
    PartnerLinkSocial: "Condividi il link sui social",
    PartnerTitle:
      "Racconta ai tuoi amici della nostra piattaforma e ricevi un premio",
    PartnerTitleStep1: "Racconta ai tuoi amici di Nibble",
    PartnerTextStep1:
      "Puoi condividere con gli amici il tuo link di riferimento o inviargli un codice promozionale",
    PartnerTitleStep2: "Iscrizione",
    PartnerTextStep2:
      "I tuoi amici si iscrivono a Nibble tramite il link di riferimento o con il codice promozionale",
    PartnerTitleStep3: "Ottieni la ricompensa",
    PartnerTextStep3:
      "Il tuo amico e tu  riceverete il 2% su ogni investimento effettuato dal tuo amico per un importo fino a 1000 euro",
    PartnerTransaction: "transazioni",
    PartnerTransactionIncome: "Accreditato",
    Password: "Password",
    PasswordChange: "Reimposta la password",
    PasswordChanged: "Password modificata",
    PasswordSentMessage: "La password è stata inviata al tuo telefono",
    PasswordsMakeSure: "Assicurati che le password corrispondano",
    PaymentOnformation: "Informazioni di fatturazione",
    PaymentPurposeInfo:
      "Trasferisci fondi sul conto bancario indicato. Assicurati di copiare la descrizione della transazione.",
    PeriodInvest: "Periodo di investimento",
    PersonalData: "Dati personali",
    PersonalDataChangeInfo:
      "Per modificare le informazioni personali, si prega di contattare l'assistenza",
    PersonalID: "ID personale",
    PersonalInfo: "Informazioni personali",
    PersonLastName: "Cognome",
    PersonName: "Nome",
    Persons: "persone",
    Phone: "Numero di contatto telefonico",
    Phone1: "Il tuo telefono",
    PhoneAlreadyReg: "Numero di telefono già registrato",
    PhoneChangeInfo:
      "Per modificare il numero di telefono di contatto, contattare l'assistenza",
    PhoneConfirm: "Numero di telefono verificato",
    PhoneNotConfirm: "Numero di telefono non verificato",
    PhoneNotValid: "Formato del numero di telefono non corretto",
    PhoneVerification: "Verifica numero telefonico",
    PlacehoderBirthDate: "gg.mm.aaaa",
    PolicyAgreement:
      'Consenso al <a href="/policy_privacy.aspx"> Trattamento dei dati personali',
    PolicyAgreement1:
      'Consenso al <a href="/policy_privacy.aspx"> Trattamento dei dati personali',
    PortfolioConfirmText:
      "Ora creeremo un portafoglio con i parametri specificati",
    PortfolioCreated: "Il portafoglio è pronto",
    PortfolioCreation: "Creazione del portafoglio",
    PortfolioID: "Portafoglio",
    PortfolioIncome: "Proventi nel portfolio",
    PortfolioParams: "Parametri di portafoglio",
    PortfolioReplenishment: "Ricarica del portafoglio[ID X]",
    PortfolioReplenishmentOperation: "Ricarica del portafoglio",
    PotentialProfit: "il tuo possibile guadagno",
    Precalculation: "Calcolo preliminare del rendimento",
    Precalculation1: "Calcolo preliminare della redditività",
    PrefferedLanguage: "Lingua preferita",
    Previous: "Precedente",
    ProductDescription: "Descrizione del prodotto",
    ProfitCalc: "Calcolo della redditività",
    ProgressCompleteInfoDesc:
      "Resta da specificare alcuni dettagli nelle impostazioni del tuo profilo personale.",
    ProgressCompleteInfoStep: "Aggiungi informazioni",
    ProgressCompleteInfoTitle: "Il tuo account è attivato ...",
    ProgressConfirmEmailDesc:
      "Conferma la tua email e attiva il tuo account. Per fare ciò, segui il link nella lettera che ti abbiamo inviato. Inviare un nuovo link di attivazione",
    ProgressConfirmEmailStep: "Conferma email",
    ProgressIdentifyDesc:
      "Esegui l'identificazione personale attraverso Veriff per depositare i fondi e iniziare a investire",
    ProgressIdentifyStep: "Verifica dell’identità",
    ProgressIdentifyTitle: "L'ultimo e più importante passo ...",
    PromoCode: "Codice promozionale",
    PropsContractsDocs: "Dettagli",
    ProvideSMSCode: "Inserisci il codice di verifica dall'SMS",
    PurposeOfPayment: "Motivo del pagamento",
    Rate: "Tasso d'interesse",
    ReceivingIncomeBy: "Entrate di [ID X]",
    Referals: "Affiliati",
    ReferralTitle: 'remunerazione del programma "porta un amico"',
    RefillFromCard: "Deposito con la carta VISA / MC",
    RefillHistory: "Cronologia di ricariche",
    RefillTheAccount:
      "Ricarica l'account in qualsiasi modo conveniente per iniziare a investire con Nibble.",
    RefillWithCard: "Deposito con la carta",
    Registrations: "Iscrizioni",
    RegreshPage: "ad aggiornare la pagina",
    ReinvestIncome: "Reinvestire i profitti",
    Reinvestment: "Reinvestimento",
    RepeatPassword: "Conferma password",
    Replenishment: "Ricarica del portafoglio, mensile",
    Replenishments: "Ricariche",
    RestorePassword: "La nuova password è stata inviata al tuo telefono",
    RestorePasswordEmail:
      "Se l'indirizzo è valido, è stato inviato un messaggio",
    ReturnDate: "Data di ritorno",
    ReturnMainPage: "Torna alla pagina iniziale",
    RevenueFromRegistrationsAndRenewals: "Redditi da iscrizioni e ricariche",
    Risks: "Rischi",
    Save: "Salva le modifiche",
    ScanHint:
      "Carica una scansione o la foto del passaporto o della patente di guida. Carica delle immagini leggibili e dettagliate dei documenti. Non ritagliare o nascondere in alcun modo qualsiasi informazione presente sul documento.",
    Selfie: "Autoritratto",
    SelfieHint:
      "La foto del viso deve essere simile a quella del tuo passaporto, senza riflessi e distorsioni.",
    SendMessageBtn: "Invia messagio",
    SendRequest: "Invia richiesta",
    SEPAInfo: "Il deposito di fondi è disponibile solo per i residenti SEPA.",
    ServiceUnavailable: "Il servizio è temporaneamente non disponibile",
    Settings: "Impostazioni",
    ShareLink: "Condividi il link",
    ShowAllLoans: "Mostra tutti i prestiti",
    SkipIdentification: "Precedente",
    SmsCode: "Codice SMS",
    SmsCodeIsSent:
      "Abbiamo inviato un SMS con un codice di conferma al numero del telefono",
    Sortby: "Ordina per:",
    SortbyIncome: "[per] reddito atteso",
    SortbyOpened: "[per] data di apertura",
    SortbyOperationDate: "[per] data dell'operazione",
    SortbyReturnDate: "[per] data di ritorno",
    SortbySum: "[per] importo",
    StartDeposit: "Importo iniziale",
    Stats: "Statistiche",
    Status: "Stato",
    STATUS_001: "Estinto",
    STATUS_002: "Attivo",
    STATUS_003: "Scaduto",
    STATUS_004: "Eseguito",
    STATUS_005: "Programatto",
    STATUS_006: "Rifiutato",
    StatusCanceled: "Annullato",
    StatusCompleted: "Completato",
    StatusInprocess: "In corso",
    Step1: "Primo passo",
    Step2: "Secondo passo",
    StrategyBalancedDescription:
      "La redditività non è fissa e, secondo le statistiche dei periodi precedenti, può raggiungere il 12-15% annuo. La strategia più equilibrata considerando il rapporto rischio-rendimento",
    StrategyBalancedTitle: "Strategia Equilibrata",
    StrategyClassicDescription:
      "La redditività di questa strategia è fissa, assistita da una garanzia di riacquisto e ammonta al 8% annuo. Questa strategia garantisce l'assenza di rischi e la redditività è garantita",
    StrategyClassicTitle: "Strategia Classica",
    StrategyDescription:
      "Scegli una strategia di investimento in base alle tue preferenze in termini di redditività e rischio. <br> Crea un portafoglio di investimenti in tre passi.",
    StrategySpecialDescription:
      "La redditività non è fissa e può raggiungere il 17–19% annuo. I rischi di investimento sono più elevati, ma allo stesso tempo la redditività consente di compensare le perdite all'interno dell'importo totale del portafoglio di investimenti",
    StrategySpecialTitle: "Strategia Speciale",
    StrategyStep1: "Passo 1: Scegli una strategia",
    StrategyStep2: "Passo 2: Imposta i parametri di investimento",
    StrategyStep3: "Passo 3: Crea un portafoglio",
    StrategyTitle: "Investimento flessibile",
    InviteFriends: "Invita gli amici",
    OtherStrategy: `Classica / Equilibrata strategia`,
    LegalStrategy: `Legale strategia`,
    String: "Indirizzo legale",
    String1: "Indirizzo di supporto e back office",
    SuccessfullySaved: "Le tue impostazioni sono state salvate con successo",
    Sum: "Quantità",
    SumAmount: "Importo della ricarica",
    Support: "Supporto",
    SupportMessageSentMessage:
      "Il tuo messaggio è stato consegnato agli operatori. Il primo operatore disponibile ti risponderà al più presto",
    SupportTextareaPlaceholder: "Scrivi il tuo messaggio qui",
    SupportTitle: "Contattaci, risponderemo a tutte le tue domande",
    SystemSettings: "Impostazioni di sistema",
    Term: "Periodo",
    TermDays: "Periodo, giorni",
    TermMonths: "Periodo, mesi",
    Test: "Prova",
    TestInvestmentsInfo:
      "Gli investimenti di prova garantiscono una possibilità di testare la piattaforma in breve tempo. Un utente può creare un solo portafoglio di prova per una somma non superiore a 300 €.",
    ThankyouErrorText:
      "Verifica fallita. Forse non è leggibile la foto del tuo documento o si è verificato un errore di comunicazione. Non preoccuparti, <a target=\"_top\" href='/profile'>prova di nuovo</a>. Prova ad utilizzare un documento diverso. ",
    ThankyouErrorTitle: "Qualcosa sembra essere andato storto ...",
    ThankyouSuccessText:
      "Identificazione superata al 100% - crea il tuo primo investimento su Nibble. Abbiamo già preparato un'area riservata e devi solo <a target=\"_top\" href='/depositing'>aggiungere denaro</a> e <a target=\"_top\" href='/profile'>creare il tuo primo portafoglio di investimenti</a>.",
    ThankyouSuccessTitle: "Tutto è andato a buon fine!",
    ThroughSocialNetworks: "Attraverso i social media",
    TimeFormat: "Formato ora",
    Try: "Prova",
    TutorialMessage0:
      "Parliamo dei principali dettagli del tuo account Nibble. Altro?",
    TutorialMessage1:
      "Puoi calcolare la redditività del tuo portafoglio con la calcolatrice",
    TutorialMessage2:
      "Per iniziare a investire devi aggiungere fondi al tuo account",
    TutorialMessage3:
      'Gestisci il tuo portafoglio nella sezione "I miei investimenti"',
    TutorialMessage4:
      "Qui trovi la cronologia di tutti i tuoi movimenti di fondi",
    TutorialMessage5: "Aumenta i tuoi guadagni grazie ai tuoi amici",
    TutorialMessage6:
      "Impara come creare un portafoglio di investimenti o come funziona il sistema in toto",
    TutorialMessage7:
      "Per iniziare, completa le attività degli investitori richieste.",
    TutorialMessage8:
      "Puoi creare un portafoglio di prova con un importo massimo di investimento di 300 € per un periodo di 21 giorni",
    Unavailable: "assente",
    //UserAgreement: 'Cliccando sul pulsante "Continua" acconsenti ai <a href="/user_agreement.aspx">Termini e Condizioni del Accordo con l\'utente</a>, nonché <a href="/policy_privacy.aspx"> l\'informativa sulla privacy di NIBBLE</a>',
    UserAgreement: {
      text_1: 'Cliccando sul pulsante "Continua" acconsenti ai ',
      text_1_legal: 'Cliccando sul pulsante "Invia richiesta" acconsenti ai ',
      text_link_1: "Termini e Condizioni del Accordo con l'utente",
      text_2: ", nonché ",
      text_link_2: "l'informativa sulla privacy di NIBBLE",
      text_3: " ",
    },
    UserAgreement1:
      'Cliccando sul pulsante "Continua" acconsenti ai <a href="/user_agreement.aspx">Termini e Condizioni del Accordo con l\'utente</a>, nonché <a href="/policy_privacy.aspx"> l\'informativa sulla privacy di NIBBLE</a>',
    VERIFF_274: "Non c’è nessuna foto",
    VERIFF_275: "Immagine del viso non riconosciuta",
    VERIFF_276: "Il documento non è visualizzato completamente",
    VERIFF_277: "Scarsa qualità dell'immagine",
    VERIFF_278: "Il documento è danneggiato",
    VERIFF_279: "Spiacente, questo tipo di documento non è supportato",
    VERIFF_280: "Il documento è scaduto",
    VERIFF_282: "Altri motivi",
    VeriffGuarantees:
      "Il servizio Veriff garantisce la sicurezza dei tuoi dati personali.",
    VeriffGuaranteesHtml:
      '<span>Il servizio<u id="veriffLink">Veriff</u> garantisce la sicurezza dei tuoi dati personali.</span>',
    VeriffInfo:
      "In conformità alle leggi dell'Unione Europea ogni investitore della piattaforma Nibble, sia esso individuo o azienda, prima di iniziare deve sottoporsi alla verifica della clientela. La procedura si svolge in due fasi. Caricare un documento di riconoscimento e successivamente attendere la verifica da parte della Veriff. L'intera procedura richiede non più di 10 minuti. Cortesemente prepara il documento e assicurati che le foto siano chiaramente visibili.",

    VeriffInfoTitle: "Esegui il processo di identificazione istantanea.",
    VeriffInfoDesc:
      "Nibble aderisce rigorosamente alle norme del diritto europeo in materia di lotta contro il riciclaggio di denaro (AML), verifica della clientela, archiviazione e utilizzo dei dati personali. Ci vogliono 2 minuti per essere verificato e diventare un investitore",
    VeriffInfoQuest: "È facile identificarsi digitalmente?",
    VeriffInfoAsk1:
      "Ti chiediamo di scattare una foto del tuo documento di identità (patente di guida, passaporto o carta d'identità) con la tua webcam o smartphone - è un processo in tempo reale",
    VeriffInfoAsk2:
      "Ti chiediamo di fare un rapido selfie con lo stesso dispositivo. Ti guideremo mentre scatti il ​​tuo selfie per assicurarci che sia perfetto al primo tentativo.",
    VeriffInfoAsk3: "Riceverai una decisione in pochi secondi. Questo è tutto!",
    VeriffStartButton: "Inizia la verifica",
    Cancel: "Lo farò più tardi",

    VeriffInProcess:
      "Il tuo documento di identità sta attraversando il processo di verifica da parte di Veriff. Di solito ci vogliono pochi minuti. </br> Fino a quando il processo di verifica non sarà completato non potrai depositare il tuo account.",
    WeAreDoingAll:
      "Stiamo facendo del nostro meglio per risolvere questo problema.",
    WeeklyReport: "Rapporto settimanale",
    WeEnsureSecurity:
      'Identificazione sicura insieme al nostro partner, il servizio <a href="https://www.veriff.com" target="_blank">Veriff</a>',
    WeWorkHonest:
      "Lavoriamo in trasparenza ed apprezziamo quando i nostri utenti condividono questo approccio.",
    WidgetBringFriendLead:
      "Raccomandaci ai tuoi amici e sarai ricompensato per ogni raccomandazione",
    WidgetHistoryLead:
      "Puoi trovare tutti i depositi, redditi maturati e prelievi di fondi qui",
    WidgetInvestLead: "Il punto centrale per la gestione dei tuoi investimenti",
    WidgetSupportLead:
      "I nostri specialisti ti aiuteranno con qualsiasi domanda e dubbio",
    WillAddXMonth:
      'i tuoi investimenti <br>per <span class="js-calcMonth">12</span> mesi',
    WillAddXMonth1: "i tuoi investimenti&nbsp;<br>per",
    WillAddXMonth2: "mesi",
    Withdrawal: "Prelievo",
    WithdrawalAmount: "Importo del prelievo",
    WithdrawalHistory: "Cronologia dei prelievi",
    WithdrawalInfo1:
      "Il prelievo di fondi verrà effettuato sul numero di conto collegato.",
    WithdrawalInfo2: "L'importo minimo di prelievo è <b> 50 EURO </b>.",
    WithdrawalInfo3:
      "Il prelievo verrà effettuato sul conto bancario del primo deposito.",
    WithdrawalOfBalances: "Prelievo dal portfolio",
    WithdrawalViaBankAccount: "Prelievo tramite conto bancario",
    WithdrawFunds: "Prelevare denaro",
    WithdrawFundsMobile: "Prelevare",
    WrongFormat: "Formato non corretto",
    XActiveLoans: "prestiti attivi",
    XClosedLoans: "prestiti estinti",
    XInvestedLoans: "prestiti investiti",
    XOverdueLoans: "prestiti scaduti",
    Yes: "Sì",
    YourInvestmentsXMonth:
      'i tuoi investimenti per <span class="js-calcMonth"></span> mesi.',
    ZIP: "Codice postale",
    LowBalanceAlert:
      "Non ci sono fondi sufficienti sul tuo bilancio per creare un portafoglio con i parametri selezionati",
    LowBalanceAlertCommon: "Non ci sono fondi sufficienti sul tuo bilancio",
    NoBankAlert:
      "Non hai specificato i dettagli del conto bancario. Si prega di contattare l'assistenza ",

    //Validation
    required: "Campo obbligatorio",
    regexDate: "Inserisci la data corretta",
    regexEmail: "Inserisci una email valida",
    checkbox: "Autorizzo il trattamento dei dati personali",
    regexNot: "Formato non valido",
    minlength: "",
    simple: "Debole",
    normal: "Normale",
    hard: "Forte",
    minSum: "L'importo minimo",
    //Tutorial
    step0:
      "Grazie per esserti unito a Nibble! Esegui l'identificazione personale attraverso Veriff per depositare i fondi e iniziare a investire",
    step1: "Per iniziare a investire devi aggiungere fondi al tuo account",
    step2:
      "Puoi calcolare la redditività del tuo portafoglio con la calcolatrice",
    step3: 'Gestisci il tuo portafoglio nella sezione "I miei investimenti"',
    step4: "Qui trovi la cronologia di tutti i tuoi movimenti di fondi",
    step5: "Aumenta i tuoi guadagni grazie ai tuoi amici",
    step6:
      "Impara come creare un portafoglio di investimenti o come funziona il sistema in toto",
    step7:
      "Puoi creare un portafoglio di prova con un importo massimo di investimento di 300 € per un periodo di 21 giorni",
    TutorialCancel: "Lo farò più tardi",
    TutorialConfirm: "Confermo adesso",
    TutorialPrev: "Precedente",
    TutorialNext: "Continuare",
    TutorialFinal: "Completa",

    NoticeMaxSum: "L'importo massimo è di",
    NoticeMinSum: "L'importo minimo è di",
    StrategyTitleInvestClassic: "Classica",
    StrategyTitleInvestBalanced: "Equilibrata",

    // ------ Судебная ------

    JudicialTitle: `Portafogli disponibili`,
    JudicialPanelTitle: `Investi`,
    JudicialBabberTitle: `Nibble introduce una nuova strategia di investimento - Legale`,
    JudicialSlideBtn: `Investire`,
    JudicialBtnText: `Investire`,
    JudicialLabel: `Importo dell'investimento`,
    JudicialSubTitle: `strategia`,
    JudicialCollection: `Resta da raccogliere ХХХ1 da ХХХ2`,
    JudicialCollectionEnd: `Fino alla fine della raccolta`,
    JudicialCollectionEnd2: `Fino alla fine della raccolta`,
    JudicialCollectionCompleted: `La raccolta è completa.`,
    JudicialCollectionCompletedSub: `Puoi investire in un nuovo portafoglio.`,
    StrategyJudicialTitle: `Strategia Legale`,
    StrategyJudicialPanelTitle: `Legale`,
    TaglineStrategyJudicialPanel: `Rendimento elevato`,
    TaglineStrategyOtherPanel: `Rischi equilibrati`,
    JudicialMoreStrategy: `Più dettagli sulla strategia`,
    JudicialGuarantee: `Tutti i portafogli sono protetti dalla garanzia di`,
    JudicialGuaranteeDb: `restituzione del deposito`,
    JudicialState1: `Raccogliamo investimenti per l'acquisto di un portafoglio`,
    JudicialState2: `Compriamo un portafoglio`,
    JudicialState3: `Negoziamo con i mutuatari`,
    JudicialStateSub3: `Esazione preliminare`,
    JudicialState4: `Presentiamo documenti al tribunale`,
    JudicialState5: `Riceviamo responso del tribunale`,
    JudicialState6: `Riscuotiamo il debito attraverso le banche e gli ufficiali giudiziari`,
    JudicialState7: `I debiti sono riscuotati`,
    JudicialAgreement: `Accordo`,
    JudicialGarantText: `Garanzia di restituzione del deposito`,
    JudicialInfo: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>É una strategia di investimento in portafogli costituiti da prestiti al consumo con classificazione B, CC e C, che sono in fase di esibizione preliminare e giudiziaria. A causa del fatto che questi prestiti hanno gli arretrati e le multe, il rendimento di questa strategia raggiunge il 19% annuo.</p>
        <p>Il periodo minimo di investimento di 6 mesi è dovuto al fatto che il processo legale e il processo di esazione richiedono un lungo periodo di tempo. Tutto il processo legale e processo dell'esazione sono forniti dalla società Boostr.</p>
        <p>Rischi associati: Rischio di insolvenza del prestito / violazione del piano di rientro /mancato rimborso dell'intero importo del prestito</p>

        <ul>
            <li>La strategia è assicurata dalla garanzia di restituzione del deposito - è l'obbligo delle agenzie di recupero creditidi restituire l’importo dell’investimento in pieno alla fine del periodo di investimento e di garantire una redditività annua minima del 8%.</li>
            <li>A causa di investimenti in un portafoglio costituito da un gran numero di prestiti, il rischio di mancato ricevimento del reddito da diversi contratti è ridotto, si sovrappongono dagli altri prestiti.</li>
            <li>Maturazione giornaliera degli interessi al tasso dell'8% annuo, pagamenti ogni 90 giorni in base al rendimento effettivamente ricevuto fino al 14,5% annuo.</li>
            <li>Mentre i soldi sono raccolti per l'acquisto di un portafoglio, noi maturiamo un reddito di 8% annuo, questo è il tuo rendimento bonus con quello principale fino al 14,5%. Il periodo massimo di una raccolta dei soldi per l'acquisto di un portafoglio è di 30 giorni.</li>
        </ul>
        <p>Come funziona?</p>
        <p>Ogni giorno ti viene maturato un tasso di interesse dell'8% annuo. Ogni 90 giorni calcoliamo automaticamente il rendimento effettivo dei portafogli e ti maturiamo la differenza tra il tasso garantito dell'8% e il tasso effettivo. In questo modo, ogni 90 giorni ti ottieni un reddito compreso tra l'8% e il 14,5% sul tuo conto Nibble.</p>
        <p>Per esempio: dopo aver investito 1000 euro per 12 mesi, alla fine del periodo di investimento ti ottieni indietro tutto il capitale di 1000 euro e il reddito da 90 a 145 euro, che ti paghiamo ogni 90 giorni.</p>
        </div></div></div>`,

    JudiciaDb: `
        <div class="judicial-slide__title"
        <div class="judicial-slide__content">
        <div class="judicial-slide__title-sub">
        <p>Strategia Legale</p>
        <p>La strategia è assicurata dalla garanzia di restituzione del deposito - è l'obbligo delle agenzie di recupero creditidi restituire l’importo dell’investimento in pieno alla fine del periodo di investimento e di garantire una redditività annua minima del 8%.</p>
        <p>Come funziona?</p>
        <p>Ogni giorno ti viene maturato un tasso di interesse dell'8% annuo. Ogni 90 giorni calcoliamo automaticamente il rendimento effettivo dei portafogli e ti maturiamo la differenza tra il tasso garantito dell'8% e il tasso effettivo. In questo modo, ogni 90 giorni ti ottieni un reddito compreso tra l'8% e il 14,5% sul tuo conto Nibble.</p>
        <p>Per esempio: dopo aver investito 1000 euro per 12 mesi, alla fine del periodo di investimento ti ottieni indietro tutto il capitale di 1000 euro e il reddito da 90 a 145 euro, che ti paghiamo ogni 90 giorni.</p>
        </div></div></div>`,

    JudicialSlide: `
        <div class="judicial-slide__title">
        <div class="judicial-slide__title-head">
            Nibble introduce una nuova strategia di investimento - Legale
        </div>
        <div class="judicial-slide__title-sub">
            <p>Da oggi per i nostri investitori è disponibile una nuova strategia di investimento, che offre alto e previsto reddito fino al 14,5% annuo e una garanzia di restituzione del deposito.</p>
            <p>Inoltre, al fine di rispettare l'equilibrio dei redditi nella situazione attuale del mercato e le esigenze del regolatore, aggiorniamo i tassi di interesse sui nuovi portafogli di strategie Classica ed Equilibrata. I tassi sui portafogli già esistenti non cambiano.</p>
        </div>
        
        
        <div class="judicial-slide__title-mini">
            Classica - 8% annuo
        </div>
        <div class="judicial-slide__title-mini">
            Equilibrata - 12, 5% annuo
        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Del prodotto
            </div>

            <div class="judicial-slide__sub-text">
                <p>In ogni società finanziaria che esercita i prestiti inevitabilmente appaiono i prestiti che non vengono restituiti nei tempi concordati dal contratto. Molte società vendono tali prestiti in grandi portafogli alle aste con uno sconto fino all'85% per restituire una parte del denaro nel business più veloce.</p>
                <p>Tali portafogli sono acquistati alle aste da Boostr. Grazie all'esperienza accumulata e alla tecnologia sviluppata internamente, Boostr fornisce l'intero processo di ritorno, consentendo di ottenere un'alta percentuale di ritorno del capitale.</p>
                <p>In Eurasia la società ha più di 5 anni di esperienza e uno staff di oltre 80 dipendenti.</p>
                <p>In Europa Boostr lavora in collaborazione con le agenzie di recupero crediti, che lavorano per il recupero debiti dei prestiti europei.</p>
                <p>Dal 2019, le piattaforme di aste per la vendita di portafogli come Debex e NLPBroker hanno iniziato a comparire attivamente sul mercato spagnolo, il che a sua volta indica la crescita del mercato nel suo complesso. Inoltre, sul mercato ci sono molte agenzie di recupero crediti che si occupano di lavoro preliminare e giudiziario. Secondo i dati forniti dai nostri partner impegnati nella gestione della raccolta del debito per più di 25 anni, il reddito degli investitori può raggiungere fino al 19% annuo.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Un portafoglio è stato acquistato.
            </div>

            <div class="judicial-slide__stend">
                <div class="judicial-slide__block">
                    <div class="judicial-slide__block-title">
                        Un portafoglio è stato acquistato.
                    </div>
                    <div class="judicial-slide__purchase-list">

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Acquistato per 
                            </div>
                            <div class="judicial-slide__purchase-money">
                                117 801 €
                            </div>
                        </div>

                        <div class="judicial-slide__purchase-item">
                            <div class="judicial-slide__purchase-info">
                                Somma dei debiti 
                            </div>
                            <div class="judicial-slide__purchase-money">
                                1 328 123 €
                            </div>
                        </div>
                    </div>

                    <div class="judicial-slide__explanation">
                            <div class="judicial-slide__explanation-icon">
                                <div class="judicial-slide__explanation-smiley" ></div>
                            </div>
                            <div class="judicial-slide__explanation-text">
                                Cioè, abbiamo comprato un portafoglio con <br /> un potenziale di 1 328 123 € per 117 801 €
                            </div>
                        </div>

                        <div class="judicial-slide__block-info">
                            <div class="judicial-slide__block-collected">
                                <div class="judicial-slide__collected-title">
                                    Nel primo anno abbiamo raccolto:
                                </div>
                                <div class="judicial-slide__collected-money">
                                    143 107&nbsp;€
                                </div>
                                <div class="judicial-slide__collected-description">
                                    che è 25 306 € in più rispetto al nostro investimento. E questo è più del 20% annuo
                                </div>
                            </div>

                            <div class="judicial-slide__block-description">
                                <div class="judicial-slide__description-icon">
                                    <div class="judicial-slide__description-info-icon"></div>
                                </div>
                                <div class="judicial-slide__block-description-text">
                                    Dopo il primo anno di esazione, possiamo vendere i prestiti restanti in portafoglio all'asta per 70&nbsp;343&nbsp;€, quello ci darà un reddito di 95&nbsp;649&nbsp;€
                                </div>
                            </div>
                        </div>

                        
                        <div class="judicial-slide__strategy">
                            <div class="judicial-slide__strategy-title">
                                Statistiche del portafoglio
                            </div>
                            <div class="judicial-slide__strategy-diagram">
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        117 801 €
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom1">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Investimenti totali
                                    </div>
                                </div>
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        143 107 €
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom2">
                                        Reddito 25 306&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Recuperato durante il primo anno
                                    </div>
                                </div>          
                                <div class="judicial-slide__strategy-column">
                                    <div class="judicial-slide__strategy-money">
                                        270 784 €
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom4">
                                        Reddito 152&nbsp;983&nbsp;€
                                    </div>
                                    <div class="judicial-slide__strategy-block-bottom3">

                                    </div>
                                    <div class="judicial-slide__strategy-info">
                                        Recuperato durante il secondo anno
                                    </div>
                                </div>          
                            </div>

                            <div class="judicial-slide__strategy-earned">
                                <div class="judicial-slide__strategy-label">
                                    Guadagnato in 2 anni:
                                </div>
                                <div class="judicial-slide__strategy-sum">
                                    152&nbsp;983&nbsp;€
                                </div>
                            </div>
                        </div>
                </div>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Sulla base di questo business abbiamo sviluppato una Strategia Legale
            </div>

            <div class="judicial-slide__sub-text">
                <p>É una strategia di investimento in portafogli costituiti da prestiti al consumo con classificazione B, CC e C, che sono in fase di esibizione preliminare e giudiziaria. A causa del fatto che questi prestiti hanno gli arretrati e le multe, il rendimento di questa strategia raggiunge il 19% annuo.</p>
                <p>Il periodo minimo di investimento di 6 mesi è dovuto al fatto che il processo legale e il processo di esazione richiedono un lungo periodo di tempo.</p>
            </div>

        </div>
    </div>

    
    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Rischi associati
            </div>

            <div class="judicial-slide__title-small">
                Rischio di insolvenza del prestito / violazione del piano di rientro /mancato rimborso dell'intero importo del prestito
            </div>

            <div class="judicial-slide__sub-text">
                <ul class="judicial-slide__roll">
                    <li class="judicial-slide__element">La strategia è assicurata dalla garanzia di restituzione del deposito - è l'obbligo delle agenzie di recupero creditidi restituire l’importo dell’investimento in pieno alla fine del periodo di investimento e di garantire una redditività annua minima del 8%.</li>
                    <li class="judicial-slide__element">A causa di investimenti in un portafoglio costituito da un gran numero di prestiti, il rischio di mancato ricevimento del reddito da diversi contratti è ridotto, si sovrappongono dagli altri prestiti.</li>
                    <li class="judicial-slide__element">Maturazione giornaliera degli interessi al tasso dell'8% annuo, pagamenti ogni 90 giorni in base al rendimento effettivamente ricevuto fino al 14,5% annuo.</li>
                    <li class="judicial-slide__element">Mentre i soldi sono raccolti per l'acquisto di un portafoglio, noi maturiamo un reddito di 8% annuo, questo è il tuo rendimento bonus con quello principale fino al 14,5%. Il periodo massimo di una raccolta dei soldi per l'acquisto di un portafoglio è di 30 giorni.</li>
                </ul>
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Come funziona?
            </div>

            <div class="judicial-slide__sub-text">
            Scegli un portafoglio in base alle tue preferenze e investi in esso. Mentre il portafoglio è in processo di raccogliere i soldi, ti viene maturato l'8% annuo al giorno. Terminata la raccolta, ogni giorno lo stesso maturano gli interessi al tasso dell'8% annuo, e ogni 90 giorni automaticamente calcoliamo un reddito effettivo dei portafogli e maturiamo la differenza tra il tasso garantito dell'8% e il tasso effettivo fino al 14,5% annuo. In questo modo, ogni 90 giorni ti ottieni un reddito compreso tra l'8% e il 14,5% sul tuo conto Nibble.
            </div>

            <div class="judicial-slide__sub-text-mini">
                Per esempio: dopo aver investito 1000 euro per 12 mesi, alla fine del periodo di investimento ti ottieni indietro tutto il capitale di 1000 euro e il reddito da 90 a 145 euro, che ti paghiamo ogni 90 giorni.
            </div>

        </div>
    </div>

    <div class="judicial-slide__list">
        <div class="judicial-slide__item">

            <div class="judicial-slide__text">
                Come guadagniamo i soldi per gli investitori:
            </div>

            <div class="judicial-slide__sub-text">
                <ol class="judicial-slide__roll">
                    <li class="judicial-slide__element">Boostr acquista prestiti scaduti da banche e MFO alle aste, con uno sconto dell'85%.</li>
                    <li class="judicial-slide__element">Inizia il processo di esazione, quando l'agenzia contatta il mutuatario e cerca di negoziare il rimborso del debito.</li>
                    <li class="judicial-slide__element">Se l'accordo non è riuscito, inizia il processo di contenzioso per ottenere un responso tribunale sul recupero del debito dal debitore che conduce Boostr o il suo partner.</li>
                    <li class="judicial-slide__element">Dopo aver ricevuto una decisione giudiziaria, attraverso l'ufficio giudiziario e le banche avviene il recupero dei debiti, interessi e multe.</li>
                </ol>
            </div>

        </div>
    </div>
        `,
    legalTitle: `Legale strategia`,
    legalInfoTitle1: `Del prodotto`,
    legalInfoTitle2: `Rendimento storico`,
    legalInfoTitle3: `Sulla base di questo business abbiamo sviluppato una Strategia Legale`,
    legalInfoTitle4: `Rischi associati`,
    legalInfoTitle5: `Come funziona?`,
    legalInfoTitle6: `Come guadagniamo i soldi per gli investitori`,
    legalInfoText1: `
        <p>In ogni società finanziaria che esercita i prestiti inevitabilmente appaiono i prestiti che non vengono restituiti nei tempi concordati dal contratto. Molte società vendono tali prestiti in grandi portafogli alle aste con uno sconto fino all'85% per restituire una parte del denaro nel business più veloce.</p>
        <p>Tali portafogli sono acquistati alle aste da Boostr.</p>
        <p>Grazie all'esperienza accumulata e alla tecnologia sviluppata internamente, Boostr fornisce l'intero processo di ritorno, consentendo di ottenere un'alta percentuale di ritorno del capitale. In Eurasia la società ha più di 5 anni di esperienza e uno staff di oltre 80 dipendenti.</p>
        <p>In Europa Boostr lavora in collaborazione con le agenzie di recupero crediti, che lavorano per il recupero debiti dei prestiti europei.</p>
        <p>Dal 2019, le piattaforme di aste per la vendita di portafogli come Debex e NLPBroker hanno iniziato a comparire attivamente sul mercato spagnolo, il che a sua volta indica la crescita del mercato nel suo complesso. Inoltre, sul mercato ci sono molte agenzie di recupero crediti che si occupano di lavoro preliminare e giudiziario. Secondo i dati forniti dai nostri partner impegnati nella gestione della raccolta del debito per più di 25 anni, il reddito degli investitori può raggiungere fino al 19% annuo.</p>
        `,
    legalInfoText2: `
        <div class="judicial-slide__stend">
          <div class="judicial-slide__block">
              <div class="judicial-slide__block-title">
                  Un portafoglio è stato acquistato.
              </div>
              <div class="judicial-slide__purchase-list">

                  <div class="judicial-slide__purchase-item">
                      <div class="judicial-slide__purchase-info">
                          Acquistato per 
                      </div>
                      <div class="judicial-slide__purchase-money">
                          117 801 €
                      </div>
                  </div>

                  <div class="judicial-slide__purchase-item">
                      <div class="judicial-slide__purchase-info">
                          Somma dei debiti 
                      </div>
                      <div class="judicial-slide__purchase-money">
                          1 328 123 €
                      </div>
                  </div>
              </div>

              <div class="judicial-slide__explanation">
                      <div class="judicial-slide__explanation-icon">
                          <div class="judicial-slide__explanation-smiley" ></div>
                      </div>
                      <div class="judicial-slide__explanation-text">
                          Cioè, abbiamo comprato un portafoglio con <br /> un potenziale di 1 328 123 € per 117 801 €
                      </div>
                  </div>

                  <div class="judicial-slide__block-info">
                      <div class="judicial-slide__block-collected">
                          <div class="judicial-slide__collected-title">
                              Nel primo anno abbiamo raccolto:
                          </div>
                          <div class="judicial-slide__collected-money">
                              143 107&nbsp;€
                          </div>
                          <div class="judicial-slide__collected-description">
                              che è 25 306 € in più rispetto al nostro investimento. E questo è più del 20% annuo
                          </div>
                      </div>

                      <div class="judicial-slide__block-description">
                          <div class="judicial-slide__description-icon">
                              <div class="judicial-slide__description-info-icon"></div>
                          </div>
                          <div class="judicial-slide__block-description-text">
                              Dopo il primo anno di esazione, possiamo vendere i prestiti restanti in portafoglio all'asta per 70&nbsp;343&nbsp;€, quello ci darà un reddito di 95&nbsp;649&nbsp;€
                          </div>
                      </div>
                  </div>

                  
                  <div class="judicial-slide__strategy">
                      <div class="judicial-slide__strategy-title">
                          Statistiche del portafoglio
                      </div>
                      <div class="judicial-slide__strategy-diagram">
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  117 801 €
                              </div>
                              <div class="judicial-slide__strategy-block-bottom1">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Investimenti totali
                              </div>
                          </div>
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  143 107 €
                              </div>
                              <div class="judicial-slide__strategy-block-bottom2">
                                  Reddito 25 306&nbsp;€
                              </div>
                              <div class="judicial-slide__strategy-block-bottom3">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Recuperato durante il primo anno
                              </div>
                          </div>          
                          <div class="judicial-slide__strategy-column">
                              <div class="judicial-slide__strategy-money">
                                  270 784 €
                              </div>
                              <div class="judicial-slide__strategy-block-bottom4">
                                  Reddito 152&nbsp;983&nbsp;€
                              </div>
                              <div class="judicial-slide__strategy-block-bottom3">

                              </div>
                              <div class="judicial-slide__strategy-info">
                                  Recuperato durante il secondo anno
                              </div>
                          </div>          
                      </div>

                      <div class="judicial-slide__strategy-earned">
                          <div class="judicial-slide__strategy-label">
                              Guadagnato in 2 anni:
                          </div>
                          <div class="judicial-slide__strategy-sum">
                              152&nbsp;983&nbsp;€
                          </div>
                      </div>
                  </div>
          </div>
      </div>

      </div>
  </div>
        `,
    legalInfoText3: `
          <p>É una strategia di investimento in portafogli costituiti da prestiti al consumo con classificazione B, CC e C, che sono in fase di esibizione preliminare e giudiziaria. A causa del fatto che questi prestiti hanno gli arretrati e le multe, il rendimento di questa strategia raggiunge il 19% annuo.</p>
          <p>Il periodo minimo di investimento di 6 mesi è dovuto al fatto che il processo legale e il processo di esazione richiedono un lungo periodo di tempo.</p>
        `,
    legalInfoText4: `
        <strong>
          Rischio di insolvenza del prestito / violazione del piano di rientro /mancato rimborso dell'intero importo del prestito
        </strong>
        <ul class="legal-list__point">
          <li>La strategia è assicurata dalla garanzia di restituzione del deposito - è l'obbligo delle agenzie di recupero creditidi restituire l’importo dell’investimento in pieno alla fine del periodo di investimento e di garantire una redditività annua minima del 8%.</li>
          <li>A causa di investimenti in un portafoglio costituito da un gran numero di prestiti, il rischio di mancato ricevimento del reddito da diversi contratti è ridotto, si sovrappongono dagli altri prestiti.</li>
          <li>Maturazione giornaliera degli interessi al tasso dell'8% annuo, pagamenti ogni 90 giorni in base al rendimento effettivamente ricevuto fino al 14,5% annuo.</li>
          <li>Mentre i soldi sono raccolti per l'acquisto di un portafoglio, noi maturiamo un reddito di 8% annuo, questo è il tuo rendimento bonus con quello principale fino al 14,5%. Il periodo massimo di una raccolta dei soldi per l'acquisto di un portafoglio è di 30 giorni.</li>
        </ul>
        `,
    legalInfoText5: `
        <p>Scegli un portafoglio in base alle tue preferenze e investi in esso. Mentre il portafoglio è in processo di raccogliere i soldi, ti viene maturato l'8% annuo al giorno. Terminata la raccolta, ogni giorno lo stesso maturano gli interessi al tasso dell'8% annuo, e ogni 90 giorni automaticamente calcoliamo un reddito effettivo dei portafogli e maturiamo la differenza tra il tasso garantito dell'8% e il tasso effettivo fino al 14,5% annuo. In questo modo, ogni 90 giorni ti ottieni un reddito compreso tra l'8% e il 14,5% sul tuo conto Nibble.</p>
        <p>Per esempio: dopo aver investito 1000 euro per 12 mesi, alla fine del periodo di investimento ti ottieni indietro tutto il capitale di 1000 euro e il reddito da 90 a 145 euro, che ti paghiamo ogni 90 giorni.</p>
        `,
    legalInfoText6: `
        <ol class="legal-list__num">
          <li>Boostr acquista prestiti scaduti da banche e MFO alle aste, con uno sconto dell'85%.</li>
          <li>Inizia il processo di esazione, quando l'agenzia contatta il mutuatario e cerca di negoziare il rimborso del debito.</li>
          <li>Se l'accordo non è riuscito, inizia il processo di contenzioso per ottenere un responso tribunale sul recupero del debito dal debitore che conduce Boostr o il suo partner.</li>
          <li>Dopo aver ricevuto una decisione giudiziaria, attraverso l'ufficio giudiziario e le banche avviene il recupero dei debiti, interessi e multe.</li>
        </ol>
        `,

    refLinkMenu1: `Condizioni del programma`,
    refLinkMenu2: `I miei inviti`,
    refLinkTab1: `In attesa`,
    refLinkTab2: `Bonus ricevuto`,
    refLinkTab3: `Non c'è il bonus`,
    refInviteFriendsTitle1: `Invita gli amici`,
    refInviteFriendsSubTitle1: `Ottieni una ricompensa`,
    refInviteFriendsText1: `fino a 1.000 € per te e tuo amico`,
    refInviteFriendsBTN1: `Invitare gli amici`,
    refInviteFriendsSubTitle2: `Come funziona?`,
    refInviteFriendsStepTitle1: `Inviti il tuo amico a unirsi a Nibble`,
    refInviteFriendsStepText1: `Mandali il tuo link per la registrazione`,
    refInviteFriendsStepTitle2: `Il tuo amico diventa un investitore`,
    refInviteFriendsStepText2: `Ha 3 mesi per creare un portafoglio`,
    refInviteFriendsStepTitle3: `Tu e il tuo amico ricevete un bonus`,
    refInviteFriendsStepText3: `Il bonus dipende dalla somma degli investimenti dell'amico`,
    refInviteFriendsTitle2: `Da che cosa dipende la somma della ricompensa?`,
    refInviteFriendsText2: `Il bonus dipende da quanto investe il tuo amico in 3 mesi dopo la registrazione`,
    refInviteFriendsBonus: `Bonus&nbsp;2%`,
    refInviteFriendsSum: `Investimenti dell'amico`,
    refInviteFriendsTitle3: `Cos'altro influenza?`,
    refInviteFriendsInfoTitle1: `Somma degli investimenti`,
    refInviteFriendsInfoText1: `La somma dei tutti gli investimenti del tuo amico deve essere più di 500 €`,
    refInviteFriendsInfoTitle2: `Periodo degli investimenti`,
    refInviteFriendsInfoText2: `Solo i portafogli con il periodo più di 3 mesi sono considerati`,
    refInviteFriendsBoxTitle1: `Investi con i tuoi amici su Nibble`,
    refInviteFriendsBoxText1: `La nostra piattaforma è adatta sia ai principianti che agli investitori esperti`,
    yourReferralLink: `Il tuo link di riferimento`,
    refInviteFriendsBTN2: `Copiare il link`,
    refMyInvitationsTitle1: `I miei inviti`,
    refMyInvitationsTotal: `Totale guadagnato`,
    refMyInvitationsFriends: `Amici registrati`,
    refMyInvitationsGetBonus: `Bonus ricevuto`,
    refMyInvitationsTitle2: `Il tuo link di riferimento`,
    refMyInvitationsTitle3: `I miei inviti`,
    refMyInvitationsNO: `Non hai ancora gli amici invitati, condividi il suo link di referral con loro`,
    bonusPeriodEnd: `Fine del periodo di bonus`,
    yourBonus: `Il tuo bonus`,
    bannerTetx: `La strategia legale è di nuovo disponibile<span class="banner-BB__text-i">!</span> Investi <span class="banner-BB__text-i">ad un </span> alto tasso di interesse <span class="banner-BB__text-i">e</span> guadagna <span class="banner-BB__text-i">con Nibble!</span>`,
  },
};
